// THIS FILE IS GENERATED, DO NOT EDIT!
import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Cursor for paging through collections */
  ConnectionCursor: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AcceptInvitationInput = {
  /** ID приглашения */
  invitationId: Scalars['ID']['input'];
};

export type AddCalendarEventParticipantsInput = {
  /** ID события */
  eventId: Scalars['ID']['input'];
  /** ID добавляемых пользователей */
  userIds: Array<Scalars['ID']['input']>;
};

export type AllTemplatesResponse = {
  __typename?: 'AllTemplatesResponse';
  global: Array<TemplateGroup>;
  personal: Array<TemplateItem>;
};

export type AnalyticsFiltersInput = {
  /** Конечная дата периода */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Фильтр по региону (максимум 100 символов) */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Начальная дата периода */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Answer = {
  __typename?: 'Answer';
  /** Массив значений для множественного выбора */
  arrayValue?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  /** ID ответа */
  id: Scalars['ID']['output'];
  /** Дополнительные данные ответа */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** Числовое значение ответа */
  numericValue?: Maybe<Scalars['Float']['output']>;
  /** ID вопроса */
  questionId: Scalars['ID']['output'];
  respondent: User;
  /** ID пользователя, давшего ответ */
  respondentUserId: Scalars['ID']['output'];
  /** Текстовое значение ответа */
  textValue?: Maybe<Scalars['String']['output']>;
  /** Временное значение ответа */
  timeValue?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AnswerConnection = {
  __typename?: 'AnswerConnection';
  /** Array of nodes. */
  nodes: Array<Answer>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type AnswerDeleteResponse = {
  __typename?: 'AnswerDeleteResponse';
  /** Массив значений для множественного выбора */
  arrayValue?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID ответа */
  id?: Maybe<Scalars['ID']['output']>;
  /** Дополнительные данные ответа */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** Числовое значение ответа */
  numericValue?: Maybe<Scalars['Float']['output']>;
  /** ID вопроса */
  questionId?: Maybe<Scalars['ID']['output']>;
  /** ID пользователя, давшего ответ */
  respondentUserId?: Maybe<Scalars['ID']['output']>;
  /** Текстовое значение ответа */
  textValue?: Maybe<Scalars['String']['output']>;
  /** Временное значение ответа */
  timeValue?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnswerFilter = {
  and?: InputMaybe<Array<AnswerFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  numericValue?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<AnswerFilter>>;
  questionId?: InputMaybe<IdFilterComparison>;
  respondentUserId?: InputMaybe<IdFilterComparison>;
  textValue?: InputMaybe<StringFieldComparison>;
  timeValue?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type AnswerFlexibleInputDto = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  questionId: Scalars['ID']['input'];
  value: Scalars['JSON']['input'];
};

export type AnswerInputDto = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  questionId: Scalars['ID']['input'];
  value: Scalars['JSON']['input'];
};

export type AnswerSort = {
  direction: SortDirection;
  field: AnswerSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AnswerSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  NumericValue = 'numericValue',
  QuestionId = 'questionId',
  RespondentUserId = 'respondentUserId',
  TextValue = 'textValue',
  TimeValue = 'timeValue',
  UpdatedAt = 'updatedAt'
}

export type AnswerSurveyDto = {
  answers: Array<AnswerFlexibleInputDto>;
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};

/** Значение ответа на вопрос */
export type AnswerValueDto = {
  __typename?: 'AnswerValueDto';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Идентификатор ответа */
  id: Scalars['ID']['output'];
  /** Метаданные */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Идентификатор вопроса */
  questionId: Scalars['ID']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** Значение ответа с подстановкой presigned URL для медиа-файлов */
  value?: Maybe<Scalars['JSON']['output']>;
};

/** Значение ответа по полю вопроса */
export type AnswerValueFieldDto = {
  __typename?: 'AnswerValueFieldDto';
  /** Идентификатор поля вопроса */
  fieldId: Scalars['ID']['output'];
  /** Тип поля вопроса */
  fieldType: QuestionFieldType;
  /** Результат ответа по полю */
  result: Scalars['JSON']['output'];
};

export type AppVersionCheck = {
  __typename?: 'AppVersionCheck';
  latestBuild?: Maybe<Scalars['Int']['output']>;
  latestVersion: Scalars['String']['output'];
  minSupportedVersion: Scalars['String']['output'];
  platform: MobilePlatform;
  releaseNotes?: Maybe<Scalars['String']['output']>;
  severity: UpdateSeverity;
  store: MobileStore;
  storeUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AppVersionCheckInput = {
  currentBuild?: InputMaybe<Scalars['Int']['input']>;
  currentVersion: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  platform: MobilePlatform;
  store: MobileStore;
};

export type AppVersionRecord = {
  __typename?: 'AppVersionRecord';
  latestBuild?: Maybe<Scalars['Int']['output']>;
  latestVersion: Scalars['String']['output'];
  minSupportedVersion: Scalars['String']['output'];
  platform: MobilePlatform;
  releaseNotes?: Maybe<Scalars['JSONObject']['output']>;
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
  store: MobileStore;
  storeUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ApproveJoinRequestInput = {
  /** Комментарий к одобрению */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** ID заявки на вступление */
  requestId: Scalars['ID']['input'];
};

export type ApproveObjectPassportApplicationInput = {
  /** Комментарий модератора */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** ID заявки */
  id: Scalars['ID']['input'];
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  /** JWT access token used to authenticate API requests. */
  access_token?: Maybe<Scalars['String']['output']>;
  /** Time in seconds until the access token expires. */
  expires_in?: Maybe<Scalars['Float']['output']>;
  /** Time in seconds until the refresh token expires. */
  refresh_expires_in?: Maybe<Scalars['Float']['output']>;
  /** JWT refresh token used to obtain a new access token when the current one expires. */
  refresh_token?: Maybe<Scalars['String']['output']>;
  /** Type of token issued, typically "Bearer". */
  token_type?: Maybe<Scalars['String']['output']>;
};

export type Avatar = {
  __typename?: 'Avatar';
  DESKTOP?: Maybe<DesktopVariation>;
  MOBILE?: Maybe<MobileVariation>;
  TABLET?: Maybe<TabletVariation>;
};

export type Background = {
  __typename?: 'Background';
  DESKTOP?: Maybe<DesktopVariation>;
  MOBILE?: Maybe<MobileVariation>;
  TABLET?: Maybe<TabletVariation>;
};

/** Entity representing a blocked type category for the system. */
export type BlockedType = {
  __typename?: 'BlockedType';
  /** Unique code representing the blocked type. Maximum length is 20 characters. */
  code: Scalars['String']['output'];
  /** Optional description providing additional details about the blocked type. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the blocked type. Automatically generated by the database. */
  id: Scalars['ID']['output'];
};

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkInviteInput = {
  /** Сообщение для всех приглашаемых */
  message?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** Список ID пользователей для приглашения */
  userIds: Array<Scalars['ID']['input']>;
};

export type BulkInviteResult = {
  __typename?: 'BulkInviteResult';
  /** Количество ошибок */
  errorCount: Scalars['Float']['output'];
  /** Список ошибок */
  errors: Array<Scalars['String']['output']>;
  /** ID созданных приглашений */
  invitationIds: Array<Scalars['ID']['output']>;
  /** Количество успешных приглашений */
  successCount: Scalars['Float']['output'];
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  attachments: Array<CalendarEventAttachment>;
  /** Количество комментариев */
  comments?: Maybe<CommentCountOutput>;
  /** Событие отмечено как выполненное */
  completed: Scalars['Boolean']['output'];
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Описание события */
  description?: Maybe<Scalars['String']['output']>;
  /** Дата и время окончания (UTC) */
  endAt: Scalars['DateTime']['output'];
  /** ID события календаря */
  id: Scalars['ID']['output'];
  /** Признак события «на весь день» */
  isAllDay: Scalars['Boolean']['output'];
  /** Является ли это событие первым (мастер) вхождением серии */
  isRecurrenceMaster: Scalars['Boolean']['output'];
  /** Местоположение / адрес проведения */
  location?: Maybe<Scalars['String']['output']>;
  /** ID владельца (создателя) события */
  ownerUserId: Scalars['ID']['output'];
  /** Список участников события */
  participants: Array<CalendarEventParticipant>;
  /** Приоритет события */
  priority: CalendarEventPriorityEnum;
  /** ID проекта; null означает личное событие пользователя */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Частота повторения серии; null — событие не повторяется */
  recurrenceFrequency?: Maybe<CalendarEventRecurrenceFrequencyEnum>;
  /** ID серии повторений (общий у всех вхождений). null — одиночное событие */
  recurrenceGroupId?: Maybe<Scalars['ID']['output']>;
  /** Интервал повторения (каждые N единиц частоты) */
  recurrenceInterval?: Maybe<Scalars['Int']['output']>;
  /** До какой даты/времени (UTC) повторяется серия */
  recurrenceUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Напоминания события. Для формы редактирования актуальны напоминания со статусом PENDING */
  reminders: Array<CalendarEventReminder>;
  /** Дата и время начала (UTC) */
  startAt: Scalars['DateTime']['output'];
  /** IANA-таймзона, в которой событие было создано */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Название события (заголовок задачи) */
  title: Scalars['String']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type CalendarEventAttachment = {
  __typename?: 'CalendarEventAttachment';
  /** Дата создания вложения */
  createdAt: Scalars['DateTime']['output'];
  /** ID события календаря */
  eventId: Scalars['ID']['output'];
  /** Ключ файла в S3/MinIO */
  fileKey: Scalars['String']['output'];
  /** Имя файла */
  fileName: Scalars['String']['output'];
  /** Размер файла в байтах */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** ID вложения */
  id: Scalars['ID']['output'];
  /** MIME-тип файла */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** ID пользователя, загрузившего файл */
  uploadedByUserId: Scalars['ID']['output'];
  /** Presigned URL для скачивания (генерируется на лету в резолвере) */
  url?: Maybe<Scalars['String']['output']>;
};

export type CalendarEventAttachmentInput = {
  /** Ключ файла в S3/MinIO */
  fileKey: Scalars['String']['input'];
  /** Имя файла, как его видит пользователь */
  fileName: Scalars['String']['input'];
  /** Размер файла в байтах */
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  /** MIME-тип файла */
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarEventDayCount = {
  __typename?: 'CalendarEventDayCount';
  /** Количество событий в этот день */
  count: Scalars['Int']['output'];
  /** Локальная дата в формате YYYY-MM-DD */
  date: Scalars['String']['output'];
  /** Есть ли в этом дне хотя бы одно событие с приоритетом IMPORTANT */
  hasImportant: Scalars['Boolean']['output'];
  /** Есть ли в этом дне хотя бы одно событие с приоритетом VERY_IMPORTANT */
  hasVeryImportant: Scalars['Boolean']['output'];
};

export type CalendarEventDayCountFilterInput = {
  /** Начало месяца/диапазона для подсчёта событий по дням */
  fromDate: Scalars['DateTime']['input'];
  /** ID проекта для фильтрации */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** Область выборки. По умолчанию ALL */
  scope?: InputMaybe<CalendarEventScopeEnum>;
  /** IANA-таймзона, в которой нужно агрегировать дни */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Конец месяца/диапазона для подсчёта событий по дням */
  toDate: Scalars['DateTime']['input'];
};

export type CalendarEventDeleteResponse = {
  __typename?: 'CalendarEventDeleteResponse';
  /** ID удалённого события */
  id: Scalars['ID']['output'];
  /** Сообщение */
  message?: Maybe<Scalars['String']['output']>;
  /** Успешность удаления */
  success: Scalars['Boolean']['output'];
};

/** Область удаления повторяющегося события: SINGLE - только это вхождение,     FUTURE - это и последующие, SERIES - вся серия */
export enum CalendarEventDeleteScopeEnum {
  Future = 'FUTURE',
  Series = 'SERIES',
  Single = 'SINGLE'
}

export type CalendarEventList = {
  __typename?: 'CalendarEventList';
  /** Есть ли следующая страница */
  hasMore: Scalars['Boolean']['output'];
  /** События */
  items: Array<CalendarEvent>;
  /** Размер страницы */
  limit: Scalars['Int']['output'];
  /** Текущая страница (с 1) */
  page: Scalars['Int']['output'];
  /** Всего событий, удовлетворяющих фильтру */
  total: Scalars['Int']['output'];
};

export type CalendarEventListFilterInput = {
  /** Начало диапазона выборки (события, заканчивающиеся раньше — отбрасываются) */
  fromDate: Scalars['DateTime']['input'];
  /** Размер страницы (макс. 500) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Только события, в которых текущий пользователь — участник */
  onlyMyParticipation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Номер страницы (с 1) */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Только события, в которых статус текущего пользователя как участника равен указанному (invited / accepted / maybe / declined). Для ACCEPTED также возвращаются события, которыми владеет пользователь (свои задачи считаются неявно принятыми). */
  participantStatus?: InputMaybe<CalendarEventParticipantStatusEnum>;
  /** Фильтр по приоритетам */
  priorities?: InputMaybe<Array<CalendarEventPriorityEnum>>;
  /** ID проекта для фильтрации */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** Область выборки: личные / проектные / все. По умолчанию ALL */
  scope?: InputMaybe<CalendarEventScopeEnum>;
  /** Поиск по заголовку/описанию (ILIKE) */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Конец диапазона выборки (события, начинающиеся позже — отбрасываются) */
  toDate: Scalars['DateTime']['input'];
};

export type CalendarEventParticipant = {
  __typename?: 'CalendarEventParticipant';
  /** Дата приглашения */
  createdAt: Scalars['DateTime']['output'];
  /** ID события календаря */
  eventId: Scalars['ID']['output'];
  /** ID записи участника */
  id: Scalars['ID']['output'];
  /** Статус участия */
  status: CalendarEventParticipantStatusEnum;
  /** Дата последнего обновления статуса */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  /** ID пользователя-участника */
  userId: Scalars['ID']['output'];
};

/** Статус участника события:     INVITED - Приглашён,     ACCEPTED - Принял,     DECLINED - Отклонил,     MAYBE - Под вопросом */
export enum CalendarEventParticipantStatusEnum {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Invited = 'INVITED',
  Maybe = 'MAYBE'
}

/** Приоритет задачи/события календаря:     STANDARD - Стандартная,     IMPORTANT - Важная,     VERY_IMPORTANT - Очень важная */
export enum CalendarEventPriorityEnum {
  Important = 'IMPORTANT',
  Standard = 'STANDARD',
  VeryImportant = 'VERY_IMPORTANT'
}

/** Частота повторения события: DAILY - каждый день, WEEKDAYS - по будням,     WEEKLY - каждую неделю, MONTHLY - каждый месяц, YEARLY - каждый год */
export enum CalendarEventRecurrenceFrequencyEnum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekdays = 'WEEKDAYS',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type CalendarEventRecurrenceInput = {
  /** Частота повторения: DAILY | WEEKDAYS | WEEKLY | MONTHLY | YEARLY */
  frequency: CalendarEventRecurrenceFrequencyEnum;
  /** Интервал: каждые N единиц частоты. По умолчанию (на сервере) 1. */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** Повторять до этой даты/времени включительно (UTC). Соответствует полям «Дата» и «Время» в окне «Повтор». */
  until: Scalars['DateTime']['input'];
};

export type CalendarEventReminder = {
  __typename?: 'CalendarEventReminder';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID события календаря */
  eventId: Scalars['ID']['output'];
  /** ID напоминания */
  id: Scalars['ID']['output'];
  /** Способ доставки напоминания */
  method: CalendarEventReminderMethodEnum;
  /** Момент отправки напоминания (UTC) */
  remindAt: Scalars['DateTime']['output'];
  /** Момент фактической отправки push (UTC), null пока не отправлено */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Статус напоминания (PENDING/SENT/…). Для формы редактирования интересны PENDING */
  status: CalendarEventReminderStatusEnum;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type CalendarEventReminderInput = {
  /** Способ доставки. По умолчанию (на сервере) — PUSH */
  method?: InputMaybe<CalendarEventReminderMethodEnum>;
  /** Момент отправки напоминания (UTC) */
  remindAt: Scalars['DateTime']['input'];
};

/** Способ доставки напоминания: PUSH - push-уведомление */
export enum CalendarEventReminderMethodEnum {
  Push = 'PUSH'
}

/** Статус напоминания: PENDING - запланировано, SENDING - в обработке,     SENT - отправлено, CANCELLED - отменено, EXPIRED - просрочено, FAILED - ошибка */
export enum CalendarEventReminderStatusEnum {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sending = 'SENDING',
  Sent = 'SENT'
}

/** Область выборки событий календаря:     PERSONAL - только личные,     PROJECT - только в рамках проекта (требуется projectId),     ALL - все доступные события */
export enum CalendarEventScopeEnum {
  All = 'ALL',
  Personal = 'PERSONAL',
  Project = 'PROJECT'
}

export type CalendarEventUsersResult = {
  __typename?: 'CalendarEventUsersResult';
  /** Участники проекта, которых можно пригласить (только для событий проекта). Каждый объект — федерированный User из ms-users. */
  availableUsers: Array<User>;
  /** Пользователи, уже являющиеся участниками события */
  participants: Array<CalendarEventParticipant>;
};

export type Comment = {
  __typename?: 'Comment';
  attachments?: Maybe<Array<MediaOutputDto>>;
  /** ID комментируемого объекта */
  commentableId: Scalars['ID']['output'];
  /** Тип комментируемого объекта */
  commentableType: CommentableTypeEnum;
  /** Текст комментария */
  content: Scalars['String']['output'];
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID пользователя, создавшего комментарий */
  createdByUserId: Scalars['ID']['output'];
  creator?: Maybe<User>;
  /** Дата удаления */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID комментария */
  id: Scalars['ID']['output'];
  likes?: Maybe<LikeOutput>;
  /** ID родительского комментария */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Квитанция прочтения комментария: кто прочитал / не прочитал (для события календаря «не прочитавшие» = аудитория задачи минус прочитавшие), и прочитал ли текущий пользователь. */
  readInfo: CommentReadInfoOutput;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** ID пользователя, обновившего комментарий */
  updatedByUserId?: Maybe<Scalars['ID']['output']>;
};


export type CommentAttachmentsArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** Array of nodes. */
  nodes: Array<Comment>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type CommentCountOutput = {
  __typename?: 'CommentCountOutput';
  /** Количество комментариев */
  commentCount: Scalars['Int']['output'];
  /** Количество непрочитанных комментариев для текущего пользователя (чужие комментарии, которые пользователь ещё не отметил прочитанными). null — если пользователь не авторизован. */
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type CommentDeleteResponse = {
  __typename?: 'CommentDeleteResponse';
  /** ID комментируемого объекта */
  commentableId?: Maybe<Scalars['ID']['output']>;
  /** Тип комментируемого объекта */
  commentableType?: Maybe<CommentableTypeEnum>;
  /** Текст комментария */
  content?: Maybe<Scalars['String']['output']>;
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя, создавшего комментарий */
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  /** Дата удаления */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID комментария */
  id?: Maybe<Scalars['ID']['output']>;
  /** ID родительского комментария */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя, обновившего комментарий */
  updatedByUserId?: Maybe<Scalars['ID']['output']>;
};

export type CommentFilter = {
  and?: InputMaybe<Array<CommentFilter>>;
  commentableId?: InputMaybe<IdFilterComparison>;
  commentableType?: InputMaybe<CommentableTypeEnumFilterComparison>;
  content?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdByUserId?: InputMaybe<IdFilterComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CommentFilter>>;
  parentId?: InputMaybe<IdFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  updatedByUserId?: InputMaybe<IdFilterComparison>;
};

export type CommentReadInfoOutput = {
  __typename?: 'CommentReadInfoOutput';
  /** Прочитал ли комментарий текущий пользователь */
  isReadByMe: Scalars['Boolean']['output'];
  /** ID пользователей, прочитавших комментарий */
  readByUserIds: Array<Scalars['ID']['output']>;
  /** Сколько пользователей прочитали */
  readCount: Scalars['Int']['output'];
  /** ID пользователей из аудитории задачи, ещё НЕ прочитавших комментарий */
  unreadByUserIds: Array<Scalars['ID']['output']>;
  /** Сколько пользователей не прочитали */
  unreadCount: Scalars['Int']['output'];
};

export type CommentSort = {
  direction: SortDirection;
  field: CommentSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CommentSortFields {
  CommentableId = 'commentableId',
  CommentableType = 'commentableType',
  Content = 'content',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  DeletedAt = 'deletedAt',
  Id = 'id',
  ParentId = 'parentId',
  UpdatedAt = 'updatedAt',
  UpdatedByUserId = 'updatedByUserId'
}

/**
 * Тип сущности, которую можно комментировать
 * PROJECT - проект
 * PHOTO - фотография
 * NEWS - новость
 * CALENDAR_EVENT - событие календаря
 */
export enum CommentableTypeEnum {
  CalendarEvent = 'CALENDAR_EVENT',
  News = 'NEWS',
  Photo = 'PHOTO',
  Project = 'PROJECT'
}

export type CommentableTypeEnumFilterComparison = {
  eq?: InputMaybe<CommentableTypeEnum>;
  gt?: InputMaybe<CommentableTypeEnum>;
  gte?: InputMaybe<CommentableTypeEnum>;
  iLike?: InputMaybe<CommentableTypeEnum>;
  in?: InputMaybe<Array<CommentableTypeEnum>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<CommentableTypeEnum>;
  lt?: InputMaybe<CommentableTypeEnum>;
  lte?: InputMaybe<CommentableTypeEnum>;
  neq?: InputMaybe<CommentableTypeEnum>;
  notILike?: InputMaybe<CommentableTypeEnum>;
  notIn?: InputMaybe<Array<CommentableTypeEnum>>;
  notLike?: InputMaybe<CommentableTypeEnum>;
};

export type ContactRequestMediaAttachmentInput = {
  /** Имя бакета MinIO (как mediaDomain в ms-media: ms-mail, ms-news, …). Секреты не в коде — только bucket. */
  bucket: Scalars['String']['input'];
  /** После getMediaUploadUrl + PUT: поле mediaStorageKey. Рекомендуется getMediaUploadUrl с mediaEntityType "contact_request" и случайным mediaEntityId (uuid). */
  objectKey: Scalars['String']['input'];
};

export type ContactRequestResponse = {
  __typename?: 'ContactRequestResponse';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  senderEmail?: Maybe<Scalars['String']['output']>;
  status: ContactRequestStatus;
  subject: Scalars['String']['output'];
};

export enum ContactRequestStatus {
  Closed = 'CLOSED',
  New = 'NEW',
  Processed = 'PROCESSED'
}

export type Counter = {
  __typename?: 'Counter';
  /** Категория счётчика */
  category: CounterCategory;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID счётчика */
  id: Scalars['ID']['output'];
  /** Название счётчика */
  name?: Maybe<Scalars['String']['output']>;
  /** Дата следующей поверки */
  nextVerificationDate?: Maybe<Scalars['DateTime']['output']>;
  project: CounterProjectConnection;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Серийный номер счётчика */
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** Тип счётчика */
  type: CounterType;
  /** Единица измерения */
  unit: Scalars['String']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** ID пользователя-владельца счётчика */
  userId: Scalars['ID']['output'];
};


export type CounterProjectArgs = {
  filter?: ProjectFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectSort>;
};

/** Категории счётчиков */
export enum CounterCategory {
  /** Электричество */
  Electro = 'ELECTRO',
  /** Отопление */
  Warm = 'WARM',
  /** Вода (холодная и горячая) */
  Water = 'WATER'
}

export type CounterCategorySummary = {
  __typename?: 'CounterCategorySummary';
  /** Категория счётчиков */
  category: CounterCategory;
  /** Счётчики в категории */
  counters: Array<CounterSummary>;
  /** Общая стоимость за текущий месяц */
  currentMonthCost: Scalars['Float']['output'];
  /** Иконка */
  icon: Scalars['String']['output'];
  /** Цвет иконки */
  iconColor: Scalars['String']['output'];
  /** Название категории */
  name: Scalars['String']['output'];
  /** Общая стоимость за год */
  yearlyCost: Scalars['Float']['output'];
};

export type CounterChartDataPoint = {
  __typename?: 'CounterChartDataPoint';
  /** Период (месяц) */
  period: Scalars['Int']['output'];
  /** Значения для диаграммы */
  values: Array<Scalars['Float']['output']>;
};

export type CounterChartLegendItem = {
  __typename?: 'CounterChartLegendItem';
  /** Цвет */
  color: Scalars['String']['output'];
  /** Название */
  label: Scalars['String']['output'];
  /** Значение */
  value: Scalars['String']['output'];
};

export type CounterDeleteResponse = {
  __typename?: 'CounterDeleteResponse';
  /** ID удалённого счётчика */
  id: Scalars['ID']['output'];
  /** Сообщение */
  message?: Maybe<Scalars['String']['output']>;
  /** Статус выполнения операции */
  success: Scalars['Boolean']['output'];
};

export type CounterEvent = {
  __typename?: 'CounterEvent';
  /** Counter Type */
  counterType: Scalars['String']['output'];
  /** Entity ID */
  entityId: Scalars['String']['output'];
  /** Entity Type */
  entityType: Scalars['String']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Timestamp */
  ts: Scalars['DateTime']['output'];
  /** User ID */
  userId?: Maybe<Scalars['String']['output']>;
};

export type CounterEventConnection = {
  __typename?: 'CounterEventConnection';
  /** Array of edges. */
  edges: Array<CounterEventEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type CounterEventDeleteResponse = {
  __typename?: 'CounterEventDeleteResponse';
  /** Counter Type */
  counterType?: Maybe<Scalars['String']['output']>;
  /** Entity ID */
  entityId?: Maybe<Scalars['String']['output']>;
  /** Entity Type */
  entityType?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Timestamp */
  ts?: Maybe<Scalars['DateTime']['output']>;
  /** User ID */
  userId?: Maybe<Scalars['String']['output']>;
};

export type CounterEventEdge = {
  __typename?: 'CounterEventEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CounterEvent */
  node: CounterEvent;
};

export type CounterEventFilter = {
  and?: InputMaybe<Array<CounterEventFilter>>;
  counterType?: InputMaybe<StringFieldComparison>;
  entityId?: InputMaybe<StringFieldComparison>;
  entityType?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CounterEventFilter>>;
  ts?: InputMaybe<DateFieldComparison>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type CounterEventNatsResponseDto = {
  __typename?: 'CounterEventNatsResponseDTO';
  /** JSON-объект с данными ответа */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Сообщение об ошибке */
  error?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  message: Scalars['String']['output'];
};

export type CounterEventSort = {
  direction: SortDirection;
  field: CounterEventSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CounterEventSortFields {
  CounterType = 'counterType',
  EntityId = 'entityId',
  EntityType = 'entityType',
  Id = 'id',
  Ts = 'ts',
  UserId = 'userId'
}

export type CounterHistory = {
  __typename?: 'CounterHistory';
  /** Данные для диаграммы */
  chartData: Array<CounterChartDataPoint>;
  /** Легенда диаграммы */
  chartLegend: Array<CounterChartLegendItem>;
  /** ID счётчика */
  counterId: Scalars['ID']['output'];
  /** Месячные данные */
  monthlyData: Array<CounterMonthlyData>;
  /** Название счётчика */
  name: Scalars['String']['output'];
  /** Тип счётчика */
  type: CounterType;
  /** Единица измерения */
  unit: Scalars['String']['output'];
  /** Год */
  year: Scalars['Int']['output'];
};

export type CounterMonthlyData = {
  __typename?: 'CounterMonthlyData';
  /** Можно ли внести показание за этот месяц */
  canEnter: Scalars['Boolean']['output'];
  /** Потребление за период */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Стоимость потребления */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Есть ли изменение по сравнению с предыдущим */
  hasDelta: Scalars['Boolean']['output'];
  /** Месяц (1-12) */
  month: Scalars['Int']['output'];
  /** Название месяца */
  monthName: Scalars['String']['output'];
  /** Показание счётчика */
  reading?: Maybe<Scalars['Float']['output']>;
  /** Дата внесения показания */
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Год */
  year: Scalars['Int']['output'];
};

export type CounterOutput = {
  __typename?: 'CounterOutput';
  counterViewed: Scalars['Float']['output'];
};

export type CounterProjectConnection = {
  __typename?: 'CounterProjectConnection';
  /** Array of nodes. */
  nodes: Array<Project>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type CounterReading = {
  __typename?: 'CounterReading';
  /** Потребление за период */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Стоимость потребления */
  cost?: Maybe<Scalars['Float']['output']>;
  /** ID счётчика */
  counterId: Scalars['ID']['output'];
  /** Дата создания записи */
  createdAt: Scalars['DateTime']['output'];
  /** ID показания */
  id: Scalars['ID']['output'];
  /** Месяц показания (1-12) */
  month: Scalars['Int']['output'];
  /** Примечание */
  note?: Maybe<Scalars['String']['output']>;
  /** Показание счётчика */
  reading: Scalars['Float']['output'];
  /** Дата внесения показания */
  recordedAt: Scalars['DateTime']['output'];
  /** ID пользователя, внёсшего показание */
  recordedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Дата обновления записи */
  updatedAt: Scalars['DateTime']['output'];
  /** Год показания */
  year: Scalars['Int']['output'];
};

export type CounterReadingConnection = {
  __typename?: 'CounterReadingConnection';
  /** Array of nodes. */
  nodes: Array<CounterReading>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type CounterReadingDeleteResponse = {
  __typename?: 'CounterReadingDeleteResponse';
  /** ID удалённого показания */
  id: Scalars['ID']['output'];
  /** Сообщение */
  message?: Maybe<Scalars['String']['output']>;
  /** Статус выполнения операции */
  success: Scalars['Boolean']['output'];
};

export type CounterReadingFilter = {
  and?: InputMaybe<Array<CounterReadingFilter>>;
  counterId?: InputMaybe<IdFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  month?: InputMaybe<IntFieldComparison>;
  or?: InputMaybe<Array<CounterReadingFilter>>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  year?: InputMaybe<IntFieldComparison>;
};

export type CounterReadingSort = {
  direction: SortDirection;
  field: CounterReadingSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CounterReadingSortFields {
  CounterId = 'counterId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Month = 'month',
  UpdatedAt = 'updatedAt',
  Year = 'year'
}

export type CounterSummary = {
  __typename?: 'CounterSummary';
  /** Категория счётчика */
  category: CounterCategory;
  /** Текущее потребление за месяц */
  currentConsumption?: Maybe<Scalars['Float']['output']>;
  /** Текущая стоимость за месяц */
  currentCost?: Maybe<Scalars['Float']['output']>;
  /** ID счётчика */
  id: Scalars['ID']['output'];
  /** Последнее показание */
  lastReading?: Maybe<Scalars['Float']['output']>;
  /** Название счётчика */
  name: Scalars['String']['output'];
  /** Тип счётчика */
  type: CounterType;
  /** Единица измерения */
  unit: Scalars['String']['output'];
  /** Общее потребление за год */
  yearlyConsumption?: Maybe<Scalars['Float']['output']>;
  /** Общая стоимость за год */
  yearlyCost?: Maybe<Scalars['Float']['output']>;
};

/** Типы счётчиков */
export enum CounterType {
  /** Холодная вода */
  ColdWater = 'COLD_WATER',
  /** Электричество (свет) */
  Electricity = 'ELECTRICITY',
  /** Отопление (тепло) */
  Heat = 'HEAT',
  /** Горячая вода */
  HotWater = 'HOT_WATER'
}

export type CreateAnswerDto = {
  /** Массив значений для множественного выбора */
  arrayValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Дополнительные данные (валюта, единица измерения и т.д.) */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Числовое значение (для цены, веса) */
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  /** ID вопроса */
  questionId: Scalars['String']['input'];
  /** ID пользователя, отвечающего на вопрос */
  respondentUserId: Scalars['String']['input'];
  /** Текстовое значение ответа (для текста, адреса, телефона, email) */
  textValue?: InputMaybe<Scalars['String']['input']>;
  /** Временное значение в формате ISO8601 */
  timeValue?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCalendarEventInput = {
  /** Вложения, уже загруженные в S3/MinIO */
  attachments?: InputMaybe<Array<CalendarEventAttachmentInput>>;
  /** Событие выполнено. По умолчанию false */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Описание события */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Дата и время окончания события (UTC) */
  endAt: Scalars['DateTime']['input'];
  /** Признак события «на весь день». По умолчанию false */
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Местоположение / адрес проведения */
  location?: InputMaybe<Scalars['String']['input']>;
  /** ID пользователей-участников. Будут добавлены со статусом INVITED */
  participantUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Приоритет события. По умолчанию — STANDARD */
  priority?: InputMaybe<CalendarEventPriorityEnum>;
  /** ID проекта. Если не указан — событие будет личным */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** Повтор задачи. Если задано — создаётся серия событий-вхождений (см. окно «Повтор»); возвращается первое (мастер-вхождение). */
  recurrence?: InputMaybe<CalendarEventRecurrenceInput>;
  /** Напоминания о задаче. Каждое — момент времени (UTC), в который придёт push владельцу и активным участникам события */
  reminders?: InputMaybe<Array<CalendarEventReminderInput>>;
  /** Дата и время начала события (UTC) */
  startAt: Scalars['DateTime']['input'];
  /** IANA-таймзона создателя (например, Europe/Moscow) */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Название события */
  title: Scalars['String']['input'];
};

export type CreateCommentDto = {
  /** ID комментируемого объекта */
  commentableId: Scalars['String']['input'];
  /** Тип комментируемого объекта */
  commentableType: CommentableTypeEnum;
  /** Содержание комментария */
  content: Scalars['String']['input'];
  /** ID родительского комментария */
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCounterEventDto = {
  /** Counter Type */
  counterType: Scalars['String']['input'];
  /** Entity ID */
  entityId: Scalars['String']['input'];
  /** Entity Type */
  entityType: Scalars['String']['input'];
  /** User ID */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCounterInput = {
  /** Категория счётчика */
  category: CounterCategory;
  /** Название счётчика */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Дата следующей поверки */
  nextVerificationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** Серийный номер счётчика */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Тип счётчика */
  type: CounterType;
  /** Единица измерения */
  unit: Scalars['String']['input'];
};

export type CreateCounterReadingInput = {
  /** Потребление за период */
  consumption?: InputMaybe<Scalars['Float']['input']>;
  /** Стоимость потребления */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** ID счётчика */
  counterId: Scalars['ID']['input'];
  /** Месяц показания (1-12) */
  month: Scalars['Int']['input'];
  /** Примечание */
  note?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта (для авторизации) */
  projectId: Scalars['ID']['input'];
  /** Показание счётчика */
  reading: Scalars['Float']['input'];
  /** Дата внесения показания */
  recordedAt: Scalars['DateTime']['input'];
  /** Год показания */
  year: Scalars['Int']['input'];
};

export type CreateDirectInvitationInput = {
  /** ID приглашаемого пользователя */
  invitedUserId: Scalars['ID']['input'];
  /** Сообщение для приглашаемого пользователя */
  message?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта */
  projectId: Scalars['ID']['input'];
};

export type CreateEmergencyContactInput = {
  /** Категория контакта */
  category: EmergencyContactCategoryEnum;
  /** Наименование (название организации или ФИО человека) */
  name: Scalars['String']['input'];
  /** Номер телефона */
  phoneNumber: Scalars['String']['input'];
  /** ID проекта */
  projectId: Scalars['String']['input'];
};

export type CreateInvitationLinkInput = {
  /** Количество дней до истечения ссылки (по умолчанию 30) */
  expiresInDays?: InputMaybe<Scalars['Float']['input']>;
  /** ID проекта */
  projectId: Scalars['ID']['input'];
};

export type CreateInviteDto = {
  channel: InviteChannel;
  /** Email получателя */
  email?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID приглашенного пользователя (для персонального приглашения) */
  invitedUserId?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  maxResponses?: Scalars['Float']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Телефон получателя */
  phone?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};

export type CreateJoinRequestInput = {
  /** Сообщение владельцу проекта */
  message?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта */
  projectId: Scalars['ID']['input'];
};

export type CreateLandingTemplateInput = {
  content: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** ID проекта (либо projectId, либо projectRequestId) */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** ID заявки на проект — черновик шаблона до одобрения */
  projectRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateLikeDto = {
  /** ID сущности, которую лайкают */
  likeableId: Scalars['String']['input'];
  /** Тип сущности, которую лайкают */
  likeableType: LikeableTypeEnum;
};

export type CreateMailThreadInput = {
  /** Содержимое первого сообщения (TipTap JSON) */
  content: Scalars['JSON']['input'];
  /** Слаг модуля обращений */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** ID получателя обращения */
  recipientUserId: Scalars['ID']['input'];
  /** Тема обращения */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyLandingTemplatesInput = {
  /** Array of records to create */
  landingTemplates: Array<CreateLandingTemplateInput>;
};

export type CreateMergeRequestDto = {
  /** ID проекта-источника сторонников */
  fromProjectId: Scalars['ID']['input'];
  /** Сообщение к заявке на слияние */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Список ID сторонников для включения в снимок */
  supporterIds: Array<Scalars['ID']['input']>;
  /** ID проекта-получателя сторонников */
  toProjectId: Scalars['ID']['input'];
};

export type CreateMockupInput = {
  /** Описание макета */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Имя файла с расширением */
  fileName: Scalars['String']['input'];
  /** Размер файла в байтах */
  fileSize: Scalars['Float']['input'];
  /** MIME тип файла */
  mimeType: Scalars['String']['input'];
  /** Название макета */
  name: Scalars['String']['input'];
  /** ID проекта (обязательно для типа PROJECT) */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** Тип макета (SYSTEM или PROJECT) */
  type: MockupTypeEnum;
};

export type CreateMockupResponse = {
  __typename?: 'CreateMockupResponse';
  /** ID созданного макета */
  id: Scalars['ID']['output'];
  /** Название макета */
  name: Scalars['String']['output'];
  /** Тип макета */
  type: MockupTypeEnum;
  /** Presigned URL для загрузки файла */
  uploadUrl: Scalars['String']['output'];
};

export type CreateNewsDto = {
  /** Дополнительная информация для новости-выступления */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Полное имя автора новости */
  authorFullname?: InputMaybe<Scalars['String']['input']>;
  /** ID автора новости */
  authorUserId: Scalars['String']['input'];
  /** Содержание новости */
  content?: InputMaybe<Scalars['JSON']['input']>;
  /** Ключи объектов (MinIO) для дополнительных фотографий, загруженных вне редактора через newsPresignedPutUrl. Поле опциональное. */
  customPhotos?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ключи объектов (MinIO) для дополнительных видео, загруженных вне редактора через newsPresignedPutUrl. Поле опциональное. */
  customVideos?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ФИО в рукописном формате для новости-выступления */
  handwrittenFullname?: InputMaybe<Scalars['String']['input']>;
  /** Список хештегов для новости */
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** URL главного изображения */
  mainImage?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля, к которому относится новость (по умолчанию project_news) */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  /** ID владельца новости (user, project, or company) */
  ownerId: Scalars['String']['input'];
  /** Тип владельца новости */
  ownerType: NewsOwnerTypeEnum;
  /** Настройки опроса, который будет прикреплён к новости */
  poll?: InputMaybe<CreateNewsPollInput>;
  /** «Первоисточник» — ссылка на исходный материал / пермалинк */
  sourceLink?: InputMaybe<Scalars['String']['input']>;
  /** Начальный статус новости. По умолчанию будет установлен DRAFT. */
  status?: InputMaybe<NewsStatusEnum>;
  /** Заголовок новости */
  title: Scalars['String']['input'];
};

export type CreateNewsPollInput = {
  /** Объяснение к опросу (опционально) */
  explanation?: InputMaybe<Scalars['String']['input']>;
  /** Анонимное ли голосование (не отображать участников) */
  isAnonymous?: Scalars['Boolean']['input'];
  /** Разрешён ли выбор нескольких вариантов */
  isMultipleChoice?: Scalars['Boolean']['input'];
  /** Режим викторины (обязательны правильные ответы) */
  isQuizMode?: Scalars['Boolean']['input'];
  /** Список вариантов ответа (минимум 2, максимум 11) */
  options: Array<CreateNewsPollOptionInput>;
  /** Вопрос голосования */
  question: Scalars['String']['input'];
};

export type CreateNewsPollOptionInput = {
  /** Признак правильного ответа */
  isCorrect?: Scalars['Boolean']['input'];
  /** Текст варианта ответа */
  title: Scalars['String']['input'];
};

export type CreateObjectPassportApplicationInput = {
  /** Дополнительная информация */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Текст обращения («Прошу согласовать моё участие…») */
  applicationText?: InputMaybe<Scalars['String']['input']>;
  /** ФИО заявителя */
  fullName: Scalars['String']['input'];
  /** Формат участия (очно / заочно) */
  participationFormat?: InputMaybe<ObjectPassportParticipationFormatEnum>;
  /** ID паспорта, к которому подаётся заявка */
  passportId: Scalars['ID']['input'];
  /** Номер телефона */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Должность / статус */
  position?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneAnswerInput = {
  /** The record to create */
  answer: CreateAnswerDto;
};

export type CreateOneCommentInput = {
  /** The record to create */
  comment: CreateCommentDto;
};

export type CreateOneCounterEventInput = {
  /** The record to create */
  counterEvent: CreateCounterEventDto;
};

export type CreateOneLandingTemplateInput = {
  /** The record to create */
  landingTemplate: CreateLandingTemplateInput;
};

export type CreateOneLikeInput = {
  /** The record to create */
  like: CreateLikeDto;
};

export type CreateOneNewsInput = {
  /** The record to create */
  news: CreateNewsDto;
};

export type CreateOneProjectInput = {
  /** The record to create */
  project: CreateProjectDto;
};

export type CreateOneProjectMemberInput = {
  /** The record to create */
  projectMember: CreateProjectMemberDto;
};

export type CreateOneProjectModuleMemberInput = {
  /** The record to create */
  projectModuleMember: CreateProjectModuleMemberDto;
};

export type CreateOneProjectOrganizationInput = {
  /** The record to create */
  projectOrganization: CreateOrganizationDto;
};

export type CreateOneProjectSupporterInput = {
  /** The record to create */
  projectSupporter: CreateSupporterDto;
};

export type CreateOneQuestionDtoInput = {
  /** The record to create */
  questionDto: CreateQuestionDto;
};

export type CreateOneQuestionFieldDtoInput = {
  /** The record to create */
  questionFieldDto: CreateQuestionFieldDto;
};

export type CreateOneSurveyDtoInput = {
  /** The record to create */
  surveyDto: CreateSurveyDto;
};

export type CreateOneUserVerifyRequestInput = {
  /** The record to create */
  userVerifyRequest: CreateUserVerifyRequestDto;
};

export type CreateOptionInputDto = {
  isOther?: Scalars['Boolean']['input'];
  order: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreateOrganizationDto = {
  /** Комментарий к адресу организации */
  companyAddressComment?: InputMaybe<Scalars['String']['input']>;
  /** JSON-объект адреса организации. */
  companyAddressJSON?: InputMaybe<Scalars['JSON']['input']>;
  /** Город организации */
  companyCity?: InputMaybe<Scalars['String']['input']>;
  /** Район города организации */
  companyCityDistrict?: InputMaybe<Scalars['String']['input']>;
  /** Email организации */
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  /** Офис организации */
  companyFlat?: InputMaybe<Scalars['String']['input']>;
  /** ИНН организации (10 или 12 цифр) */
  companyInn?: InputMaybe<Scalars['String']['input']>;
  /** Флаг ручного ввода адреса организации */
  companyIsManual?: InputMaybe<Scalars['Boolean']['input']>;
  /** КПП организации (9 цифр) */
  companyKpp?: InputMaybe<Scalars['String']['input']>;
  /** Полное наименование организации */
  companyName: Scalars['String']['input'];
  /** ОГРН организации (13 или 15 цифр) */
  companyOgrn?: InputMaybe<Scalars['String']['input']>;
  /** Телефон организации */
  companyPhone?: InputMaybe<Scalars['String']['input']>;
  /** Должность представителя */
  companyPosition?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс организации */
  companyPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Область организации */
  companyRegion?: InputMaybe<Scalars['String']['input']>;
  /** Поселение организации */
  companySettlement?: InputMaybe<Scalars['String']['input']>;
  /** Краткое наименование организации */
  companyShortName?: InputMaybe<Scalars['String']['input']>;
  /** Улица и дом организации */
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  /** Email представителя */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Имя представителя */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Дата праздничного дня */
  holidayDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Название праздничного дня */
  holidayName?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия представителя */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Отчество представителя */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля реестра. По умолчанию основной модуль supporters. */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  /** Телефон представителя */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта */
  projectId: Scalars['String']['input'];
};

export type CreateProgramItemInput = {
  /** Вложения «Карта проезда/прохода» (изображения и PDF). Уже загружены в S3/MinIO */
  attachments?: InputMaybe<Array<ProgramItemAttachmentInput>>;
  /** Контактное лицо (отображаемое имя/ФИО) */
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  /** Контактное лицо — ссылка на пользователя платформы */
  contactPersonUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Дата и время окончания (UTC) */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Место проведения */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Слаг экземпляра кастомного модуля (program[_<suffix>]) */
  moduleSlug: Scalars['String']['input'];
  /** Наименование мероприятия */
  name: Scalars['String']['input'];
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** Порядок карточки в списке */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Дата и время начала (UTC) */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** IANA-таймзона создателя (например, Europe/Moscow) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProjectCustomModuleInput = {
  /** Дополнительная информация для модуля */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Цвет фона модуля */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Базовый тип модуля (news, survey, supporters, mail, object_passport, program, reglament) */
  baseModuleType: CustomModuleBaseTypeEnum;
  /** Формат отображения модуля */
  format?: InputMaybe<CustomModuleFormatEnum>;
  /** Подпись (ФИО от руки) для модуля */
  handwrittenFullname?: InputMaybe<Scalars['String']['input']>;
  /** Иконка модуля (URL или название иконки) */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Цвет иконки модуля */
  iconColor?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля (уникальный в рамках проекта, lowercase_snake_case) */
  moduleSlug: Scalars['String']['input'];
  /** Название модуля */
  name: Scalars['String']['input'];
  /** ID проекта (либо projectId, либо projectRequestId) */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** ID заявки на проект — черновик модуля до одобрения (либо projectId, либо это поле) */
  projectRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateProjectDto = {
  /** Подробное описание проекта */
  detailedDescription?: InputMaybe<Scalars['String']['input']>;
  /** Дата окончания проекта в формате ISO8601. Если не указана, проект считается бесконечным (без даты окончания) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Кнопки гамбургер-меню проекта (произвольная JSON-структура). Если не передано — пустой массив. */
  hamburgerButtons?: InputMaybe<Scalars['JSON']['input']>;
  /** Кнопки шапки (header) проекта (произвольная JSON-структура). Если не передано — пустой массив. */
  headerButtons?: InputMaybe<Scalars['JSON']['input']>;
  /** Кастомные модули при создании (только для классического проекта) */
  initialCustomModules?: InputMaybe<Array<InitialProjectCustomModuleInput>>;
  /** Опубликован ли проект. Необязательно: если не передано — true. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Название проекта. Если не передано — сохраняется пустая строка. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID пользователя, владельца проекта */
  ownerUserId: Scalars['String']['input'];
  /** URL или ID объекта minio, представляющего фотографию проекта */
  photo?: InputMaybe<Scalars['String']['input']>;
  /** Запросы на добавление в проект */
  projectRequestId?: InputMaybe<Scalars['String']['input']>;
  /** Краткое описание проекта. Если не передано — сохраняется пустая строка. */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** URL-дружелюбный слаг проекта (опционально) */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Дата начала проекта */
  startDate: Scalars['String']['input'];
  /** Шаблон проекта (classic или deputy) */
  templateType?: ProjectTemplateEnum;
  /** Темы проекта. Если не передан или пуст — подставляется тема по умолчанию (ALL). */
  themes?: InputMaybe<Array<ProjectThemeEnum>>;
  /** Тип видимости проекта */
  visibility: ProjectVisibilityEnum;
  /** Пресет нативных модулей (ЖКХ). Для типового проекта (deputy) обязателен. */
  workspacePreset?: InputMaybe<ProjectWorkspacePresetEnum>;
};

export type CreateProjectMemberDto = {
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** Роль пользователя в проекте */
  role: ProjectMemberRoleEnum;
  /** ID пользователя */
  userId: Scalars['ID']['input'];
};

export type CreateProjectModuleMemberDto = {
  /** Слаг модуля проекта */
  moduleSlug: Scalars['String']['input'];
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** ID участника проекта */
  projectMemberId: Scalars['ID']['input'];
  /** Роль пользователя в модуле проекта */
  role?: InputMaybe<ProjectModuleRoleEnum>;
};

export type CreateProjectRequestDto = {
  /** Подробное описание проекта */
  detailedDescription?: InputMaybe<Scalars['String']['input']>;
  /** Дата окончания проекта. Если не указана - проект считается бесконечным */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Кастомные модули при создании (только классический проект) */
  initialCustomModules?: InputMaybe<Array<InitialProjectCustomModuleInput>>;
  /** Опубликована ли заявка. Необязательно: если не передано — true. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Название проекта. Если не передано — сохраняется пустая строка. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ключ объекта MinIO логотипа проекта (например unprocessed/{id}/original.webp) */
  photo?: InputMaybe<Scalars['String']['input']>;
  /** Краткое описание проекта. Если не передано — сохраняется пустая строка. */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** Дата начала проекта */
  startDate: Scalars['DateTime']['input'];
  /** Вид проекта: классический или типовой (deputy) */
  templateType?: InputMaybe<ProjectTemplateEnum>;
  /** Темы проекта. Если не передан или пуст — подставляется тема по умолчанию (ALL). */
  themes?: InputMaybe<Array<ProjectThemeEnum>>;
  /** Видимость проекта смотри описание множества */
  visibility: ProjectVisibilityEnum;
  /** Пресет модулей (ЖКХ). Для типового проекта обязателен. */
  workspacePreset?: InputMaybe<ProjectWorkspacePresetEnum>;
};

export type CreateQuestionDto = {
  /** Описание вопроса */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Обязателен ли вопрос */
  isRequired?: Scalars['Boolean']['input'];
  /** Дополнительные настройки вопроса */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Варианты ответов для вопросов с выбором */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Порядок вопроса в опросе */
  order: Scalars['Float']['input'];
  /** ID опроса */
  surveyId: Scalars['String']['input'];
  /** Название вопроса */
  title: Scalars['String']['input'];
};

export type CreateQuestionFieldDto = {
  answerExplanation?: InputMaybe<Scalars['String']['input']>;
  answerValidationType?: InputMaybe<Scalars['String']['input']>;
  /** Правильный ответ */
  correctAnswer?: InputMaybe<Scalars['JSON']['input']>;
  correctAnswerPattern?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order: Scalars['Float']['input'];
  questionId: Scalars['ID']['input'];
  type: QuestionFieldType;
  value?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type CreateQuestionFieldInputDto = {
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order: Scalars['Float']['input'];
  type: QuestionFieldType;
  value?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type CreateQuestionFullInputDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<CreateQuestionFieldInputDto>;
  isRequired?: Scalars['Boolean']['input'];
  options?: InputMaybe<Array<CreateOptionInputDto>>;
  order: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type CreateReglamentItemInput = {
  /** Дата и время окончания выступления (UTC) */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Слаг экземпляра кастомного модуля (reglament[_<suffix>]) */
  moduleSlug: Scalars['String']['input'];
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** Конец времени на вопросы (UTC) */
  questionsEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Начало времени на вопросы (UTC) */
  questionsStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Тема доклада */
  reportTopic?: InputMaybe<Scalars['String']['input']>;
  /** Порядок строки в списке */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** ФИО выступающего */
  speakerName: Scalars['String']['input'];
  /** Дата и время начала выступления (UTC) */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** IANA-таймзона создателя (например, Europe/Moscow) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupporterDto = {
  /** Комментарий (comment). */
  addressComment?: InputMaybe<Scalars['String']['input']>;
  /** JSON-объект адреса. */
  addressJSON?: InputMaybe<Scalars['JSON']['input']>;
  /** Дата рождения */
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** Город (city). */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Район города (city_district). */
  cityDistrict?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий к адресу компании. */
  companyAddressComment?: InputMaybe<Scalars['String']['input']>;
  /** JSON-объект адреса компании. */
  companyAddressJSON?: InputMaybe<Scalars['JSON']['input']>;
  /** Город компании. */
  companyCity?: InputMaybe<Scalars['String']['input']>;
  /** Район города компании. */
  companyCityDistrict?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий к компании. */
  companyComment?: InputMaybe<Scalars['String']['input']>;
  /** Домофон компании. */
  companyDoorphone?: InputMaybe<Scalars['String']['input']>;
  /** Email компании. */
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  /** Подъезд компании. */
  companyEntrance?: InputMaybe<Scalars['String']['input']>;
  /** Квартира компании. */
  companyFlat?: InputMaybe<Scalars['String']['input']>;
  /** Этаж компании. */
  companyFloor?: InputMaybe<Scalars['String']['input']>;
  /** ИНН компании (10 или 12 цифр). */
  companyInn?: InputMaybe<Scalars['String']['input']>;
  /** Флаг ручного ввода адреса компании. */
  companyIsManual?: InputMaybe<Scalars['Boolean']['input']>;
  /** КПП компании (9 цифр). */
  companyKpp?: InputMaybe<Scalars['String']['input']>;
  /** Название компании. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** ОГРН компании (13 или 15 цифр). */
  companyOgrn?: InputMaybe<Scalars['String']['input']>;
  /** Телефон компании. */
  companyPhone?: InputMaybe<Scalars['String']['input']>;
  /** Должность в компании. */
  companyPosition?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс компании. */
  companyPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Область компании. */
  companyRegion?: InputMaybe<Scalars['String']['input']>;
  /** Поселение компании. */
  companySettlement?: InputMaybe<Scalars['String']['input']>;
  /** Улица и дом компании. */
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  /** Домофон (doorphone). */
  doorphone?: InputMaybe<Scalars['String']['input']>;
  /** Email сторонника */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Подъезд (entrance). */
  entrance?: InputMaybe<Scalars['String']['input']>;
  /** Имя сторонника */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Квартира (flat/apartment). */
  flat?: InputMaybe<Scalars['String']['input']>;
  /** Этаж (floor). */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** Пол сторонника */
  gender?: InputMaybe<SupporterGender>;
  /** Дата праздничного дня */
  holidayDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Название праздничного дня */
  holidayName?: InputMaybe<Scalars['String']['input']>;
  /** Флаг, указывающий, был ли адрес введён вручную (true) или найден через DaData (false). */
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  /** Фамилия сторонника */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Отчество сторонника */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля реестра. По умолчанию основной модуль supporters. */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  /** Телефон сторонника */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс (postalCode). */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта */
  projectId: Scalars['String']['input'];
  /** Область (region). */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Поселение (settlement). */
  settlement?: InputMaybe<Scalars['String']['input']>;
  /** Улица и дом (street). */
  street?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSurveyDto = {
  allowAnonymous?: Scalars['Boolean']['input'];
  allowEditResponse?: Scalars['Boolean']['input'];
  allowMultipleResponses?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля опросов. По умолчанию основной модуль project_survey. */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  responseDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  status?: SurveyStatus;
  title: Scalars['String']['input'];
};

export type CreateSurveyFullDto = {
  allowAnonymous?: Scalars['Boolean']['input'];
  allowEditResponse?: Scalars['Boolean']['input'];
  allowMultipleResponses?: Scalars['Boolean']['input'];
  allowRetake?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isTest?: Scalars['Boolean']['input'];
  /** Слаг модуля опросов. По умолчанию основной модуль project_survey. */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  questions: Array<CreateQuestionFullInputDto>;
  responseDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};

export type CreateTemplateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CreateUploadUrlDto = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserVerifyRequestDto = {
  /** Статус запроса на верификацию пользователя */
  status: UserVerifyRequestStatusEnum;
  /** ID пользователя */
  userId: Scalars['ID']['input'];
};

export type CurrentUserGlobalModuleCapabilities = {
  __typename?: 'CurrentUserGlobalModuleCapabilities';
  /** Может редактировать записи (настроено право редактирования или полный доступ) */
  canEdit: Scalars['Boolean']['output'];
  /** Может редактировать ЛЮБЫЕ записи (all_records), а не только свои */
  canEditAllRecords: Scalars['Boolean']['output'];
  /** Может добавлять записи (внесение / data_entry) */
  canInsert: Scalars['Boolean']['output'];
  /** Полный доступ (в списке «Полный доступ» или квест-админ) */
  hasFullAccess: Scalars['Boolean']['output'];
  /** Slug глобального модуля (например news_digest) */
  moduleSlug: Scalars['String']['output'];
};

export type CurrentUserProjectModuleCapabilities = {
  __typename?: 'CurrentUserProjectModuleCapabilities';
  /** Может редактировать записи (edit capability настроен) */
  canEdit: Scalars['Boolean']['output'];
  /** Может редактировать любые записи (all_records), а не только свои */
  canEditAllRecords: Scalars['Boolean']['output'];
  /** Может добавлять записи (data_entry / insert rows) */
  canInsert: Scalars['Boolean']['output'];
  /** Может видеть модуль на рабочем столе (show) */
  canShow: Scalars['Boolean']['output'];
  /** Может просматривать записи модуля (view / read rows) */
  canView: Scalars['Boolean']['output'];
  /** Полный доступ: владелец проекта или участник в списке «Полный доступ» */
  hasFullAccess: Scalars['Boolean']['output'];
  /** Slug модуля */
  moduleSlug: Scalars['String']['output'];
};

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Базовый тип кастомного модуля: NEWS — новости, SURVEY — опросы, SUPPORTERS — сторонники, MAIL — обращения, OBJECT_PASSPORT — паспорт объекта (мероприятия) с заявками на участие, PROGRAM — программа мероприятия (список мероприятий с картой проезда), REGLAMENT — регламент мероприятия (список выступлений с таймингами) */
export enum CustomModuleBaseTypeEnum {
  Mail = 'MAIL',
  News = 'NEWS',
  ObjectPassport = 'OBJECT_PASSPORT',
  Program = 'PROGRAM',
  Reglament = 'REGLAMENT',
  Supporters = 'SUPPORTERS',
  Survey = 'SURVEY'
}

/** Формат отображения кастомного модуля: HORIZONTAL — горизонтальный, VERTICAL — вертикальный */
export enum CustomModuleFormatEnum {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type DateRangeInput = {
  /** Начало периода */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** Конец периода */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeclineInvitationInput = {
  /** ID приглашения */
  invitationId: Scalars['ID']['input'];
};

export type DeleteCalendarEventInput = {
  /** ID удаляемого события */
  id: Scalars['ID']['input'];
  /** Для повторяющихся событий: SINGLE — только это вхождение (по умолчанию, если не передано), FUTURE — это и последующие, SERIES — вся серия */
  scope?: InputMaybe<CalendarEventDeleteScopeEnum>;
};

export type DeleteCounterInput = {
  /** ID счётчика для удаления */
  id: Scalars['ID']['input'];
  /** ID проекта (для авторизации) */
  projectId: Scalars['ID']['input'];
};

export type DeleteCounterReadingInput = {
  /** ID показания для удаления */
  id: Scalars['ID']['input'];
  /** ID проекта (для авторизации) */
  projectId: Scalars['ID']['input'];
};

export type DeleteEmergencyContactInput = {
  /** ID контакта для удаления */
  id: Scalars['ID']['input'];
  /** ID проекта (для проверки прав доступа) */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteManyLandingTemplatesInput = {
  /** Filter to find records to delete */
  filter: LandingTemplateDeleteFilter;
};

export type DeleteManyQuestionDtosInput = {
  /** Filter to find records to delete */
  filter: QuestionDtoDeleteFilter;
};

export type DeleteManyResponse = {
  __typename?: 'DeleteManyResponse';
  /** The number of records deleted. */
  deletedCount: Scalars['Int']['output'];
};

export type DeleteManySurveyDtosInput = {
  /** Filter to find records to delete */
  filter: SurveyDtoDeleteFilter;
};

export type DeleteOneAnswerInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneCommentInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneCounterEventInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneLandingTemplateInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneLikeInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneNewsInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneProjectInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneProjectMemberInput = {
  /** ID участника */
  id: Scalars['ID']['input'];
  /** ID проекта */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteOneProjectModuleMemberInput = {
  /** ID участника модуля */
  id: Scalars['ID']['input'];
  /** ID проекта */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteOneProjectOrganizationInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneProjectSupporterInput = {
  /** ID сторонника */
  id: Scalars['ID']['input'];
  /** ID проекта */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteOneQuestionDtoInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneQuestionFieldDtoInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneSurveyDtoInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneUserVerifyRequestInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteProjectMembersByUserIdsInput = {
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** Массив ID пользователей для удаления из проекта */
  userIds: Array<Scalars['ID']['input']>;
};

export type DeleteProjectMembersResult = {
  __typename?: 'DeleteProjectMembersResult';
  /** Массив ID успешно удалённых участников */
  deletedMemberIds: Array<Scalars['ID']['output']>;
  /** Массив участников, которых не удалось удалить */
  failedDeletions?: Maybe<Array<FailedDeletion>>;
  /** Количество неудачных попыток удаления */
  failureCount: Scalars['Float']['output'];
  /** Количество успешно удалённых участников */
  successCount: Scalars['Float']['output'];
};

export type DeleteRegistryContactsInput = {
  /** ID контактов для удаления */
  contactIds: Array<Scalars['ID']['input']>;
  /** Типы контактов для удаления */
  contactTypes: Array<RegistryContactTypeEnum>;
  /** ID проекта */
  projectId: Scalars['ID']['input'];
};

export type DeleteRegistryContactsResult = {
  __typename?: 'DeleteRegistryContactsResult';
  /** Удаленные контакты */
  deleted: Array<DeletedContactResult>;
  /** Ошибки удаления */
  failed: Array<FailedContactDeletion>;
};

export type DeletedContactResult = {
  __typename?: 'DeletedContactResult';
  /** Тип контакта */
  contactType: RegistryContactTypeEnum;
  /** ID удаленного контакта */
  id: Scalars['ID']['output'];
};

export type DesktopVariation = {
  __typename?: 'DesktopVariation';
  FRIENDS_CARD?: Maybe<Scalars['String']['output']>;
  FRIENDS_MINI_AVATAR?: Maybe<Scalars['String']['output']>;
  ORIGINAL?: Maybe<Scalars['String']['output']>;
  PROFILE?: Maybe<Scalars['String']['output']>;
};

/** Allowed device types for online status */
export enum DeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type DuplicateCalendarEventInput = {
  /** Дата и время окончания копии. По умолчанию — как у исходного; если указан только startAt, длительность сохраняется от исходного */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID исходного события для копирования */
  eventId: Scalars['ID']['input'];
  /** Скопировать участников (со статусом INVITED). По умолчанию true */
  includeParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  /** Дата и время начала копии. По умолчанию — как у исходного события */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Название копии. По умолчанию — «{исходное название} (копия)» */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  /** Категория контакта */
  category: EmergencyContactCategoryEnum;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID контакта экстренной службы */
  id: Scalars['ID']['output'];
  /** Наименование (название организации или ФИО человека) */
  name: Scalars['String']['output'];
  /** Номер телефона */
  phoneNumber: Scalars['String']['output'];
  project: EmergencyContactProjectConnection;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};


export type EmergencyContactProjectArgs = {
  filter?: ProjectFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectSort>;
};

/** Категория контакта экстренной службы:     HEAT - Тепло,     WATER - Вода,     GAS - Газ,     ELECTRICITY - Свет,     HOSPITAL - Больница,     POLICE - Полиция,     MANAGEMENT_COMPANY - Управляющая компания,     CITY_ADMINISTRATION - Администрация города */
export enum EmergencyContactCategoryEnum {
  CityAdministration = 'CITY_ADMINISTRATION',
  Electricity = 'ELECTRICITY',
  Gas = 'GAS',
  Heat = 'HEAT',
  Hospital = 'HOSPITAL',
  ManagementCompany = 'MANAGEMENT_COMPANY',
  Police = 'POLICE',
  Water = 'WATER'
}

export type EmergencyContactCategoryFilterComparison = {
  eq?: InputMaybe<EmergencyContactCategoryEnum>;
  in?: InputMaybe<Array<EmergencyContactCategoryEnum>>;
};

export type EmergencyContactConnection = {
  __typename?: 'EmergencyContactConnection';
  /** Array of nodes. */
  nodes: Array<EmergencyContact>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type EmergencyContactDeleteResponse = {
  __typename?: 'EmergencyContactDeleteResponse';
  /** ID удаленного контакта */
  id: Scalars['ID']['output'];
  /** Сообщение */
  message?: Maybe<Scalars['String']['output']>;
  /** Успешность удаления */
  success: Scalars['Boolean']['output'];
};

export type EmergencyContactFilter = {
  and?: InputMaybe<Array<EmergencyContactFilter>>;
  category?: InputMaybe<EmergencyContactCategoryFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EmergencyContactFilter>>;
  phoneNumber?: InputMaybe<StringFieldComparison>;
  project?: InputMaybe<EmergencyContactFilterProjectFilter>;
  projectId?: InputMaybe<IdFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type EmergencyContactFilterProjectFilter = {
  and?: InputMaybe<Array<EmergencyContactFilterProjectFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  detailedDescription?: InputMaybe<StringFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPublished?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EmergencyContactFilterProjectFilter>>;
  ownerUserId?: InputMaybe<IdFilterComparison>;
  photo?: InputMaybe<StringFieldComparison>;
  shortDescription?: InputMaybe<StringFieldComparison>;
  slug?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  templateType?: InputMaybe<ProjectTemplateEnumFilterComparison>;
  themes?: InputMaybe<ProjectThemesFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  visibility?: InputMaybe<ProjectVisibilityEnumFilterComparison>;
};

export type EmergencyContactProjectConnection = {
  __typename?: 'EmergencyContactProjectConnection';
  /** Array of nodes. */
  nodes: Array<Project>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type EmergencyContactSort = {
  direction: SortDirection;
  field: EmergencyContactSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum EmergencyContactSortFields {
  Category = 'category',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  PhoneNumber = 'phoneNumber',
  ProjectId = 'projectId',
  UpdatedAt = 'updatedAt'
}

export type ExportColumnInput = {
  questionId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExportColumnType;
};

export enum ExportColumnType {
  FullName = 'FULL_NAME',
  Index = 'INDEX',
  Question = 'QUESTION',
  RespondentId = 'RESPONDENT_ID',
  SubmittedAt = 'SUBMITTED_AT'
}

export enum ExportFormat {
  Pdf = 'PDF',
  Xlsx = 'XLSX'
}

export type ExportRegistryContactsInput = {
  /** Фильтры для экспорта */
  filter: RegistryFilterInput;
  /** ID выбранных контактов (если нужен экспорт конкретных) */
  selectedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ExportSupporterReportInput = {
  /** Text block left offset percentage (0-100) */
  contentLeft?: Scalars['Int']['input'];
  /** Text block width percentage (0-100) */
  contentWidth?: Scalars['Int']['input'];
  /** Whether to hide supporter address */
  hideAddress?: Scalars['Boolean']['input'];
  /** Whether to hide author name */
  hideAuthor?: Scalars['Boolean']['input'];
  /** Include envelope back page */
  includeEnvelopeBack?: Scalars['Boolean']['input'];
  /** Whether this is a global (admin) export */
  isGlobal: Scalars['Boolean']['input'];
  /** Mockup ID (null = no header image) */
  mockupId?: InputMaybe<Scalars['String']['input']>;
  /** Project ID (for non-global exports) */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** Pre-defined letter text (for global templates) */
  selectedLetterText?: InputMaybe<Scalars['String']['input']>;
  /** IDs of supporters to include in the report */
  supporterIds: Array<Scalars['String']['input']>;
  /** Type of supporters: INDIVIDUAL or ORGANIZATION */
  supporterType?: InputMaybe<Scalars['String']['input']>;
  /** User template ID (for custom templates) */
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type ExportSupporterReportResult = {
  __typename?: 'ExportSupporterReportResult';
  /** Generated filename */
  filename: Scalars['String']['output'];
  /** Presigned URL to download the PDF */
  url: Scalars['String']['output'];
};

export type ExportSurveyReportInput = {
  columns?: InputMaybe<Array<ExportColumnInput>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  format: ExportFormat;
  questionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  surveyId: Scalars['String']['input'];
};

export type ExportSurveyReportResult = {
  __typename?: 'ExportSurveyReportResult';
  base64: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type FailedContactDeletion = {
  __typename?: 'FailedContactDeletion';
  /** Тип контакта */
  contactType: RegistryContactTypeEnum;
  /** ID контакта */
  id: Scalars['ID']['output'];
  /** Причина ошибки */
  reason: Scalars['String']['output'];
};

export type FailedDeletion = {
  __typename?: 'FailedDeletion';
  /** ID участника, которого не удалось удалить */
  memberId: Scalars['ID']['output'];
  /** Причина неудачного удаления */
  reason: Scalars['String']['output'];
};

/** Allowed file extensions for the user */
export enum FileExtensions {
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Png = 'PNG',
  Webp = 'WEBP'
}

/** Allowed file object types for the user */
export enum FileObjectType {
  Avatar = 'AVATAR',
  Background = 'BACKGROUND'
}

export type FriendRelationship = {
  __typename?: 'FriendRelationship';
  /** Имя друга в этой связи */
  firstName?: Maybe<Scalars['String']['output']>;
  friend: User;
  id: Scalars['ID']['output'];
  /** Онлайн ли друг в данный момент */
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  isOutgoing: Scalars['Boolean']['output'];
  /** Фамилия друга в этой связи */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Время последнего появления в сети */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  receiverId: Scalars['String']['output'];
  senderId: Scalars['String']['output'];
  /** Описывает статус запроса на добавление в друзья: PENDING - отправлен запрос, SUBSCRIBER - запрос отклонен, отправитель стал подписчиком, ACCEPTED - оба стали друзьями */
  status: FriendStatus;
  user: User;
  userId: Scalars['String']['output'];
};


export type FriendRelationshipUserIdArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
  userId1?: InputMaybe<Scalars['String']['input']>;
};

/** Статус дружбы */
export enum FriendStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Subscriber = 'SUBSCRIBER'
}

/** Allowed gender options for the user */
export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GetMergeRequestsDto = {
  /** ID проекта */
  projectId: Scalars['ID']['input'];
};

export type GetNextQuestionDto = {
  /** ID опроса */
  surveyId: Scalars['ID']['input'];
};

/** DTO для входных параметров запроса presigned URL. */
export type GetPresignedUrlInput = {
  /** Время жизни ссылки в секундах. По умолчанию 600 секунд. */
  expires?: InputMaybe<Scalars['Int']['input']>;
  /** Расширение файла. */
  extension: FileExtensions;
  /** Тип файла. */
  objectType: FileObjectType;
};

export type GetProjectSupporterOwnersInput = {
  /** Список ID проектов для анализа владельцев сторонников */
  projectIds: Array<Scalars['ID']['input']>;
};

export type GlobalModuleAccessSettings = {
  __typename?: 'GlobalModuleAccessSettings';
  /** Внесение: область */
  dataEntryScope: ModuleAccessScopeEnum;
  /** userId с правом внесения (для scope=PARTICIPANT) */
  dataEntryUserIds: Array<Scalars['ID']['output']>;
  /** Редактирование: OWN_ONLY / ALL_RECORDS */
  editParticipantScope?: Maybe<ModuleAccessEditScopeEnum>;
  /** userId с правом редактирования */
  editUserIds: Array<Scalars['ID']['output']>;
  /** userId с полным доступом */
  fullAccessUserIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  moduleSlug: Scalars['String']['output'];
};

export type GlobalModuleDataEntryRuleInput = {
  /** userId выбранных пользователей (для scope=PARTICIPANT) */
  participantUserIds: Array<Scalars['ID']['input']>;
  /** Только UNRESTRICTED (без ограничений) или PARTICIPANT (выбранные пользователи) */
  scope: ModuleAccessScopeEnum;
};

export type GlobalModuleEditRuleInput = {
  /** OWN_ONLY (своей информации) / ALL_RECORDS (всех записей) */
  participantScope?: InputMaybe<ModuleAccessEditScopeEnum>;
  /** userId пользователей с правом редактирования */
  participantUserIds: Array<Scalars['ID']['input']>;
};

/** Group by */
export enum GroupBy {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  iLike?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notILike?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notLike?: InputMaybe<Scalars['ID']['input']>;
};

/** Типы изображений по размерам и назначению */
export enum ImageVariationType {
  FriendsCard = 'FRIENDS_CARD',
  FriendsMiniAvatar = 'FRIENDS_MINI_AVATAR',
  Original = 'ORIGINAL',
  Profile = 'PROFILE'
}

export type ImportDataDto = {
  /** Уникальный идентификатор проекта, в который выполняется импорт */
  projectId: Scalars['String']['input'];
  /** Массив записей для импорта из CSV/JSON файла */
  records: Array<ImportRecordDto>;
};

export type ImportRecordDto = {
  /** Время создания записи в исходной системе */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** Способ отправки поздравлений (почта, курьер, самовывоз и т.д.) */
  deliveryMethod?: InputMaybe<Scalars['String']['input']>;
  /** Тип сущности: "Физическое лицо" или "Юридическое лицо" */
  entityType?: InputMaybe<Scalars['String']['input']>;
  /** Уникальный идентификатор записи из исходного файла */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый адрес организации для отправки поздравления */
  organizationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Повод для поздравления организации (юбилей, праздник и т.д.) */
  organizationCelebrationReason?: InputMaybe<Scalars['String']['input']>;
  /** Свой вариант повода для поздравления организации */
  organizationCustomReason?: InputMaybe<Scalars['String']['input']>;
  /** Дата праздника или юбилея организации */
  organizationDate?: InputMaybe<Scalars['String']['input']>;
  /** ФИО руководителя организации */
  organizationHeadName?: InputMaybe<Scalars['String']['input']>;
  /** Наименование организации (полное или сокращенное) */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый адрес физического лица для отправки поздравления */
  personAddress?: InputMaybe<Scalars['String']['input']>;
  /** Повод для поздравления физического лица (день рождения, праздник и т.д.) */
  personCelebrationReason?: InputMaybe<Scalars['String']['input']>;
  /** Свой вариант повода для поздравления физического лица */
  personCustomReason?: InputMaybe<Scalars['String']['input']>;
  /** Дата праздника или дня рождения физического лица */
  personDate?: InputMaybe<Scalars['String']['input']>;
  /** ФИО поздравляемого физического лица */
  personName?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый адрес поздравляющего */
  senderAddress?: InputMaybe<Scalars['String']['input']>;
  /** ФИО заполняющего форму для адресатов поздравлений */
  senderName?: InputMaybe<Scalars['String']['input']>;
  /** Телефон заполняющего форму для адресатов поздравлений */
  senderPhone?: InputMaybe<Scalars['String']['input']>;
};

export type ImportResultDto = {
  __typename?: 'ImportResultDto';
  /** Список ошибок, возникших в процессе импорта */
  errors: Array<Scalars['String']['output']>;
  /** Количество записей, которые не удалось импортировать */
  failedRecords: Scalars['Float']['output'];
  /** Количество успешно импортированных организаций */
  successfulOrganizations: Scalars['Float']['output'];
  /** Количество успешно импортированных физических лиц */
  successfulPersons: Scalars['Float']['output'];
  /** Общее количество записей в файле для импорта */
  totalRecords: Scalars['Float']['output'];
  /** Список предупреждений (например, о найденных дубликатах) */
  warnings: Array<Scalars['String']['output']>;
};

export type InitialProjectCustomModuleInput = {
  /** Цвет фона модуля */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Базовый тип модуля (news, survey, supporters, mail) */
  baseModuleType: CustomModuleBaseTypeEnum;
  /** Формат отображения модуля */
  format?: InputMaybe<CustomModuleFormatEnum>;
  /** Иконка модуля (URL или название иконки) */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Цвет иконки модуля */
  iconColor?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля (уникальный в рамках проекта, lowercase_snake_case) */
  moduleSlug: Scalars['String']['input'];
  /** Название модуля */
  name: Scalars['String']['input'];
};

export type IntFieldComparison = {
  between?: InputMaybe<IntFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notBetween?: InputMaybe<IntFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntFieldComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

/** Ответ internal: presigned GET + метаданные */
export type InternalMediaObjectPresignedOutput = {
  __typename?: 'InternalMediaObjectPresignedOutput';
  /** Размер объекта из stat (если доступен) */
  contentLength?: Maybe<Scalars['Int']['output']>;
  /** Content-Type из метаданных объекта */
  contentType?: Maybe<Scalars['String']['output']>;
  expiresInSeconds: Scalars['Int']['output'];
  /** Presigned GET URL (внутренний host MinIO из конфига ms-media) */
  presignedUrl: Scalars['String']['output'];
};

/** Внутренний запрос: скачивание объекта из MinIO (только между микросервисами) */
export type InternalMediaObjectReadInput = {
  /** Имя бакета: ms-mail | ms-news | ms-project | ms-survey */
  bucket: Scalars['String']['input'];
  /** TTL presigned URL в секундах (по умолчанию 120, макс. 600) */
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Если задано и размер объекта больше — отказ (байты) */
  maxAllowedBytes?: InputMaybe<Scalars['Int']['input']>;
  /** Ключ объекта в бакете */
  objectKey: Scalars['String']['input'];
};

export type InvitationLinkStats = {
  __typename?: 'InvitationLinkStats';
  /** Количество переходов по ссылке */
  clickCount: Scalars['Float']['output'];
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Дата истечения */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID приглашения */
  invitationId: Scalars['ID']['output'];
  /** Активна ли ссылка */
  isActive: Scalars['Boolean']['output'];
  /** Количество успешных присоединений */
  joinCount: Scalars['Float']['output'];
  /** Количество ожидающих заявок */
  pendingCount: Scalars['Float']['output'];
  /** Токен ссылки */
  token: Scalars['String']['output'];
};

/** Статус приглашения пользователя к опросу */
export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Статус приглашения: PENDING - ожидает, ACCEPTED - принято, DECLINED - отклонено, EXPIRED - истекло */
export enum InvitationStatusEnum {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type InvitationStatusFilterComparison = {
  eq?: InputMaybe<InvitationStatus>;
  gt?: InputMaybe<InvitationStatus>;
  gte?: InputMaybe<InvitationStatus>;
  iLike?: InputMaybe<InvitationStatus>;
  in?: InputMaybe<Array<InvitationStatus>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<InvitationStatus>;
  lt?: InputMaybe<InvitationStatus>;
  lte?: InputMaybe<InvitationStatus>;
  neq?: InputMaybe<InvitationStatus>;
  notILike?: InputMaybe<InvitationStatus>;
  notIn?: InputMaybe<Array<InvitationStatus>>;
  notLike?: InputMaybe<InvitationStatus>;
};

/** Тип приглашения: DIRECT - прямое, LINK - по ссылке */
export enum InvitationTypeEnum {
  Direct = 'DIRECT',
  Link = 'LINK'
}

/** Канал отправки приглашения */
export enum InviteChannel {
  Email = 'EMAIL',
  Link = 'LINK',
  Public = 'PUBLIC',
  Sms = 'SMS'
}

export type InviteChannelFilterComparison = {
  eq?: InputMaybe<InviteChannel>;
  gt?: InputMaybe<InviteChannel>;
  gte?: InputMaybe<InviteChannel>;
  iLike?: InputMaybe<InviteChannel>;
  in?: InputMaybe<Array<InviteChannel>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<InviteChannel>;
  lt?: InputMaybe<InviteChannel>;
  lte?: InputMaybe<InviteChannel>;
  neq?: InputMaybe<InviteChannel>;
  notILike?: InputMaybe<InviteChannel>;
  notIn?: InputMaybe<Array<InviteChannel>>;
  notLike?: InputMaybe<InviteChannel>;
};

/** Приглашение к опросу */
export type InviteDto = {
  __typename?: 'InviteDto';
  /** Канал отправки */
  channel: InviteChannel;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Email получателя */
  email?: Maybe<Scalars['String']['output']>;
  /** Дата истечения */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Идентификатор приглашения */
  id: Scalars['ID']['output'];
  /** ID пользователя, отправившего приглашение */
  invitedByUserId?: Maybe<Scalars['String']['output']>;
  invitedUserId?: Maybe<Scalars['String']['output']>;
  /** Активность приглашения */
  isActive: Scalars['Boolean']['output'];
  /** Максимальное количество ответов */
  maxResponses: Scalars['Float']['output'];
  /** Метаданные */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Телефон получателя */
  phone?: Maybe<Scalars['String']['output']>;
  /** Время ответа на приглашение */
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Статус приглашения */
  status: InvitationStatus;
  /** Токен приглашения */
  token: Scalars['String']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** Количество использований */
  usedCount: Scalars['Float']['output'];
};

export type InviteDtoFilter = {
  and?: InputMaybe<Array<InviteDtoFilter>>;
  channel?: InputMaybe<InviteChannelFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  expiresAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  invitedByUserId?: InputMaybe<StringFieldComparison>;
  invitedUserId?: InputMaybe<StringFieldComparison>;
  isActive?: InputMaybe<BooleanFieldComparison>;
  maxResponses?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<InviteDtoFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
  respondedAt?: InputMaybe<DateFieldComparison>;
  status?: InputMaybe<InvitationStatusFilterComparison>;
  token?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  usedCount?: InputMaybe<NumberFieldComparison>;
};

export type InviteDtoSort = {
  direction: SortDirection;
  field: InviteDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum InviteDtoSortFields {
  Channel = 'channel',
  CreatedAt = 'createdAt',
  Email = 'email',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  InvitedByUserId = 'invitedByUserId',
  InvitedUserId = 'invitedUserId',
  IsActive = 'isActive',
  MaxResponses = 'maxResponses',
  Phone = 'phone',
  RespondedAt = 'respondedAt',
  Status = 'status',
  Token = 'token',
  UpdatedAt = 'updatedAt',
  UsedCount = 'usedCount'
}

export type JsonFilterComparison = {
  eq?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  iLike?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  neq?: InputMaybe<Scalars['JSON']['input']>;
  notILike?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  notLike?: InputMaybe<Scalars['JSON']['input']>;
};

/** Результат присоединения к проекту по ссылке-приглашению: заявка (для CLOSED проектов) или прямое членство (для OPEN проектов) */
export type JoinByInvitationResult = ProjectJoinRequest | ProjectMember;

/** Источник заявки: MANUAL - ручная подача, INVITATION_LINK - через ссылку-приглашение */
export enum JoinRequestSourceEnum {
  InvitationLink = 'INVITATION_LINK',
  Manual = 'MANUAL'
}

/** Статус заявки на вступление: PENDING - ожидает, APPROVED - одобрено, REJECTED - отклонено */
export enum JoinRequestStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

export type LandingImageUploadInput = {
  contentType: Scalars['String']['input'];
  expires?: InputMaybe<Scalars['Float']['input']>;
  fileName: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
};

export type LandingImageUploadResponse = {
  __typename?: 'LandingImageUploadResponse';
  imagePath: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type LandingTemplate = {
  __typename?: 'LandingTemplate';
  content: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  projectId?: Maybe<Scalars['ID']['output']>;
  projectRequestId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['ID']['output'];
};

export type LandingTemplateAggregateFilter = {
  and?: InputMaybe<Array<LandingTemplateAggregateFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<IdFilterComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPublic?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LandingTemplateAggregateFilter>>;
  projectId?: InputMaybe<IdFilterComparison>;
  projectRequestId?: InputMaybe<IdFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  updatedBy?: InputMaybe<IdFilterComparison>;
};

export type LandingTemplateAggregateGroupBy = {
  __typename?: 'LandingTemplateAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  projectRequestId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};


export type LandingTemplateAggregateGroupByCreatedAtArgs = {
  by?: GroupBy;
};


export type LandingTemplateAggregateGroupByUpdatedAtArgs = {
  by?: GroupBy;
};

export type LandingTemplateAggregateResponse = {
  __typename?: 'LandingTemplateAggregateResponse';
  count?: Maybe<LandingTemplateCountAggregate>;
  groupBy?: Maybe<LandingTemplateAggregateGroupBy>;
  max?: Maybe<LandingTemplateMaxAggregate>;
  min?: Maybe<LandingTemplateMinAggregate>;
};

export type LandingTemplateConnection = {
  __typename?: 'LandingTemplateConnection';
  /** Array of edges. */
  edges: Array<LandingTemplateEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type LandingTemplateCountAggregate = {
  __typename?: 'LandingTemplateCountAggregate';
  createdAt?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPublic?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectRequestId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type LandingTemplateDeleteFilter = {
  and?: InputMaybe<Array<LandingTemplateDeleteFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<IdFilterComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPublic?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LandingTemplateDeleteFilter>>;
  projectId?: InputMaybe<IdFilterComparison>;
  projectRequestId?: InputMaybe<IdFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  updatedBy?: InputMaybe<IdFilterComparison>;
};

export type LandingTemplateDeleteResponse = {
  __typename?: 'LandingTemplateDeleteResponse';
  content?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  projectRequestId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type LandingTemplateEdge = {
  __typename?: 'LandingTemplateEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the LandingTemplate */
  node: LandingTemplate;
};

export type LandingTemplateFilter = {
  and?: InputMaybe<Array<LandingTemplateFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<IdFilterComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPublic?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LandingTemplateFilter>>;
  projectId?: InputMaybe<IdFilterComparison>;
  projectRequestId?: InputMaybe<IdFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  updatedBy?: InputMaybe<IdFilterComparison>;
};

export type LandingTemplateMaxAggregate = {
  __typename?: 'LandingTemplateMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  projectRequestId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type LandingTemplateMinAggregate = {
  __typename?: 'LandingTemplateMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  projectRequestId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type LandingTemplateSort = {
  direction: SortDirection;
  field: LandingTemplateSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum LandingTemplateSortFields {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Description = 'description',
  Id = 'id',
  IsPublic = 'isPublic',
  Name = 'name',
  ProjectId = 'projectId',
  ProjectRequestId = 'projectRequestId',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type LandingTemplateUpdateFilter = {
  and?: InputMaybe<Array<LandingTemplateUpdateFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<IdFilterComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPublic?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LandingTemplateUpdateFilter>>;
  projectId?: InputMaybe<IdFilterComparison>;
  projectRequestId?: InputMaybe<IdFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  updatedBy?: InputMaybe<IdFilterComparison>;
};

export type Like = {
  __typename?: 'Like';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID пользователя, который поставил лайк */
  createdByUserId: Scalars['String']['output'];
  /** ID лайка */
  id: Scalars['ID']['output'];
  /** ID сущности, которую лайкают */
  likeableId: Scalars['String']['output'];
  /** Тип сущности, которую лайкают */
  likeableType: LikeableTypeEnum;
};

export type LikeConnection = {
  __typename?: 'LikeConnection';
  /** Array of nodes. */
  nodes: Array<Like>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type LikeDeleteResponse = {
  __typename?: 'LikeDeleteResponse';
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя, который поставил лайк */
  createdByUserId?: Maybe<Scalars['String']['output']>;
  /** ID лайка */
  id?: Maybe<Scalars['ID']['output']>;
  /** ID сущности, которую лайкают */
  likeableId?: Maybe<Scalars['String']['output']>;
  /** Тип сущности, которую лайкают */
  likeableType?: Maybe<LikeableTypeEnum>;
};

export type LikeFilter = {
  and?: InputMaybe<Array<LikeFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdByUserId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  likeableId?: InputMaybe<StringFieldComparison>;
  likeableType?: InputMaybe<LikeableTypeEnumFilterComparison>;
  or?: InputMaybe<Array<LikeFilter>>;
};

export type LikeOutput = {
  __typename?: 'LikeOutput';
  isLiked: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
};

export type LikeSort = {
  direction: SortDirection;
  field: LikeSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum LikeSortFields {
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Id = 'id',
  LikeableId = 'likeableId',
  LikeableType = 'likeableType'
}

/**
 * Тип сущности, которую можно лайкнуть
 * PROJECT - проект
 * PHOTO - фотография
 * NEWS - новость
 * COMMENT - комментарий
 * FRIEND - друг
 */
export enum LikeableTypeEnum {
  Comment = 'COMMENT',
  Friend = 'FRIEND',
  News = 'NEWS',
  Photo = 'PHOTO',
  Project = 'PROJECT'
}

export type LikeableTypeEnumFilterComparison = {
  eq?: InputMaybe<LikeableTypeEnum>;
  gt?: InputMaybe<LikeableTypeEnum>;
  gte?: InputMaybe<LikeableTypeEnum>;
  iLike?: InputMaybe<LikeableTypeEnum>;
  in?: InputMaybe<Array<LikeableTypeEnum>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<LikeableTypeEnum>;
  lt?: InputMaybe<LikeableTypeEnum>;
  lte?: InputMaybe<LikeableTypeEnum>;
  neq?: InputMaybe<LikeableTypeEnum>;
  notILike?: InputMaybe<LikeableTypeEnum>;
  notIn?: InputMaybe<Array<LikeableTypeEnum>>;
  notLike?: InputMaybe<LikeableTypeEnum>;
};

export type LikedProjectsConnection = {
  __typename?: 'LikedProjectsConnection';
  /** Избранные проекты текущего пользователя */
  nodes: Array<Project>;
  /** Общее количество избранных проектов */
  totalCount: Scalars['Int']['output'];
};

export type LoginRequest = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  /** Номер телефона, должен быть корректным российским номером (например "79777008810") */
  phone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type MailMessage = {
  __typename?: 'MailMessage';
  /** Содержимое сообщения (TipTap JSON) */
  content: Scalars['JSON']['output'];
  /** Текстовое превью содержимого */
  contentPreview?: Maybe<Scalars['String']['output']>;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID сообщения */
  id: Scalars['ID']['output'];
  /** Номер сообщения в формате {Рег.Номер}/{Порядковый номер} */
  messageNumber: Scalars['String']['output'];
  /** Отправитель (резолвится через федерацию из ms-users) */
  senderUser: User;
  /** ID отправителя */
  senderUserId: Scalars['ID']['output'];
  /** Порядковый номер сообщения */
  sequenceNumber: Scalars['Int']['output'];
  /** ID обращения */
  threadId: Scalars['ID']['output'];
};

export type MailRecipient = {
  __typename?: 'MailRecipient';
  /** Роль в проекте */
  role: Scalars['String']['output'];
  /** Пользователь (резолвится через федерацию из ms-users) */
  user: User;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

export type MailThread = {
  __typename?: 'MailThread';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Автор обращения (резолвится через федерацию из ms-users) */
  creatorUser: User;
  /** ID автора обращения */
  creatorUserId: Scalars['ID']['output'];
  /** ID обращения */
  id: Scalars['ID']['output'];
  /** Прочитано ли обращение текущим пользователем */
  isRead: Scalars['Boolean']['output'];
  /** Дата последнего сообщения */
  lastMessageAt: Scalars['DateTime']['output'];
  /** Превью последнего сообщения */
  lastMessagePreview: Scalars['String']['output'];
  /** ID автора последнего сообщения */
  lastMessageUserId: Scalars['ID']['output'];
  /** Количество сообщений в обращении */
  messageCount: Scalars['Int']['output'];
  /** Слаг модуля обращений */
  moduleSlug: Scalars['String']['output'];
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Получатель обращения (резолвится через федерацию из ms-users) */
  recipientUser: User;
  /** ID получателя обращения */
  recipientUserId: Scalars['ID']['output'];
  /** Регистрационный номер обращения */
  registrationNumber: Scalars['String']['output'];
  /** Статус обращения */
  status: MailThreadStatusEnum;
  /** Тема обращения */
  subject?: Maybe<Scalars['String']['output']>;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

/** Фильтр обращений: ALL - все, UNANSWERED - без ответа, ANSWERED - с ответом */
export enum MailThreadFilterEnum {
  All = 'ALL',
  Answered = 'ANSWERED',
  Unanswered = 'UNANSWERED'
}

export type MailThreadList = {
  __typename?: 'MailThreadList';
  /** Есть ли ещё обращения */
  hasMore: Scalars['Boolean']['output'];
  /** Список обращений */
  items: Array<MailThread>;
  /** Общее количество обращений */
  totalCount: Scalars['Int']['output'];
};

/** Статус обращения: OPEN - открыто, CLOSED - закрыто */
export enum MailThreadStatusEnum {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type Media = {
  __typename?: 'Media';
  avatar?: Maybe<Avatar>;
  background?: Maybe<Background>;
};

/** Типы устройств для получения версий медиа */
export enum MediaDeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Tablet = 'TABLET'
}

/**
 * Домены медиа
 * MS_NEWS - новости
 * MS_PROJECT - проекты
 * MS_SURVEY - опросы
 * MS_MAIL - обращения
 * MS_CALENDAR_EVENT - вложения событий календаря
 * MS_OBJECT_PASSPORT - файлы паспорта объекта (обложка, карта, программа, регламент)
 * MS_PROGRAM - файлы программы мероприятия (карта проезда/прохода: изображения и PDF)
 */
export enum MediaDomainNameEnum {
  MsCalendarEvent = 'MS_CALENDAR_EVENT',
  MsMail = 'MS_MAIL',
  MsNews = 'MS_NEWS',
  MsObjectPassport = 'MS_OBJECT_PASSPORT',
  MsProgram = 'MS_PROGRAM',
  MsProject = 'MS_PROJECT',
  MsSurvey = 'MS_SURVEY'
}

/** Ответ скачивания медиа */
export type MediaOutputDto = {
  __typename?: 'MediaOutputDTO';
  contentType: Scalars['String']['output'];
  /** Флаг, готово ли медиа к отображению */
  isReady: Scalars['Boolean']['output'];
  jobId: Scalars['String']['output'];
  originalKey: Scalars['String']['output'];
  processedAt: Scalars['DateTime']['output'];
  processedPath: Scalars['String']['output'];
  variants: MediaVariantsDto;
  version: Scalars['Float']['output'];
};

/** Входные данные для проверки статуса медиа */
export type MediaStatusInputDto = {
  /** Домен медиа (например, ms-news, ms-project, ms-survey, etc.) */
  mediaDomain: MediaDomainNameEnum;
  /** Идентификатор сущности, для которой загружается медиа */
  mediaEntityId: Scalars['ID']['input'];
  /** Тип загружаемой сущности (например, news, project, supporter, etc.) */
  mediaEntityType: Scalars['String']['input'];
};

/** Ответ на проверку статуса медиа */
export type MediaStatusItemOutputDto = {
  __typename?: 'MediaStatusItemOutputDTO';
  /** Разрешение */
  error?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор медиа */
  mediaId: Scalars['String']['output'];
  /** Статус медиа */
  mediaStatus: Scalars['String']['output'];
};

/** Входные данные для запроса URL загрузки медиа */
export type MediaUploadUrlInputDto = {
  /** Имя файла вместе с расширением */
  filename: Scalars['String']['input'];
  /** Домен медиа (например, ms-news, ms-project, ms-survey, etc.) */
  mediaDomain: MediaDomainNameEnum;
  /** Идентификатор сущности, для которой загружается медиа */
  mediaEntityId: Scalars['ID']['input'];
  /** Тип загружаемой сущности (например, news, project, supporter, etc.) */
  mediaEntityType: Scalars['String']['input'];
};

/** Ответ с временными данными для загрузки медиа */
export type MediaUploadUrlOutputDto = {
  __typename?: 'MediaUploadUrlOutputDTO';
  /** Момент времени, когда URL перестанет быть валидным */
  mediaExpiresAt: Scalars['DateTime']['output'];
  /** Уникальный идентификатор медиа */
  mediaId: Scalars['String']['output'];
  /** Ключ объекта, который будет сохранён в MinIO */
  mediaStorageKey: Scalars['String']['output'];
  /** Предподписанный URL для загрузки файла в MinIO */
  mediaUploadUrl: Scalars['String']['output'];
};

/** Варианты медиа */
export type MediaVariantsDto = {
  __typename?: 'MediaVariantsDTO';
  desktop?: Maybe<Scalars['String']['output']>;
  hls?: Maybe<MediaVariantsHlsdto>;
  mobile?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  tablet?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
};

/** Варианты HLS медиа */
export type MediaVariantsHlsdto = {
  __typename?: 'MediaVariantsHLSDTO';
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  master?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  /** Список доступных рендеров (названия качеств, например: 720p, 1080p) */
  renditions?: Maybe<Array<Scalars['String']['output']>>;
  rotation?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** Вариант HLS сегмента */
export type MediaVariantsHlsSegmentDto = {
  __typename?: 'MediaVariantsHLSSegmentDTO';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Входные данные для запроса мастер-плейлиста HLS */
export type MediaVideoHlsMasterPlaylistInputDto = {
  /** Домен медиа (например, ms-news, ms-project, ms-survey, etc.) */
  mediaDomain: MediaDomainNameEnum;
  /** Идентификатор сущности, для которой загружается медиа */
  mediaEntityId: Scalars['ID']['input'];
  /** Тип загружаемой сущности (например, news, project, supporter, etc.) */
  mediaEntityType: Scalars['String']['input'];
  /** Идентификатор медиа */
  mediaId: Scalars['ID']['input'];
};

/** Мастер-плейлист HLS */
export type MediaVideoHlsMasterPlaylistOutputDto = {
  __typename?: 'MediaVideoHlsMasterPlaylistOutputDTO';
  /** URL мастер-плейлиста HLS */
  url: Scalars['String']['output'];
};

/** Входные данные для запроса плейлиста HLS */
export type MediaVideoHlsVariantPlaylistInputDto = {
  /** Домен медиа (например, ms-news, ms-project, ms-survey, etc.) */
  mediaDomain: MediaDomainNameEnum;
  /** Идентификатор сущности, для которой загружается медиа */
  mediaEntityId: Scalars['ID']['input'];
  /** Тип загружаемой сущности (например, news, project, supporter, etc.) */
  mediaEntityType: Scalars['String']['input'];
  /** Идентификатор медиа */
  mediaId: Scalars['ID']['input'];
  /** Разрешение */
  resolution: Scalars['String']['input'];
};

/** Ответ на заявку слияния */
export enum MergeRequestResponse {
  /** Принять заявку */
  Accept = 'ACCEPT',
  /** Отклонить заявку */
  Reject = 'REJECT'
}

export type MergeSessionDto = {
  __typename?: 'MergeSessionDTO';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Детальная информация о предстоящих изменениях при слиянии сторонников */
  diff?: Maybe<SupporterMergeDiffDto>;
  /** Информация о проекте-источнике (откуда приходят сторонники) */
  fromProject?: Maybe<Project>;
  /** ID проекта-источника */
  fromProjectId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Сообщение к заявке */
  message?: Maybe<Scalars['String']['output']>;
  /** Время отправки заявки */
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Пользователь, инициировавший заявку на слияние */
  requestedByUser?: Maybe<User>;
  /** ID пользователя, инициировавшего заявку */
  requestedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Время ответа на заявку */
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Выбранные сторонники для снимка */
  selectedSupporterIds: Array<Scalars['ID']['output']>;
  /** Время создания снимка */
  snapshotCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Статус сессии слияния */
  state: MergeSessionState;
  /** Статистика слияния */
  stats?: Maybe<Scalars['JSON']['output']>;
  /** Список сторонников из snapshot для отображения на фронтенде */
  supporters?: Maybe<Array<SnapshotSupporter>>;
  /** Информация о проекте-получателе (куда передаются сторонники) */
  toProject?: Maybe<Project>;
  /** ID проекта-получателя */
  toProjectId: Scalars['ID']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

/** Статус сессии слияния сторонников */
export enum MergeSessionState {
  /** Заявка принята получателем */
  Accepted = 'ACCEPTED',
  /** Изменения применены */
  Applied = 'APPLIED',
  /** Сессия отменена */
  Canceled = 'CANCELED',
  /** Матчинг выполнен */
  Matched = 'MATCHED',
  /** Заявка на слияние отправлена */
  MergeRequested = 'MERGE_REQUESTED',
  /** Снимок готов к обработке */
  Ready = 'READY',
  /** Заявка отклонена получателем */
  Rejected = 'REJECTED',
  /** Конфликты разрешены */
  Resolved = 'RESOLVED',
  /** Заявка отозвана отправителем */
  Withdrawn = 'WITHDRAWN'
}

/** Платформа мобильного клиента */
export enum MobilePlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

/** Магазин приложений, откуда установлен клиент */
export enum MobileStore {
  AppStore = 'APP_STORE',
  GooglePlay = 'GOOGLE_PLAY',
  RuStore = 'RU_STORE'
}

export type MobileVariation = {
  __typename?: 'MobileVariation';
  FRIENDS_CARD?: Maybe<Scalars['String']['output']>;
  FRIENDS_MINI_AVATAR?: Maybe<Scalars['String']['output']>;
  ORIGINAL?: Maybe<Scalars['String']['output']>;
  PROFILE?: Maybe<Scalars['String']['output']>;
};

export type Mockup = {
  __typename?: 'Mockup';
  access: MockupAccess;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  type: MockupTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  updatedByUserId?: Maybe<Scalars['ID']['output']>;
};

export type MockupAccess = {
  __typename?: 'MockupAccess';
  canDelete: Scalars['Boolean']['output'];
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
};

export type MockupFilterInput = {
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<MockupTypeEnum>;
  types?: InputMaybe<Array<MockupTypeEnum>>;
};

export type MockupPresignedPutUrlInput = {
  /** Время жизни ссылки в секундах (по умолчанию 600) */
  expires?: InputMaybe<Scalars['Int']['input']>;
  /** ID макета для получения presigned URL загрузки */
  mockupId: Scalars['ID']['input'];
};

export type MockupPresignedUrlResponse = {
  __typename?: 'MockupPresignedUrlResponse';
  url: Scalars['String']['output'];
};

/** Типы макетов */
export enum MockupTypeEnum {
  /** Админские макеты */
  Admin = 'ADMIN',
  /** Проектные макеты */
  Project = 'PROJECT',
  /** Системные макеты */
  System = 'SYSTEM'
}

export type ModuleAccessEditRule = {
  __typename?: 'ModuleAccessEditRule';
  membersScope?: Maybe<ModuleAccessEditScopeEnum>;
  participantScope?: Maybe<ModuleAccessEditScopeEnum>;
  participants: Array<ProjectMember>;
  statusScope?: Maybe<ModuleAccessEditScopeEnum>;
};

export type ModuleAccessEditRuleInput = {
  membersScope?: InputMaybe<ModuleAccessEditScopeEnum>;
  participantMemberIds: Array<Scalars['ID']['input']>;
  participantScope?: InputMaybe<ModuleAccessEditScopeEnum>;
  statusScope?: InputMaybe<ModuleAccessEditScopeEnum>;
};

/** Область редактирования: own_only или all_records */
export enum ModuleAccessEditScopeEnum {
  AllRecords = 'ALL_RECORDS',
  OwnOnly = 'OWN_ONLY'
}

/** Область доступа к модулю: unrestricted, members_only, with_status, participant */
export enum ModuleAccessScopeEnum {
  MembersOnly = 'MEMBERS_ONLY',
  Participant = 'PARTICIPANT',
  Unrestricted = 'UNRESTRICTED',
  WithStatus = 'WITH_STATUS'
}

export type ModuleAccessScopeRule = {
  __typename?: 'ModuleAccessScopeRule';
  participants: Array<ProjectMember>;
  scope: ModuleAccessScopeEnum;
};

export type ModuleAccessScopeRuleInput = {
  /** ID участников проекта (project_member.id) */
  participantMemberIds: Array<Scalars['ID']['input']>;
  scope: ModuleAccessScopeEnum;
};

export type MonthDayRangeInput = {
  /** Начальный день (1-31) */
  fromDay?: InputMaybe<Scalars['Int']['input']>;
  /** Начальный месяц (1-12) */
  fromMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Конечный день (1-31) */
  toDay?: InputMaybe<Scalars['Int']['input']>;
  /** Конечный месяц (1-12) */
  toMonth?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Принять запрос на добавление в друзья от пользователя. */
  acceptFriendRequest: FriendRelationship;
  /** Принять прямое приглашение в проект */
  acceptInvitation: ProjectMember;
  /** Добавить пользователей в событие календаря */
  addCalendarEventParticipants: CalendarEvent;
  /** Добавить новость в избранное текущего пользователя. */
  addNewsFavourite: Scalars['Boolean']['output'];
  answerSurvey: ResponseDto;
  answerSurveyWithCaptcha: ResponseDto;
  /** Ответить на вопрос теста и получить результат проверки */
  answerTestQuestion: TestAnswerResultDto;
  /** Применить изменения слияния */
  applyMergeChanges: Scalars['Boolean']['output'];
  /** Одобрить заявку на вступление в проект */
  approveJoinRequest: ProjectJoinRequest;
  /** Согласовать заявку на участие (кнопка «Согласовать») */
  approveObjectPassportApplication: ObjectPassportApplication;
  /** Одобрить запрос на добавление в проект. Используется в админке для модерации заявок. */
  approveProjectRequest: Project;
  /** Апрув выступления (my_speech). Доступно владельцу проекта, администратору проекта и QUEST_ADMIN. */
  approveSpeechNews: News;
  /** Одобрить запрос на верификацию пользователя */
  approveUserVerifyRequest: UserVerifyResponse;
  /** Массовое приглашение пользователей в проект */
  bulkInviteUsers: BulkInviteResult;
  /** Отменить исходящий запрос в друзья, который вы отправили пользователю. */
  cancelOutgoingFriendRequest: Scalars['Boolean']['output'];
  closeSurvey: SurveyDto;
  /** Подтвердить код и восстановить аккаунт (неавторизованный). */
  confirmAccountRestore: Scalars['String']['output'];
  /** Confirm verification code (OTP/email/phone). */
  confirmVerificationCode: VerifyResponse;
  /** Добавить подписчика в друзья. */
  convertSubscriberToFriend: FriendRelationship;
  createAdminTemplate: Template;
  /** Создать событие календаря (личное или в проекте) */
  createCalendarEvent: CalendarEvent;
  /** Создать новый счётчик */
  createCounter: Counter;
  /** Создать новое показание счётчика */
  createCounterReading: CounterReading;
  /** Создать прямое приглашение пользователю в проект */
  createDirectInvitation: ProjectInvitation;
  /** Создать новый контакт экстренной службы */
  createEmergencyContact: EmergencyContact;
  /** Создать многоразовую ссылку-приглашение для проекта */
  createInvitationLink: ProjectInvitation;
  createInvite: InviteDto;
  /** Создать заявку на вступление в проект (только для CLOSED проектов) */
  createJoinRequest: ProjectJoinRequest;
  /** Создать новое обращение */
  createMailThread: MailThread;
  createManyLandingTemplates: Array<LandingTemplate>;
  /** Создать заявку на слияние сторонников */
  createMergeRequest: MergeSessionDto;
  /** Создать макет и получить URL для загрузки файла */
  createMockup: CreateMockupResponse;
  /** Создать запрос на добавление в проект для текущего пользователя. По умолчанию статус запроса - PENDING. Используется в UI формы создания заявки. */
  createMyProjectRequest: ProjectRequest;
  /** Отправить заявку на участие (кнопка «Отправить заявку») */
  createObjectPassportApplication: ObjectPassportApplication;
  createOneAnswer: Answer;
  createOneComment: Comment;
  createOneCounterEvent: CounterEvent;
  createOneLandingTemplate: LandingTemplate;
  createOneLike: Like;
  createOneNews: News;
  createOneProject: Project;
  createOneProjectMember: ProjectMember;
  createOneProjectModuleMember: ProjectModuleMember;
  createOneProjectOrganization: ProjectOrganization;
  createOneProjectSupporter: ProjectSupporter;
  createOneQuestionDto: QuestionDto;
  createOneQuestionFieldDto: QuestionFieldDto;
  createOneSurveyDto: SurveyDto;
  createOneUserVerifyRequest: UserVerifyRequest;
  /** Создать мероприятие программы (одна карточка) */
  createProgramItem: ProgramItem;
  /** Создать кастомный модуль в проекте */
  createProjectCustomModule: ProjectCustomModule;
  /** @deprecated Use toggleSurveyPublicLink on Survey instead */
  createPublicLink: InviteDto;
  /** Создать выступление регламента (одна строка) */
  createReglamentItem: ReglamentItem;
  createSurveyFull: SurveyDto;
  createUploadUrl: UploadUrlDto;
  createUserTemplate: Template;
  deactivateInvite: InviteDto;
  /** Отклонить прямое приглашение в проект */
  declineInvitation: Scalars['Boolean']['output'];
  /** Удалить событие календаря */
  deleteCalendarEvent: CalendarEventDeleteResponse;
  /** Удалить счётчик */
  deleteCounter: CounterDeleteResponse;
  /** Удалить показание счётчика */
  deleteCounterReading: CounterReadingDeleteResponse;
  /** Удалить контакт экстренной службы */
  deleteEmergencyContact: EmergencyContactDeleteResponse;
  deleteManyLandingTemplates: DeleteManyResponse;
  deleteManyQuestionDtos: DeleteManyResponse;
  deleteManySurveyDtos: DeleteManyResponse;
  deleteMe: Scalars['Boolean']['output'];
  /** Удаляет медиафайл пользователя и все его вариации */
  deleteMedia: Scalars['Boolean']['output'];
  deleteMockup: Scalars['Boolean']['output'];
  deleteOneAnswer: AnswerDeleteResponse;
  deleteOneComment: CommentDeleteResponse;
  deleteOneCounterEvent: CounterEventDeleteResponse;
  deleteOneLandingTemplate: LandingTemplateDeleteResponse;
  deleteOneLike: LikeDeleteResponse;
  deleteOneNews: NewsDeleteResponse;
  deleteOneProject: ProjectDeleteResponse;
  /** Удалить участника по его ID и projectId (опционально) */
  deleteOneProjectMember?: Maybe<ProjectMemberDeleteResponse>;
  /** Удалить участника модуля проекта по его ID и projectId (опционально) */
  deleteOneProjectModuleMember?: Maybe<ProjectModuleMemberDeleteResponse>;
  deleteOneProjectOrganization: ProjectOrganizationDeleteResponse;
  /** Удалить сторонника по его ID и projectId (опционально) */
  deleteOneProjectSupporter?: Maybe<SupporterDeleteResponse>;
  deleteOneQuestionDto: QuestionDtoDeleteResponse;
  deleteOneQuestionFieldDto: QuestionFieldDtoDeleteResponse;
  deleteOneSurveyDto: SurveyDtoDeleteResponse;
  deleteOneUserVerifyRequest: UserVerifyRequestDeleteResponse;
  /** Удалить мероприятие программы по его ID (мягкое удаление) */
  deleteProgramItem: Scalars['Boolean']['output'];
  /** Удалить кастомный модуль (soft delete) */
  deleteProjectCustomModule: ProjectCustomModule;
  /** Удалить участников проекта по ID пользователей (batch-операция) */
  deleteProjectMembersByUserIds: DeleteProjectMembersResult;
  /** Удалить запрос на добавление в проект (жёсткое удаление). Используется для удаления заявки в админке. */
  deleteProjectRequest: Scalars['Boolean']['output'];
  /** Batch удаление контактов реестра */
  deleteRegistryContacts: DeleteRegistryContactsResult;
  /** Удалить выступление регламента по его ID (мягкое удаление) */
  deleteReglamentItem: Scalars['Boolean']['output'];
  deleteSystemMockup: Scalars['Boolean']['output'];
  deleteUserAddress: Scalars['Boolean']['output'];
  deleteUserTemplate: Scalars['Boolean']['output'];
  /** Создать копию существующего события календаря (новый владелец — текущий пользователь) */
  duplicateCalendarEvent: CalendarEvent;
  /** Экспортировать отчет по сторонникам в PDF формате с шаблоном письма */
  exportSupporterReport: ExportSupporterReportResult;
  /** Экспортировать статистику опроса в PDF или XLSX формате */
  exportSurveyReport: ExportSurveyReportResult;
  /** Генерирует общий отчет по платформе КВЕСТ */
  generatePlatformSummaryReport: PlatformSummaryReportEntity;
  /** Генерирует детализированный отчет по конкретному проекту или группе проектов */
  generateProjectDetailedReport: Array<ProjectDetailedReportEntity>;
  /** Генерирует региональный отчет по пользователям, проектам и активности */
  generateRegionalReport: Array<RegionalReportEntity>;
  /** Генерирует детализированный отчет по пользователям с разбивкой по проектам и друзьям */
  generateUserDetailedReport: Array<UserDetailedReportEntity>;
  /** Получить presigned URL для загрузки изображения в шаблон лендинга */
  getLandingImageUploadUrl: LandingImageUploadResponse;
  /** Импорт сторонников и организаций из CSV файла */
  importFromCsv: ImportResultDto;
  /** Импорт сторонников и организаций из переданных данных */
  importFromData: ImportResultDto;
  /** Импорт сторонников и организаций из JSON файла */
  importFromJson: ImportResultDto;
  /** Инициализировать счётчики по умолчанию для проекта для текущего пользователя */
  initializeProjectCounters: Array<Counter>;
  /** Сервис-сервис: no-op для проверки секрета и доступности internal GraphQL (не трогает MinIO). */
  internalPingMediaServiceMesh: Scalars['Boolean']['output'];
  /** Introspects a token via Keycloak and returns detailed information. */
  introspectToken: Scalars['String']['output'];
  /** Создать персональное приглашение пользователю */
  inviteUserToSurvey: InviteDto;
  /** Присоединиться к открытому проекту напрямую (без заявки) */
  joinOpenProject: ProjectMember;
  /** Присоединиться к проекту по ссылке-приглашению (для авторизованных пользователей) */
  joinProjectByInvitationLink: JoinByInvitationResult;
  /** Покинуть событие календаря — текущий авторизованный пользователь выходит из участников */
  leaveCalendarEvent: CalendarEvent;
  /** Загружает недостающие системные макеты */
  loadSystemMockups: Scalars['String']['output'];
  /** Login mutation using password grant. */
  login: AuthResponse;
  /** Вход по коду (PIN-разблокировка): по refresh-токену от прошлого входа + коду продлевает сессию и возвращает новые токены. Код опционален — если не задан, используйте обычный login. */
  loginByCode: AuthResponse;
  markAllNotificationsAsRead: Scalars['Boolean']['output'];
  /** Отметить комментарии прочитанными текущим пользователем (идемпотентно). */
  markCommentsRead: Scalars['Boolean']['output'];
  /** Отметить обращение как прочитанное */
  markMailThreadAsRead: Scalars['Boolean']['output'];
  /** Пометить новость как просмотренную */
  markNewsAsViewed: CounterEventNatsResponseDto;
  /** Отметить новости как просмотренные текущим пользователем (уменьшает счётчик непросмотренных в «Дайджест новостей»). Идемпотентно. */
  markNewsSeen: Scalars['Boolean']['output'];
  markNotificationActionApplied: Scalars['Boolean']['output'];
  markNotificationAsRead: Scalars['Boolean']['output'];
  pauseSurvey: SurveyDto;
  /** Обработать заявку на вступление (одобрить/отклонить) */
  processJoinRequest: ProjectJoinRequest;
  /** Обработать запланированные публикации */
  processScheduledPublishing: Array<SurveyDto>;
  publishSurvey: SurveyDto;
  /** Refresh token mutation. */
  refreshToken: AuthResponse;
  /** Перегенерировать токен ссылки-приглашения (для владельца/админа) */
  regenerateInvitationLink: ProjectInvitation;
  /** Registers a new user and logs in automatically. */
  registerUser: AuthResponse;
  registerUserToken: Scalars['Boolean']['output'];
  /** Отклонить входящий запрос в друзья. После отклонения запроса, отправитель становится подписчиком. */
  rejectIncomingFriendRequest: Scalars['Boolean']['output'];
  /** Отклонить заявку на вступление в проект */
  rejectJoinRequest: ProjectJoinRequest;
  /** Отклонить заявку на участие (кнопка «Отклонить») */
  rejectObjectPassportApplication: ObjectPassportApplication;
  /** Отклонить запрос на добавление в проект c указанием причины. Используется в админке для модерации заявок. */
  rejectProjectRequest: ProjectRequest;
  /** Отклонение выступления (my_speech) с опциональной причиной отказа. */
  rejectSpeechNews: News;
  /** Отклонить запрос на верификацию пользователя */
  rejectUserVerifyRequest: UserVerifyResponse;
  /** Перезагружает системные макеты из файловой системы */
  reloadSystemMockups: Scalars['String']['output'];
  /** Удалить пользователя из события календаря */
  removeCalendarEventParticipant: CalendarEvent;
  /** Удалить пользователя из друзей. Отношения дружбы полностью удаляются. */
  removeFriend: FriendRelationship;
  /** Удалить код быстрого входа текущего пользователя. Требует авторизации. */
  removeLoginCode: Scalars['Boolean']['output'];
  /** Убрать новость из избранного текущего пользователя. */
  removeNewsFavourite: Scalars['Boolean']['output'];
  /** Возможность убрать человеĸа из «Подписчиĸов» */
  removeSubscriber: Scalars['Boolean']['output'];
  removeToken: Scalars['Boolean']['output'];
  /** Изменить порядок выступлений (my_speech) в списке — глобально, для всех пользователей. orderedNewsIds задаёт новый порядок (i-й id → позиция i); все id должны принадлежать модулю выступлений (projectId, moduleSlug). Доступно владельцу проекта, администратору проекта и QUEST_ADMIN. */
  reorderSpeechNews: Array<News>;
  /** Запрос кода для восстановления аккаунта (неавторизованный). */
  requestAccountRestore: Scalars['String']['output'];
  /** Requests a password reset via the chosen notification method (unauthenticated). */
  requestPasswordReset: Scalars['String']['output'];
  /** Resets the password for an authenticated user. */
  resetPassword: Scalars['String']['output'];
  /** Ответить на заявку слияния (принять/отклонить) */
  respondToMergeRequest: MergeSessionDto;
  /** Отозвать приглашение (для владельца/админа проекта) */
  revokeInvitation: Scalars['Boolean']['output'];
  /** Отменить свой голос в опросе */
  revokeNewsPollVote: NewsPollResults;
  /** Revokes a token (access or refresh). */
  revokeToken: Scalars['String']['output'];
  /** Пакетно сохранить программу (кнопка «Сохранить»): синхронизирует весь набор карточек модуля */
  saveProgramItems: Array<ProgramItem>;
  /** Пакетно сохранить регламент (кнопка «Сохранить»): синхронизирует весь набор строк модуля */
  saveReglamentItems: Array<ReglamentItem>;
  /** @deprecated use answerSurvey instead */
  saveResponse: ResponseDto;
  /** Запланировать публикацию опроса */
  schedulePublishSurvey: SurveyDto;
  /** Отправить запрос в друзья пользователю. */
  sendFriendRequest: FriendRelationship;
  /** Отправить сообщение в обращение */
  sendMailMessage: MailMessage;
  /** Отправить уведомление всем сторонникам проекта */
  sendProjectSupportersNotification: Scalars['Boolean']['output'];
  sendPush: Scalars['Boolean']['output'];
  sendPushToUser: Scalars['Boolean']['output'];
  /** Отправить уведомление конкретным сторонникам по их ID */
  sendSupporterNotification: Scalars['Boolean']['output'];
  /** Send verification code. */
  sendVerificationCode: VerifyResponse;
  /** Задать/обновить код быстрого входа (4–12 цифр) для текущего пользователя. Требует авторизации. */
  setLoginCode: Scalars['Boolean']['output'];
  /** Sets new password after OTP verification (unauthenticated). */
  setNewPasswordAfterReset: Scalars['String']['output'];
  /** Установить видимость опроса для администраторов и участников проекта */
  setSurveyVisibility: SurveyDto;
  /** @deprecated use answerSurvey instead */
  startResponse: ResponseDto;
  submitContactRequest: ContactRequestResponse;
  /** @deprecated use answerSurvey instead */
  submitResponse: ResponseDto;
  subscribeToGlobal: Scalars['Boolean']['output'];
  toggleLike: LikeOutput;
  /** Включить/выключить обязательность вопроса */
  toggleQuestionRequired: QuestionDto;
  /** Включить/выключить публичную ссылку; генерирует токен при включении */
  toggleSurveyPublicLink: SurveyDto;
  /** Админ: создать или обновить запись об актуальной версии мобильного клиента. */
  updateAppVersion: AppVersionRecord;
  /** Обновить событие календаря */
  updateCalendarEvent: CalendarEvent;
  /** Обновить статус участника события (принять/отклонить/maybe) */
  updateCalendarEventParticipantStatus: CalendarEvent;
  /** Обновить счётчик */
  updateCounter: Counter;
  /** Обновить показание счётчика */
  updateCounterReading: CounterReading;
  /** Обновить контакт экстренной службы */
  updateEmergencyContact: EmergencyContact;
  /** Обновить настройки ссылки-приглашения */
  updateInvitationLink: ProjectInvitation;
  /** Обновить содержимое сообщения (например, после загрузки медиа) */
  updateMailMessage: MailMessage;
  updateManyLandingTemplates: UpdateManyResponse;
  updateMockup: Mockup;
  /** Обновить запрос на добавление в проект для текущего пользователя. Используется для редактирования своей заявки в личном кабинете. */
  updateMyProjectRequest: ProjectRequest;
  updateOneAnswer: Answer;
  updateOneComment: Comment;
  updateOneCounterEvent: CounterEvent;
  updateOneLandingTemplate: LandingTemplate;
  updateOneNews: News;
  updateOneProject: Project;
  updateOneProjectMember: ProjectMember;
  updateOneProjectOrganization: ProjectOrganization;
  updateOneProjectSupporter: ProjectSupporter;
  updateOneQuestionDto: QuestionDto;
  updateOneQuestionFieldDto: QuestionFieldDto;
  updateOneSurveyDto: SurveyDto;
  updateOneUserVerifyRequest: UserVerifyRequest;
  /** Обновить мероприятие программы по его ID */
  updateProgramItem: ProgramItem;
  /** Обновить настройки кастомного модуля */
  updateProjectCustomModule: ProjectCustomModule;
  /** Обновить запрос на добавление в проект. Используется для редактирования заявки в админке. */
  updateProjectRequest: ProjectRequest;
  /** Создать/обновить/удалить поля вопроса одним вызовом */
  updateQuestionFields: QuestionDto;
  /** Обновить вопрос и его поля одним запросом */
  updateQuestionFull: QuestionDto;
  /** Обновить выступление регламента по его ID */
  updateReglamentItem: ReglamentItem;
  /** Обновить опрос с автопубликацией */
  updateSurveyWithPublish: SurveyDto;
  updateUser: User;
  updateUserOnlineStatus: User;
  /** Обновляет пользовательский шаблон. Возвращает null если шаблон не найден. */
  updateUserTemplate?: Maybe<Template>;
  /** Настроить доступ к глобальному модулю (внесение / редактирование / полный доступ). Только квест-админ. */
  upsertGlobalModuleAccessSettings: GlobalModuleAccessSettings;
  /** Создать или обновить паспорт объекта (кнопка «Сохранить»). Один паспорт на экземпляр модуля */
  upsertObjectPassport: ObjectPassport;
  /** Сохранить настройки доступа к модулю проекта */
  upsertProjectModuleAccessSettings: ProjectModuleAccessSettings;
  /** Verifies an MFA challenge using the provided OTP code. */
  verifyMfa: AuthResponse;
  /** Verifies OTP code for password reset (unauthenticated). */
  verifyPasswordResetOtp: Scalars['String']['output'];
  /** Verifies a token and returns its payload if valid. */
  verifyToken: Scalars['String']['output'];
  /** Проголосовать в опросе и получить обновлённые результаты */
  voteNewsPoll: NewsPollResults;
  /** Отклонить запрос в друзья от пользователя. После отклонения запроса, запрашиваемый пользватель попадает в статус подписчика (FriendStatus.SUBSCRIBER). */
  withdrawFriendRequest: Scalars['Boolean']['output'];
  /** Отозвать свою заявку на вступление в проект */
  withdrawJoinRequest: ProjectJoinRequest;
  /** Отозвать заявку на слияние */
  withdrawMergeRequest: MergeSessionDto;
};


export type MutationAcceptFriendRequestArgs = {
  friendId: Scalars['String']['input'];
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAddCalendarEventParticipantsArgs = {
  input: AddCalendarEventParticipantsInput;
};


export type MutationAddNewsFavouriteArgs = {
  newsId: Scalars['String']['input'];
};


export type MutationAnswerSurveyArgs = {
  input: AnswerSurveyDto;
};


export type MutationAnswerSurveyWithCaptchaArgs = {
  input: AnswerSurveyDto;
};


export type MutationAnswerTestQuestionArgs = {
  answer: Scalars['JSON']['input'];
  questionId: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
};


export type MutationApplyMergeChangesArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationApproveJoinRequestArgs = {
  input: ApproveJoinRequestInput;
};


export type MutationApproveObjectPassportApplicationArgs = {
  input: ApproveObjectPassportApplicationInput;
};


export type MutationApproveProjectRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationApproveSpeechNewsArgs = {
  newsId: Scalars['String']['input'];
};


export type MutationApproveUserVerifyRequestArgs = {
  approvedByUserId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationBulkInviteUsersArgs = {
  input: BulkInviteInput;
};


export type MutationCancelOutgoingFriendRequestArgs = {
  friendId: Scalars['String']['input'];
};


export type MutationCloseSurveyArgs = {
  surveyId: Scalars['String']['input'];
};


export type MutationConfirmAccountRestoreArgs = {
  code: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};


export type MutationConfirmVerificationCodeArgs = {
  input: VerifyRequest;
};


export type MutationConvertSubscriberToFriendArgs = {
  subscriberId: Scalars['String']['input'];
};


export type MutationCreateAdminTemplateArgs = {
  input: CreateTemplateInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCalendarEventArgs = {
  input: CreateCalendarEventInput;
};


export type MutationCreateCounterArgs = {
  input: CreateCounterInput;
};


export type MutationCreateCounterReadingArgs = {
  input: CreateCounterReadingInput;
};


export type MutationCreateDirectInvitationArgs = {
  input: CreateDirectInvitationInput;
};


export type MutationCreateEmergencyContactArgs = {
  input: CreateEmergencyContactInput;
};


export type MutationCreateInvitationLinkArgs = {
  input: CreateInvitationLinkInput;
};


export type MutationCreateInviteArgs = {
  input: CreateInviteDto;
};


export type MutationCreateJoinRequestArgs = {
  input: CreateJoinRequestInput;
};


export type MutationCreateMailThreadArgs = {
  input: CreateMailThreadInput;
};


export type MutationCreateManyLandingTemplatesArgs = {
  input: CreateManyLandingTemplatesInput;
};


export type MutationCreateMergeRequestArgs = {
  input: CreateMergeRequestDto;
};


export type MutationCreateMockupArgs = {
  input: CreateMockupInput;
};


export type MutationCreateMyProjectRequestArgs = {
  input: CreateProjectRequestDto;
};


export type MutationCreateObjectPassportApplicationArgs = {
  input: CreateObjectPassportApplicationInput;
};


export type MutationCreateOneAnswerArgs = {
  input: CreateOneAnswerInput;
};


export type MutationCreateOneCommentArgs = {
  input: CreateOneCommentInput;
};


export type MutationCreateOneCounterEventArgs = {
  input: CreateOneCounterEventInput;
};


export type MutationCreateOneLandingTemplateArgs = {
  input: CreateOneLandingTemplateInput;
};


export type MutationCreateOneLikeArgs = {
  input: CreateOneLikeInput;
};


export type MutationCreateOneNewsArgs = {
  input: CreateOneNewsInput;
};


export type MutationCreateOneProjectArgs = {
  input: CreateOneProjectInput;
};


export type MutationCreateOneProjectMemberArgs = {
  input: CreateOneProjectMemberInput;
};


export type MutationCreateOneProjectModuleMemberArgs = {
  input: CreateOneProjectModuleMemberInput;
};


export type MutationCreateOneProjectOrganizationArgs = {
  input: CreateOneProjectOrganizationInput;
};


export type MutationCreateOneProjectSupporterArgs = {
  input: CreateOneProjectSupporterInput;
};


export type MutationCreateOneQuestionDtoArgs = {
  input: CreateOneQuestionDtoInput;
};


export type MutationCreateOneQuestionFieldDtoArgs = {
  input: CreateOneQuestionFieldDtoInput;
};


export type MutationCreateOneSurveyDtoArgs = {
  input: CreateOneSurveyDtoInput;
};


export type MutationCreateOneUserVerifyRequestArgs = {
  input: CreateOneUserVerifyRequestInput;
};


export type MutationCreateProgramItemArgs = {
  input: CreateProgramItemInput;
};


export type MutationCreateProjectCustomModuleArgs = {
  input: CreateProjectCustomModuleInput;
};


export type MutationCreatePublicLinkArgs = {
  surveyId: Scalars['String']['input'];
};


export type MutationCreateReglamentItemArgs = {
  input: CreateReglamentItemInput;
};


export type MutationCreateSurveyFullArgs = {
  input: CreateSurveyFullDto;
};


export type MutationCreateUploadUrlArgs = {
  input: CreateUploadUrlDto;
};


export type MutationCreateUserTemplateArgs = {
  input: CreateTemplateInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeactivateInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type MutationDeclineInvitationArgs = {
  input: DeclineInvitationInput;
};


export type MutationDeleteCalendarEventArgs = {
  input: DeleteCalendarEventInput;
};


export type MutationDeleteCounterArgs = {
  input: DeleteCounterInput;
};


export type MutationDeleteCounterReadingArgs = {
  input: DeleteCounterReadingInput;
};


export type MutationDeleteEmergencyContactArgs = {
  input: DeleteEmergencyContactInput;
};


export type MutationDeleteManyLandingTemplatesArgs = {
  input: DeleteManyLandingTemplatesInput;
};


export type MutationDeleteManyQuestionDtosArgs = {
  input: DeleteManyQuestionDtosInput;
};


export type MutationDeleteManySurveyDtosArgs = {
  input: DeleteManySurveyDtosInput;
};


export type MutationDeleteMediaArgs = {
  objectType: FileObjectType;
};


export type MutationDeleteMockupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOneAnswerArgs = {
  input: DeleteOneAnswerInput;
};


export type MutationDeleteOneCommentArgs = {
  input: DeleteOneCommentInput;
};


export type MutationDeleteOneCounterEventArgs = {
  input: DeleteOneCounterEventInput;
};


export type MutationDeleteOneLandingTemplateArgs = {
  input: DeleteOneLandingTemplateInput;
};


export type MutationDeleteOneLikeArgs = {
  input: DeleteOneLikeInput;
};


export type MutationDeleteOneNewsArgs = {
  input: DeleteOneNewsInput;
};


export type MutationDeleteOneProjectArgs = {
  input: DeleteOneProjectInput;
};


export type MutationDeleteOneProjectMemberArgs = {
  input: DeleteOneProjectMemberInput;
};


export type MutationDeleteOneProjectModuleMemberArgs = {
  input: DeleteOneProjectModuleMemberInput;
};


export type MutationDeleteOneProjectOrganizationArgs = {
  input: DeleteOneProjectOrganizationInput;
};


export type MutationDeleteOneProjectSupporterArgs = {
  input: DeleteOneProjectSupporterInput;
};


export type MutationDeleteOneQuestionDtoArgs = {
  input: DeleteOneQuestionDtoInput;
};


export type MutationDeleteOneQuestionFieldDtoArgs = {
  input: DeleteOneQuestionFieldDtoInput;
};


export type MutationDeleteOneSurveyDtoArgs = {
  input: DeleteOneSurveyDtoInput;
};


export type MutationDeleteOneUserVerifyRequestArgs = {
  input: DeleteOneUserVerifyRequestInput;
};


export type MutationDeleteProgramItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectCustomModuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectMembersByUserIdsArgs = {
  input: DeleteProjectMembersByUserIdsInput;
};


export type MutationDeleteProjectRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRegistryContactsArgs = {
  input: DeleteRegistryContactsInput;
};


export type MutationDeleteReglamentItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSystemMockupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserAddressArgs = {
  addressId: Scalars['Float']['input'];
};


export type MutationDeleteUserTemplateArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};


export type MutationDuplicateCalendarEventArgs = {
  input: DuplicateCalendarEventInput;
};


export type MutationExportSupporterReportArgs = {
  input: ExportSupporterReportInput;
};


export type MutationExportSurveyReportArgs = {
  input: ExportSurveyReportInput;
};


export type MutationGeneratePlatformSummaryReportArgs = {
  filters?: InputMaybe<AnalyticsFiltersInput>;
};


export type MutationGenerateProjectDetailedReportArgs = {
  filters?: InputMaybe<ProjectDetailedFiltersInput>;
};


export type MutationGenerateRegionalReportArgs = {
  filters?: InputMaybe<AnalyticsFiltersInput>;
};


export type MutationGenerateUserDetailedReportArgs = {
  filters?: InputMaybe<UserDetailedFiltersInput>;
};


export type MutationGetLandingImageUploadUrlArgs = {
  input: LandingImageUploadInput;
};


export type MutationImportFromCsvArgs = {
  csvContent: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationImportFromDataArgs = {
  importData: ImportDataDto;
};


export type MutationImportFromJsonArgs = {
  jsonContent: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationInitializeProjectCountersArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationIntrospectTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationInviteUserToSurveyArgs = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  surveyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationJoinOpenProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationJoinProjectByInvitationLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationLeaveCalendarEventArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  registerUserInput: LoginRequest;
};


export type MutationLoginByCodeArgs = {
  code: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};


export type MutationMarkAllNotificationsAsReadArgs = {
  type?: InputMaybe<NotificationType>;
};


export type MutationMarkCommentsReadArgs = {
  commentIds: Array<Scalars['ID']['input']>;
};


export type MutationMarkMailThreadAsReadArgs = {
  threadId: Scalars['ID']['input'];
};


export type MutationMarkNewsAsViewedArgs = {
  newsId: Scalars['String']['input'];
};


export type MutationMarkNewsSeenArgs = {
  newsIds: Array<Scalars['ID']['input']>;
};


export type MutationMarkNotificationActionAppliedArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationPauseSurveyArgs = {
  surveyId: Scalars['String']['input'];
};


export type MutationProcessJoinRequestArgs = {
  input: ProcessJoinRequestInput;
};


export type MutationPublishSurveyArgs = {
  input: PublishSurveyDto;
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegenerateInvitationLinkArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationRegisterUserArgs = {
  registerUserInput: RegisterUserRequest;
};


export type MutationRegisterUserTokenArgs = {
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRejectIncomingFriendRequestArgs = {
  requesterId: Scalars['String']['input'];
};


export type MutationRejectJoinRequestArgs = {
  input: RejectJoinRequestInput;
};


export type MutationRejectObjectPassportApplicationArgs = {
  input: RejectObjectPassportApplicationInput;
};


export type MutationRejectProjectRequestArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectSpeechNewsArgs = {
  newsId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectUserVerifyRequestArgs = {
  id: Scalars['String']['input'];
  rejectedByUserId: Scalars['String']['input'];
};


export type MutationRemoveCalendarEventParticipantArgs = {
  input: RemoveCalendarEventParticipantInput;
};


export type MutationRemoveFriendArgs = {
  friendId: Scalars['String']['input'];
};


export type MutationRemoveNewsFavouriteArgs = {
  newsId: Scalars['String']['input'];
};


export type MutationRemoveSubscriberArgs = {
  friendId: Scalars['String']['input'];
};


export type MutationRemoveTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationReorderSpeechNewsArgs = {
  moduleSlug: Scalars['String']['input'];
  orderedNewsIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationRequestAccountRestoreArgs = {
  identifier: Scalars['String']['input'];
  method?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPasswordResetArgs = {
  identifier: Scalars['String']['input'];
  method: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  identifier: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationRespondToMergeRequestArgs = {
  input: RespondMergeRequestDto;
};


export type MutationRevokeInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationRevokeNewsPollVoteArgs = {
  pollId: Scalars['ID']['input'];
};


export type MutationRevokeTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationSaveProgramItemsArgs = {
  input: SaveProgramItemsInput;
};


export type MutationSaveReglamentItemsArgs = {
  input: SaveReglamentItemsInput;
};


export type MutationSaveResponseArgs = {
  input: SaveResponseDto;
};


export type MutationSchedulePublishSurveyArgs = {
  input: SchedulePublishSurveyDto;
};


export type MutationSendFriendRequestArgs = {
  friendId: Scalars['String']['input'];
};


export type MutationSendMailMessageArgs = {
  input: SendMailMessageInput;
};


export type MutationSendProjectSupportersNotificationArgs = {
  apiKeyType?: InputMaybe<SmscApiKeyType>;
  content?: InputMaybe<NotificationContentDto>;
  projectId: Scalars['String']['input'];
  template?: InputMaybe<NotificationTemplate>;
  templateParams?: InputMaybe<Scalars['String']['input']>;
  type: NotificationDeliveryType;
};


export type MutationSendPushArgs = {
  badge?: InputMaybe<Scalars['Int']['input']>;
  body: Scalars['String']['input'];
  extraData?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendPushToUserArgs = {
  badge?: InputMaybe<Scalars['Int']['input']>;
  body: Scalars['String']['input'];
  extraData?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSendSupporterNotificationArgs = {
  apiKeyType?: InputMaybe<SmscApiKeyType>;
  content?: InputMaybe<NotificationContentDto>;
  supporterIds: Array<Scalars['String']['input']>;
  template?: InputMaybe<NotificationTemplate>;
  templateParams?: InputMaybe<Scalars['String']['input']>;
  type: NotificationDeliveryType;
};


export type MutationSendVerificationCodeArgs = {
  input: SendVerificationCodeRequest;
};


export type MutationSetLoginCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationSetNewPasswordAfterResetArgs = {
  identifier: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationSetSurveyVisibilityArgs = {
  surveyId: Scalars['String']['input'];
  visibleToProjectAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  visibleToProjectMembers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationStartResponseArgs = {
  input: StartResponseDto;
};


export type MutationSubmitContactRequestArgs = {
  input: SubmitContactRequestInput;
};


export type MutationSubmitResponseArgs = {
  input: SubmitResponseDto;
};


export type MutationSubscribeToGlobalArgs = {
  token: Scalars['String']['input'];
};


export type MutationToggleLikeArgs = {
  input: ToggleLikeInput;
};


export type MutationToggleQuestionRequiredArgs = {
  input: ToggleQuestionRequiredDto;
};


export type MutationToggleSurveyPublicLinkArgs = {
  enabled: Scalars['Boolean']['input'];
  surveyId: Scalars['String']['input'];
};


export type MutationUpdateAppVersionArgs = {
  input: UpdateAppVersionInput;
};


export type MutationUpdateCalendarEventArgs = {
  input: UpdateCalendarEventInput;
};


export type MutationUpdateCalendarEventParticipantStatusArgs = {
  input: UpdateCalendarEventParticipantStatusInput;
};


export type MutationUpdateCounterArgs = {
  input: UpdateCounterInput;
};


export type MutationUpdateCounterReadingArgs = {
  input: UpdateCounterReadingInput;
};


export type MutationUpdateEmergencyContactArgs = {
  input: UpdateEmergencyContactInput;
};


export type MutationUpdateInvitationLinkArgs = {
  input: UpdateInvitationLinkInput;
};


export type MutationUpdateMailMessageArgs = {
  input: UpdateMailMessageInput;
};


export type MutationUpdateManyLandingTemplatesArgs = {
  input: UpdateManyLandingTemplatesInput;
};


export type MutationUpdateMockupArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMockupInput;
};


export type MutationUpdateMyProjectRequestArgs = {
  id: Scalars['String']['input'];
  input: UpdateProjectRequestDto;
};


export type MutationUpdateOneAnswerArgs = {
  input: UpdateOneAnswerInput;
};


export type MutationUpdateOneCommentArgs = {
  input: UpdateOneCommentInput;
};


export type MutationUpdateOneCounterEventArgs = {
  input: UpdateOneCounterEventInput;
};


export type MutationUpdateOneLandingTemplateArgs = {
  input: UpdateOneLandingTemplateInput;
};


export type MutationUpdateOneNewsArgs = {
  input: UpdateOneNewsInput;
};


export type MutationUpdateOneProjectArgs = {
  input: UpdateOneProjectInput;
};


export type MutationUpdateOneProjectMemberArgs = {
  input: UpdateOneProjectMemberInput;
};


export type MutationUpdateOneProjectOrganizationArgs = {
  input: UpdateOneProjectOrganizationInput;
};


export type MutationUpdateOneProjectSupporterArgs = {
  input: UpdateOneProjectSupporterInput;
};


export type MutationUpdateOneQuestionDtoArgs = {
  input: UpdateOneQuestionDtoInput;
};


export type MutationUpdateOneQuestionFieldDtoArgs = {
  input: UpdateOneQuestionFieldDtoInput;
};


export type MutationUpdateOneSurveyDtoArgs = {
  input: UpdateOneSurveyDtoInput;
};


export type MutationUpdateOneUserVerifyRequestArgs = {
  input: UpdateOneUserVerifyRequestInput;
};


export type MutationUpdateProgramItemArgs = {
  input: UpdateProgramItemInput;
};


export type MutationUpdateProjectCustomModuleArgs = {
  input: UpdateProjectCustomModuleInput;
};


export type MutationUpdateProjectRequestArgs = {
  id: Scalars['String']['input'];
  input: UpdateProjectRequestDto;
};


export type MutationUpdateQuestionFieldsArgs = {
  input: UpdateQuestionFieldsDto;
};


export type MutationUpdateQuestionFullArgs = {
  input: UpdateQuestionFullDto;
};


export type MutationUpdateReglamentItemArgs = {
  input: UpdateReglamentItemInput;
};


export type MutationUpdateSurveyWithPublishArgs = {
  input: UpdateSurveyWithPublishDto;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateUserOnlineStatusArgs = {
  input: UpdateUserOnlineStatusInput;
};


export type MutationUpdateUserTemplateArgs = {
  input: UpdateTemplateInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};


export type MutationUpsertGlobalModuleAccessSettingsArgs = {
  input: UpsertGlobalModuleAccessSettingsInput;
};


export type MutationUpsertObjectPassportArgs = {
  input: UpsertObjectPassportInput;
};


export type MutationUpsertProjectModuleAccessSettingsArgs = {
  input: UpsertProjectModuleAccessSettingsInput;
};


export type MutationVerifyMfaArgs = {
  otpCode: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationVerifyPasswordResetOtpArgs = {
  identifier: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationVoteNewsPollArgs = {
  optionIds: Array<Scalars['ID']['input']>;
  pollId: Scalars['ID']['input'];
};


export type MutationWithdrawFriendRequestArgs = {
  friendId: Scalars['String']['input'];
};


export type MutationWithdrawJoinRequestArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationWithdrawMergeRequestArgs = {
  sessionId: Scalars['String']['input'];
};

export type News = {
  __typename?: 'News';
  /** Дополнительная информация для новости-выступления */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  author?: Maybe<User>;
  /** Полное имя автора новости */
  authorFullname?: Maybe<Scalars['String']['output']>;
  /** ID автора новости */
  authorUserId?: Maybe<Scalars['ID']['output']>;
  /** Количество комментариев */
  comments?: Maybe<CommentCountOutput>;
  /** Содержание новости */
  content?: Maybe<Scalars['JSON']['output']>;
  counters?: Maybe<CounterOutput>;
  createdAt: Scalars['DateTime']['output'];
  /** ID пользователя, создавшего новость */
  createdByUserId: Scalars['ID']['output'];
  /** Ссылки на дополнительные фотографии (presigned GET URL). Опциональное поле. */
  customPhotos?: Maybe<Array<Scalars['String']['output']>>;
  /** Ссылки на дополнительные видео (presigned GET URL). Опциональное поле. */
  customVideos?: Maybe<Array<Scalars['String']['output']>>;
  /** ФИО в рукописном формате для новости-выступления */
  handwrittenFullname?: Maybe<Scalars['String']['output']>;
  /** ID новости */
  id: Scalars['ID']['output'];
  /** Находится ли новость в избранном у текущего пользователя (персонально). */
  isFavourite: Scalars['Boolean']['output'];
  likes?: Maybe<LikeOutput>;
  /** URL главного изображения */
  mainImage?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<MediaOutputDto>>;
  /** Производный статус модерации для выступлений (my_speech): PENDING / APPROVED / REJECTED / ARCHIVED. Для не-выступлений всегда null. */
  moderationStatus?: Maybe<NewsModerationStatusEnum>;
  /** Слаг модуля, к которому относится новость */
  moduleSlug: Scalars['String']['output'];
  owner: NewsOwner;
  /** ID владельца новости */
  ownerId: Scalars['ID']['output'];
  /** Тип владельца новости */
  ownerType: NewsOwnerTypeEnum;
  /** Возвращает массив с разрешениями */
  permissions?: Maybe<Scalars['JSON']['output']>;
  /** Информация об опросе, прикреплённом к новости */
  poll?: Maybe<NewsPoll>;
  /** Результаты голосования (агрегированные данные) */
  pollResults?: Maybe<NewsPollResults>;
  /** Причина отклонения выступления. После reject поле всегда non-null (пустая строка, если модератор не указал причину). null означает "никогда не отклонялось" (PENDING или APPROVED). */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** Ручной порядок в списке (для выступлений my_speech; меньше = выше). Сортируйте список по sortOrder ASC. null — порядок не задан */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** «Первоисточник» — ссылка на исходный материал / пермалинк */
  sourceLink?: Maybe<Scalars['String']['output']>;
  /** Статус новости */
  status: NewsStatusEnum;
  tags: NewsTagsConnection;
  /** Заголовок новости */
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** ID пользователя, обновившего новость */
  updatedByUserId?: Maybe<Scalars['ID']['output']>;
};


export type NewsTagsArgs = {
  filter?: TagDtoFilter;
  paging?: OffsetPaging;
  sorting?: Array<TagDtoSort>;
};

export type NewsDeleteResponse = {
  __typename?: 'NewsDeleteResponse';
  /** Дополнительная информация для новости-выступления */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Полное имя автора новости */
  authorFullname?: Maybe<Scalars['String']['output']>;
  /** ID автора новости */
  authorUserId?: Maybe<Scalars['ID']['output']>;
  /** Содержание новости */
  content?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя, создавшего новость */
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  /** Ссылки на дополнительные фотографии (presigned GET URL). Опциональное поле. */
  customPhotos?: Maybe<Array<Scalars['String']['output']>>;
  /** Ссылки на дополнительные видео (presigned GET URL). Опциональное поле. */
  customVideos?: Maybe<Array<Scalars['String']['output']>>;
  /** ФИО в рукописном формате для новости-выступления */
  handwrittenFullname?: Maybe<Scalars['String']['output']>;
  /** ID новости */
  id?: Maybe<Scalars['ID']['output']>;
  /** Находится ли новость в избранном у текущего пользователя (персонально). */
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  /** URL главного изображения */
  mainImage?: Maybe<Scalars['String']['output']>;
  /** Производный статус модерации для выступлений (my_speech): PENDING / APPROVED / REJECTED / ARCHIVED. Для не-выступлений всегда null. */
  moderationStatus?: Maybe<NewsModerationStatusEnum>;
  /** Слаг модуля, к которому относится новость */
  moduleSlug?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<NewsOwner>;
  /** ID владельца новости */
  ownerId?: Maybe<Scalars['ID']['output']>;
  /** Тип владельца новости */
  ownerType?: Maybe<NewsOwnerTypeEnum>;
  /** Информация об опросе, прикреплённом к новости */
  poll?: Maybe<NewsPoll>;
  /** Результаты голосования (агрегированные данные) */
  pollResults?: Maybe<NewsPollResults>;
  /** Причина отклонения выступления. После reject поле всегда non-null (пустая строка, если модератор не указал причину). null означает "никогда не отклонялось" (PENDING или APPROVED). */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** Ручной порядок в списке (для выступлений my_speech; меньше = выше). Сортируйте список по sortOrder ASC. null — порядок не задан */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** «Первоисточник» — ссылка на исходный материал / пермалинк */
  sourceLink?: Maybe<Scalars['String']['output']>;
  /** Статус новости */
  status?: Maybe<NewsStatusEnum>;
  /** Заголовок новости */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя, обновившего новость */
  updatedByUserId?: Maybe<Scalars['ID']['output']>;
};

export type NewsDigestUnseenCount = {
  __typename?: 'NewsDigestUnseenCount';
  /** Непросмотренные новости во вкладке «Новости Проекта» (ownerType=PROJECT из проектов, где пользователь участник). */
  project: Scalars['Int']['output'];
  /** Непросмотренные новости во вкладке «Новости Квест» (moduleSlug=news_digest), с учётом createdAtGte, если передан. */
  quest: Scalars['Int']['output'];
  /** Всего непросмотренных (quest + project). */
  total: Scalars['Int']['output'];
};

export type NewsFilter = {
  and?: InputMaybe<Array<NewsFilter>>;
  authorFullname?: InputMaybe<StringFieldComparison>;
  authorUserId?: InputMaybe<IdFilterComparison>;
  content?: InputMaybe<JsonFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdByUserId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  mainImage?: InputMaybe<StringFieldComparison>;
  moduleSlug?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<NewsFilter>>;
  ownerId?: InputMaybe<IdFilterComparison>;
  ownerType?: InputMaybe<NewsOwnerTypeEnumFilterComparison>;
  sortOrder?: InputMaybe<IntFieldComparison>;
  sourceLink?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<NewsStatusEnumFilterComparison>;
  tags?: InputMaybe<NewsFilterTagDtoFilter>;
  title?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  updatedByUserId?: InputMaybe<IdFilterComparison>;
};

export type NewsFilterTagDtoFilter = {
  and?: InputMaybe<Array<NewsFilterTagDtoFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<NewsFilterTagDtoFilter>>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export enum NewsMediaType {
  Photo = 'PHOTO',
  Video = 'VIDEO'
}

/** Производный статус модерации выступления (my_speech). PENDING — на модерации (создано/отправлено заново после правки). APPROVED — одобрено и опубликовано. REJECTED — отклонено модератором (rejectionReason содержит причину или пусто). ARCHIVED — архив. Для не-выступлений значение всегда null. */
export enum NewsModerationStatusEnum {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type NewsOffsetConnection = {
  __typename?: 'NewsOffsetConnection';
  /** Array of nodes. */
  nodes: Array<News>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type NewsOwner = Project | User;

/** The type of owner for a news item (user, project, or company) */
export enum NewsOwnerTypeEnum {
  Project = 'PROJECT',
  User = 'USER'
}

export type NewsOwnerTypeEnumFilterComparison = {
  eq?: InputMaybe<NewsOwnerTypeEnum>;
  gt?: InputMaybe<NewsOwnerTypeEnum>;
  gte?: InputMaybe<NewsOwnerTypeEnum>;
  iLike?: InputMaybe<NewsOwnerTypeEnum>;
  in?: InputMaybe<Array<NewsOwnerTypeEnum>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<NewsOwnerTypeEnum>;
  lt?: InputMaybe<NewsOwnerTypeEnum>;
  lte?: InputMaybe<NewsOwnerTypeEnum>;
  neq?: InputMaybe<NewsOwnerTypeEnum>;
  notILike?: InputMaybe<NewsOwnerTypeEnum>;
  notIn?: InputMaybe<Array<NewsOwnerTypeEnum>>;
  notLike?: InputMaybe<NewsOwnerTypeEnum>;
};

export type NewsPoll = {
  __typename?: 'NewsPoll';
  /** Объяснение к опросу (может отсутствовать) */
  explanation?: Maybe<Scalars['String']['output']>;
  /** ID опроса */
  id: Scalars['ID']['output'];
  /** Флаг анонимного голосования */
  isAnonymous: Scalars['Boolean']['output'];
  /** Разрешён ли множественный выбор */
  isMultipleChoice: Scalars['Boolean']['output'];
  /** Находится ли опрос в режиме викторины */
  isQuizMode: Scalars['Boolean']['output'];
  /** Список вариантов ответа */
  options: Array<NewsPollOption>;
  /** Вопрос опроса */
  question: Scalars['String']['output'];
  /** Проголосовал ли текущий пользователь (если указан) */
  viewerHasVoted?: Maybe<Scalars['Boolean']['output']>;
  /** Идентификаторы вариантов, выбранных текущим пользователем (если он голосовал) */
  viewerOptionIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type NewsPollOption = {
  __typename?: 'NewsPollOption';
  /** ID варианта ответа */
  id: Scalars['ID']['output'];
  /** Признак правильного ответа (используется в режиме викторины) */
  isCorrect: Scalars['Boolean']['output'];
  /** Позиция варианта в списке (начинается с 0) */
  position: Scalars['Int']['output'];
  /** Текст варианта ответа */
  title: Scalars['String']['output'];
};

export type NewsPollOptionResult = {
  __typename?: 'NewsPollOptionResult';
  /** Признак правильности варианта (актуально в режиме викторины) */
  isCorrect: Scalars['Boolean']['output'];
  /** ID варианта ответа */
  optionId: Scalars['ID']['output'];
  /** Доля голосов за вариант относительно уникальных участников */
  percentage: Scalars['Float']['output'];
  /** Текст варианта ответа */
  title: Scalars['String']['output'];
  /** Количество голосов за вариант */
  voteCount: Scalars['Int']['output'];
  /** Список участников, проголосовавших за вариант (только если опрос не анонимный) */
  voters?: Maybe<Array<User>>;
};

export type NewsPollResults = {
  __typename?: 'NewsPollResults';
  /** Статистика по вариантам ответа */
  options: Array<NewsPollOptionResult>;
  /** ID опроса */
  pollId: Scalars['ID']['output'];
  /** Количество уникальных участников, проголосовавших в опросе */
  totalVoters: Scalars['Int']['output'];
  /** Общее количество голосов (учитывает множественный выбор как несколько голосов) */
  totalVotes: Scalars['Int']['output'];
};

export type NewsPresignedGetUrlInput = {
  /** Время жизни ссылки в секундах (по умолчанию 600). */
  expires?: InputMaybe<Scalars['Int']['input']>;
  /** Ключ объекта в MinIO (значение из customPhotos / customVideos новости). */
  objectName: Scalars['String']['input'];
};

export type NewsPresignedGetUrlResponse = {
  __typename?: 'NewsPresignedGetUrlResponse';
  /** Ключ объекта в MinIO */
  objectName: Scalars['String']['output'];
  /** Presigned GET URL для скачивания файла из MinIO */
  url: Scalars['String']['output'];
};

export type NewsPresignedPutUrlInput = {
  /** Время жизни ссылки в секундах (по умолчанию 600). */
  expires?: InputMaybe<Scalars['Int']['input']>;
  /** Имя исходного файла (с расширением). Расширение используется для формирования ключа объекта в MinIO. */
  filename: Scalars['String']['input'];
  /** Тип медиафайла (PHOTO или VIDEO). Определяет префикс пути в хранилище. */
  mediaType: NewsMediaType;
  /** ID новости, к которой привязан медиафайл. Новость должна быть создана заранее (например, со статусом DRAFT). */
  newsId: Scalars['ID']['input'];
};

export type NewsPresignedPutUrlResponse = {
  __typename?: 'NewsPresignedPutUrlResponse';
  /** Ключ объекта в MinIO. Должен быть сохранён в customPhotos / customVideos после успешной загрузки. */
  objectName: Scalars['String']['output'];
  /** Presigned PUT URL для загрузки файла в MinIO */
  url: Scalars['String']['output'];
};

export type NewsSort = {
  direction: SortDirection;
  field: NewsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum NewsSortFields {
  AuthorFullname = 'authorFullname',
  AuthorUserId = 'authorUserId',
  Content = 'content',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Id = 'id',
  MainImage = 'mainImage',
  ModuleSlug = 'moduleSlug',
  OwnerId = 'ownerId',
  OwnerType = 'ownerType',
  SortOrder = 'sortOrder',
  SourceLink = 'sourceLink',
  Status = 'status',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UpdatedByUserId = 'updatedByUserId'
}

/**
 * Статус новости
 * DRAFT - черновик
 * PUBLISHED - опубликована
 * ARCHIVED - архивирована
 */
export enum NewsStatusEnum {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type NewsStatusEnumFilterComparison = {
  eq?: InputMaybe<NewsStatusEnum>;
  gt?: InputMaybe<NewsStatusEnum>;
  gte?: InputMaybe<NewsStatusEnum>;
  iLike?: InputMaybe<NewsStatusEnum>;
  in?: InputMaybe<Array<NewsStatusEnum>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<NewsStatusEnum>;
  lt?: InputMaybe<NewsStatusEnum>;
  lte?: InputMaybe<NewsStatusEnum>;
  neq?: InputMaybe<NewsStatusEnum>;
  notILike?: InputMaybe<NewsStatusEnum>;
  notIn?: InputMaybe<Array<NewsStatusEnum>>;
  notLike?: InputMaybe<NewsStatusEnum>;
};

export type NewsTagsConnection = {
  __typename?: 'NewsTagsConnection';
  /** Array of nodes. */
  nodes: Array<TagDto>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

/** Ответ с следующим вопросом теста */
export type NextQuestionResponseDto = {
  __typename?: 'NextQuestionResponseDto';
  /** Прогресс прохождения теста */
  progress: TestProgressDto;
  /** Следующий вопрос теста */
  question?: Maybe<QuestionDto>;
};

export type NotInPendingStatus = {
  __typename?: 'NotInPendingStatus';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type NotSuccess = {
  __typename?: 'NotSuccess';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  actionApplied: Scalars['Boolean']['output'];
  body: Scalars['String']['output'];
  calendarEventId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  project?: Maybe<ProjectInfo>;
  sender?: Maybe<UserInfo>;
  title: Scalars['String']['output'];
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Notification>;
  total: Scalars['Float']['output'];
  unreadCount: Scalars['Float']['output'];
};

export type NotificationContentDto = {
  html?: InputMaybe<Scalars['String']['input']>;
  smsMessage?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Способ доставки уведомления (EMAIL, SMS или BOTH) */
export enum NotificationDeliveryType {
  Both = 'BOTH',
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** Шаблон уведомления */
export enum NotificationTemplate {
  Email_2Fa = 'EMAIL_2FA',
  EmailInfo = 'EMAIL_INFO',
  EmailOther = 'EMAIL_OTHER',
  EmailPromo = 'EMAIL_PROMO',
  EmailSupport = 'EMAIL_SUPPORT',
  EmailVerification = 'EMAIL_VERIFICATION',
  EmailWarning = 'EMAIL_WARNING',
  Sms_2Fa = 'SMS_2FA',
  SmsBroadcast = 'SMS_BROADCAST',
  SmsInfo = 'SMS_INFO',
  SmsOther = 'SMS_OTHER',
  SmsPhoneVerification = 'SMS_PHONE_VERIFICATION',
  SmsPromo = 'SMS_PROMO',
  SmsSupport = 'SMS_SUPPORT',
  SmsWarning = 'SMS_WARNING'
}

/** Types of notifications (all, friends, projects) */
export enum NotificationType {
  All = 'ALL',
  Friends = 'FRIENDS',
  Projects = 'PROJECTS'
}

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type ObjectPassport = {
  __typename?: 'ObjectPassport';
  attachments: Array<ObjectPassportAttachment>;
  /** Контактное лицо (отображаемое имя/ФИО) */
  contactPersonName?: Maybe<Scalars['String']['output']>;
  /** Контактное лицо — ссылка на пользователя платформы (если выбран) */
  contactPersonUserId?: Maybe<Scalars['ID']['output']>;
  /** Контактный телефон */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID пользователя, создавшего паспорт */
  createdByUserId: Scalars['ID']['output'];
  /** Краткое описание */
  description?: Maybe<Scalars['String']['output']>;
  /** Дата и время окончания (UTC) */
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** Вид мероприятия */
  eventType?: Maybe<Scalars['String']['output']>;
  /** Предполагаемая численность участников */
  expectedHeadcount?: Maybe<Scalars['Int']['output']>;
  /** ID паспорта */
  id: Scalars['ID']['output'];
  /** Место проведения */
  location?: Maybe<Scalars['String']['output']>;
  /** Слаг связанного модуля «Программа» (program[_<suffix>]) того же проекта */
  moduleProgramRelated?: Maybe<Scalars['String']['output']>;
  /** Слаг связанного модуля «Регламент» (reglament[_<suffix>]) того же проекта */
  moduleReglamentRelated?: Maybe<Scalars['String']['output']>;
  /** Слаг экземпляра модуля */
  moduleSlug: Scalars['String']['output'];
  /** Название мероприятия/объекта */
  name: Scalars['String']['output'];
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Дата и время начала (UTC) */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** IANA-таймзона, в которой заполнялся паспорт */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type ObjectPassportApplication = {
  __typename?: 'ObjectPassportApplication';
  /** Дополнительная информация */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** ID пользователя, отправившего заявку (если был авторизован) */
  applicantUserId?: Maybe<Scalars['ID']['output']>;
  /** Текст обращения */
  applicationText?: Maybe<Scalars['String']['output']>;
  /** Дата создания заявки */
  createdAt: Scalars['DateTime']['output'];
  /** ФИО заявителя */
  fullName: Scalars['String']['output'];
  /** ID заявки */
  id: Scalars['ID']['output'];
  /** Момент принятия решения модератором */
  moderatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID модератора, принявшего решение */
  moderatedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Комментарий модератора */
  moderatorComment?: Maybe<Scalars['String']['output']>;
  /** Слаг модуля */
  moduleSlug: Scalars['String']['output'];
  /** Формат участия (очно / заочно) */
  participationFormat?: Maybe<ObjectPassportParticipationFormatEnum>;
  /** ID паспорта */
  passportId: Scalars['ID']['output'];
  /** Номер телефона */
  phone?: Maybe<Scalars['String']['output']>;
  /** Должность / статус */
  position?: Maybe<Scalars['String']['output']>;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Статус модерации заявки */
  status: ObjectPassportApplicationStatusEnum;
  /** Дата обновления заявки */
  updatedAt: Scalars['DateTime']['output'];
};

export type ObjectPassportApplicationList = {
  __typename?: 'ObjectPassportApplicationList';
  /** Есть ли следующая страница */
  hasMore: Scalars['Boolean']['output'];
  /** Заявки */
  items: Array<ObjectPassportApplication>;
  /** Размер страницы */
  limit: Scalars['Int']['output'];
  /** Текущая страница (с 1) */
  page: Scalars['Int']['output'];
  /** Всего заявок, удовлетворяющих фильтру */
  total: Scalars['Int']['output'];
};

export type ObjectPassportApplicationListFilterInput = {
  /** Размер страницы (1–500) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Слаг модуля (вместе с projectId) */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  /** Страница (с 1) */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** ID паспорта (либо passportId, либо projectId+moduleSlug) */
  passportId?: InputMaybe<Scalars['ID']['input']>;
  /** ID проекта (вместе с moduleSlug) */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** Фильтр по статусу заявки */
  status?: InputMaybe<ObjectPassportApplicationStatusEnum>;
};

/** Статус заявки на участие: PENDING — на рассмотрении, APPROVED — согласована, REJECTED — отклонена */
export enum ObjectPassportApplicationStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ObjectPassportAttachment = {
  __typename?: 'ObjectPassportAttachment';
  /** Дата создания вложения */
  createdAt: Scalars['DateTime']['output'];
  /** Ключ файла в S3/MinIO */
  fileKey: Scalars['String']['output'];
  /** Имя файла */
  fileName: Scalars['String']['output'];
  /** Размер файла в байтах */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** ID вложения */
  id: Scalars['ID']['output'];
  /** Тип файла (обложка / карта проезда / программа / регламент) */
  kind: ObjectPassportFileKindEnum;
  /** MIME-тип файла */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** ID паспорта */
  passportId: Scalars['ID']['output'];
  /** ID пользователя, загрузившего файл */
  uploadedByUserId: Scalars['ID']['output'];
  /** Presigned URL для скачивания (генерируется на лету в резолвере) */
  url?: Maybe<Scalars['String']['output']>;
};

export type ObjectPassportAttachmentInput = {
  /** Ключ файла в S3/MinIO */
  fileKey: Scalars['String']['input'];
  /** Имя файла, как его видит пользователь */
  fileName: Scalars['String']['input'];
  /** Размер файла в байтах */
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  /** Тип файла (обложка / карта проезда / программа / регламент) */
  kind: ObjectPassportFileKindEnum;
  /** MIME-тип файла */
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/** Тип файла паспорта: COVER — обложка, ROUTE_MAP — карта проезда/прохода, PROGRAM — программа, REGLAMENT — регламент */
export enum ObjectPassportFileKindEnum {
  Cover = 'COVER',
  Program = 'PROGRAM',
  Reglament = 'REGLAMENT',
  RouteMap = 'ROUTE_MAP'
}

/** Формат участия: IN_PERSON — очно, REMOTE — заочно */
export enum ObjectPassportParticipationFormatEnum {
  InPerson = 'IN_PERSON',
  Remote = 'REMOTE'
}

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
};

export type OffsetPaging = {
  /** Limit the number of records returned */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Offset to start returning records from */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Вариант ответа для choice-вопроса */
export type OptionDto = {
  __typename?: 'OptionDto';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Идентификатор варианта */
  id: Scalars['ID']['output'];
  /** Является ли вариант "Другое" с возможностью свободного ввода */
  isOther: Scalars['Boolean']['output'];
  /** Порядок варианта в списке */
  order: Scalars['Float']['output'];
  /** Текст варианта ответа */
  text: Scalars['String']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type OptionDtoFilter = {
  and?: InputMaybe<Array<OptionDtoFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isOther?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<OptionDtoFilter>>;
  order?: InputMaybe<NumberFieldComparison>;
  text?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type OptionDtoSort = {
  direction: SortDirection;
  field: OptionDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OptionDtoSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsOther = 'isOther',
  Order = 'order',
  Text = 'text',
  UpdatedAt = 'updatedAt'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
};

export type ParsedAddressDto = {
  __typename?: 'ParsedAddressDto';
  /** Исходный адрес как есть (если парсинг неуверенный) */
  addressComment?: Maybe<Scalars['String']['output']>;
  /** JSON структуры нормализованного адреса */
  addressJSON?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<Scalars['String']['output']>;
  /** Район города */
  cityDistrict?: Maybe<Scalars['String']['output']>;
  /** Код домофона */
  doorphone?: Maybe<Scalars['String']['output']>;
  /** Номер подъезда */
  entrance?: Maybe<Scalars['String']['output']>;
  /** Номер квартиры */
  flat?: Maybe<Scalars['String']['output']>;
  /** Номер этажа */
  floor?: Maybe<Scalars['String']['output']>;
  /** Флаг ручного ввода адреса (true если автопарсинг не сработал) */
  isManual?: Maybe<Scalars['Boolean']['output']>;
  /** Почтовый индекс (6 цифр) */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Регион, область, край */
  region?: Maybe<Scalars['String']['output']>;
  /** Населенный пункт (деревня, село и т.д.) */
  settlement?: Maybe<Scalars['String']['output']>;
  /** Улица, проспект, переулок */
  street?: Maybe<Scalars['String']['output']>;
};

/** Направление сортировки участников */
export enum ParticipantSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Поле для сортировки участников */
export enum ParticipantSortField {
  CompletedCount = 'COMPLETED_COUNT',
  FirstResponse = 'FIRST_RESPONSE',
  LastResponse = 'LAST_RESPONSE'
}

export type Phrase = {
  __typename?: 'Phrase';
  author?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type PlatformSummaryReportEntity = {
  __typename?: 'PlatformSummaryReportEntity';
  /** Общее количество активных пользователей */
  activeUsersCount: Scalars['Int']['output'];
  /** Среднее время нахождения в КВЕСТ (в минутах) */
  averageSessionDuration?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Конец периода отчета */
  periodEnd: Scalars['DateTime']['output'];
  /** Начало периода отчета */
  periodStart: Scalars['DateTime']['output'];
  /** Дата формирования отчета */
  reportDate: Scalars['DateTime']['output'];
  /** Общее количество дружеских связей */
  totalFriendships: Scalars['Int']['output'];
  /** Количество владельцев проектов */
  totalProjectOwners: Scalars['Int']['output'];
  /** Количество людей, состоящих хотя бы в одном проекте */
  totalProjectParticipants: Scalars['Int']['output'];
  /** Проектов на площадке КВЕСТ */
  totalProjects: Scalars['Int']['output'];
  /** Количество зарегистрированных в КВЕСТе */
  totalRegisteredUsers: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  /** Ключ объекта в MinIO. Можно сохранить в поле photo заявки/проекта после загрузки. */
  objectName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ProcessJoinRequestInput = {
  /** Одобрить заявку (true) или отклонить (false) */
  approve: Scalars['Boolean']['input'];
  /** Причина отклонения (обязательно при отклонении) */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** ID заявки на вступление */
  requestId: Scalars['ID']['input'];
};

/** Тип файла программы: ROUTE_MAP — карта проезда/прохода */
export enum ProgramFileKindEnum {
  RouteMap = 'ROUTE_MAP'
}

export type ProgramItem = {
  __typename?: 'ProgramItem';
  attachments: Array<ProgramItemAttachment>;
  /** Контактное лицо (отображаемое имя/ФИО) */
  contactPersonName?: Maybe<Scalars['String']['output']>;
  /** Контактное лицо — ссылка на пользователя платформы (если выбран) */
  contactPersonUserId?: Maybe<Scalars['ID']['output']>;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID пользователя, создавшего карточку */
  createdByUserId: Scalars['ID']['output'];
  /** Дата и время окончания (UTC) */
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID мероприятия программы */
  id: Scalars['ID']['output'];
  /** Место проведения */
  location?: Maybe<Scalars['String']['output']>;
  /** Слаг экземпляра модуля */
  moduleSlug: Scalars['String']['output'];
  /** Наименование мероприятия */
  name: Scalars['String']['output'];
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Порядок карточки в списке */
  sortOrder: Scalars['Int']['output'];
  /** Дата и время начала (UTC) */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** IANA-таймзона, в которой заполнялась карточка */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** ID пользователя, последним обновившего карточку */
  updatedByUserId?: Maybe<Scalars['ID']['output']>;
};

export type ProgramItemAttachment = {
  __typename?: 'ProgramItemAttachment';
  /** Дата создания вложения */
  createdAt: Scalars['DateTime']['output'];
  /** Ключ файла в S3/MinIO */
  fileKey: Scalars['String']['output'];
  /** Имя файла */
  fileName: Scalars['String']['output'];
  /** Размер файла в байтах */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** ID вложения */
  id: Scalars['ID']['output'];
  /** Тип файла (карта проезда/прохода) */
  kind: ProgramFileKindEnum;
  /** MIME-тип файла */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** ID мероприятия программы */
  programItemId: Scalars['ID']['output'];
  /** ID пользователя, загрузившего файл */
  uploadedByUserId: Scalars['ID']['output'];
  /** Presigned URL для скачивания (генерируется на лету в резолвере) */
  url?: Maybe<Scalars['String']['output']>;
};

export type ProgramItemAttachmentInput = {
  /** Ключ файла в S3/MinIO */
  fileKey: Scalars['String']['input'];
  /** Имя файла, как его видит пользователь */
  fileName: Scalars['String']['input'];
  /** Размер файла в байтах */
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  /** Тип файла (карта проезда/прохода) */
  kind?: InputMaybe<ProgramFileKindEnum>;
  /** MIME-тип файла (image/* или application/pdf) */
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type Project = {
  __typename?: 'Project';
  createdAt: Scalars['DateTime']['output'];
  /** Дата мягкого удаления проекта */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Подробное описание проекта */
  detailedDescription?: Maybe<Scalars['String']['output']>;
  /** Дата окончания проекта */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Кнопки гамбургер-меню проекта (произвольная JSON-структура) */
  hamburgerButtons?: Maybe<Scalars['JSON']['output']>;
  /** Кнопки шапки (header) проекта (произвольная JSON-структура) */
  headerButtons?: Maybe<Scalars['JSON']['output']>;
  /** ID проекта */
  id: Scalars['ID']['output'];
  /** Активен ли проект (не закончился) */
  isActive: Scalars['Boolean']['output'];
  /** Признак того, что проект удалён (soft delete) */
  isDeleted: Scalars['Boolean']['output'];
  /** Опубликован ли проект (видимость в каталогах/публичных выдачах) */
  isPublished: Scalars['Boolean']['output'];
  likes?: Maybe<LikeOutput>;
  media?: Maybe<ProjectMedia>;
  /** Название проекта */
  name: Scalars['String']['output'];
  owner: User;
  /** ID пользователя, которому принадлежит проект */
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  /** Ключ объекта MinIO логотипа проекта (PNG/WebP) или presigned URL */
  photo?: Maybe<Scalars['String']['output']>;
  projectMembers: ProjectProjectMembersConnection;
  /** ID запроса на добавление в проект */
  projectRequestId?: Maybe<Scalars['ID']['output']>;
  /** Краткое описание проекта */
  shortDescription: Scalars['String']['output'];
  /** URL-дружелюбный слаг проекта (опционально) */
  slug?: Maybe<Scalars['String']['output']>;
  /** Дата начала проекта */
  startDate: Scalars['DateTime']['output'];
  /** Шаблон проекта (classic или deputy) */
  templateType: ProjectTemplateEnum;
  /** Тема проекта */
  themes: Array<ProjectThemeEnum>;
  updatedAt: Scalars['DateTime']['output'];
  /** Тип видимости проекта */
  visibility: ProjectVisibilityEnum;
  /** Нативные модули рабочего стола (порядок отображения) */
  workspaceNativeModules: Array<ProjectModuleSlugEnum>;
  /** Выбранный пресет модулей при создании (например ЖКХ) */
  workspacePreset?: Maybe<ProjectWorkspacePresetEnum>;
};


export type ProjectProjectMembersArgs = {
  filter?: ProjectMemberFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectMemberSort>;
};

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  /** Array of nodes. */
  nodes: Array<Project>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ProjectCountersSummary = {
  __typename?: 'ProjectCountersSummary';
  /** Сводка по категориям */
  categories: Array<CounterCategorySummary>;
  /** Данные для общей диаграммы */
  chartData: Array<CounterChartDataPoint>;
  /** Легенда общей диаграммы */
  chartLegend: Array<CounterChartLegendItem>;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
};

export type ProjectCustomModule = {
  __typename?: 'ProjectCustomModule';
  /** Дополнительная информация для модуля */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Цвет фона модуля */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Базовый тип модуля (news, survey, supporters, mail, object_passport, program, reglament) */
  baseModuleType: CustomModuleBaseTypeEnum;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Формат отображения модуля (горизонтальный/вертикальный) */
  format: CustomModuleFormatEnum;
  /** Подпись (ФИО от руки) для модуля */
  handwrittenFullname?: Maybe<Scalars['String']['output']>;
  /** Иконка модуля (URL или название иконки) */
  icon?: Maybe<Scalars['String']['output']>;
  /** Цвет иконки модуля */
  iconColor?: Maybe<Scalars['String']['output']>;
  /** ID кастомного модуля */
  id: Scalars['ID']['output'];
  /** Слаг модуля (уникальный в рамках проекта) */
  moduleSlug: Scalars['String']['output'];
  /** Название модуля */
  name: Scalars['String']['output'];
  /** ID проекта (null для черновика по заявке) */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** ID заявки, если модуль ещё не привязан к проекту */
  projectRequestId?: Maybe<Scalars['ID']['output']>;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectDeleteResponse = {
  __typename?: 'ProjectDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Дата мягкого удаления проекта */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Подробное описание проекта */
  detailedDescription?: Maybe<Scalars['String']['output']>;
  /** Дата окончания проекта */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Кнопки гамбургер-меню проекта (произвольная JSON-структура) */
  hamburgerButtons?: Maybe<Scalars['JSON']['output']>;
  /** Кнопки шапки (header) проекта (произвольная JSON-структура) */
  headerButtons?: Maybe<Scalars['JSON']['output']>;
  /** ID проекта */
  id?: Maybe<Scalars['ID']['output']>;
  /** Активен ли проект (не закончился) */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Признак того, что проект удалён (soft delete) */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Опубликован ли проект (видимость в каталогах/публичных выдачах) */
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  /** Медиа-ресурсы проекта */
  media?: Maybe<ProjectMedia>;
  /** Название проекта */
  name?: Maybe<Scalars['String']['output']>;
  /** ID пользователя, которому принадлежит проект */
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  /** Ключ объекта MinIO логотипа проекта (PNG/WebP) или presigned URL */
  photo?: Maybe<Scalars['String']['output']>;
  /** ID запроса на добавление в проект */
  projectRequestId?: Maybe<Scalars['ID']['output']>;
  /** Краткое описание проекта */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** URL-дружелюбный слаг проекта (опционально) */
  slug?: Maybe<Scalars['String']['output']>;
  /** Дата начала проекта */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Шаблон проекта (classic или deputy) */
  templateType?: Maybe<ProjectTemplateEnum>;
  /** Тема проекта */
  themes?: Maybe<Array<ProjectThemeEnum>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Тип видимости проекта */
  visibility?: Maybe<ProjectVisibilityEnum>;
  /** Нативные модули рабочего стола (порядок отображения) */
  workspaceNativeModules?: Maybe<Array<ProjectModuleSlugEnum>>;
  /** Выбранный пресет модулей при создании (например ЖКХ) */
  workspacePreset?: Maybe<ProjectWorkspacePresetEnum>;
};

export type ProjectDetailedFiltersInput = {
  /** Конечная дата периода */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID конкретного проекта для отчета */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** Название проекта для поиска (частичное совпадение) */
  projectName?: InputMaybe<Scalars['String']['input']>;
  /** ID владельца проекта для фильтрации */
  projectOwnerId?: InputMaybe<Scalars['String']['input']>;
  /** Фильтр по региону (максимум 100 символов) */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Начальная дата периода */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectDetailedReportEntity = {
  __typename?: 'ProjectDetailedReportEntity';
  /** Количество активных участников проекта */
  activeParticipantsCount: Scalars['Int']['output'];
  /** Количество администраторов проекта */
  adminParticipantsCount: Scalars['Int']['output'];
  /** Среднее время участия в проекте (в минутах) */
  averageParticipationDuration?: Maybe<Scalars['Float']['output']>;
  /** Среднее время онлайн участников проекта (в минутах) */
  averageSessionDuration?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Количество участников из других регионов */
  differentRegionParticipantsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Количество дружеских связей между участниками проекта */
  internalFriendshipsCount: Scalars['Int']['output'];
  /** Количество обычных участников проекта */
  memberParticipantsCount: Scalars['Int']['output'];
  /** Количество модераторов проекта */
  moderatorParticipantsCount: Scalars['Int']['output'];
  /** Конец периода отчета */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Начало периода отчета */
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  /** Город проекта */
  projectCity?: Maybe<Scalars['String']['output']>;
  /** Дата создания проекта */
  projectCreatedAt: Scalars['DateTime']['output'];
  /** Описание проекта */
  projectDescription?: Maybe<Scalars['String']['output']>;
  /** ID проекта */
  projectId: Scalars['String']['output'];
  /** Название проекта */
  projectName: Scalars['String']['output'];
  /** ID владельца проекта */
  projectOwnerId: Scalars['String']['output'];
  /** ФИО владельца проекта */
  projectOwnerName: Scalars['String']['output'];
  /** Регион проекта */
  projectRegion?: Maybe<Scalars['String']['output']>;
  /** Дата формирования отчета */
  reportDate: Scalars['DateTime']['output'];
  /** Количество участников из того же региона, что и владелец */
  sameRegionParticipantsCount: Scalars['Int']['output'];
  /** Общее количество участников проекта */
  totalParticipantsCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectFilter = {
  and?: InputMaybe<Array<ProjectFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  detailedDescription?: InputMaybe<StringFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPublished?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProjectFilter>>;
  ownerUserId?: InputMaybe<IdFilterComparison>;
  photo?: InputMaybe<StringFieldComparison>;
  projectMembers?: InputMaybe<ProjectFilterProjectMemberFilter>;
  shortDescription?: InputMaybe<StringFieldComparison>;
  slug?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  templateType?: InputMaybe<ProjectTemplateEnumFilterComparison>;
  themes?: InputMaybe<ProjectThemesFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  visibility?: InputMaybe<ProjectVisibilityEnumFilterComparison>;
};

export type ProjectFilterProjectMemberFilter = {
  and?: InputMaybe<Array<ProjectFilterProjectMemberFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ProjectFilterProjectMemberFilter>>;
  projectId?: InputMaybe<IdFilterComparison>;
  role?: InputMaybe<ProjectMemberRoleEnumFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  userId?: InputMaybe<IdFilterComparison>;
};

export type ProjectImage = {
  __typename?: 'ProjectImage';
  /** Вариации изображений для пк */
  DESKTOP?: Maybe<ProjectImageDeviceVariation>;
  /** Вариации изображений для мобильных устройств */
  MOBILE?: Maybe<ProjectImageDeviceVariation>;
  /** Вариации изображений для планшета */
  TABLET?: Maybe<ProjectImageDeviceVariation>;
};

export type ProjectImageDeviceVariation = {
  __typename?: 'ProjectImageDeviceVariation';
  LIST?: Maybe<Scalars['String']['output']>;
  OPEN_PROJECT?: Maybe<Scalars['String']['output']>;
  OPEN_REQUEST?: Maybe<Scalars['String']['output']>;
  REQUEST?: Maybe<Scalars['String']['output']>;
  WORKSPACE?: Maybe<Scalars['String']['output']>;
};

export type ProjectInfo = {
  __typename?: 'ProjectInfo';
  invitationId?: Maybe<Scalars['ID']['output']>;
  joinRequestId?: Maybe<Scalars['ID']['output']>;
  moduleSlug?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['ID']['output']>;
};

export type ProjectInvitation = {
  __typename?: 'ProjectInvitation';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Дата истечения приглашения */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID приглашения */
  id: Scalars['ID']['output'];
  /** ID пригласившего пользователя */
  invitedByUserId: Scalars['ID']['output'];
  /** ID приглашенного пользователя (null для ссылок) */
  invitedUserId?: Maybe<Scalars['ID']['output']>;
  /** Токен ссылки-приглашения (только для создателя) */
  linkToken?: Maybe<Scalars['String']['output']>;
  /** Сообщение от приглашающего */
  message?: Maybe<Scalars['String']['output']>;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Статус приглашения */
  status: InvitationStatusEnum;
  /** Тип приглашения */
  type: InvitationTypeEnum;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectJoinRequest = {
  __typename?: 'ProjectJoinRequest';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID заявки на вступление */
  id: Scalars['ID']['output'];
  /** ID приглашения, если заявка через ссылку */
  invitationId?: Maybe<Scalars['ID']['output']>;
  /** Сообщение от пользователя */
  message?: Maybe<Scalars['String']['output']>;
  /** Дата обработки заявки */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя, обработавшего заявку */
  processedByUserId?: Maybe<Scalars['ID']['output']>;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Причина отклонения */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** Источник заявки */
  source: JoinRequestSourceEnum;
  /** Статус заявки */
  status: JoinRequestStatusEnum;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

export type ProjectLandingMedia = {
  __typename?: 'ProjectLandingMedia';
  /** URL master.m3u8 для HLS-видео лендинга проекта */
  master?: Maybe<Scalars['String']['output']>;
};

export type ProjectMedia = {
  __typename?: 'ProjectMedia';
  /** ID проекта для связи с медиа-ресурсами */
  id: Scalars['String']['output'];
  /** Изображения проекта (вариации для разных устройств и целей) */
  image?: Maybe<ProjectImage>;
  landing?: Maybe<ProjectLandingMedia>;
  logo?: Maybe<Scalars['String']['output']>;
};

export enum ProjectMediaType {
  Image = 'IMAGE',
  Landing = 'LANDING',
  Logo = 'LOGO'
}

export type ProjectMember = {
  __typename?: 'ProjectMember';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID участника проекта */
  id: Scalars['ID']['output'];
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Роль пользователя в проекте */
  role?: Maybe<ProjectMemberRoleEnum>;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

export type ProjectMemberConnection = {
  __typename?: 'ProjectMemberConnection';
  /** Array of nodes. */
  nodes: Array<ProjectMember>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ProjectMemberDeleteResponse = {
  __typename?: 'ProjectMemberDeleteResponse';
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID участника проекта */
  id?: Maybe<Scalars['ID']['output']>;
  /** ID проекта */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Роль пользователя в проекте */
  role?: Maybe<ProjectMemberRoleEnum>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ProjectMemberFilter = {
  and?: InputMaybe<Array<ProjectMemberFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ProjectMemberFilter>>;
  projectId?: InputMaybe<IdFilterComparison>;
  role?: InputMaybe<ProjectMemberRoleEnumFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  userId?: InputMaybe<IdFilterComparison>;
};

/** Тип роли участника проекта:     OWNER - владелец,     ADMIN - администратор,     MEMBER - участник */
export enum ProjectMemberRoleEnum {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export type ProjectMemberRoleEnumFilterComparison = {
  eq?: InputMaybe<ProjectMemberRoleEnum>;
  gt?: InputMaybe<ProjectMemberRoleEnum>;
  gte?: InputMaybe<ProjectMemberRoleEnum>;
  iLike?: InputMaybe<ProjectMemberRoleEnum>;
  in?: InputMaybe<Array<ProjectMemberRoleEnum>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ProjectMemberRoleEnum>;
  lt?: InputMaybe<ProjectMemberRoleEnum>;
  lte?: InputMaybe<ProjectMemberRoleEnum>;
  neq?: InputMaybe<ProjectMemberRoleEnum>;
  notILike?: InputMaybe<ProjectMemberRoleEnum>;
  notIn?: InputMaybe<Array<ProjectMemberRoleEnum>>;
  notLike?: InputMaybe<ProjectMemberRoleEnum>;
};

export type ProjectMemberSort = {
  direction: SortDirection;
  field: ProjectMemberSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ProjectMemberSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  ProjectId = 'projectId',
  Role = 'role',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ProjectModuleAccessSettings = {
  __typename?: 'ProjectModuleAccessSettings';
  dataEntry: ModuleAccessScopeRule;
  edit: ModuleAccessEditRule;
  fullAccessMembers: Array<ProjectMember>;
  id: Scalars['ID']['output'];
  moduleSlug: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  show: ModuleAccessScopeRule;
  view: ModuleAccessScopeRule;
};

export type ProjectModuleMember = {
  __typename?: 'ProjectModuleMember';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID участника модуля */
  id: Scalars['ID']['output'];
  /** Слаг модуля проекта */
  moduleSlug: Scalars['String']['output'];
  project: Project;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  projectMember: ProjectMember;
  /** ID участника проекта */
  projectMemberId: Scalars['ID']['output'];
  /** Роль участника в модуле проекта */
  role?: Maybe<ProjectModuleRoleEnum>;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectModuleMemberConnection = {
  __typename?: 'ProjectModuleMemberConnection';
  /** Array of nodes. */
  nodes: Array<ProjectModuleMember>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ProjectModuleMemberDeleteResponse = {
  __typename?: 'ProjectModuleMemberDeleteResponse';
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID участника модуля */
  id?: Maybe<Scalars['ID']['output']>;
  /** Слаг модуля проекта */
  moduleSlug?: Maybe<Scalars['String']['output']>;
  /** ID проекта */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** ID участника проекта */
  projectMemberId?: Maybe<Scalars['ID']['output']>;
  /** Роль участника в модуле проекта */
  role?: Maybe<ProjectModuleRoleEnum>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectModuleMemberFilter = {
  and?: InputMaybe<Array<ProjectModuleMemberFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  moduleSlug?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProjectModuleMemberFilter>>;
  projectId?: InputMaybe<IdFilterComparison>;
  projectMemberId?: InputMaybe<IdFilterComparison>;
  role?: InputMaybe<ProjectModuleRoleEnumFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ProjectModuleMemberSort = {
  direction: SortDirection;
  field: ProjectModuleMemberSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ProjectModuleMemberSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  ModuleSlug = 'moduleSlug',
  ProjectId = 'projectId',
  ProjectMemberId = 'projectMemberId',
  Role = 'role',
  UpdatedAt = 'updatedAt'
}

/** Тип роли участника модуля:     ADMIN - администратор,     MEMBER - участник */
export enum ProjectModuleRoleEnum {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type ProjectModuleRoleEnumFilterComparison = {
  eq?: InputMaybe<ProjectModuleRoleEnum>;
  gt?: InputMaybe<ProjectModuleRoleEnum>;
  gte?: InputMaybe<ProjectModuleRoleEnum>;
  iLike?: InputMaybe<ProjectModuleRoleEnum>;
  in?: InputMaybe<Array<ProjectModuleRoleEnum>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ProjectModuleRoleEnum>;
  lt?: InputMaybe<ProjectModuleRoleEnum>;
  lte?: InputMaybe<ProjectModuleRoleEnum>;
  neq?: InputMaybe<ProjectModuleRoleEnum>;
  notILike?: InputMaybe<ProjectModuleRoleEnum>;
  notIn?: InputMaybe<Array<ProjectModuleRoleEnum>>;
  notLike?: InputMaybe<ProjectModuleRoleEnum>;
};

/** Алиасы модулей:     SUPPORTERS - сторонники,     ABOUT_PROJECT - о проекте,     PROJECT_MEMBERS - участники проекта,     PROJECT_MANAGEMENT - управление проектом,     PROJECT_NEWS - новости проекта     PROJECT_SURVEY - опросы проекта     QUESTION_TO_DEPUTY - раздел «Вопрос депутату» (опросы)     SERVICE_PHONES - раздел «Телефоны служб» (реестр)     CONSUMER_RIGHTS - раздел «Права потребителя» (новости)     ACCIDENT_GUIDANCE - раздел «Что делать при аварии» (новости)     ENTERTAINMENT - раздел «Развлечения» (новости)     PROJECT_ORG_MAIL - написать организаторам (почта)     PROJECT_COUNTERS - счётчики     PROJECT_CALENDAR - календарь / события     PROJECT_SPEECHES - выступления */
export enum ProjectModuleSlugEnum {
  AboutProject = 'ABOUT_PROJECT',
  AccidentGuidance = 'ACCIDENT_GUIDANCE',
  ConsumerRights = 'CONSUMER_RIGHTS',
  Entertainment = 'ENTERTAINMENT',
  ProjectCalendar = 'PROJECT_CALENDAR',
  ProjectCounters = 'PROJECT_COUNTERS',
  ProjectManagement = 'PROJECT_MANAGEMENT',
  ProjectMembers = 'PROJECT_MEMBERS',
  ProjectNews = 'PROJECT_NEWS',
  ProjectOrgMail = 'PROJECT_ORG_MAIL',
  ProjectSpeeches = 'PROJECT_SPEECHES',
  ProjectSurvey = 'PROJECT_SURVEY',
  QuestionToDeputy = 'QUESTION_TO_DEPUTY',
  ServicePhones = 'SERVICE_PHONES',
  Supporters = 'SUPPORTERS'
}

export type ProjectNewsModuleAccessCapabilitiesDto = {
  __typename?: 'ProjectNewsModuleAccessCapabilitiesDTO';
  /** Может создавать новости в модуле (capability data_entry в настройках доступа). */
  canCreateNews: Scalars['Boolean']['output'];
  /** Может видеть список новостей модуля (capability view в настройках доступа). */
  canViewList: Scalars['Boolean']['output'];
};

export type ProjectOrganization = {
  __typename?: 'ProjectOrganization';
  /** Комментарий к адресу организации */
  companyAddressComment?: Maybe<Scalars['String']['output']>;
  /** JSON-объект адреса организации. */
  companyAddressJSON?: Maybe<Scalars['JSON']['output']>;
  /** Город организации */
  companyCity?: Maybe<Scalars['String']['output']>;
  /** Район города организации */
  companyCityDistrict?: Maybe<Scalars['String']['output']>;
  /** Email организации */
  companyEmail?: Maybe<Scalars['String']['output']>;
  /** Офис организации */
  companyFlat?: Maybe<Scalars['String']['output']>;
  /** ИНН организации */
  companyInn?: Maybe<Scalars['String']['output']>;
  /** Флаг ручного ввода адреса организации */
  companyIsManual?: Maybe<Scalars['Boolean']['output']>;
  /** КПП организации */
  companyKpp?: Maybe<Scalars['String']['output']>;
  /** Полное наименование организации */
  companyName: Scalars['String']['output'];
  /** ОГРН организации */
  companyOgrn?: Maybe<Scalars['String']['output']>;
  /** Телефон организации */
  companyPhone?: Maybe<Scalars['String']['output']>;
  /** Должность представителя */
  companyPosition?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс организации */
  companyPostalCode?: Maybe<Scalars['String']['output']>;
  /** Область организации */
  companyRegion?: Maybe<Scalars['String']['output']>;
  /** Поселение организации */
  companySettlement?: Maybe<Scalars['String']['output']>;
  /** Краткое наименование организации */
  companyShortName?: Maybe<Scalars['String']['output']>;
  /** Улица и дом организации */
  companyStreet?: Maybe<Scalars['String']['output']>;
  /** Дата создания организации */
  createdAt: Scalars['DateTime']['output'];
  /** Email представителя */
  email?: Maybe<Scalars['String']['output']>;
  /** Имя представителя */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Дата праздничного дня */
  holidayDate?: Maybe<Scalars['DateTime']['output']>;
  /** День месяца праздничной даты (1-31) */
  holidayDay?: Maybe<Scalars['Int']['output']>;
  /** Месяц праздничной даты (1-12) */
  holidayMonth?: Maybe<Scalars['Int']['output']>;
  /** Месяц и день праздничной даты (MM-DD) для сортировки без учета года */
  holidayMonthDay?: Maybe<Scalars['String']['output']>;
  /** Название праздничного дня */
  holidayName?: Maybe<Scalars['String']['output']>;
  /** Год праздничной даты (YYYY) */
  holidayYear?: Maybe<Scalars['Int']['output']>;
  /** ID организации */
  id: Scalars['ID']['output'];
  /** Фамилия представителя */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество представителя */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Слаг модуля реестра организаций */
  moduleSlug?: Maybe<Scalars['String']['output']>;
  /** Дата праздника организации (для импорта) */
  orgHolidayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Название праздника организации (для импорта) */
  orgHolidayName?: Maybe<Scalars['String']['output']>;
  originalOwner?: Maybe<User>;
  /** ID оригинального владельца организации (кто инициировал слияние) */
  originalOwnerId?: Maybe<Scalars['ID']['output']>;
  /** ID оригинального проекта (откуда была перенесена организация) */
  originalProjectId?: Maybe<Scalars['ID']['output']>;
  /** Телефон представителя */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  project: ProjectOrganizationProjectConnection;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Дата последнего обновления организации */
  updatedAt: Scalars['DateTime']['output'];
};


export type ProjectOrganizationProjectArgs = {
  filter?: ProjectFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectSort>;
};

export type ProjectOrganizationCompanyInnFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectOrganizationCompanyKppFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectOrganizationCompanyNameFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectOrganizationCompanyOgrnFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectOrganizationCompanyPositionFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectOrganizationCompanyShortNameFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectOrganizationConnection = {
  __typename?: 'ProjectOrganizationConnection';
  /** Array of nodes. */
  nodes: Array<ProjectOrganization>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ProjectOrganizationCreatedAtFilterComparison = {
  between?: InputMaybe<ProjectOrganizationCreatedAtFilterComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectOrganizationCreatedAtFilterComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type ProjectOrganizationDeleteResponse = {
  __typename?: 'ProjectOrganizationDeleteResponse';
  /** Комментарий к адресу организации */
  companyAddressComment?: Maybe<Scalars['String']['output']>;
  /** JSON-объект адреса организации. */
  companyAddressJSON?: Maybe<Scalars['JSON']['output']>;
  /** Город организации */
  companyCity?: Maybe<Scalars['String']['output']>;
  /** Район города организации */
  companyCityDistrict?: Maybe<Scalars['String']['output']>;
  /** Email организации */
  companyEmail?: Maybe<Scalars['String']['output']>;
  /** Офис организации */
  companyFlat?: Maybe<Scalars['String']['output']>;
  /** ИНН организации */
  companyInn?: Maybe<Scalars['String']['output']>;
  /** Флаг ручного ввода адреса организации */
  companyIsManual?: Maybe<Scalars['Boolean']['output']>;
  /** КПП организации */
  companyKpp?: Maybe<Scalars['String']['output']>;
  /** Полное наименование организации */
  companyName?: Maybe<Scalars['String']['output']>;
  /** ОГРН организации */
  companyOgrn?: Maybe<Scalars['String']['output']>;
  /** Телефон организации */
  companyPhone?: Maybe<Scalars['String']['output']>;
  /** Должность представителя */
  companyPosition?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс организации */
  companyPostalCode?: Maybe<Scalars['String']['output']>;
  /** Область организации */
  companyRegion?: Maybe<Scalars['String']['output']>;
  /** Поселение организации */
  companySettlement?: Maybe<Scalars['String']['output']>;
  /** Краткое наименование организации */
  companyShortName?: Maybe<Scalars['String']['output']>;
  /** Улица и дом организации */
  companyStreet?: Maybe<Scalars['String']['output']>;
  /** Дата создания организации */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Email представителя */
  email?: Maybe<Scalars['String']['output']>;
  /** Имя представителя */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Дата праздничного дня */
  holidayDate?: Maybe<Scalars['DateTime']['output']>;
  /** День месяца праздничной даты (1-31) */
  holidayDay?: Maybe<Scalars['Int']['output']>;
  /** Месяц праздничной даты (1-12) */
  holidayMonth?: Maybe<Scalars['Int']['output']>;
  /** Месяц и день праздничной даты (MM-DD) для сортировки без учета года */
  holidayMonthDay?: Maybe<Scalars['String']['output']>;
  /** Название праздничного дня */
  holidayName?: Maybe<Scalars['String']['output']>;
  /** Год праздничной даты (YYYY) */
  holidayYear?: Maybe<Scalars['Int']['output']>;
  /** ID организации */
  id?: Maybe<Scalars['ID']['output']>;
  /** Фамилия представителя */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество представителя */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Слаг модуля реестра организаций */
  moduleSlug?: Maybe<Scalars['String']['output']>;
  /** Дата праздника организации (для импорта) */
  orgHolidayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Название праздника организации (для импорта) */
  orgHolidayName?: Maybe<Scalars['String']['output']>;
  /** ID оригинального владельца организации (кто инициировал слияние) */
  originalOwnerId?: Maybe<Scalars['ID']['output']>;
  /** ID оригинального проекта (откуда была перенесена организация) */
  originalProjectId?: Maybe<Scalars['ID']['output']>;
  /** Телефон представителя */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** ID проекта */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Дата последнего обновления организации */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectOrganizationFilter = {
  and?: InputMaybe<Array<ProjectOrganizationFilter>>;
  companyCity?: InputMaybe<StringFieldComparison>;
  companyInn?: InputMaybe<ProjectOrganizationCompanyInnFilterComparison>;
  companyKpp?: InputMaybe<ProjectOrganizationCompanyKppFilterComparison>;
  companyName?: InputMaybe<ProjectOrganizationCompanyNameFilterComparison>;
  companyOgrn?: InputMaybe<ProjectOrganizationCompanyOgrnFilterComparison>;
  companyPosition?: InputMaybe<ProjectOrganizationCompanyPositionFilterComparison>;
  companyRegion?: InputMaybe<StringFieldComparison>;
  companyShortName?: InputMaybe<ProjectOrganizationCompanyShortNameFilterComparison>;
  createdAt?: InputMaybe<ProjectOrganizationCreatedAtFilterComparison>;
  firstName?: InputMaybe<ProjectOrganizationFirstNameFilterComparison>;
  holidayDate?: InputMaybe<DateFieldComparison>;
  holidayDay?: InputMaybe<ProjectOrganizationHolidayDayFilterComparison>;
  holidayMonth?: InputMaybe<ProjectOrganizationHolidayMonthFilterComparison>;
  holidayMonthDay?: InputMaybe<StringFieldComparison>;
  holidayName?: InputMaybe<StringFieldComparison>;
  holidayYear?: InputMaybe<ProjectOrganizationHolidayYearFilterComparison>;
  id?: InputMaybe<ProjectOrganizationIdFilterComparison>;
  lastName?: InputMaybe<ProjectOrganizationLastNameFilterComparison>;
  middleName?: InputMaybe<ProjectOrganizationMiddleNameFilterComparison>;
  moduleSlug?: InputMaybe<ProjectOrganizationModuleSlugFilterComparison>;
  or?: InputMaybe<Array<ProjectOrganizationFilter>>;
  originalOwnerId?: InputMaybe<ProjectOrganizationOriginalOwnerIdFilterComparison>;
  originalProjectId?: InputMaybe<ProjectOrganizationOriginalProjectIdFilterComparison>;
  project?: InputMaybe<ProjectOrganizationFilterProjectFilter>;
  projectId?: InputMaybe<ProjectOrganizationProjectIdFilterComparison>;
  updatedAt?: InputMaybe<ProjectOrganizationUpdatedAtFilterComparison>;
};

export type ProjectOrganizationFilterProjectFilter = {
  and?: InputMaybe<Array<ProjectOrganizationFilterProjectFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  detailedDescription?: InputMaybe<StringFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPublished?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProjectOrganizationFilterProjectFilter>>;
  ownerUserId?: InputMaybe<IdFilterComparison>;
  photo?: InputMaybe<StringFieldComparison>;
  shortDescription?: InputMaybe<StringFieldComparison>;
  slug?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  templateType?: InputMaybe<ProjectTemplateEnumFilterComparison>;
  themes?: InputMaybe<ProjectThemesFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  visibility?: InputMaybe<ProjectVisibilityEnumFilterComparison>;
};

export type ProjectOrganizationFirstNameFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectOrganizationHolidayDayFilterComparison = {
  between?: InputMaybe<ProjectOrganizationHolidayDayFilterComparisonBetween>;
};

export type ProjectOrganizationHolidayDayFilterComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

export type ProjectOrganizationHolidayMonthFilterComparison = {
  between?: InputMaybe<ProjectOrganizationHolidayMonthFilterComparisonBetween>;
};

export type ProjectOrganizationHolidayMonthFilterComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

export type ProjectOrganizationHolidayYearFilterComparison = {
  between?: InputMaybe<ProjectOrganizationHolidayYearFilterComparisonBetween>;
};

export type ProjectOrganizationHolidayYearFilterComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

export type ProjectOrganizationIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectOrganizationLastNameFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectOrganizationMiddleNameFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectOrganizationModuleSlugFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectOrganizationOriginalOwnerIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectOrganizationOriginalProjectIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectOrganizationProjectConnection = {
  __typename?: 'ProjectOrganizationProjectConnection';
  /** Array of nodes. */
  nodes: Array<Project>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ProjectOrganizationProjectIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectOrganizationSort = {
  direction: SortDirection;
  field: ProjectOrganizationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ProjectOrganizationSortFields {
  CompanyCity = 'companyCity',
  CompanyInn = 'companyInn',
  CompanyKpp = 'companyKpp',
  CompanyName = 'companyName',
  CompanyOgrn = 'companyOgrn',
  CompanyPosition = 'companyPosition',
  CompanyRegion = 'companyRegion',
  CompanyShortName = 'companyShortName',
  CreatedAt = 'createdAt',
  FirstName = 'firstName',
  HolidayDate = 'holidayDate',
  HolidayDay = 'holidayDay',
  HolidayMonth = 'holidayMonth',
  HolidayMonthDay = 'holidayMonthDay',
  HolidayName = 'holidayName',
  HolidayYear = 'holidayYear',
  Id = 'id',
  LastName = 'lastName',
  MiddleName = 'middleName',
  ModuleSlug = 'moduleSlug',
  OriginalOwnerId = 'originalOwnerId',
  OriginalProjectId = 'originalProjectId',
  ProjectId = 'projectId',
  UpdatedAt = 'updatedAt'
}

export type ProjectOrganizationUpdatedAtFilterComparison = {
  between?: InputMaybe<ProjectOrganizationUpdatedAtFilterComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectOrganizationUpdatedAtFilterComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type ProjectProjectMembersConnection = {
  __typename?: 'ProjectProjectMembersConnection';
  /** Array of nodes. */
  nodes: Array<ProjectMember>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ProjectRequest = {
  __typename?: 'ProjectRequest';
  /** ID пользователя, апрувившего(одобрившего) проект */
  approvedByUserId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Подробное описание проекта */
  detailedDescription?: Maybe<Scalars['String']['output']>;
  /** Дата окончания проекта */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID запроса на добавление в проект */
  id: Scalars['ID']['output'];
  /** Черновик кастомных модулей при создании заявки */
  initialCustomModules?: Maybe<Scalars['JSON']['output']>;
  /** Опубликована ли заявка (для выдачи в каталогах после одобрения и т.п.) */
  isPublished: Scalars['Boolean']['output'];
  media?: Maybe<ProjectMedia>;
  /** Название проекта */
  name: Scalars['String']['output'];
  /** Ключ объекта MinIO логотипа проекта (PNG/WebP) или presigned URL */
  photo?: Maybe<Scalars['String']['output']>;
  /** ID созданного проекта после апрува, до этого null */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Отклонения запроса на добавление в проект */
  rejections?: Maybe<Array<ProjectRequestRejection>>;
  /** Краткое описание проекта */
  shortDescription: Scalars['String']['output'];
  /** Дата начала проекта */
  startDate: Scalars['DateTime']['output'];
  /** Статус запроса на добавление в проект */
  status: ProjectRequestStatusEnum;
  /** Вид проекта (классический / типовой) */
  templateType: ProjectTemplateEnum;
  /** Тема проекта */
  themes: Array<ProjectThemeEnum>;
  updatedAt: Scalars['DateTime']['output'];
  /** ID пользователя, создающего проект */
  userId: Scalars['ID']['output'];
  /** Тип видимости проекта */
  visibility: ProjectVisibilityEnum;
  /** Выбранный пресет модулей */
  workspacePreset?: Maybe<ProjectWorkspacePresetEnum>;
};

export type ProjectRequestPresignedUrlInput = {
  /** Время жизни ссылки в секундах (по умолчанию 600) */
  expires?: InputMaybe<Scalars['Int']['input']>;
  /** Имя файла с расширением (.png, .webp, .jpg, .jpeg). Если не передано — используется legacy-путь original.jpg. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Тип медиафайла: LANDING (видео лендинга), IMAGE (обложка проекта) или LOGO (логотип проекта) */
  mediaType: ProjectMediaType;
  /** ID проекта для presigned URL */
  projectId: Scalars['String']['input'];
};

export type ProjectRequestRejection = {
  __typename?: 'ProjectRequestRejection';
  /** ID заявки на проект */
  projectRequestId: Scalars['ID']['output'];
  /** Причина отклонения заявки */
  reason: Scalars['String']['output'];
  /** ID пользователя, отклонившего заявку */
  rejectedByUserId: Scalars['ID']['output'];
};

/** Описание статусов:     PENDING - заявка ожидает подтверждения,     APPROVED - заявка подтверждена,     REJECTED - заявка отклонена но не окончательно,     BUNNED - заявка отклонена окончательно */
export enum ProjectRequestStatusEnum {
  Approved = 'APPROVED',
  Bunned = 'BUNNED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Enum тем для запросов на добавление в проект */
export type ProjectRequestThemeDto = {
  __typename?: 'ProjectRequestThemeDTO';
  /** Ключ темы проекта */
  key: Scalars['String']['output'];
  /** Название темы проекта */
  value: Scalars['String']['output'];
};

export type ProjectSort = {
  direction: SortDirection;
  field: ProjectSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ProjectSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DetailedDescription = 'detailedDescription',
  EndDate = 'endDate',
  Id = 'id',
  IsPublished = 'isPublished',
  Name = 'name',
  OwnerUserId = 'ownerUserId',
  Photo = 'photo',
  ShortDescription = 'shortDescription',
  Slug = 'slug',
  StartDate = 'startDate',
  TemplateType = 'templateType',
  Themes = 'themes',
  UpdatedAt = 'updatedAt',
  Visibility = 'visibility'
}

export type ProjectSupporter = {
  __typename?: 'ProjectSupporter';
  /** Комментарий (comment). */
  addressComment?: Maybe<Scalars['String']['output']>;
  /** JSON-объект адреса. */
  addressJSON?: Maybe<Scalars['JSON']['output']>;
  /** Дата рождения */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** День месяца рождения (1-31) */
  birthdayDay?: Maybe<Scalars['Int']['output']>;
  /** Месяц рождения (1-12) */
  birthdayMonth?: Maybe<Scalars['Int']['output']>;
  /** Месяц и день рождения (MM-DD) для сортировки без учета года */
  birthdayMonthDay?: Maybe<Scalars['String']['output']>;
  /** Год рождения (YYYY) */
  birthdayYear?: Maybe<Scalars['Int']['output']>;
  /** Город (city). */
  city?: Maybe<Scalars['String']['output']>;
  /** Район города (city_district). */
  cityDistrict?: Maybe<Scalars['String']['output']>;
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  /** Комментарий к адресу компании. */
  companyAddressComment?: Maybe<Scalars['String']['output']>;
  /** JSON-объект адреса компании. */
  companyAddressJSON?: Maybe<Scalars['JSON']['output']>;
  /** Город компании. */
  companyCity?: Maybe<Scalars['String']['output']>;
  /** Район города компании. */
  companyCityDistrict?: Maybe<Scalars['String']['output']>;
  /** Комментарий к компании. */
  companyComment?: Maybe<Scalars['String']['output']>;
  /** Домофон компании. */
  companyDoorphone?: Maybe<Scalars['String']['output']>;
  /** Email компании. */
  companyEmail?: Maybe<Scalars['String']['output']>;
  /** Подъезд компании. */
  companyEntrance?: Maybe<Scalars['String']['output']>;
  /** Квартира компании. */
  companyFlat?: Maybe<Scalars['String']['output']>;
  /** Этаж компании. */
  companyFloor?: Maybe<Scalars['String']['output']>;
  /** ИНН компании. */
  companyInn?: Maybe<Scalars['String']['output']>;
  /** Флаг ручного ввода адреса компании. */
  companyIsManual?: Maybe<Scalars['Boolean']['output']>;
  /** КПП компании. */
  companyKpp?: Maybe<Scalars['String']['output']>;
  /** Название компании. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** ОГРН компании. */
  companyOgrn?: Maybe<Scalars['String']['output']>;
  /** Телефон компании. */
  companyPhone?: Maybe<Scalars['String']['output']>;
  /** Должность в компании. */
  companyPosition?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс компании. */
  companyPostalCode?: Maybe<Scalars['String']['output']>;
  /** Область компании. */
  companyRegion?: Maybe<Scalars['String']['output']>;
  /** Поселение компании. */
  companySettlement?: Maybe<Scalars['String']['output']>;
  /** Улица и дом компании. */
  companyStreet?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Домофон (doorphone). */
  doorphone?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Подъезд (entrance). */
  entrance?: Maybe<Scalars['String']['output']>;
  /** Фамилия */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Квартира (flat/apartment). */
  flat?: Maybe<Scalars['String']['output']>;
  /** Этаж (floor). */
  floor?: Maybe<Scalars['String']['output']>;
  /** Пол */
  gender?: Maybe<SupporterGender>;
  /** Дата праздничного дня */
  holidayDate?: Maybe<Scalars['DateTime']['output']>;
  /** День месяца праздничной даты (1-31) */
  holidayDay?: Maybe<Scalars['Int']['output']>;
  /** Месяц праздничной даты (1-12) */
  holidayMonth?: Maybe<Scalars['Int']['output']>;
  /** Месяц и день праздничной даты (MM-DD) для сортировки без учета года */
  holidayMonthDay?: Maybe<Scalars['String']['output']>;
  /** Название праздничного дня */
  holidayName?: Maybe<Scalars['String']['output']>;
  /** Год праздничной даты (YYYY) */
  holidayYear?: Maybe<Scalars['Int']['output']>;
  /** ID сторонника */
  id: Scalars['ID']['output'];
  /** Флаг, указывающий, был ли адрес введён вручную (true) или найден через DaData (false). */
  isManual?: Maybe<Scalars['Boolean']['output']>;
  /** Имя */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Слаг модуля реестра */
  moduleSlug: Scalars['String']['output'];
  originalOwner?: Maybe<User>;
  /** ID оригинального владельца сторонника (кто инициировал слияние) */
  originalOwnerId?: Maybe<Scalars['ID']['output']>;
  originalProject?: Maybe<Project>;
  /** ID оригинального проекта (откуда был перенесен сторонник) */
  originalProjectId?: Maybe<Scalars['ID']['output']>;
  /** Телефон */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс (postalCode). */
  postalCode?: Maybe<Scalars['String']['output']>;
  project: ProjectSupporterProjectConnection;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Область (region). */
  region?: Maybe<Scalars['String']['output']>;
  /** Поселение (settlement). */
  settlement?: Maybe<Scalars['String']['output']>;
  /** Улица и дом (street). */
  street?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type ProjectSupporterProjectArgs = {
  filter?: ProjectFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectSort>;
};

export type ProjectSupporterConnection = {
  __typename?: 'ProjectSupporterConnection';
  /** Array of nodes. */
  nodes: Array<ProjectSupporter>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

/** Формат экспорта сторонников проекта */
export enum ProjectSupporterExportFormat {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type ProjectSupporterFilter = {
  and?: InputMaybe<Array<ProjectSupporterFilter>>;
  birthday?: InputMaybe<DateFieldComparison>;
  birthdayDay?: InputMaybe<IntFieldComparison>;
  birthdayMonth?: InputMaybe<IntFieldComparison>;
  birthdayMonthDay?: InputMaybe<StringFieldComparison>;
  birthdayYear?: InputMaybe<IntFieldComparison>;
  city?: InputMaybe<StringFieldComparison>;
  comment?: InputMaybe<StringFieldComparison>;
  companyName?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  firstName?: InputMaybe<StringFieldComparison>;
  gender?: InputMaybe<ProjectSupporterGenderFilterComparison>;
  holidayDate?: InputMaybe<DateFieldComparison>;
  holidayDay?: InputMaybe<ProjectSupporterHolidayDayFilterComparison>;
  holidayMonth?: InputMaybe<ProjectSupporterHolidayMonthFilterComparison>;
  holidayMonthDay?: InputMaybe<StringFieldComparison>;
  holidayName?: InputMaybe<StringFieldComparison>;
  holidayYear?: InputMaybe<ProjectSupporterHolidayYearFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  middleName?: InputMaybe<StringFieldComparison>;
  moduleSlug?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProjectSupporterFilter>>;
  originalOwnerId?: InputMaybe<IdFilterComparison>;
  originalProjectId?: InputMaybe<IdFilterComparison>;
  phoneNumber?: InputMaybe<StringFieldComparison>;
  project?: InputMaybe<ProjectSupporterFilterProjectFilter>;
  projectId?: InputMaybe<IdFilterComparison>;
  region?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ProjectSupporterFilterProjectFilter = {
  and?: InputMaybe<Array<ProjectSupporterFilterProjectFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  detailedDescription?: InputMaybe<StringFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPublished?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProjectSupporterFilterProjectFilter>>;
  ownerUserId?: InputMaybe<IdFilterComparison>;
  photo?: InputMaybe<StringFieldComparison>;
  shortDescription?: InputMaybe<StringFieldComparison>;
  slug?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  templateType?: InputMaybe<ProjectTemplateEnumFilterComparison>;
  themes?: InputMaybe<ProjectThemesFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  visibility?: InputMaybe<ProjectVisibilityEnumFilterComparison>;
};

export type ProjectSupporterGenderFilterComparison = {
  eq?: InputMaybe<SupporterGender>;
  in?: InputMaybe<Array<SupporterGender>>;
};

export type ProjectSupporterHolidayDayFilterComparison = {
  between?: InputMaybe<ProjectSupporterHolidayDayFilterComparisonBetween>;
};

export type ProjectSupporterHolidayDayFilterComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

export type ProjectSupporterHolidayMonthFilterComparison = {
  between?: InputMaybe<ProjectSupporterHolidayMonthFilterComparisonBetween>;
};

export type ProjectSupporterHolidayMonthFilterComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

export type ProjectSupporterHolidayYearFilterComparison = {
  between?: InputMaybe<ProjectSupporterHolidayYearFilterComparisonBetween>;
};

export type ProjectSupporterHolidayYearFilterComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

export type ProjectSupporterOwnersResponseDto = {
  __typename?: 'ProjectSupporterOwnersResponseDTO';
  /** Уникальный список проектов-источников (откуда пришли сторонники) по всем владельцам */
  originProjects: Array<Project>;
  /** Список владельцев сторонников */
  owners: Array<SupporterOwnerDto>;
  /** Текущий проект */
  project: Project;
  /** Общее количество уникальных владельцев */
  totalOwnersCount: Scalars['Float']['output'];
  /** Общее количество сторонников в проекте */
  totalSupportersCount: Scalars['Float']['output'];
};

export type ProjectSupporterProjectConnection = {
  __typename?: 'ProjectSupporterProjectConnection';
  /** Array of nodes. */
  nodes: Array<Project>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ProjectSupporterSort = {
  direction: SortDirection;
  field: ProjectSupporterSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ProjectSupporterSortFields {
  Birthday = 'birthday',
  BirthdayDay = 'birthdayDay',
  BirthdayMonth = 'birthdayMonth',
  BirthdayMonthDay = 'birthdayMonthDay',
  BirthdayYear = 'birthdayYear',
  City = 'city',
  Comment = 'comment',
  CompanyName = 'companyName',
  CreatedAt = 'createdAt',
  Email = 'email',
  FirstName = 'firstName',
  Gender = 'gender',
  HolidayDate = 'holidayDate',
  HolidayDay = 'holidayDay',
  HolidayMonth = 'holidayMonth',
  HolidayMonthDay = 'holidayMonthDay',
  HolidayName = 'holidayName',
  HolidayYear = 'holidayYear',
  Id = 'id',
  LastName = 'lastName',
  MiddleName = 'middleName',
  ModuleSlug = 'moduleSlug',
  OriginalOwnerId = 'originalOwnerId',
  OriginalProjectId = 'originalProjectId',
  PhoneNumber = 'phoneNumber',
  ProjectId = 'projectId',
  Region = 'region',
  UpdatedAt = 'updatedAt'
}

/** Тип шаблона проекта: classic — базовый набор модулей, deputy — спецшаблон с доп. модулями, expert_opinion — «Экспертное мнение» (настройки, участники, новости, письмо организаторам, реестр, опросы). */
export enum ProjectTemplateEnum {
  Classic = 'CLASSIC',
  Deputy = 'DEPUTY',
  ExpertOpinion = 'EXPERT_OPINION'
}

export type ProjectTemplateEnumFilterComparison = {
  eq?: InputMaybe<ProjectTemplateEnum>;
  gt?: InputMaybe<ProjectTemplateEnum>;
  gte?: InputMaybe<ProjectTemplateEnum>;
  iLike?: InputMaybe<ProjectTemplateEnum>;
  in?: InputMaybe<Array<ProjectTemplateEnum>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ProjectTemplateEnum>;
  lt?: InputMaybe<ProjectTemplateEnum>;
  lte?: InputMaybe<ProjectTemplateEnum>;
  neq?: InputMaybe<ProjectTemplateEnum>;
  notILike?: InputMaybe<ProjectTemplateEnum>;
  notIn?: InputMaybe<Array<ProjectTemplateEnum>>;
  notLike?: InputMaybe<ProjectTemplateEnum>;
};

/** Тип темы проекта:     ALL - все темы,     PORTFOLIO_RESUME - портфолио/резюме,     PHOTO - фото,     DESIGN - дизайн,     VIDEO_CINEMA - видео/кино,     LITERATURE - литература,     JOURNALISM - журналистика,     MUSIC - музыка,     THEATER - театр,     CHARITY - благотворительность,     SOCIAL_INITIATIVES - социальные инициативы,     NATURE - природа,     ECOLOGY - экология,     EDUCATION - образование,     SCIENCE_ENLIGHTENMENT - наука/просвещение */
export enum ProjectThemeEnum {
  All = 'ALL',
  Charity = 'CHARITY',
  Design = 'DESIGN',
  Ecology = 'ECOLOGY',
  Education = 'EDUCATION',
  Journalism = 'JOURNALISM',
  Literature = 'LITERATURE',
  Music = 'MUSIC',
  Nature = 'NATURE',
  Photo = 'PHOTO',
  PortfolioResume = 'PORTFOLIO_RESUME',
  ScienceEnlightenment = 'SCIENCE_ENLIGHTENMENT',
  SocialInitiatives = 'SOCIAL_INITIATIVES',
  Theater = 'THEATER',
  VideoCinema = 'VIDEO_CINEMA'
}

export type ProjectThemesFilterComparison = {
  eq?: InputMaybe<Array<ProjectThemeEnum>>;
  in?: InputMaybe<Array<Array<ProjectThemeEnum>>>;
};

/** Тип видимости проекта:     OPEN - проект виден всем пользователям,     CLOSED - проект виден только участникам,     HIDDEN - проект скрыт от всех */
export enum ProjectVisibilityEnum {
  Closed = 'CLOSED',
  Hidden = 'HIDDEN',
  Open = 'OPEN'
}

export type ProjectVisibilityEnumFilterComparison = {
  eq?: InputMaybe<ProjectVisibilityEnum>;
  gt?: InputMaybe<ProjectVisibilityEnum>;
  gte?: InputMaybe<ProjectVisibilityEnum>;
  iLike?: InputMaybe<ProjectVisibilityEnum>;
  in?: InputMaybe<Array<ProjectVisibilityEnum>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ProjectVisibilityEnum>;
  lt?: InputMaybe<ProjectVisibilityEnum>;
  lte?: InputMaybe<ProjectVisibilityEnum>;
  neq?: InputMaybe<ProjectVisibilityEnum>;
  notILike?: InputMaybe<ProjectVisibilityEnum>;
  notIn?: InputMaybe<Array<ProjectVisibilityEnum>>;
  notLike?: InputMaybe<ProjectVisibilityEnum>;
};

/** Пресет нативных модулей рабочего стола (например ЖКХ). */
export enum ProjectWorkspacePresetEnum {
  Zhkh = 'ZHKH'
}

export type PublicProject = {
  __typename?: 'PublicProject';
  /** Подробное описание проекта */
  detailedDescription?: Maybe<Scalars['String']['output']>;
  /** ID проекта */
  id: Scalars['ID']['output'];
  media?: Maybe<ProjectMedia>;
  /** Название проекта */
  name: Scalars['String']['output'];
  /** Краткое описание проекта */
  shortDescription: Scalars['String']['output'];
  /** URL-дружелюбный слаг проекта (опционально) */
  slug?: Maybe<Scalars['String']['output']>;
};

export type PublishSurveyDto = {
  surveyId: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  answer: Answer;
  answers: AnswerConnection;
  /** Проверка актуальности версии мобильного клиента. Возвращает вердикт (NONE/RECOMMENDED/REQUIRED) и ссылку на магазин для обновления. */
  appVersionCheck: AppVersionCheck;
  /** Админ: список всех записей о версиях мобильных клиентов. */
  appVersions: Array<AppVersionRecord>;
  blockedTypes: Array<BlockedType>;
  /** Получить событие календаря по ID */
  calendarEvent: CalendarEvent;
  /** Получить количество событий по дням за указанный период (для отметок «3 задачи») */
  calendarEventDayCounts: Array<CalendarEventDayCount>;
  /** Участники события (participants) и пользователи, которых можно пригласить (availableUsers). Если eventId указан — participants содержит уже добавленных участников события, availableUsers — участников проекта, ещё не добавленных. Если eventId не указан — participants пуст, availableUsers содержит всех участников проекта (требуется projectId). Каждый объект — федерированный User из ms-users с firstName, lastName, nickname, media и т.д. */
  calendarEventUsers: CalendarEventUsersResult;
  /** Получить список событий календаря в указанном диапазоне дат */
  calendarEvents: CalendarEventList;
  comment: Comment;
  comments: CommentConnection;
  /** Получить список общих друзей между двумя пользователями. */
  commonFriends: Array<FriendRelationship>;
  /** Получить счётчик по ID */
  counter?: Maybe<Counter>;
  counterEvent: CounterEvent;
  counterEvents: CounterEventConnection;
  /** Получить историю показаний счётчика за год */
  counterHistory: CounterHistory;
  /** Получить показание по ID */
  counterReading?: Maybe<CounterReading>;
  counterReadings: CounterReadingConnection;
  /** Получить все счётчики проекта для текущего пользователя */
  counters: Array<Counter>;
  /** Получить счётчики по категории для текущего пользователя */
  countersByCategory: Array<Counter>;
  /** Права текущего пользователя на глобальный модуль (внесение / редактирование / полный доступ) — для гейтинга UI. Доступно любому пользователю про себя. */
  currentUserGlobalModuleCapabilities: CurrentUserGlobalModuleCapabilities;
  /** Права текущего пользователя на модуль (show / view / insert / edit / full access) */
  currentUserProjectModuleCapabilities: CurrentUserProjectModuleCapabilities;
  /** Права текущего пользователя на несколько модулей (для отладки рабочего стола) */
  currentUserProjectModuleCapabilitiesBatch: Array<CurrentUserProjectModuleCapabilities>;
  /** Получить контакт экстренной службы по ID */
  emergencyContact?: Maybe<EmergencyContact>;
  emergencyContacts: EmergencyContactConnection;
  /** Получить контакты экстренных служб по категории */
  emergencyContactsByCategory: Array<EmergencyContact>;
  /** Получить ссылку на отчёт по всем организациям во всех проектах в формате csv или pdf c фильтром */
  exportAllOrganizations: Scalars['String']['output'];
  /** Получить ссылку на отчёт по всем сторонникам во всех проектах в формате csv или pdf c фильтром */
  exportAllSupporters: Scalars['String']['output'];
  /** Получить ссылку на отчёт по сторонникам, организациям и участникам для одного проекта в формате csv или pdf */
  exportCombinedData: Scalars['String']['output'];
  /** Получить ссылку на отчёт по организациям для одного проекта в формате csv или pdf */
  exportMyOrganizations: Scalars['String']['output'];
  /** Получить ссылку на отчёт по сторонникам для одного проекта в формате csv или pdf */
  exportMySupporters: Scalars['String']['output'];
  /** Экспортировать контакты реестра с применением текущих фильтров в PDF или Excel (CSV) */
  exportRegistryContacts: Scalars['String']['output'];
  exportSurveyData: Scalars['String']['output'];
  /** Получить статус отношений между двумя пользователями */
  friendRelationship?: Maybe<FriendRelationship>;
  /** Получить список друзей пользователя по его ID (только статус ACCEPTED). */
  friendsByUserId: Array<FriendRelationship>;
  /** Получить все запросы на добавление в проект с возможностью фильтрации по статусу и поиска по названию, краткому и подробному описанию. Используется для отображения всех заявок в админке и для аналитики. */
  getAllProjectRequests: Array<ProjectRequest>;
  getAllTemplates: AllTemplatesResponse;
  /** Получить входящие заявки на слияние для проекта */
  getIncomingMergeRequests: Array<MergeSessionDto>;
  /** Получить информацию о приглашении по токену ссылки */
  getInvitationByToken: ProjectInvitation;
  /** Получить статистику ссылки-приглашения */
  getInvitationLinkStats: InvitationLinkStats;
  /** Получить статус медиа */
  getMediaStatus: Array<MediaStatusItemOutputDto>;
  /** Получить ссылку на загрузку медиа */
  getMediaUploadUrl: MediaUploadUrlOutputDto;
  /** Получить мастер-плейлист HLS для видео */
  getMediaVideoHlsMaster: MediaVideoHlsMasterPlaylistOutputDto;
  /** Получить вариант-плейлист HLS для видео */
  getMediaVideoHlsVariant: Scalars['String']['output'];
  /** Получить информацию о сессии слияния с diff данными */
  getMergeSession: MergeSessionDto;
  /** Получить все сессии слияния для проекта */
  getMergeSessionsForProject: Array<MergeSessionDto>;
  getMockup: Mockup;
  getMockups: Array<Mockup>;
  /** Получить все разрешения для модуля аналитики для текущего пользователя */
  getMsAnalyticsPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Комментарии для текущего пользователя */
  getMsCommentPermissions: Array<Scalars['String']['output']>;
  /** Получить разрешения для модуля новостей или конкретной новости. Если указан newsId — возвращаются права на неё. */
  getMsNewsPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Календарь для текущего пользователя */
  getMsProjectCalendarEventPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Счётчики для текущего пользователя */
  getMsProjectCounterPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Кастомные модули для текущего пользователя */
  getMsProjectCustomModulePermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.ТелефоныСпецслужб для текущего пользователя */
  getMsProjectEmergencyContactPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Шаблоны лендингов для текущего пользователя */
  getMsProjectLandingTemplatePermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Обращения для текущего пользователя */
  getMsProjectMailPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Участники для текущего пользователя */
  getMsProjectMemberPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Макеты для текущего пользователя */
  getMsProjectMockupsPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для настроек доступа к модулям проекта для текущего пользователя */
  getMsProjectModuleAccessPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Модули для текущего пользователя */
  getMsProjectModuleMemberPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля «Паспорт объекта» для текущего пользователя */
  getMsProjectObjectPassportPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Организации для текущего пользователя */
  getMsProjectOrganizationsPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты для текущего пользователя */
  getMsProjectPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля «Программа» для текущего пользователя */
  getMsProjectProgramPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.ЗаявкиНаПроект для текущего пользователя */
  getMsProjectProjectRequestPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Реестр для текущего пользователя */
  getMsProjectRegistryPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля «Регламент» для текущего пользователя */
  getMsProjectReglamentPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Слияние Сторонников для текущего пользователя */
  getMsProjectSupporterMergePermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Сторонники для текущего пользователя */
  getMsProjectSupportersPermissions: Array<Scalars['String']['output']>;
  /** Получить все разрешения для модуля Проекты.Шаблоны для текущего пользователя */
  getMsProjectTemplatesPermissions: Array<Scalars['String']['output']>;
  /** Получить разрешения для модуля опросов или конкретного опроса. */
  getMsSurveyPermissions: Array<Scalars['String']['output']>;
  /** Получить все запросы на добавление в проект независимо от статуса только для текущего пользователя. Используется в личном кабинете пользователя. */
  getMyAllProjectRequests: Array<ProjectRequest>;
  /** Получить список приглашений текущего пользователя */
  getMyInvitations: Array<ProjectInvitation>;
  /** Получить список заявок текущего пользователя */
  getMyJoinRequests: Array<ProjectJoinRequest>;
  /** Получить избранные проекты текущего пользователя */
  getMyLikedProjects: LikedProjectsConnection;
  /** Получить запрос на добавление в проект по ID для текущего пользователя. Используется для просмотра деталей своей заявки в личном кабинете. */
  getMyProjectRequest: ProjectRequest;
  /** Получить следующий вопрос теста */
  getNextTestQuestion: NextQuestionResponseDto;
  /** Получить исходящие заявки на слияние для проекта */
  getOutgoingMergeRequests: Array<MergeSessionDto>;
  /** Получить ожидающие заявки проекта (для владельца/админа) */
  getPendingJoinRequests: Array<ProjectJoinRequest>;
  /** Получить количество ожидающих заявок на вступление в проект (для владельца/админа) */
  getPendingJoinRequestsCount: Scalars['Int']['output'];
  getPhraseOfTheDay: Phrase;
  /** Получить сохраненные общие отчеты по платформе */
  getPlatformSummaryReports: Array<PlatformSummaryReportEntity>;
  /** Получить сохраненные детализированные отчеты по проектам */
  getProjectDetailedReports: Array<ProjectDetailedReportEntity>;
  /** Получить активные ссылки-приглашения проекта (для владельца/админа) */
  getProjectInvitationLinks: Array<ProjectInvitation>;
  /** Получить список приглашений проекта (для владельца/админа) */
  getProjectInvitations: Array<ProjectInvitation>;
  /** Получить список заявок проекта (для владельца/админа) */
  getProjectJoinRequests: Array<ProjectJoinRequest>;
  getProjectMockups: Array<Mockup>;
  /** Получить запрос на добавление в проект по ID. Используется для просмотра деталей заявки в админке. */
  getProjectRequest: ProjectRequest;
  /** Получить все значения enum тем для запросов на добавление в проект. Используется для отображения вариантов тем в UI формы заявки. */
  getProjectRequestThemes: Array<ProjectRequestThemeDto>;
  /** Получить статистику платформы в реальном времени (без сохранения) */
  getRealTimeStatistics: PlatformSummaryReportEntity;
  /** Получить сохраненные региональные отчеты */
  getRegionalReports: Array<RegionalReportEntity>;
  /** Унифицированная мета-информация по владельцам сторонников для фильтрации */
  getSupportersMeta: ProjectSupporterOwnersResponseDto;
  getSystemMockups: Array<Mockup>;
  /** Получить прогресс прохождения теста */
  getTestProgress: TestProgressDto;
  getUnreadNotificationsCount: Scalars['Int']['output'];
  /** Получить сохраненные детализированные отчеты по пользователям */
  getUserDetailedReports: Array<UserDetailedReportEntity>;
  getUserNotifications: NotificationConnection;
  getUserTemplates: Array<Template>;
  /** Настройки доступа глобального модуля (например, «Дайджест новостей») */
  globalModuleAccessSettings: GlobalModuleAccessSettings;
  /** Получить список входящих заявок в друзья, отправленных пользователю */
  incomingFriendRequests: Array<FriendRelationship>;
  /** Сервис-сервис: presigned GET к MinIO по внутреннему URL + проверка размера. Требует заголовок x-internal-media-graphql-secret. */
  internalPresignedGetMediaObject: InternalMediaObjectPresignedOutput;
  inviteByToken?: Maybe<InviteDto>;
  landingTemplate: LandingTemplate;
  landingTemplateAggregate: Array<LandingTemplateAggregateResponse>;
  landingTemplates: LandingTemplateConnection;
  like: Like;
  likes: LikeConnection;
  likesForObject: LikeOutput;
  /** Установлен ли у текущего пользователя код быстрого входа. Требует авторизации. */
  loginCodeStatus: Scalars['Boolean']['output'];
  /** Получить сообщение обращения по ID */
  mailMessage: MailMessage;
  /** Получить сообщения обращения */
  mailMessages: Array<MailMessage>;
  /** Получить список доступных получателей для нового обращения */
  mailRecipients: Array<MailRecipient>;
  /** Получить обращение по ID */
  mailThread?: Maybe<MailThread>;
  /** Получить список обращений проекта */
  mailThreads: MailThreadList;
  /** Получить количество непрочитанных обращений */
  mailUnreadCount: Scalars['Int']['output'];
  me: User;
  /** Получить presigned URL для загрузки файла макета в MinIO */
  mockupPresignedPutUrl: MockupPresignedUrlResponse;
  news: NewsOffsetConnection;
  /** Количество непросмотренных новостей в «Дайджест новостей» для текущего пользователя: quest (Новости Квест) / project (Новости Проекта) / total. */
  newsDigestUnseenCount: NewsDigestUnseenCount;
  newsOne: News;
  /** Получить агрегированные результаты опроса */
  newsPollResults?: Maybe<NewsPollResults>;
  /** Получить presigned GET URL по ключу объекта (значение из customPhotos / customVideos). Используется для предпросмотра загруженного медиа. */
  newsPresignedGetUrl: NewsPresignedGetUrlResponse;
  /** Получить presigned PUT URL для загрузки фото/видео к новости (customPhotos / customVideos). Поведение аналогично projectRequestPresignedPutUrl. */
  newsPresignedPutUrl: NewsPresignedPutUrlResponse;
  /** Паспорт объекта экземпляра модуля (projectId + moduleSlug). null, если ещё не заполнен */
  objectPassport?: Maybe<ObjectPassport>;
  /** Список заявок на участие. Модераторы видят все заявки, обычный пользователь — только свои */
  objectPassportApplications: ObjectPassportApplicationList;
  /** Паспорт объекта по его ID. null, если не найден */
  objectPassportById?: Maybe<ObjectPassport>;
  /** Участники проекта — кандидаты для выпадающего списка «Контактное лицо». Каждый объект — федерированный User из ms-users */
  objectPassportContactCandidates: Array<User>;
  /** Список паспортов объектов проекта (по одному на экземпляр модуля) */
  objectPassports: Array<ObjectPassport>;
  /** Получить список исходящих заявок в друзья, отправленных текущим пользователем */
  outgoingFriendRequests: Array<FriendRelationship>;
  presignedGetUrl: Scalars['String']['output'];
  presignedPutUrl: Scalars['String']['output'];
  /** Участники проекта — кандидаты для выпадающего списка «Контактное лицо». Каждый объект — федерированный User из ms-users */
  programContactCandidates: Array<User>;
  /** Мероприятие программы по его ID. null, если не найдено */
  programItem?: Maybe<ProgramItem>;
  /** Список мероприятий программы экземпляра модуля (projectId + moduleSlug) */
  programItems: Array<ProgramItem>;
  /** Получить проект по одному из опциональных фильтров: id, slug (точное совпадение) или shortDescription (регистронезависимое точное совпадение). Укажите хотя бы один; приоритет: id → slug → shortDescription. Возвращает null, если проект не найден */
  project?: Maybe<Project>;
  /** Получить сводку по всем счётчикам проекта для текущего пользователя */
  projectCountersSummary: ProjectCountersSummary;
  /** Получить кастомный модуль по ID */
  projectCustomModule?: Maybe<ProjectCustomModule>;
  /** Кастомные модули проекта, видимые текущему пользователю (с учётом «Показать модуль») */
  projectCustomModules: Array<ProjectCustomModule>;
  /** Кастомные модули, привязанные к заявке (черновик до одобрения проекта) */
  projectCustomModulesForProjectRequest: Array<ProjectCustomModule>;
  /** Получить участника проекта по его ID и projectId (опционально) */
  projectMember: ProjectMember;
  projectMembers: ProjectMemberConnection;
  /** Список участников проекта с опциональным фильтром по moduleSlug (только участники, состоящие в указанном модуле). Без moduleSlug — все участники проекта */
  projectMembersByModule: Array<ProjectMember>;
  /** Настройки доступа к модулю проекта */
  projectModuleAccessSettings: ProjectModuleAccessSettings;
  /** Настройки доступа по сегменту URL (/management/module/:moduleSegment) */
  projectModuleAccessSettingsBySegment: ProjectModuleAccessSettings;
  /** Получить участника модуля проекта по его ID и projectId (опционально) */
  projectModuleMember: ProjectModuleMember;
  projectModuleMembers: ProjectModuleMemberConnection;
  /** Права на список и создание новостей модуля по настройкам доступа (OPA data). Предпочтительно: ms-project `currentUserProjectModuleCapabilities` (canView / canInsert). */
  projectNewsModuleAccessCapabilities: ProjectNewsModuleAccessCapabilitiesDto;
  projectOrganization: ProjectOrganization;
  projectOrganizations: ProjectOrganizationConnection;
  /** Получить presigned URL для скачивания файла (видео/изображения) из Minio. Используется в UI для предпросмотра или скачивания медиа. */
  projectRequestPresignedGetUrl: PresignedUrlResponse;
  /** Получить presigned URL для загрузки файла (видео/изображения) в Minio. Используется в UI для загрузки медиа. */
  projectRequestPresignedPutUrl: PresignedUrlResponse;
  /** Получить сторонника по его ID и projectId (опционально) */
  projectSupporter: ProjectSupporter;
  projectSupporters: ProjectSupporterConnection;
  /** Слаги модулей (нативных и кастомных), которые текущий пользователь может видеть на рабочем столе проекта */
  projectWorkspaceVisibleModuleSlugs: Array<Scalars['String']['output']>;
  projects: ProjectConnection;
  /** Fetches the public key from Keycloak. */
  publicKey: Scalars['String']['output'];
  /** Получить публичную информацию о проекте по ID или slug (без авторизации). Укажите хотя бы один аргумент; при наличии обоих приоритет у id */
  publicProject: PublicProject;
  questionDto: QuestionDto;
  questionDtos: QuestionDtoConnection;
  questionFieldDto: QuestionFieldDto;
  questionFieldDtos: QuestionFieldDtoConnection;
  /** Получить вопросы опроса со статистикой ответов */
  questionsWithStats: Array<QuestionWithStatsDto>;
  /** Возвращает список пользователей, с которыми вы еще НЕ дружите (включая отправивших входящую заявку в друзья), с возможностью поиска и разбиения на страницы */
  recommendedUsers: Array<User>;
  /** Получить список уникальных городов для проекта */
  registryCities: Array<Scalars['String']['output']>;
  /** Получить контакт реестра по ID */
  registryContact?: Maybe<RegistryContact>;
  /** Получить список контактов реестра с фильтрами, поиском и пагинацией */
  registryContacts: RegistryContactConnection;
  /** Получить список уникальных регионов для проекта */
  registryRegions: Array<Scalars['String']['output']>;
  /** Выступление регламента по его ID. null, если не найдено */
  reglamentItem?: Maybe<ReglamentItem>;
  /** Список выступлений регламента экземпляра модуля (projectId + moduleSlug) */
  reglamentItems: Array<ReglamentItem>;
  response?: Maybe<ResponseDto>;
  /** Получить опросы с запланированной публикацией */
  scheduledSurveys: Array<SurveyDto>;
  /** Поиск контактов экстренных служб по наименованию */
  searchEmergencyContacts: Array<EmergencyContact>;
  searchUsers: Array<User>;
  /** Получить список подписчиков пользователя по его ID. */
  subscribersByUserId: Array<FriendRelationship>;
  /** Получить список подписок пользователя (на кого он подписан) по его ID. */
  subscriptionsByUserId: Array<FriendRelationship>;
  surveyAnalytics: Scalars['JSON']['output'];
  surveyDtos: SurveyDtoConnection;
  surveyInvites: Array<InviteDto>;
  /** Получить пользователей, проходивших конкретный опрос */
  surveyParticipants: Array<SurveyParticipantDto>;
  surveyPublic?: Maybe<SurveyPublicDto>;
  /** Готовая публичная ссылка для опроса */
  surveyPublicLink: Scalars['String']['output'];
  surveyStats: SurveyStatsDto;
  tagOne: TagDto;
  tags: TagDtoConnection;
  uploadInfo?: Maybe<UploadInfoDto>;
  user: User;
  /** Получить пройденные опросы пользователя */
  userCompletedSurveys: Array<UserCompletedSurveyDto>;
  userResponses: Array<ResponseDto>;
  /** Получить ответ пользователя на опрос */
  userSurveyResponse?: Maybe<ResponseDto>;
  userSurveys: Array<SurveyDto>;
  userVerifyRequest: UserVerifyRequest;
  userVerifyRequests: UserVerifyRequestConnection;
  /** Валидация конфигурации вопроса */
  validateQuestionConfiguration: Array<Scalars['String']['output']>;
  verificationStatuses: Array<VerificationStatus>;
};


export type QueryAnswerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnswersArgs = {
  filter?: AnswerFilter;
  paging?: OffsetPaging;
  sorting?: Array<AnswerSort>;
};


export type QueryAppVersionCheckArgs = {
  input: AppVersionCheckInput;
};


export type QueryCalendarEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalendarEventDayCountsArgs = {
  filter: CalendarEventDayCountFilterInput;
};


export type QueryCalendarEventUsersArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCalendarEventsArgs = {
  filter: CalendarEventListFilterInput;
};


export type QueryCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommentsArgs = {
  filter?: CommentFilter;
  paging?: OffsetPaging;
  sorting?: Array<CommentSort>;
};


export type QueryCommonFriendsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
  userId1: Scalars['String']['input'];
  userId2: Scalars['String']['input'];
};


export type QueryCounterArgs = {
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCounterEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCounterEventsArgs = {
  filter?: CounterEventFilter;
  paging?: CursorPaging;
  sorting?: Array<CounterEventSort>;
};


export type QueryCounterHistoryArgs = {
  counterId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type QueryCounterReadingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCounterReadingsArgs = {
  filter?: CounterReadingFilter;
  paging?: OffsetPaging;
  sorting?: Array<CounterReadingSort>;
};


export type QueryCountersArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryCountersByCategoryArgs = {
  category: CounterCategory;
  projectId: Scalars['ID']['input'];
};


export type QueryCurrentUserGlobalModuleCapabilitiesArgs = {
  moduleSlug: Scalars['String']['input'];
};


export type QueryCurrentUserProjectModuleCapabilitiesArgs = {
  moduleSlug: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryCurrentUserProjectModuleCapabilitiesBatchArgs = {
  moduleSlugs: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryEmergencyContactArgs = {
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmergencyContactsArgs = {
  filter?: EmergencyContactFilter;
  paging?: OffsetPaging;
  sorting?: Array<EmergencyContactSort>;
};


export type QueryEmergencyContactsByCategoryArgs = {
  category: EmergencyContactCategoryEnum;
  projectId: Scalars['ID']['input'];
};


export type QueryExportAllOrganizationsArgs = {
  filter?: InputMaybe<ProjectOrganizationFilter>;
  format: ProjectSupporterExportFormat;
  sorting?: InputMaybe<Array<ProjectOrganizationSort>>;
};


export type QueryExportAllSupportersArgs = {
  filter?: InputMaybe<ProjectSupporterFilter>;
  format: ProjectSupporterExportFormat;
  sorting?: InputMaybe<Array<ProjectSupporterSort>>;
};


export type QueryExportCombinedDataArgs = {
  format: ProjectSupporterExportFormat;
  includeMembers?: Scalars['Boolean']['input'];
  includeOrganizations?: Scalars['Boolean']['input'];
  includeSupporters?: Scalars['Boolean']['input'];
  memberFilter?: InputMaybe<ProjectMemberFilter>;
  memberSorting?: InputMaybe<Array<ProjectMemberSort>>;
  organizationFilter?: InputMaybe<ProjectOrganizationFilter>;
  organizationSorting?: InputMaybe<Array<ProjectOrganizationSort>>;
  projectId: Scalars['String']['input'];
  supporterFilter?: InputMaybe<ProjectSupporterFilter>;
  supporterSorting?: InputMaybe<Array<ProjectSupporterSort>>;
};


export type QueryExportMyOrganizationsArgs = {
  format: ProjectSupporterExportFormat;
  projectId: Scalars['String']['input'];
};


export type QueryExportMySupportersArgs = {
  format: ProjectSupporterExportFormat;
  projectId: Scalars['String']['input'];
};


export type QueryExportRegistryContactsArgs = {
  format: ProjectSupporterExportFormat;
  input: ExportRegistryContactsInput;
};


export type QueryExportSurveyDataArgs = {
  surveyId: Scalars['String']['input'];
};


export type QueryFriendRelationshipArgs = {
  friendId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryFriendsByUserIdArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetAllProjectRequestsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectRequestStatusEnum>;
};


export type QueryGetAllTemplatesArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetIncomingMergeRequestsArgs = {
  input: GetMergeRequestsDto;
};


export type QueryGetInvitationByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetInvitationLinkStatsArgs = {
  invitationId: Scalars['String']['input'];
};


export type QueryGetMediaStatusArgs = {
  input: MediaStatusInputDto;
};


export type QueryGetMediaUploadUrlArgs = {
  input: MediaUploadUrlInputDto;
};


export type QueryGetMediaVideoHlsMasterArgs = {
  input: MediaVideoHlsMasterPlaylistInputDto;
};


export type QueryGetMediaVideoHlsVariantArgs = {
  input: MediaVideoHlsVariantPlaylistInputDto;
};


export type QueryGetMergeSessionArgs = {
  includeDiff?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['String']['input'];
};


export type QueryGetMergeSessionsForProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMockupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMockupsArgs = {
  filter?: InputMaybe<MockupFilterInput>;
};


export type QueryGetMsNewsPermissionsArgs = {
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  newsId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMsProjectCalendarEventPermissionsArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMsProjectCounterPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectCustomModulePermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectEmergencyContactPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectLandingTemplatePermissionsArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMsProjectMailPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectMemberPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectMockupsPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectModuleAccessPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectModuleMemberPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectObjectPassportPermissionsArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMsProjectOrganizationsPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectProgramPermissionsArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMsProjectRegistryPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectReglamentPermissionsArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMsProjectSupporterMergePermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectSupportersPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsProjectTemplatesPermissionsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetMsSurveyPermissionsArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  surveyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMyLikedProjectsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryGetMyProjectRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetNextTestQuestionArgs = {
  input: GetNextQuestionDto;
};


export type QueryGetOutgoingMergeRequestsArgs = {
  input: GetMergeRequestsDto;
};


export type QueryGetPendingJoinRequestsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetPendingJoinRequestsCountArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetPlatformSummaryReportsArgs = {
  filters?: InputMaybe<AnalyticsFiltersInput>;
};


export type QueryGetProjectDetailedReportsArgs = {
  filters?: InputMaybe<ProjectDetailedFiltersInput>;
};


export type QueryGetProjectInvitationLinksArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetProjectInvitationsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetProjectJoinRequestsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetProjectMockupsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryGetProjectRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetRegionalReportsArgs = {
  filters?: InputMaybe<AnalyticsFiltersInput>;
};


export type QueryGetSupportersMetaArgs = {
  input: GetProjectSupporterOwnersInput;
};


export type QueryGetTestProgressArgs = {
  surveyId: Scalars['String']['input'];
};


export type QueryGetUnreadNotificationsCountArgs = {
  type?: InputMaybe<NotificationType>;
};


export type QueryGetUserDetailedReportsArgs = {
  filters?: InputMaybe<UserDetailedFiltersInput>;
};


export type QueryGetUserNotificationsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  type?: NotificationType;
};


export type QueryGetUserTemplatesArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGlobalModuleAccessSettingsArgs = {
  moduleSlug: Scalars['String']['input'];
};


export type QueryIncomingFriendRequestsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryInternalPresignedGetMediaObjectArgs = {
  input: InternalMediaObjectReadInput;
};


export type QueryInviteByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryLandingTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLandingTemplateAggregateArgs = {
  filter?: InputMaybe<LandingTemplateAggregateFilter>;
};


export type QueryLandingTemplatesArgs = {
  filter?: LandingTemplateFilter;
  paging?: CursorPaging;
  sorting?: Array<LandingTemplateSort>;
};


export type QueryLikeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLikesArgs = {
  filter?: LikeFilter;
  paging?: OffsetPaging;
  sorting?: Array<LikeSort>;
};


export type QueryLikesForObjectArgs = {
  likeableId: Scalars['String']['input'];
  likeableType: LikeableTypeEnum;
};


export type QueryMailMessageArgs = {
  threadId: Scalars['ID']['input'];
};


export type QueryMailMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['ID']['input'];
};


export type QueryMailRecipientsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryMailThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailThreadsArgs = {
  filter?: InputMaybe<MailThreadFilterEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMailUnreadCountArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryMockupPresignedPutUrlArgs = {
  input: MockupPresignedPutUrlInput;
};


export type QueryNewsArgs = {
  filter?: NewsFilter;
  friendsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  moderationStatus?: InputMaybe<NewsModerationStatusEnum>;
  myProjectsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  paging?: OffsetPaging;
  questAdminsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: Array<NewsSort>;
};


export type QueryNewsDigestUnseenCountArgs = {
  createdAtGte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryNewsOneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsPollResultsArgs = {
  pollId: Scalars['ID']['input'];
};


export type QueryNewsPresignedGetUrlArgs = {
  input: NewsPresignedGetUrlInput;
};


export type QueryNewsPresignedPutUrlArgs = {
  input: NewsPresignedPutUrlInput;
};


export type QueryObjectPassportArgs = {
  moduleSlug: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryObjectPassportApplicationsArgs = {
  filter: ObjectPassportApplicationListFilterInput;
};


export type QueryObjectPassportByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryObjectPassportContactCandidatesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryObjectPassportsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryOutgoingFriendRequestsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryPresignedGetUrlArgs = {
  deviceType?: MediaDeviceType;
  expires?: InputMaybe<Scalars['Float']['input']>;
  imageType?: ImageVariationType;
  objectType: FileObjectType;
};


export type QueryPresignedPutUrlArgs = {
  input: GetPresignedUrlInput;
};


export type QueryProgramContactCandidatesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProgramItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramItemsArgs = {
  moduleSlug: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectCountersSummaryArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectCustomModuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectCustomModulesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectCustomModulesForProjectRequestArgs = {
  projectRequestId: Scalars['ID']['input'];
};


export type QueryProjectMemberArgs = {
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectMembersArgs = {
  filter?: ProjectMemberFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectMemberSort>;
};


export type QueryProjectMembersByModuleArgs = {
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryProjectModuleAccessSettingsArgs = {
  moduleSlug: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryProjectModuleAccessSettingsBySegmentArgs = {
  moduleSegment: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryProjectModuleMemberArgs = {
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectModuleMembersArgs = {
  filter?: ProjectModuleMemberFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectModuleMemberSort>;
};


export type QueryProjectNewsModuleAccessCapabilitiesArgs = {
  moduleSlug: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type QueryProjectOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectOrganizationsArgs = {
  filter?: ProjectOrganizationFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectOrganizationSort>;
};


export type QueryProjectRequestPresignedGetUrlArgs = {
  input: ProjectRequestPresignedUrlInput;
};


export type QueryProjectRequestPresignedPutUrlArgs = {
  input: ProjectRequestPresignedUrlInput;
};


export type QueryProjectSupporterArgs = {
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectSupportersArgs = {
  filter?: ProjectSupporterFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectSupporterSort>;
};


export type QueryProjectWorkspaceVisibleModuleSlugsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  filter?: ProjectFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectSort>;
};


export type QueryPublicProjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQuestionDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionDtosArgs = {
  filter?: QuestionDtoFilter;
  paging?: OffsetPaging;
  sorting?: Array<QuestionDtoSort>;
};


export type QueryQuestionFieldDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionFieldDtosArgs = {
  filter?: QuestionFieldDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<QuestionFieldDtoSort>;
};


export type QueryQuestionsWithStatsArgs = {
  surveyId: Scalars['String']['input'];
};


export type QueryRecommendedUsersArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  withFriends?: Scalars['Boolean']['input'];
};


export type QueryRegistryCitiesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryRegistryContactArgs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryRegistryContactsArgs = {
  filter: RegistryFilterInput;
};


export type QueryRegistryRegionsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryReglamentItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReglamentItemsArgs = {
  moduleSlug: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryResponseArgs = {
  id: Scalars['String']['input'];
};


export type QuerySearchEmergencyContactsArgs = {
  category?: InputMaybe<EmergencyContactCategoryEnum>;
  projectId: Scalars['ID']['input'];
  searchQuery: Scalars['String']['input'];
};


export type QuerySearchUsersArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type QuerySubscribersByUserIdArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QuerySubscriptionsByUserIdArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QuerySurveyAnalyticsArgs = {
  surveyId: Scalars['String']['input'];
};


export type QuerySurveyDtosArgs = {
  filter?: SurveyDtoFilter;
  paging?: OffsetPaging;
  sorting?: Array<SurveyDtoSort>;
};


export type QuerySurveyInvitesArgs = {
  surveyId: Scalars['String']['input'];
};


export type QuerySurveyParticipantsArgs = {
  filter: SurveyParticipantsFilterDto;
};


export type QuerySurveyPublicArgs = {
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['String']['input'];
};


export type QuerySurveyPublicLinkArgs = {
  surveyId: Scalars['String']['input'];
};


export type QuerySurveyStatsArgs = {
  surveyId: Scalars['String']['input'];
};


export type QueryTagOneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagsArgs = {
  filter?: TagDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<TagDtoSort>;
};


export type QueryUploadInfoArgs = {
  uploadId: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserCompletedSurveysArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserResponsesArgs = {
  surveyId: Scalars['String']['input'];
};


export type QueryUserSurveyResponseArgs = {
  surveyId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserVerifyRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserVerifyRequestsArgs = {
  filter?: UserVerifyRequestFilter;
  paging?: OffsetPaging;
  sorting?: Array<UserVerifyRequestSort>;
};


export type QueryValidateQuestionConfigurationArgs = {
  fields: Array<Scalars['JSON']['input']>;
  questionData: Scalars['JSON']['input'];
  surveyId: Scalars['String']['input'];
};

/** Ответ на вопрос с детальными значениями */
export type QuestionAnswerDto = {
  __typename?: 'QuestionAnswerDto';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Дедлайн для редактирования */
  editDeadlineAt?: Maybe<Scalars['DateTime']['output']>;
  /** Идентификатор ответа */
  id: Scalars['ID']['output'];
  /** Токен приглашения */
  inviteToken?: Maybe<Scalars['String']['output']>;
  /** Флаг анонимного ответа */
  isAnonymous: Scalars['Boolean']['output'];
  /** Метаданные */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Пользователь-респондент */
  respondent?: Maybe<User>;
  /** ID пользователя-респондента */
  respondentUserId?: Maybe<Scalars['ID']['output']>;
  /** Статус ответа */
  status: ResponseStatus;
  /** Дата отправки */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID опроса */
  surveyId: Scalars['ID']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** Значения ответов по полям */
  value: Array<AnswerValueFieldDto>;
};

/** Вопрос в опросе */
export type QuestionDto = {
  __typename?: 'QuestionDto';
  /** Ответы на вопрос с детальными значениями */
  answers?: Maybe<Array<QuestionAnswerDto>>;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Описание вопроса */
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<QuestionFieldDto>;
  /** Идентификатор вопроса */
  id: Scalars['ID']['output'];
  /** Обязательность вопроса */
  isRequired: Scalars['Boolean']['output'];
  /** Дополнительные настройки */
  metadata?: Maybe<Scalars['JSON']['output']>;
  options: Array<OptionDto>;
  /** Порядок вопроса в опросе */
  order: Scalars['Float']['output'];
  /** Готовая статистика по вопросу */
  stats?: Maybe<QuestionStatsDto>;
  /** ID опроса */
  surveyId: Scalars['ID']['output'];
  /** Текст вопроса */
  title: Scalars['String']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};


/** Вопрос в опросе */
export type QuestionDtoAnswersArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Вопрос в опросе */
export type QuestionDtoFieldsArgs = {
  filter?: QuestionFieldDtoFilter;
  sorting?: Array<QuestionFieldDtoSort>;
};


/** Вопрос в опросе */
export type QuestionDtoOptionsArgs = {
  filter?: OptionDtoFilter;
  sorting?: Array<OptionDtoSort>;
};

export type QuestionDtoConnection = {
  __typename?: 'QuestionDtoConnection';
  /** Array of nodes. */
  nodes: Array<QuestionDto>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type QuestionDtoDeleteFilter = {
  and?: InputMaybe<Array<QuestionDtoDeleteFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isRequired?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<QuestionDtoDeleteFilter>>;
  order?: InputMaybe<NumberFieldComparison>;
  surveyId?: InputMaybe<IdFilterComparison>;
  title?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type QuestionDtoDeleteResponse = {
  __typename?: 'QuestionDtoDeleteResponse';
  /** Ответы на вопрос с детальными значениями */
  answers?: Maybe<Array<QuestionAnswerDto>>;
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Описание вопроса */
  description?: Maybe<Scalars['String']['output']>;
  /** Идентификатор вопроса */
  id?: Maybe<Scalars['ID']['output']>;
  /** Обязательность вопроса */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Дополнительные настройки */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Порядок вопроса в опросе */
  order?: Maybe<Scalars['Float']['output']>;
  /** Готовая статистика по вопросу */
  stats?: Maybe<QuestionStatsDto>;
  /** ID опроса */
  surveyId?: Maybe<Scalars['ID']['output']>;
  /** Текст вопроса */
  title?: Maybe<Scalars['String']['output']>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionDtoFilter = {
  and?: InputMaybe<Array<QuestionDtoFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isRequired?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<QuestionDtoFilter>>;
  order?: InputMaybe<NumberFieldComparison>;
  surveyId?: InputMaybe<IdFilterComparison>;
  title?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type QuestionDtoSort = {
  direction: SortDirection;
  field: QuestionDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum QuestionDtoSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsRequired = 'isRequired',
  Order = 'order',
  SurveyId = 'surveyId',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

/** Поле вопроса в опросе */
export type QuestionFieldDto = {
  __typename?: 'QuestionFieldDto';
  /** Пояснение правильного ответа */
  answerExplanation?: Maybe<Scalars['String']['output']>;
  /** Тип валидации ответа */
  answerValidationType?: Maybe<Scalars['String']['output']>;
  /** Правильный ответ (виден только владельцам/админам) */
  correctAnswer?: Maybe<Scalars['JSON']['output']>;
  /** Паттерн правильного ответа (regex) */
  correctAnswerPattern?: Maybe<Scalars['String']['output']>;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Идентификатор поля вопроса */
  id: Scalars['ID']['output'];
  /** Дополнительные настройки поля */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Варианты ответов (для choice полей) */
  options?: Maybe<Array<Scalars['String']['output']>>;
  /** Порядок поля в вопросе */
  order: Scalars['Float']['output'];
  /** ID вопроса */
  questionId: Scalars['ID']['output'];
  /** Тип поля: DESCRIPTION для предзаготовленного контента, ANSWER для пользовательского ввода */
  type: QuestionFieldType;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** Значение поля с подстановкой presigned URL вместо идентификаторов медиа */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type QuestionFieldDtoConnection = {
  __typename?: 'QuestionFieldDtoConnection';
  /** Array of edges. */
  edges: Array<QuestionFieldDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type QuestionFieldDtoDeleteResponse = {
  __typename?: 'QuestionFieldDtoDeleteResponse';
  /** Пояснение правильного ответа */
  answerExplanation?: Maybe<Scalars['String']['output']>;
  /** Тип валидации ответа */
  answerValidationType?: Maybe<Scalars['String']['output']>;
  /** Правильный ответ (виден только владельцам/админам) */
  correctAnswer?: Maybe<Scalars['JSON']['output']>;
  /** Паттерн правильного ответа (regex) */
  correctAnswerPattern?: Maybe<Scalars['String']['output']>;
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Идентификатор поля вопроса */
  id?: Maybe<Scalars['ID']['output']>;
  /** Дополнительные настройки поля */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Варианты ответов (для choice полей) */
  options?: Maybe<Array<Scalars['String']['output']>>;
  /** Порядок поля в вопросе */
  order?: Maybe<Scalars['Float']['output']>;
  /** ID вопроса */
  questionId?: Maybe<Scalars['ID']['output']>;
  /** Тип поля: DESCRIPTION для предзаготовленного контента, ANSWER для пользовательского ввода */
  type?: Maybe<QuestionFieldType>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Значение поля (для DESCRIPTION полей) - может быть string, string[], number и т.д. */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type QuestionFieldDtoEdge = {
  __typename?: 'QuestionFieldDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the QuestionFieldDto */
  node: QuestionFieldDto;
};

export type QuestionFieldDtoFilter = {
  and?: InputMaybe<Array<QuestionFieldDtoFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<QuestionFieldDtoFilter>>;
  order?: InputMaybe<NumberFieldComparison>;
  questionId?: InputMaybe<IdFilterComparison>;
  type?: InputMaybe<QuestionFieldDtoTypeFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type QuestionFieldDtoSort = {
  direction: SortDirection;
  field: QuestionFieldDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum QuestionFieldDtoSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Order = 'order',
  QuestionId = 'questionId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type QuestionFieldDtoTypeFilterComparison = {
  eq?: InputMaybe<QuestionFieldType>;
  in?: InputMaybe<Array<QuestionFieldType>>;
  neq?: InputMaybe<QuestionFieldType>;
  notIn?: InputMaybe<Array<QuestionFieldType>>;
};

/** Типы полей вопроса: DESCRIPTION для предзаготовленного контента, ANSWER для пользовательского ввода */
export enum QuestionFieldType {
  AddressAnswer = 'ADDRESS_ANSWER',
  AddressDescription = 'ADDRESS_DESCRIPTION',
  ChoiceAnswer = 'CHOICE_ANSWER',
  ChoiceMultipleAnswer = 'CHOICE_MULTIPLE_ANSWER',
  DateAnswer = 'DATE_ANSWER',
  DateDescription = 'DATE_DESCRIPTION',
  EmailAnswer = 'EMAIL_ANSWER',
  MediaAnswer = 'MEDIA_ANSWER',
  MediaDescription = 'MEDIA_DESCRIPTION',
  PhoneAnswer = 'PHONE_ANSWER',
  PriceAnswer = 'PRICE_ANSWER',
  ProductDescription = 'PRODUCT_DESCRIPTION',
  TextAnswer = 'TEXT_ANSWER',
  TextDescription = 'TEXT_DESCRIPTION',
  TimeAnswer = 'TIME_ANSWER',
  TimeDescription = 'TIME_DESCRIPTION',
  WeightAnswer = 'WEIGHT_ANSWER'
}

/** Статистика для отдельного вопроса */
export type QuestionStatsDto = {
  __typename?: 'QuestionStatsDto';
  /** Распределение ответов по опциям (для choice-вопросов) */
  distribution?: Maybe<Scalars['JSON']['output']>;
  /** Самая популярная опция (для choice-вопросов) */
  mostPopular?: Maybe<Scalars['JSON']['output']>;
  /** ID вопроса */
  questionId: Scalars['ID']['output'];
  /** Название вопроса */
  questionTitle: Scalars['String']['output'];
  /** Тип вопроса */
  questionType: Scalars['String']['output'];
  /** Процент ответивших (response rate) */
  responseRate: Scalars['Float']['output'];
  /** Общее количество ответов */
  totalAnswers: Scalars['Float']['output'];
  /** Распределение значений для других типов вопросов */
  values?: Maybe<Scalars['JSON']['output']>;
};

/** Вопрос в опросе со статистикой */
export type QuestionWithStatsDto = {
  __typename?: 'QuestionWithStatsDto';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Описание вопроса */
  description?: Maybe<Scalars['String']['output']>;
  /** Идентификатор вопроса */
  id: Scalars['ID']['output'];
  /** Обязательность вопроса */
  isRequired: Scalars['Boolean']['output'];
  /** Дополнительные настройки */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Порядок вопроса в опросе */
  order: Scalars['Float']['output'];
  /** Статистика ответов на этот вопрос */
  stats?: Maybe<QuestionStatsDto>;
  /** Текст вопроса */
  title: Scalars['String']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type RegionalReportEntity = {
  __typename?: 'RegionalReportEntity';
  /** Среднее время нахождения в КВЕСТ (в минутах) */
  averageSessionDuration?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Количество владельцев проектов */
  projectOwnersCount: Scalars['Int']['output'];
  /** Количество людей, хотя бы в одном проекте */
  projectParticipantsCount: Scalars['Int']['output'];
  /** Количество проектов */
  projectsCount: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  /** Количество зарегистрированных в КВЕСТ */
  registeredUsersCount: Scalars['Int']['output'];
  /** Дата формирования отчета */
  reportDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RegisterUserRequest = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  /** Номер телефона, должен быть корректным российским номером (например "79777008810") */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RegistryAdditionalFilterInput = {
  /** Только с адресом */
  hasAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Только с датой рождения */
  hasBirthday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Только с email */
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Только с праздником */
  hasHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Только с номером телефона */
  hasPhone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegistryContact = {
  __typename?: 'RegistryContact';
  /** Комментарий к адресу */
  addressComment?: Maybe<Scalars['String']['output']>;
  /** Дата рождения */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** День месяца рождения (1-31) */
  birthdayDay?: Maybe<Scalars['Int']['output']>;
  /** Месяц рождения (1-12) */
  birthdayMonth?: Maybe<Scalars['Int']['output']>;
  /** Месяц и день рождения (MM-DD) */
  birthdayMonthDay?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<Scalars['String']['output']>;
  /** Район города */
  cityDistrict?: Maybe<Scalars['String']['output']>;
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  /** Комментарий к адресу организации */
  companyAddressComment?: Maybe<Scalars['String']['output']>;
  /** Город организации */
  companyCity?: Maybe<Scalars['String']['output']>;
  /** Район города организации */
  companyCityDistrict?: Maybe<Scalars['String']['output']>;
  /** Email организации */
  companyEmail?: Maybe<Scalars['String']['output']>;
  /** Офис организации */
  companyFlat?: Maybe<Scalars['String']['output']>;
  /** ИНН */
  companyInn?: Maybe<Scalars['String']['output']>;
  /** КПП */
  companyKpp?: Maybe<Scalars['String']['output']>;
  /** Название организации */
  companyName?: Maybe<Scalars['String']['output']>;
  /** ОГРН */
  companyOgrn?: Maybe<Scalars['String']['output']>;
  /** Телефон организации */
  companyPhone?: Maybe<Scalars['String']['output']>;
  /** Должность в организации */
  companyPosition?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс организации */
  companyPostalCode?: Maybe<Scalars['String']['output']>;
  /** Регион организации */
  companyRegion?: Maybe<Scalars['String']['output']>;
  /** Поселение организации */
  companySettlement?: Maybe<Scalars['String']['output']>;
  /** Улица и дом организации */
  companyStreet?: Maybe<Scalars['String']['output']>;
  /** Тип контакта */
  contactType: RegistryContactTypeEnum;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Отображаемое имя/название */
  displayName: Scalars['String']['output'];
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Имя */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Квартира/офис */
  flat?: Maybe<Scalars['String']['output']>;
  /** Полный адрес */
  fullAddress?: Maybe<Scalars['String']['output']>;
  /** Пол */
  gender?: Maybe<SupporterGender>;
  /** Есть адрес */
  hasAddress: Scalars['Boolean']['output'];
  /** Есть дата рождения */
  hasBirthday: Scalars['Boolean']['output'];
  /** Есть email */
  hasEmail: Scalars['Boolean']['output'];
  /** Есть праздник */
  hasHoliday: Scalars['Boolean']['output'];
  /** Есть номер телефона */
  hasPhone: Scalars['Boolean']['output'];
  /** Дата праздника */
  holidayDate?: Maybe<Scalars['DateTime']['output']>;
  /** День месяца праздника (1-31) */
  holidayDay?: Maybe<Scalars['Int']['output']>;
  /** Месяц праздника (1-12) */
  holidayMonth?: Maybe<Scalars['Int']['output']>;
  /** Месяц и день праздника (MM-DD) */
  holidayMonthDay?: Maybe<Scalars['String']['output']>;
  /** Название праздника */
  holidayName?: Maybe<Scalars['String']['output']>;
  /** ID контакта */
  id: Scalars['ID']['output'];
  /** Фамилия */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Роль в проекте */
  memberRole?: Maybe<ProjectMemberRoleEnum>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Слаг модуля реестра */
  moduleSlug?: Maybe<Scalars['String']['output']>;
  /** ID оригинального владельца */
  originalOwnerId?: Maybe<Scalars['ID']['output']>;
  /** ID оригинального проекта */
  originalProjectId?: Maybe<Scalars['ID']['output']>;
  /** Телефон */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Название проекта */
  projectName?: Maybe<Scalars['String']['output']>;
  /** Регион */
  region?: Maybe<Scalars['String']['output']>;
  /** Поселение */
  settlement?: Maybe<Scalars['String']['output']>;
  /** Улица и дом */
  street?: Maybe<Scalars['String']['output']>;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** ID пользователя */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type RegistryContactConnection = {
  __typename?: 'RegistryContactConnection';
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая страница */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Список контактов */
  nodes: Array<RegistryContact>;
  /** Общее количество контактов */
  totalCount: Scalars['Int']['output'];
};

/** Тип контакта в реестре: individual — физ. лицо, organization — юр. лицо, project_member — участник проекта */
export enum RegistryContactTypeEnum {
  Individual = 'INDIVIDUAL',
  Organization = 'ORGANIZATION',
  ProjectMember = 'PROJECT_MEMBER'
}

export type RegistryFilterInput = {
  /** Дополнительные фильтры по наличию данных */
  additionalFilters?: InputMaybe<RegistryAdditionalFilterInput>;
  /** Диапазон дат рождения (полная дата, включая год) */
  birthdayDateRange?: InputMaybe<DateRangeInput>;
  /** Диапазон дат рождения (месяц-день) */
  birthdayRange?: InputMaybe<MonthDayRangeInput>;
  /** Фильтр по городу */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Типы контактов для выборки (физ. лица, организации, участники) */
  contactTypes?: InputMaybe<Array<RegistryContactTypeEnum>>;
  /** Диапазон дат включения в реестр */
  createdAtRange?: InputMaybe<DateRangeInput>;
  /** Диапазон дат праздников (месяц-день) */
  holidayRange?: InputMaybe<MonthDayRangeInput>;
  /** Количество записей на странице */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Слаг модуля реестра (supporters — основной, service_phones — телефонный справочник, или кастомный слаг) */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  /** Номер страницы (начиная с 0) */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** Фильтр по региону */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Поиск по ФИО/названию (iLike) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Сортировка */
  sort?: InputMaybe<RegistrySortEnum>;
  /** ID проекта-источника (фильтр по originalProjectId) */
  sourceProjectId?: InputMaybe<Scalars['ID']['input']>;
  /** ID пользователя-источника (фильтр по originalOwnerId) */
  sourceUserId?: InputMaybe<Scalars['ID']['input']>;
};

/** Варианты сортировки контактов в реестре: name_asc — от А до Я, holiday_asc — по празднику, birthday_asc — по дате рождения, created_at_desc — по дате включения (новые) */
export enum RegistrySortEnum {
  BirthdayAsc = 'BIRTHDAY_ASC',
  BirthdayYearAsc = 'BIRTHDAY_YEAR_ASC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  HolidayAsc = 'HOLIDAY_ASC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type ReglamentItem = {
  __typename?: 'ReglamentItem';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** ID пользователя, создавшего строку */
  createdByUserId: Scalars['ID']['output'];
  /** Дата и время окончания выступления (UTC) */
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID выступления регламента */
  id: Scalars['ID']['output'];
  /** Слаг экземпляра модуля */
  moduleSlug: Scalars['String']['output'];
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Конец времени на вопросы (UTC) */
  questionsEndAt?: Maybe<Scalars['DateTime']['output']>;
  /** Начало времени на вопросы (UTC) */
  questionsStartAt?: Maybe<Scalars['DateTime']['output']>;
  /** Тема доклада */
  reportTopic?: Maybe<Scalars['String']['output']>;
  /** Порядок строки в списке */
  sortOrder: Scalars['Int']['output'];
  /** ФИО выступающего */
  speakerName: Scalars['String']['output'];
  /** Дата и время начала выступления (UTC) */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** IANA-таймзона, в которой заполнялась строка */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** ID пользователя, последним обновившего строку */
  updatedByUserId?: Maybe<Scalars['ID']['output']>;
};

export type RejectJoinRequestInput = {
  /** Причина отклонения */
  reason: Scalars['String']['input'];
  /** ID заявки на вступление */
  requestId: Scalars['ID']['input'];
};

export type RejectObjectPassportApplicationInput = {
  /** Комментарий модератора (причина отклонения) */
  comment: Scalars['String']['input'];
  /** ID заявки */
  id: Scalars['ID']['input'];
};

export type RemoveCalendarEventParticipantInput = {
  /** ID события */
  eventId: Scalars['ID']['input'];
  /** ID удаляемого пользователя */
  userId: Scalars['ID']['input'];
};

export type RespondMergeRequestDto = {
  /** Ответ на заявку */
  response: MergeRequestResponse;
  /** ID сессии слияния */
  sessionId: Scalars['ID']['input'];
};

/** Ответ на опрос */
export type ResponseDto = {
  __typename?: 'ResponseDto';
  /** Ответы на вопросы */
  answers: Array<AnswerValueDto>;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Идентификатор ответа */
  id: Scalars['ID']['output'];
  /** Токен приглашения */
  inviteToken?: Maybe<Scalars['String']['output']>;
  /** Метаданные */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Респондент */
  respondent?: Maybe<User>;
  /** Статус ответа */
  status: ResponseStatus;
  /** Дата отправки */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Опрос */
  survey?: Maybe<SurveyDto>;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type ResponseDtoFilter = {
  and?: InputMaybe<Array<ResponseDtoFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  inviteToken?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ResponseDtoFilter>>;
  status?: InputMaybe<ResponseStatusFilterComparison>;
  submittedAt?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ResponseDtoSort = {
  direction: SortDirection;
  field: ResponseDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ResponseDtoSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  InviteToken = 'inviteToken',
  Status = 'status',
  SubmittedAt = 'submittedAt',
  UpdatedAt = 'updatedAt'
}

/** Статус ответа на опрос */
export enum ResponseStatus {
  InProgress = 'IN_PROGRESS',
  Submitted = 'SUBMITTED'
}

export type ResponseStatusFilterComparison = {
  eq?: InputMaybe<ResponseStatus>;
  gt?: InputMaybe<ResponseStatus>;
  gte?: InputMaybe<ResponseStatus>;
  iLike?: InputMaybe<ResponseStatus>;
  in?: InputMaybe<Array<ResponseStatus>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ResponseStatus>;
  lt?: InputMaybe<ResponseStatus>;
  lte?: InputMaybe<ResponseStatus>;
  neq?: InputMaybe<ResponseStatus>;
  notILike?: InputMaybe<ResponseStatus>;
  notIn?: InputMaybe<Array<ResponseStatus>>;
  notLike?: InputMaybe<ResponseStatus>;
};

export type SaveProgramItemInput = {
  /** Вложения «Карта проезда/прохода» (полностью заменяют набор карточки) */
  attachments?: InputMaybe<Array<ProgramItemAttachmentInput>>;
  /** Контактное лицо (отображаемое имя/ФИО) */
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  /** Контактное лицо — ссылка на пользователя платформы */
  contactPersonUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Дата и время окончания (UTC) */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID существующей карточки (без него — создаётся новая) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Место проведения */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Наименование мероприятия */
  name: Scalars['String']['input'];
  /** Порядок карточки в списке */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Дата и время начала (UTC) */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** IANA-таймзона создателя */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type SaveProgramItemsInput = {
  /** Полный желаемый набор карточек программы модуля */
  items: Array<SaveProgramItemInput>;
  /** Слаг экземпляра кастомного модуля (program[_<suffix>]) */
  moduleSlug: Scalars['String']['input'];
  /** ID проекта */
  projectId: Scalars['ID']['input'];
};

export type SaveReglamentItemInput = {
  /** Дата и время окончания выступления (UTC) */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID существующей строки (без него — создаётся новая) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Конец времени на вопросы (UTC) */
  questionsEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Начало времени на вопросы (UTC) */
  questionsStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Тема доклада */
  reportTopic?: InputMaybe<Scalars['String']['input']>;
  /** Порядок строки в списке */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** ФИО выступающего */
  speakerName: Scalars['String']['input'];
  /** Дата и время начала выступления (UTC) */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** IANA-таймзона создателя */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type SaveReglamentItemsInput = {
  /** Полный желаемый набор строк регламента модуля */
  items: Array<SaveReglamentItemInput>;
  /** Слаг экземпляра кастомного модуля (reglament[_<suffix>]) */
  moduleSlug: Scalars['String']['input'];
  /** ID проекта */
  projectId: Scalars['ID']['input'];
};

export type SaveResponseDto = {
  answers: Array<AnswerInputDto>;
  responseId: Scalars['ID']['input'];
};

export type SchedulePublishSurveyDto = {
  /** Комментарий к отложенной публикации */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Время планируемой публикации */
  scheduledAt: Scalars['DateTime']['input'];
  surveyId: Scalars['ID']['input'];
};

export type SendMailMessageInput = {
  /** Содержимое сообщения (TipTap JSON) */
  content: Scalars['JSON']['input'];
  /** ID обращения */
  threadId: Scalars['ID']['input'];
};

export type SendVerificationCodeRequest = {
  action?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  type: VerificationTypes;
};

/** Тип API ключа для SMSC */
export enum SmscApiKeyType {
  Default = 'DEFAULT',
  Ldpr = 'LDPR'
}

export type SnapshotSupporter = {
  __typename?: 'SnapshotSupporter';
  /** Дополнительная информация адреса */
  addressExtra?: Maybe<Scalars['String']['output']>;
  /** Дата рождения */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** Город */
  city?: Maybe<Scalars['String']['output']>;
  /** Район города */
  cityDistrict?: Maybe<Scalars['String']['output']>;
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  /** Город компании */
  companyCity?: Maybe<Scalars['String']['output']>;
  /** Комментарий о компании */
  companyComment?: Maybe<Scalars['String']['output']>;
  /** Email компании */
  companyEmail?: Maybe<Scalars['String']['output']>;
  /** Название компании */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Телефон компании */
  companyPhone?: Maybe<Scalars['String']['output']>;
  /** Должность в компании */
  companyPosition?: Maybe<Scalars['String']['output']>;
  /** Область компании */
  companyRegion?: Maybe<Scalars['String']['output']>;
  /** Координаты */
  coordinates?: Maybe<Scalars['String']['output']>;
  /** Дата создания записи */
  createdAt: Scalars['DateTime']['output'];
  /** Адрес DaData */
  dadataAddress?: Maybe<Scalars['JSON']['output']>;
  /** Дата удаления записи */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Подъезд */
  entrance?: Maybe<Scalars['String']['output']>;
  /** Имя */
  firstName: Scalars['String']['output'];
  /** Квартира */
  flat?: Maybe<Scalars['String']['output']>;
  /** Пол */
  gender?: Maybe<SupporterGender>;
  /** Дата праздника */
  holidayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Название праздника */
  holidayName?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор сторонника */
  id: Scalars['ID']['output'];
  /** Фамилия */
  lastName: Scalars['String']['output'];
  /** Отчество */
  middleName?: Maybe<Scalars['String']['output']>;
  /** ID оригинального владельца */
  originalOwnerId?: Maybe<Scalars['ID']['output']>;
  /** Оригинальный проект (откуда был перенесен сторонник при слиянии) */
  originalProject?: Maybe<Project>;
  /** ID оригинального проекта (откуда был перенесен сторонник) */
  originalProjectId?: Maybe<Scalars['ID']['output']>;
  /** Номер телефона */
  phoneNumber: Scalars['String']['output'];
  /** ID избирательного участка */
  pollingStationId?: Maybe<Scalars['String']['output']>;
  /** Индекс */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Проект к которому принадлежал сторонник */
  project?: Maybe<Project>;
  /** ID проекта к которому принадлежал сторонник */
  projectId: Scalars['ID']['output'];
  /** Область */
  region?: Maybe<Scalars['String']['output']>;
  /** Поселение */
  settlement?: Maybe<Scalars['String']['output']>;
  /** Улица и дом */
  street?: Maybe<Scalars['String']['output']>;
  /** Дата обновления записи */
  updatedAt: Scalars['DateTime']['output'];
};

/** Sort Directions */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Sort Nulls Options */
export enum SortNulls {
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST'
}

export type StartResponseDto = {
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notILike?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitContactRequestInput = {
  description: Scalars['String']['input'];
  /** Файлы в MinIO после getMediaUploadUrl + PUT: bucket и mediaStorageKey. Разработчикам уйдут как вложения письма (без публичных URL и без правок nginx). */
  mediaAttachments?: InputMaybe<Array<ContactRequestMediaAttachmentInput>>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SubmitResponseDto = {
  responseId: Scalars['ID']['input'];
};

export type Success = {
  __typename?: 'Success';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type SupporterDeleteResponse = {
  __typename?: 'SupporterDeleteResponse';
  /** Комментарий (comment). */
  addressComment?: Maybe<Scalars['String']['output']>;
  /** JSON-объект адреса. */
  addressJSON?: Maybe<Scalars['JSON']['output']>;
  /** Дата рождения */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** День месяца рождения (1-31) */
  birthdayDay?: Maybe<Scalars['Int']['output']>;
  /** Месяц рождения (1-12) */
  birthdayMonth?: Maybe<Scalars['Int']['output']>;
  /** Месяц и день рождения (MM-DD) для сортировки без учета года */
  birthdayMonthDay?: Maybe<Scalars['String']['output']>;
  /** Год рождения (YYYY) */
  birthdayYear?: Maybe<Scalars['Int']['output']>;
  /** Город (city). */
  city?: Maybe<Scalars['String']['output']>;
  /** Район города (city_district). */
  cityDistrict?: Maybe<Scalars['String']['output']>;
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  /** Комментарий к адресу компании. */
  companyAddressComment?: Maybe<Scalars['String']['output']>;
  /** JSON-объект адреса компании. */
  companyAddressJSON?: Maybe<Scalars['JSON']['output']>;
  /** Город компании. */
  companyCity?: Maybe<Scalars['String']['output']>;
  /** Район города компании. */
  companyCityDistrict?: Maybe<Scalars['String']['output']>;
  /** Комментарий к компании. */
  companyComment?: Maybe<Scalars['String']['output']>;
  /** Домофон компании. */
  companyDoorphone?: Maybe<Scalars['String']['output']>;
  /** Email компании. */
  companyEmail?: Maybe<Scalars['String']['output']>;
  /** Подъезд компании. */
  companyEntrance?: Maybe<Scalars['String']['output']>;
  /** Квартира компании. */
  companyFlat?: Maybe<Scalars['String']['output']>;
  /** Этаж компании. */
  companyFloor?: Maybe<Scalars['String']['output']>;
  /** ИНН компании. */
  companyInn?: Maybe<Scalars['String']['output']>;
  /** Флаг ручного ввода адреса компании. */
  companyIsManual?: Maybe<Scalars['Boolean']['output']>;
  /** КПП компании. */
  companyKpp?: Maybe<Scalars['String']['output']>;
  /** Название компании. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** ОГРН компании. */
  companyOgrn?: Maybe<Scalars['String']['output']>;
  /** Телефон компании. */
  companyPhone?: Maybe<Scalars['String']['output']>;
  /** Должность в компании. */
  companyPosition?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс компании. */
  companyPostalCode?: Maybe<Scalars['String']['output']>;
  /** Область компании. */
  companyRegion?: Maybe<Scalars['String']['output']>;
  /** Поселение компании. */
  companySettlement?: Maybe<Scalars['String']['output']>;
  /** Улица и дом компании. */
  companyStreet?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Домофон (doorphone). */
  doorphone?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Подъезд (entrance). */
  entrance?: Maybe<Scalars['String']['output']>;
  /** Фамилия */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Квартира (flat/apartment). */
  flat?: Maybe<Scalars['String']['output']>;
  /** Этаж (floor). */
  floor?: Maybe<Scalars['String']['output']>;
  /** Пол */
  gender?: Maybe<SupporterGender>;
  /** Дата праздничного дня */
  holidayDate?: Maybe<Scalars['DateTime']['output']>;
  /** День месяца праздничной даты (1-31) */
  holidayDay?: Maybe<Scalars['Int']['output']>;
  /** Месяц праздничной даты (1-12) */
  holidayMonth?: Maybe<Scalars['Int']['output']>;
  /** Месяц и день праздничной даты (MM-DD) для сортировки без учета года */
  holidayMonthDay?: Maybe<Scalars['String']['output']>;
  /** Название праздничного дня */
  holidayName?: Maybe<Scalars['String']['output']>;
  /** Год праздничной даты (YYYY) */
  holidayYear?: Maybe<Scalars['Int']['output']>;
  /** ID сторонника */
  id?: Maybe<Scalars['ID']['output']>;
  /** Флаг, указывающий, был ли адрес введён вручную (true) или найден через DaData (false). */
  isManual?: Maybe<Scalars['Boolean']['output']>;
  /** Имя */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Слаг модуля реестра */
  moduleSlug?: Maybe<Scalars['String']['output']>;
  /** ID оригинального владельца сторонника (кто инициировал слияние) */
  originalOwnerId?: Maybe<Scalars['ID']['output']>;
  /** ID оригинального проекта (откуда был перенесен сторонник) */
  originalProjectId?: Maybe<Scalars['ID']['output']>;
  /** Телефон */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс (postalCode). */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** ID проекта */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Область (region). */
  region?: Maybe<Scalars['String']['output']>;
  /** Поселение (settlement). */
  settlement?: Maybe<Scalars['String']['output']>;
  /** Улица и дом (street). */
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Информация о сторонике для diff */
export type SupporterDiffPersonDto = {
  __typename?: 'SupporterDiffPersonDTO';
  /** Дата рождения */
  birthday?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Полное имя сторонника */
  fullName: Scalars['String']['output'];
  /** Телефон */
  phone?: Maybe<Scalars['String']['output']>;
};

/** Изменение поля сторонника */
export type SupporterFieldChangeDto = {
  __typename?: 'SupporterFieldChangeDTO';
  /** Значение после изменения */
  after?: Maybe<Scalars['JSON']['output']>;
  /** Значение до изменения */
  before?: Maybe<Scalars['JSON']['output']>;
  /** Отображаемое название поля */
  fieldDisplayName?: Maybe<Scalars['String']['output']>;
  /** Название поля */
  fieldName: Scalars['String']['output'];
  /** Тип поля для корректного отображения */
  fieldType?: Maybe<Scalars['String']['output']>;
  /** Есть ли изменение в этом поле */
  hasChange: Scalars['Boolean']['output'];
};

/**
 * Пол сторонника:
 * MALE - мужской
 * FEMALE - женский
 */
export enum SupporterGender {
  Female = 'FEMALE',
  Male = 'MALE'
}

/** Типы действий при слиянии сторонников */
export enum SupporterMergeActionEnum {
  Create = 'CREATE',
  Skip = 'SKIP',
  Update = 'UPDATE'
}

/** Информация о предстоящих изменениях при слиянии сторонников */
export type SupporterMergeDiffDto = {
  __typename?: 'SupporterMergeDiffDTO';
  /** Время анализа */
  analyzedAt: Scalars['DateTime']['output'];
  /** Краткая статистика */
  summary: SupporterMergeDiffStatsDto;
  /** Список сторонников с детальными изменениями */
  supporters: Array<SupporterMergeItemDiffDto>;
};

/** Простая статистика изменений */
export type SupporterMergeDiffStatsDto = {
  __typename?: 'SupporterMergeDiffStatsDTO';
  /** Останутся без изменений */
  noChanges: Scalars['Float']['output'];
  /** Будут созданы как новые */
  toCreate: Scalars['Float']['output'];
  /** Будут обновлены (найдены дубликаты) */
  toUpdate: Scalars['Float']['output'];
  /** Общее количество сторонников */
  total: Scalars['Float']['output'];
};

/** Детальная информация об изменении сторонника */
export type SupporterMergeItemDiffDto = {
  __typename?: 'SupporterMergeItemDiffDTO';
  /** Действие при слиянии */
  action: SupporterMergeActionEnum;
  /** Количество полей с изменениями */
  changedFieldsCount: Scalars['Float']['output'];
  /** Детальные изменения всех полей */
  fieldChanges: Array<SupporterFieldChangeDto>;
  /** Как был найден дубликат */
  matchReason?: Maybe<Scalars['String']['output']>;
  /** Краткая информация о сторонике из источника */
  sourceSupporter: SupporterDiffPersonDto;
  /** ID сторонника из исходного проекта */
  sourceSupporterId: Scalars['String']['output'];
  /** Краткая информация о найденном сторонике в целевом проекте */
  targetSupporter?: Maybe<SupporterDiffPersonDto>;
  /** ID сторонника в целевом проекте (если найден) */
  targetSupporterId?: Maybe<Scalars['String']['output']>;
};

export type SupporterOwnerDto = {
  __typename?: 'SupporterOwnerDTO';
  /** Является ли владелец изначальным (из другого проекта) */
  isOrigin: Scalars['Boolean']['output'];
  /**
   * Исходный проект (устарело, используйте originProjects)
   * @deprecated Заменено на originProjects
   */
  originProject?: Maybe<Project>;
  /** Список исходных проектов, откуда пришли сторонники (для фильтрации) */
  originProjects: Array<Project>;
  /** Пользователь-владелец */
  owner: User;
  /** Тип владения */
  ownershipType: SupporterOwnershipTypeEnum;
  /** Количество сторонников */
  supporterCount: Scalars['Float']['output'];
  /** Список ID сторонников, принадлежащих этому владельцу */
  supporterIds: Array<Scalars['ID']['output']>;
};

/** Тип владения сторонником */
export enum SupporterOwnershipTypeEnum {
  /** Текущий владелец проекта */
  Current = 'CURRENT',
  /** Изначальный владелец (слит из другого проекта) */
  Origin = 'ORIGIN'
}

/** Опрос */
export type SurveyDto = {
  __typename?: 'SurveyDto';
  /** Разрешены ли анонимные ответы */
  allowAnonymous: Scalars['Boolean']['output'];
  /** Разрешено ли редактирование ответов */
  allowEditResponse: Scalars['Boolean']['output'];
  /** Разрешены ли множественные ответы от одного пользователя */
  allowMultipleResponses: Scalars['Boolean']['output'];
  /** Разрешено ли повторное прохождение теста */
  allowRetake: Scalars['Boolean']['output'];
  /** Дата закрытия */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** ID пользователя-создателя */
  createdByUserId: Scalars['ID']['output'];
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Описание опроса */
  description?: Maybe<Scalars['String']['output']>;
  /** Идентификатор опроса */
  id: Scalars['ID']['output'];
  invites: Array<InviteDto>;
  /** Является ли опрос тестом */
  isTest: Scalars['Boolean']['output'];
  media?: Maybe<Array<MediaOutputDto>>;
  /** Слаг модуля опросов */
  moduleSlug: Scalars['String']['output'];
  /** ID проекта */
  projectId: Scalars['ID']['output'];
  /** Включена ли публичная ссылка */
  publicLinkEnabled: Scalars['Boolean']['output'];
  /** Дата публикации */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  questions: SurveyDtoQuestionsConnection;
  /** Дедлайн для ответов */
  responseDeadline?: Maybe<Scalars['DateTime']['output']>;
  responses: SurveyDtoResponsesConnection;
  /** Комментарий к запланированной публикации */
  scheduleComment?: Maybe<Scalars['String']['output']>;
  /** Время запланированной публикации */
  scheduledPublishAt?: Maybe<Scalars['DateTime']['output']>;
  /** Статус опроса */
  status: SurveyStatus;
  /** Название опроса */
  title: Scalars['String']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
  /** ID пользователя, обновившего опрос */
  updatedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Версия опроса */
  version: Scalars['Float']['output'];
  /** Опрос виден всем администраторам проекта */
  visibleToProjectAdmins: Scalars['Boolean']['output'];
  /** Опрос виден всем участникам проекта */
  visibleToProjectMembers: Scalars['Boolean']['output'];
};


/** Опрос */
export type SurveyDtoInvitesArgs = {
  filter?: InviteDtoFilter;
  sorting?: Array<InviteDtoSort>;
};


/** Опрос */
export type SurveyDtoQuestionsArgs = {
  filter?: QuestionDtoFilter;
  paging?: OffsetPaging;
  sorting?: Array<QuestionDtoSort>;
};


/** Опрос */
export type SurveyDtoResponsesArgs = {
  filter?: ResponseDtoFilter;
  paging?: OffsetPaging;
  sorting?: Array<ResponseDtoSort>;
};

export type SurveyDtoConnection = {
  __typename?: 'SurveyDtoConnection';
  /** Array of nodes. */
  nodes: Array<SurveyDto>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type SurveyDtoDeleteFilter = {
  and?: InputMaybe<Array<SurveyDtoDeleteFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdByUserId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  moduleSlug?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SurveyDtoDeleteFilter>>;
  projectId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<SurveyDtoStatusFilterComparison>;
  title?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  updatedByUserId?: InputMaybe<IdFilterComparison>;
};

export type SurveyDtoDeleteResponse = {
  __typename?: 'SurveyDtoDeleteResponse';
  /** Разрешены ли анонимные ответы */
  allowAnonymous?: Maybe<Scalars['Boolean']['output']>;
  /** Разрешено ли редактирование ответов */
  allowEditResponse?: Maybe<Scalars['Boolean']['output']>;
  /** Разрешены ли множественные ответы от одного пользователя */
  allowMultipleResponses?: Maybe<Scalars['Boolean']['output']>;
  /** Разрешено ли повторное прохождение теста */
  allowRetake?: Maybe<Scalars['Boolean']['output']>;
  /** Дата закрытия */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя-создателя */
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  /** Дата удаления (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Описание опроса */
  description?: Maybe<Scalars['String']['output']>;
  /** Идентификатор опроса */
  id?: Maybe<Scalars['ID']['output']>;
  /** Является ли опрос тестом */
  isTest?: Maybe<Scalars['Boolean']['output']>;
  /** Слаг модуля опросов */
  moduleSlug?: Maybe<Scalars['String']['output']>;
  /** ID проекта */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Включена ли публичная ссылка */
  publicLinkEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Дата публикации */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Дедлайн для ответов */
  responseDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** Комментарий к запланированной публикации */
  scheduleComment?: Maybe<Scalars['String']['output']>;
  /** Время запланированной публикации */
  scheduledPublishAt?: Maybe<Scalars['DateTime']['output']>;
  /** Статус опроса */
  status?: Maybe<SurveyStatus>;
  /** Название опроса */
  title?: Maybe<Scalars['String']['output']>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя, обновившего опрос */
  updatedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Версия опроса */
  version?: Maybe<Scalars['Float']['output']>;
  /** Опрос виден всем администраторам проекта */
  visibleToProjectAdmins?: Maybe<Scalars['Boolean']['output']>;
  /** Опрос виден всем участникам проекта */
  visibleToProjectMembers?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveyDtoFilter = {
  and?: InputMaybe<Array<SurveyDtoFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdByUserId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  moduleSlug?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SurveyDtoFilter>>;
  projectId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<SurveyDtoStatusFilterComparison>;
  title?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  updatedByUserId?: InputMaybe<IdFilterComparison>;
};

export type SurveyDtoQuestionsConnection = {
  __typename?: 'SurveyDtoQuestionsConnection';
  /** Array of nodes. */
  nodes: Array<QuestionDto>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type SurveyDtoResponsesConnection = {
  __typename?: 'SurveyDtoResponsesConnection';
  /** Array of nodes. */
  nodes: Array<ResponseDto>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type SurveyDtoSort = {
  direction: SortDirection;
  field: SurveyDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SurveyDtoSortFields {
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Id = 'id',
  ModuleSlug = 'moduleSlug',
  ProjectId = 'projectId',
  Status = 'status',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UpdatedByUserId = 'updatedByUserId'
}

export type SurveyDtoStatusFilterComparison = {
  eq?: InputMaybe<SurveyStatus>;
  in?: InputMaybe<Array<SurveyStatus>>;
  neq?: InputMaybe<SurveyStatus>;
  notIn?: InputMaybe<Array<SurveyStatus>>;
};

/** Участник конкретного опроса */
export type SurveyParticipantDto = {
  __typename?: 'SurveyParticipantDto';
  /** Количество прохождений этого опроса */
  completedResponsesCount: Scalars['Float']['output'];
  /** Дата первого прохождения */
  firstResponseAt: Scalars['DateTime']['output'];
  /** Дата последнего прохождения */
  lastResponseAt: Scalars['DateTime']['output'];
  /** ID всех ответов пользователя на этот опрос */
  responseIds: Array<Scalars['ID']['output']>;
  /** Информация о пользователе */
  user: User;
  /** ID пользователя-респондента */
  userId: Scalars['ID']['output'];
};

/** Фильтр для поиска участников опроса */
export type SurveyParticipantsFilterDto = {
  /** Лимит записей на странице */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Смещение для пагинации */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Поиск по ID пользователя */
  searchUserId?: InputMaybe<Scalars['String']['input']>;
  /** Поле для сортировки */
  sortBy?: InputMaybe<ParticipantSortField>;
  /** Направление сортировки */
  sortDirection?: InputMaybe<ParticipantSortDirection>;
  /** ID опроса */
  surveyId: Scalars['String']['input'];
};

/** Публичная информация об опросе */
export type SurveyPublicDto = {
  __typename?: 'SurveyPublicDto';
  /** Разрешены ли анонимные ответы */
  allowAnonymous: Scalars['Boolean']['output'];
  /** Разрешено ли редактирование ответов */
  allowEditResponse: Scalars['Boolean']['output'];
  /** Описание опроса */
  description?: Maybe<Scalars['String']['output']>;
  /** Идентификатор опроса */
  id: Scalars['ID']['output'];
  /** Дата публикации */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Вопросы опроса */
  questions: Array<QuestionDto>;
  /** Дедлайн для ответов */
  responseDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** Статус опроса */
  status: SurveyStatus;
  /** Название опроса */
  title: Scalars['String']['output'];
};

/** Статистика опроса */
export type SurveyStatsDto = {
  __typename?: 'SurveyStatsDto';
  /** Количество черновиков */
  draftResponses: Scalars['Float']['output'];
  /** Статистика по вопросам */
  questionStats: Scalars['JSON']['output'];
  /** Количество завершенных ответов */
  submittedResponses: Scalars['Float']['output'];
  /** Идентификатор опроса */
  surveyId: Scalars['ID']['output'];
  /** Общее количество ответов */
  totalResponses: Scalars['Float']['output'];
  /** Дата последнего обновления статистики */
  updatedAt: Scalars['DateTime']['output'];
};

/** Статус опроса */
export enum SurveyStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Paused = 'PAUSED',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

export type TabletVariation = {
  __typename?: 'TabletVariation';
  FRIENDS_CARD?: Maybe<Scalars['String']['output']>;
  FRIENDS_MINI_AVATAR?: Maybe<Scalars['String']['output']>;
  ORIGINAL?: Maybe<Scalars['String']['output']>;
  PROFILE?: Maybe<Scalars['String']['output']>;
};

/** Хештег новости */
export type TagDto = {
  __typename?: 'TagDto';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Идентификатор тега */
  id: Scalars['ID']['output'];
  /** Название тега */
  name: Scalars['String']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

export type TagDtoConnection = {
  __typename?: 'TagDtoConnection';
  /** Array of edges. */
  edges: Array<TagDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type TagDtoEdge = {
  __typename?: 'TagDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TagDto */
  node: TagDto;
};

export type TagDtoFilter = {
  and?: InputMaybe<Array<TagDtoFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<TagDtoFilter>>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type TagDtoSort = {
  direction: SortDirection;
  field: TagDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TagDtoSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type Template = {
  __typename?: 'Template';
  category?: Maybe<Scalars['String']['output']>;
  categoryLabel?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isGlobal: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type TemplateGroup = {
  __typename?: 'TemplateGroup';
  items: Array<TemplateItem>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TemplateItem = {
  __typename?: 'TemplateItem';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** Результат проверки ответа на тест */
export type TestAnswerResultDto = {
  __typename?: 'TestAnswerResultDto';
  /** Правильный ответ */
  correctAnswer?: Maybe<Scalars['JSON']['output']>;
  /** Пояснение */
  explanation?: Maybe<Scalars['String']['output']>;
  /** Итоговые результаты теста */
  finalResults?: Maybe<TestResultSummaryDto>;
  /** Правильный ли ответ */
  isCorrect: Scalars['Boolean']['output'];
  /** Завершён ли тест */
  isTestCompleted: Scalars['Boolean']['output'];
  /** ID следующего вопроса */
  nextQuestionId?: Maybe<Scalars['ID']['output']>;
};

/** Прогресс прохождения теста */
export type TestProgressDto = {
  __typename?: 'TestProgressDto';
  /** Дата завершения */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Количество правильных ответов */
  correctAnswersCount: Scalars['Int']['output'];
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Индекс текущего вопроса */
  currentQuestionIndex: Scalars['Int']['output'];
  /** ID прогресса */
  id: Scalars['ID']['output'];
  /** ID респондента */
  respondentUserId: Scalars['ID']['output'];
  /** ID ответа */
  responseId?: Maybe<Scalars['ID']['output']>;
  /** Статус прогресса */
  status: TestProgressStatus;
  /** ID опроса */
  surveyId: Scalars['ID']['output'];
  /** Общее количество данных ответов */
  totalAnswersCount: Scalars['Int']['output'];
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
};

/** Статус прохождения теста */
export enum TestProgressStatus {
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

/** Итоговые результаты теста */
export type TestResultSummaryDto = {
  __typename?: 'TestResultSummaryDto';
  /** Количество правильных ответов */
  correctAnswers: Scalars['Int']['output'];
  /** Количество неправильных ответов */
  incorrectAnswers: Scalars['Int']['output'];
  /** Процент правильных ответов */
  scorePercentage: Scalars['Float']['output'];
  /** Общее количество вопросов */
  totalQuestions: Scalars['Int']['output'];
};

export type ToggleLikeInput = {
  likeableId: Scalars['String']['input'];
  /** Тип сущности, которую лайкают */
  likeableType: LikeableTypeEnum;
  shouldUnlike?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ToggleQuestionRequiredDto = {
  /** Новый статус обязательности */
  isRequired: Scalars['Boolean']['input'];
  /** ID вопроса */
  questionId: Scalars['ID']['input'];
};

export type UpdateAnswerDto = {
  /** Массив значений для множественного выбора */
  arrayValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Дополнительные данные (валюта, единица измерения и т.д.) */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Числовое значение (для цены, веса) */
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  /** ID вопроса */
  questionId?: InputMaybe<Scalars['String']['input']>;
  /** ID пользователя, отвечающего на вопрос */
  respondentUserId?: InputMaybe<Scalars['String']['input']>;
  /** Текстовое значение ответа (для текста, адреса, телефона, email) */
  textValue?: InputMaybe<Scalars['String']['input']>;
  /** Временное значение в формате ISO8601 */
  timeValue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppVersionInput = {
  latestBuild?: InputMaybe<Scalars['Int']['input']>;
  latestVersion: Scalars['String']['input'];
  minSupportedVersion: Scalars['String']['input'];
  platform: MobilePlatform;
  releaseNotes?: InputMaybe<Scalars['JSONObject']['input']>;
  releasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  store: MobileStore;
  storeUrl: Scalars['String']['input'];
};

export type UpdateCalendarEventInput = {
  /** Полный новый список вложений (заменяет текущий список) */
  attachments?: InputMaybe<Array<CalendarEventAttachmentInput>>;
  /** Снять повтор с задачи: удаляет остальные вхождения серии (кроме этого) и делает это событие одиночным (обнуляет поля повтора). Для повторяющихся событий. */
  clearRecurrence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Событие выполнено */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Описание события */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Дата и время окончания */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID обновляемого события */
  id: Scalars['ID']['input'];
  /** Признак события «на весь день» */
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Местоположение / адрес проведения */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Полный новый список ID участников (заменяет текущий список) */
  participantUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Приоритет события */
  priority?: InputMaybe<CalendarEventPriorityEnum>;
  /** Полный новый список напоминаний (заменяет ещё не отправленные — PENDING). Передать [] — очистить будущие напоминания. Не передавать (null) — оставить как есть. Уже отправленные напоминания (SENT) сохраняются в истории и не пересылаются. */
  reminders?: InputMaybe<Array<CalendarEventReminderInput>>;
  /** Дата и время начала */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** IANA-таймзона события */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Название события */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCalendarEventParticipantStatusInput = {
  /** ID события */
  eventId: Scalars['ID']['input'];
  /** Новый статус участника */
  status: CalendarEventParticipantStatusEnum;
  /** ID пользователя, чей статус обновляется. По умолчанию — текущий пользователь */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCommentDto = {
  /** ID комментируемого объекта */
  commentableId?: InputMaybe<Scalars['String']['input']>;
  /** Тип комментируемого объекта */
  commentableType?: InputMaybe<CommentableTypeEnum>;
  /** Содержание комментария */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ID родительского комментария */
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCounterEventDto = {
  /** Counter Type */
  counterType?: InputMaybe<Scalars['String']['input']>;
  /** Entity ID */
  entityId?: InputMaybe<Scalars['String']['input']>;
  /** Entity Type */
  entityType?: InputMaybe<Scalars['String']['input']>;
  /** User ID */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCounterInput = {
  /** ID счётчика */
  id: Scalars['ID']['input'];
  /** Название счётчика */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Дата следующей поверки */
  nextVerificationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID проекта (для авторизации) */
  projectId: Scalars['ID']['input'];
  /** Серийный номер счётчика */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCounterReadingInput = {
  /** Потребление за период */
  consumption?: InputMaybe<Scalars['Float']['input']>;
  /** Стоимость потребления */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** ID показания */
  id: Scalars['ID']['input'];
  /** Примечание */
  note?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта (для авторизации) */
  projectId: Scalars['ID']['input'];
  /** Показание счётчика */
  reading?: InputMaybe<Scalars['Float']['input']>;
  /** Дата внесения показания */
  recordedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateEmergencyContactInput = {
  /** Категория контакта */
  category?: InputMaybe<EmergencyContactCategoryEnum>;
  /** ID контакта для обновления */
  id: Scalars['ID']['input'];
  /** Наименование (название организации или ФИО человека) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Номер телефона */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта (для проверки прав доступа) */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateInvitationLinkInput = {
  /** Количество дней до истечения ссылки */
  expiresInDays?: InputMaybe<Scalars['Float']['input']>;
  /** ID приглашения */
  invitationId: Scalars['ID']['input'];
  /** Активировать/деактивировать ссылку */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLandingTemplateInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта (либо projectId, либо projectRequestId) */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** ID заявки на проект — черновик шаблона до одобрения */
  projectRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMailMessageInput = {
  /** Обновлённое содержимое сообщения (TipTap JSON с mediaId) */
  content: Scalars['JSON']['input'];
  /** ID сообщения */
  messageId: Scalars['ID']['input'];
};

export type UpdateManyLandingTemplatesInput = {
  /** Filter used to find fields to update */
  filter: LandingTemplateUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateLandingTemplateInput;
};

export type UpdateManyResponse = {
  __typename?: 'UpdateManyResponse';
  /** The number of records updated. */
  updatedCount: Scalars['Int']['output'];
};

export type UpdateMockupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNewsDto = {
  /** Дополнительная информация для новости-выступления */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Полное имя автора новости */
  authorFullname?: InputMaybe<Scalars['String']['input']>;
  /** ID автора новости */
  authorUserId?: InputMaybe<Scalars['String']['input']>;
  /** Содержание новости */
  content?: InputMaybe<Scalars['JSON']['input']>;
  /** Ключи объектов (MinIO) для дополнительных фотографий, загруженных вне редактора через newsPresignedPutUrl. Поле опциональное. */
  customPhotos?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ключи объектов (MinIO) для дополнительных видео, загруженных вне редактора через newsPresignedPutUrl. Поле опциональное. */
  customVideos?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ФИО в рукописном формате для новости-выступления */
  handwrittenFullname?: InputMaybe<Scalars['String']['input']>;
  /** Список хештегов для новости */
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** URL главного изображения */
  mainImage?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля, к которому относится новость (по умолчанию project_news) */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  /** ID владельца новости (user, project, or company) */
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** Тип владельца новости */
  ownerType?: InputMaybe<NewsOwnerTypeEnum>;
  /** Обновление или удаление опроса, прикреплённого к новости */
  poll?: InputMaybe<UpdateNewsPollInput>;
  /** «Первоисточник» — ссылка на исходный материал / пермалинк */
  sourceLink?: InputMaybe<Scalars['String']['input']>;
  /** Начальный статус новости. По умолчанию будет установлен DRAFT. */
  status?: InputMaybe<NewsStatusEnum>;
  /** Заголовок новости */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNewsPollInput = {
  /** Обновлённое объяснение */
  explanation?: InputMaybe<Scalars['String']['input']>;
  /** ID существующего опроса (заполняется автоматически) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Актуальный признак анонимности */
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  /** Актуальный признак множественного выбора */
  isMultipleChoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Актуальный режим викторины */
  isQuizMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** Обновлённый список вариантов ответа. Передайте полный список для пересоздания. */
  options?: InputMaybe<Array<UpdateNewsPollOptionInput>>;
  /** Обновлённый вопрос голосования */
  question?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNewsPollOptionInput = {
  /** ID варианта ответа (для обновления существующего) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Признак правильного ответа */
  isCorrect?: Scalars['Boolean']['input'];
  /** Текст варианта ответа */
  title: Scalars['String']['input'];
};

export type UpdateOneAnswerInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateAnswerDto;
};

export type UpdateOneCommentInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateCommentDto;
};

export type UpdateOneCounterEventInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateCounterEventDto;
};

export type UpdateOneLandingTemplateInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateLandingTemplateInput;
};

export type UpdateOneNewsInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateNewsDto;
};

export type UpdateOneProjectInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateProjectDto;
};

export type UpdateOneProjectMemberInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateProjectMemberDto;
};

export type UpdateOneProjectOrganizationInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateOrganizationDto;
};

export type UpdateOneProjectSupporterInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateSupporterDto;
};

export type UpdateOneQuestionDtoInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateQuestionDto;
};

export type UpdateOneQuestionFieldDtoInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateQuestionFieldDto;
};

export type UpdateOneSurveyDtoInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateSurveyDto;
};

export type UpdateOneUserVerifyRequestInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateUserVerifyRequestDto;
};

export type UpdateOrganizationDto = {
  /** Комментарий к адресу организации */
  companyAddressComment?: InputMaybe<Scalars['String']['input']>;
  /** JSON-объект адреса организации. */
  companyAddressJSON?: InputMaybe<Scalars['JSON']['input']>;
  /** Город организации */
  companyCity?: InputMaybe<Scalars['String']['input']>;
  /** Район города организации */
  companyCityDistrict?: InputMaybe<Scalars['String']['input']>;
  /** Email организации */
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  /** Офис организации */
  companyFlat?: InputMaybe<Scalars['String']['input']>;
  /** ИНН организации (10 или 12 цифр) */
  companyInn?: InputMaybe<Scalars['String']['input']>;
  /** Флаг ручного ввода адреса организации */
  companyIsManual?: InputMaybe<Scalars['Boolean']['input']>;
  /** КПП организации (9 цифр) */
  companyKpp?: InputMaybe<Scalars['String']['input']>;
  /** Полное наименование организации */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** ОГРН организации (13 или 15 цифр) */
  companyOgrn?: InputMaybe<Scalars['String']['input']>;
  /** Телефон организации */
  companyPhone?: InputMaybe<Scalars['String']['input']>;
  /** Должность представителя */
  companyPosition?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс организации */
  companyPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Область организации */
  companyRegion?: InputMaybe<Scalars['String']['input']>;
  /** Поселение организации */
  companySettlement?: InputMaybe<Scalars['String']['input']>;
  /** Краткое наименование организации */
  companyShortName?: InputMaybe<Scalars['String']['input']>;
  /** Улица и дом организации */
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  /** Email представителя */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Имя представителя */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Дата праздничного дня */
  holidayDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Название праздничного дня */
  holidayName?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия представителя */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Отчество представителя */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля реестра. По умолчанию основной модуль supporters. */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  /** Телефон представителя */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта */
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramItemInput = {
  /** Вложения «Карта проезда/прохода» (полностью заменяют текущий набор, если передан) */
  attachments?: InputMaybe<Array<ProgramItemAttachmentInput>>;
  /** Контактное лицо (отображаемое имя/ФИО) */
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  /** Контактное лицо — ссылка на пользователя платформы */
  contactPersonUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Дата и время окончания (UTC) */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID мероприятия программы */
  id: Scalars['ID']['input'];
  /** Место проведения */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Наименование мероприятия */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Порядок карточки в списке */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Дата и время начала (UTC) */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** IANA-таймзона создателя (например, Europe/Moscow) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectCustomModuleInput = {
  /** Дополнительная информация для модуля */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Цвет фона модуля */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Формат отображения модуля */
  format?: InputMaybe<CustomModuleFormatEnum>;
  /** Подпись (ФИО от руки) для модуля */
  handwrittenFullname?: InputMaybe<Scalars['String']['input']>;
  /** Иконка модуля (URL или название иконки) */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Цвет иконки модуля */
  iconColor?: InputMaybe<Scalars['String']['input']>;
  /** ID кастомного модуля */
  id: Scalars['ID']['input'];
  /** Название модуля */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectDto = {
  /** Подробное описание проекта */
  detailedDescription?: InputMaybe<Scalars['String']['input']>;
  /** Дата окончания проекта в формате ISO8601. Если не указана, проект считается бесконечным (без даты окончания) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Кнопки гамбургер-меню проекта (произвольная JSON-структура). Если не передано — пустой массив. */
  hamburgerButtons?: InputMaybe<Scalars['JSON']['input']>;
  /** Кнопки шапки (header) проекта (произвольная JSON-структура). Если не передано — пустой массив. */
  headerButtons?: InputMaybe<Scalars['JSON']['input']>;
  /** Опубликован ли проект. Необязательно: если не передано — true. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Название проекта. Если не передано — сохраняется пустая строка. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID пользователя, владельца проекта */
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  /** URL или ID объекта minio, представляющего фотографию проекта */
  photo?: InputMaybe<Scalars['String']['input']>;
  /** Запросы на добавление в проект */
  projectRequestId?: InputMaybe<Scalars['String']['input']>;
  /** Краткое описание проекта. Если не передано — сохраняется пустая строка. */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** URL-дружелюбный слаг проекта (опционально) */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Дата начала проекта */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Шаблон проекта (classic или deputy). Если не задан — не изменяется. */
  templateType?: InputMaybe<ProjectTemplateEnum>;
  /** Темы проекта. Если не передан или пуст — подставляется тема по умолчанию (ALL). */
  themes?: InputMaybe<Array<ProjectThemeEnum>>;
  /** Тип видимости проекта */
  visibility?: InputMaybe<ProjectVisibilityEnum>;
  /** Пресет нативных модулей (ЖКХ). Для типового проекта (deputy) обязателен. */
  workspacePreset?: InputMaybe<ProjectWorkspacePresetEnum>;
};

export type UpdateProjectMemberDto = {
  /** ID проекта */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** Роль пользователя в проекте */
  role?: InputMaybe<ProjectMemberRoleEnum>;
  /** ID пользователя */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProjectRequestDto = {
  /** Подробное описание проекта */
  detailedDescription?: InputMaybe<Scalars['String']['input']>;
  /** Дата окончания проекта. Если не указана - проект считается бесконечным */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Кастомные модули при создании (только классический проект) */
  initialCustomModules?: InputMaybe<Array<InitialProjectCustomModuleInput>>;
  /** Опубликована ли заявка. Необязательно: если не передано — true. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Название проекта. Если не передано — сохраняется пустая строка. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ключ объекта MinIO логотипа проекта (например unprocessed/{id}/original.webp) */
  photo?: InputMaybe<Scalars['String']['input']>;
  /** Краткое описание проекта. Если не передано — сохраняется пустая строка. */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** Дата начала проекта */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Вид проекта: классический или типовой (deputy) */
  templateType?: InputMaybe<ProjectTemplateEnum>;
  /** Темы проекта. Если не передан или пуст — подставляется тема по умолчанию (ALL). */
  themes?: InputMaybe<Array<ProjectThemeEnum>>;
  /** Видимость проекта смотри описание множества */
  visibility?: InputMaybe<ProjectVisibilityEnum>;
  /** Пресет модулей (ЖКХ). Для типового проекта обязателен. */
  workspacePreset?: InputMaybe<ProjectWorkspacePresetEnum>;
};

export type UpdateQuestionDto = {
  /** Описание вопроса */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Обязателен ли вопрос */
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Дополнительные настройки вопроса */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Варианты ответов для вопросов с выбором */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Порядок вопроса в опросе */
  order?: InputMaybe<Scalars['Float']['input']>;
  /** ID опроса */
  surveyId?: InputMaybe<Scalars['String']['input']>;
  /** Название вопроса */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuestionFieldDto = {
  answerExplanation?: InputMaybe<Scalars['String']['input']>;
  answerValidationType?: InputMaybe<Scalars['String']['input']>;
  /** Правильный ответ */
  correctAnswer?: InputMaybe<Scalars['JSON']['input']>;
  correctAnswerPattern?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Float']['input']>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<QuestionFieldType>;
  value?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UpdateQuestionFieldsDto = {
  /** ID полей для удаления */
  deleteFieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID вопроса */
  questionId: Scalars['ID']['input'];
  /** Создание/обновление полей */
  upserts: Array<UpsertQuestionFieldInput>;
};

export type UpdateQuestionFullDto = {
  deleteFieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateQuestionPatchDto>;
  upserts?: InputMaybe<Array<UpsertQuestionFieldInput>>;
};

export type UpdateQuestionPatchDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReglamentItemInput = {
  /** Дата и время окончания выступления (UTC) */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID выступления регламента */
  id: Scalars['ID']['input'];
  /** Конец времени на вопросы (UTC) */
  questionsEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Начало времени на вопросы (UTC) */
  questionsStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Тема доклада */
  reportTopic?: InputMaybe<Scalars['String']['input']>;
  /** Порядок строки в списке */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** ФИО выступающего */
  speakerName?: InputMaybe<Scalars['String']['input']>;
  /** Дата и время начала выступления (UTC) */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** IANA-таймзона создателя (например, Europe/Moscow) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Степень срочности обновления мобильного клиента */
export enum UpdateSeverity {
  None = 'NONE',
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED'
}

export type UpdateSupporterDto = {
  /** Комментарий (comment). */
  addressComment?: InputMaybe<Scalars['String']['input']>;
  /** JSON-объект адреса. */
  addressJSON?: InputMaybe<Scalars['JSON']['input']>;
  /** Дата рождения */
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** Город (city). */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Район города (city_district). */
  cityDistrict?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий к адресу компании. */
  companyAddressComment?: InputMaybe<Scalars['String']['input']>;
  /** JSON-объект адреса компании. */
  companyAddressJSON?: InputMaybe<Scalars['JSON']['input']>;
  /** Город компании. */
  companyCity?: InputMaybe<Scalars['String']['input']>;
  /** Район города компании. */
  companyCityDistrict?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий к компании. */
  companyComment?: InputMaybe<Scalars['String']['input']>;
  /** Домофон компании. */
  companyDoorphone?: InputMaybe<Scalars['String']['input']>;
  /** Email компании. */
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  /** Подъезд компании. */
  companyEntrance?: InputMaybe<Scalars['String']['input']>;
  /** Квартира компании. */
  companyFlat?: InputMaybe<Scalars['String']['input']>;
  /** Этаж компании. */
  companyFloor?: InputMaybe<Scalars['String']['input']>;
  /** ИНН компании (10 или 12 цифр). */
  companyInn?: InputMaybe<Scalars['String']['input']>;
  /** Флаг ручного ввода адреса компании. */
  companyIsManual?: InputMaybe<Scalars['Boolean']['input']>;
  /** КПП компании (9 цифр). */
  companyKpp?: InputMaybe<Scalars['String']['input']>;
  /** Название компании. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** ОГРН компании (13 или 15 цифр). */
  companyOgrn?: InputMaybe<Scalars['String']['input']>;
  /** Телефон компании. */
  companyPhone?: InputMaybe<Scalars['String']['input']>;
  /** Должность в компании. */
  companyPosition?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс компании. */
  companyPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Область компании. */
  companyRegion?: InputMaybe<Scalars['String']['input']>;
  /** Поселение компании. */
  companySettlement?: InputMaybe<Scalars['String']['input']>;
  /** Улица и дом компании. */
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  /** Домофон (doorphone). */
  doorphone?: InputMaybe<Scalars['String']['input']>;
  /** Email сторонника */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Подъезд (entrance). */
  entrance?: InputMaybe<Scalars['String']['input']>;
  /** Имя сторонника */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Квартира (flat/apartment). */
  flat?: InputMaybe<Scalars['String']['input']>;
  /** Этаж (floor). */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** Пол сторонника */
  gender?: InputMaybe<SupporterGender>;
  /** Дата праздничного дня */
  holidayDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Название праздничного дня */
  holidayName?: InputMaybe<Scalars['String']['input']>;
  /** Флаг, указывающий, был ли адрес введён вручную (true) или найден через DaData (false). */
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  /** Фамилия сторонника */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Отчество сторонника */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля реестра. По умолчанию основной модуль supporters. */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  /** Телефон сторонника */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс (postalCode). */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** ID проекта */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** Область (region). */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Поселение (settlement). */
  settlement?: InputMaybe<Scalars['String']['input']>;
  /** Улица и дом (street). */
  street?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSurveyDto = {
  allowAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  allowEditResponse?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultipleResponses?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Слаг модуля опросов. По умолчанию основной модуль project_survey. */
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  responseDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SurveyStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSurveyWithPublishDto = {
  allowAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  allowEditResponse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Автоматически опубликовать после обновления */
  autoPublish?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  responseDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  surveyId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemplateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserAddressInput = {
  /** City of the address. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** City district of the address. */
  cityDistrict?: InputMaybe<Scalars['String']['input']>;
  /** Additional comment about the address. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Doorphone code. */
  doorphone?: InputMaybe<Scalars['String']['input']>;
  /** Entrance of the building. */
  entrance?: InputMaybe<Scalars['String']['input']>;
  /** Flat or apartment number. */
  flat?: InputMaybe<Scalars['String']['input']>;
  /** Floor of the building. */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** ID of address for (updating existing address). */
  id?: InputMaybe<Scalars['Float']['input']>;
  /** Region of the address. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Settlement of the address. */
  settlement?: InputMaybe<Scalars['String']['input']>;
  /** Street and building of the address. */
  street?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  /** Single address for the user. */
  address?: InputMaybe<UpdateUserAddressInput>;
  /** URL of the user's avatar. */
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth of the user. */
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  /** Email of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the user. Uses the Gender enum for allowed values. */
  gender?: InputMaybe<Gender>;
  /** Unique identifier of the user to be updated. */
  id: Scalars['ID']['input'];
  /** Last name of the user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Locale setting for the user. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** User's nickname. Must be unique. */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Patronymic of the user. */
  patronymic?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserOnlineStatusInput = {
  /** Device type the user is using when online. */
  deviceType: DeviceType;
};

export type UpdateUserVerifyRequestDto = {
  /** ID заявки на верификацию */
  id: Scalars['ID']['input'];
  /** Статус запроса на верификацию пользователя */
  status?: InputMaybe<UserVerifyRequestStatusEnum>;
  /** ID пользователя */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadInfoDto = {
  __typename?: 'UploadInfoDto';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type UploadUrlDto = {
  __typename?: 'UploadUrlDto';
  fields: Scalars['JSON']['output'];
  uploadId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UpsertGlobalModuleAccessSettingsInput = {
  /** Внесение информации */
  dataEntry: GlobalModuleDataEntryRuleInput;
  /** Редактирование */
  edit: GlobalModuleEditRuleInput;
  /** userId пользователей с полным доступом */
  fullAccessUserIds: Array<Scalars['ID']['input']>;
  /** Слаг глобального модуля, например "news_digest" */
  moduleSlug: Scalars['String']['input'];
};

export type UpsertObjectPassportInput = {
  /** Вложения паспорта (полностью заменяют текущий набор). Уже загружены в S3/MinIO */
  attachments?: InputMaybe<Array<ObjectPassportAttachmentInput>>;
  /** Контактное лицо (отображаемое имя/ФИО) */
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  /** Контактное лицо — ссылка на пользователя платформы */
  contactPersonUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Контактный телефон */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Краткое описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Дата и время окончания (UTC) */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Вид мероприятия */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Предполагаемая численность участников */
  expectedHeadcount?: InputMaybe<Scalars['Int']['input']>;
  /** Место проведения */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Слаг связанного модуля «Программа» (program[_<suffix>]) того же проекта. Пустая строка/пропуск — связь не задаётся */
  moduleProgramRelated?: InputMaybe<Scalars['String']['input']>;
  /** Слаг связанного модуля «Регламент» (reglament[_<suffix>]) того же проекта. Пустая строка/пропуск — связь не задаётся */
  moduleReglamentRelated?: InputMaybe<Scalars['String']['input']>;
  /** Слаг экземпляра кастомного модуля (object_passport[_<suffix>]) */
  moduleSlug: Scalars['String']['input'];
  /** Название мероприятия/объекта */
  name: Scalars['String']['input'];
  /** ID проекта */
  projectId: Scalars['ID']['input'];
  /** Дата и время начала (UTC) */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** IANA-таймзона создателя (например, Europe/Moscow) */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertProjectModuleAccessSettingsInput = {
  dataEntry: ModuleAccessScopeRuleInput;
  edit: ModuleAccessEditRuleInput;
  /** Участники с полным доступом (project_member.id) */
  fullAccessMemberIds: Array<Scalars['ID']['input']>;
  moduleSlug: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  show: ModuleAccessScopeRuleInput;
  view: ModuleAccessScopeRuleInput;
};

export type UpsertQuestionFieldInput = {
  /** Данные поля (создание/обновление) */
  data: CreateQuestionFieldDto;
  /** ID существующего поля (если обновляем) */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** User entity representing a system user */
export type User = {
  __typename?: 'User';
  /** One-to-one relationship with the UserActivityStatus entity. Contains the user's online status, device type, and last seen timestamp. */
  activityStatus?: Maybe<UserActivityStatus>;
  /** One-to-many relationship with the UserAddress entity. Represents all addresses of the user. */
  addresses?: Maybe<Array<UserAddress>>;
  /** Timestamp when the user record was created. Defaults to the current timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** Date of birth (ISO datetime) */
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the user was soft deleted. Null if the user is not deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Device type that the user is using when online.
   * @deprecated Use activityStatus.deviceType instead
   */
  deviceType?: Maybe<DeviceType>;
  /** Email of the user (optional). */
  email?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether the email is verified. Defaults to false. */
  emailVerified: Scalars['Boolean']['output'];
  /** First name of the user. */
  firstName: Scalars['String']['output'];
  /** Gender of the user (optional). Uses the Gender enum for allowed values. */
  gender?: Maybe<Gender>;
  /** Unique identifier for the user. Automatically generated. */
  id: Scalars['ID']['output'];
  /** Indicates whether the user is active. Defaults to true. */
  isActive: Scalars['Boolean']['output'];
  /** Признак мягкого удаления */
  isDeleted: Scalars['Boolean']['output'];
  /**
   * Indicates whether the user is currently online.
   * @deprecated Use activityStatus.isOnline instead
   */
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  /** Является ли владелец изначальным (из другого проекта) */
  isOrigin: Scalars['Boolean']['output'];
  /** Last name of the user. */
  lastName: Scalars['String']['output'];
  /**
   * Timestamp when the user was last seen online.
   * @deprecated Use activityStatus.lastSeenAt instead
   */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Locale setting for the user. Defaults to 'ru', with a maximum length of 10 characters. */
  locale: Scalars['String']['output'];
  media?: Maybe<Media>;
  /** Unique nickname of the user. Maximum length is 64 characters. */
  nickname: Scalars['String']['output'];
  /** Patronymic of the user (optional). */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** Phone number of the user (optional). */
  phone?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether the phone number is verified. Defaults to false. */
  phoneVerified: Scalars['Boolean']['output'];
  /** One-to-many relationship with the UserProfileChange entity. Contains the history of changes to the user's profile. */
  profileChanges?: Maybe<Array<UserProfileChange>>;
  projectUsers: UserProjectUsersConnection;
  /** Timestamp when the user record was last updated. Defaults to the current timestamp. */
  updatedAt: Scalars['DateTime']['output'];
  /** User's verification status. */
  verificationStatus?: Maybe<VerificationStatus>;
};


/** User entity representing a system user */
export type UserProjectUsersArgs = {
  filter?: ProjectMemberFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProjectMemberSort>;
};

/** Entity tracking user online activity status */
export type UserActivityStatus = {
  __typename?: 'UserActivityStatus';
  /** Timestamp when the activity status record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Device type that the user is using when online. */
  deviceType?: Maybe<DeviceType>;
  /** Unique identifier for the activity status record. */
  id: Scalars['ID']['output'];
  /** Indicates whether the user is currently online. Defaults to false. */
  isOnline: Scalars['Boolean']['output'];
  /** Timestamp when the user was last seen online. */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the activity status record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The ID of the user this activity status belongs to. */
  userId: Scalars['String']['output'];
};

/** Entity representing a user's address details */
export type UserAddress = {
  __typename?: 'UserAddress';
  /** Город (city). */
  city?: Maybe<Scalars['String']['output']>;
  /** Район города (city_district). */
  cityDistrict?: Maybe<Scalars['String']['output']>;
  /** Комментарий (comment). */
  comment?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the address record was created. Defaults to the current timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** Домофон (doorphone). */
  doorphone?: Maybe<Scalars['String']['output']>;
  /** Подъезд (entrance). */
  entrance?: Maybe<Scalars['String']['output']>;
  /** Квартира (flat/apartment). */
  flat?: Maybe<Scalars['String']['output']>;
  /** Этаж (floor). */
  floor?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the user address. Automatically generated by the database. */
  id: Scalars['ID']['output'];
  /** Flag indicating if the address was entered manually (true) or found via DaData (false). */
  isManual: Scalars['Boolean']['output'];
  /** Область (region). */
  region?: Maybe<Scalars['String']['output']>;
  /** Поселение (settlement). */
  settlement?: Maybe<Scalars['String']['output']>;
  /** Улица и дом (street). */
  street?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the address record was last updated. Defaults to the current timestamp. */
  updatedAt: Scalars['DateTime']['output'];
  /** The associated user. Many-to-one relationship with the User entity. If the user is deleted, the address records are also removed (CASCADE deletion). */
  user: User;
};

/** Пройденный опрос пользователя */
export type UserCompletedSurveyDto = {
  __typename?: 'UserCompletedSurveyDto';
  /** Дата завершения последнего ответа */
  completedAt: Scalars['DateTime']['output'];
  /** ID последнего завершенного ответа */
  responseId: Scalars['ID']['output'];
  /** Количество завершенных ответов пользователя на этот опрос */
  responsesCount: Scalars['Float']['output'];
  /** Информация об опросе */
  survey: SurveyDto;
  /** ID опроса */
  surveyId: Scalars['ID']['output'];
};

export type UserDetailedFiltersInput = {
  /** Конечная дата периода */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Фильтр по региону (максимум 100 символов) */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Начальная дата периода */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserDetailedReportEntity = {
  __typename?: 'UserDetailedReportEntity';
  /** Среднее время нахождения в КВЕСТ (в минутах) */
  averageSessionDuration?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Количество друзей */
  friendsCount: Scalars['Int']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Количество проектов где пользователь ВЛАДЕЛЕЦ */
  ownedProjectsCount: Scalars['Int']['output'];
  /** Количество проектов где пользователь УЧАСТНИК */
  participatedProjectsCount: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  /** Дата формирования отчета */
  reportDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  avatar?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Entity representing a change in a user's profile details. */
export type UserProfileChange = {
  __typename?: 'UserProfileChange';
  /** Identifier of the admin user who reviewed the change (optional). */
  adminUserId?: Maybe<Scalars['Float']['output']>;
  /** Timestamp when the profile change record was created. Defaults to the current timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** Name of the profile field that was changed. Maximum length is 50 characters. */
  fieldName: Scalars['String']['output'];
  /** Unique identifier for the profile change record. Automatically generated by the database. */
  id: Scalars['ID']['output'];
  /** New value of the profile field. */
  newValue: Scalars['String']['output'];
  /** Previous value of the profile field (optional). */
  oldValue?: Maybe<Scalars['String']['output']>;
  /** Status of the profile change. Allowed values: 'PENDING', 'APPROVED', or 'REJECTED'. Defaults to 'PENDING'. */
  status: Scalars['String']['output'];
  /** Timestamp when the profile change record was last updated. Defaults to the current timestamp. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user entity associated with this profile change. Establishes a many-to-one relationship with the User entity. On deletion of the user, related profile change records are removed (CASCADE deletion). */
  user: User;
  /** Identifier of the user whose profile was changed. Stored redundantly for quick reference. */
  userId: Scalars['Float']['output'];
};

export type UserProjectUsersConnection = {
  __typename?: 'UserProjectUsersConnection';
  /** Array of nodes. */
  nodes: Array<ProjectMember>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type UserRoleNotSet = {
  __typename?: 'UserRoleNotSet';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type UserVerifyError = NotInPendingStatus | NotSuccess | Success | UserRoleNotSet;

export type UserVerifyRequest = {
  __typename?: 'UserVerifyRequest';
  /** Дата создания */
  createdAt: Scalars['DateTime']['output'];
  /** Дата удаления */
  deletedAt: Scalars['DateTime']['output'];
  /** ID запроса на верификацию */
  id: Scalars['ID']['output'];
  /** Статус запроса на верификацию пользователя */
  status: UserVerifyRequestStatusEnum;
  /** Дата обновления */
  updatedAt: Scalars['DateTime']['output'];
  /** ID пользователя, который обновил */
  updatedByUserId: Scalars['String']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type UserVerifyRequestConnection = {
  __typename?: 'UserVerifyRequestConnection';
  /** Array of nodes. */
  nodes: Array<UserVerifyRequest>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type UserVerifyRequestDeleteResponse = {
  __typename?: 'UserVerifyRequestDeleteResponse';
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Дата удаления */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID запроса на верификацию */
  id?: Maybe<Scalars['ID']['output']>;
  /** Статус запроса на верификацию пользователя */
  status?: Maybe<UserVerifyRequestStatusEnum>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID пользователя, который обновил */
  updatedByUserId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserVerifyRequestFilter = {
  and?: InputMaybe<Array<UserVerifyRequestFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<UserVerifyRequestFilter>>;
  status?: InputMaybe<UserVerifyRequestStatusEnumFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  updatedByUserId?: InputMaybe<StringFieldComparison>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type UserVerifyRequestSort = {
  direction: SortDirection;
  field: UserVerifyRequestSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum UserVerifyRequestSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UpdatedByUserId = 'updatedByUserId',
  UserId = 'userId'
}

/** Описание статусов: PENDING - заявка ожидает подтверждения, APPROVED - заявка подтверждена, REJECTED - заявка отклонена но не окончательно */
export enum UserVerifyRequestStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type UserVerifyRequestStatusEnumFilterComparison = {
  eq?: InputMaybe<UserVerifyRequestStatusEnum>;
  gt?: InputMaybe<UserVerifyRequestStatusEnum>;
  gte?: InputMaybe<UserVerifyRequestStatusEnum>;
  iLike?: InputMaybe<UserVerifyRequestStatusEnum>;
  in?: InputMaybe<Array<UserVerifyRequestStatusEnum>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<UserVerifyRequestStatusEnum>;
  lt?: InputMaybe<UserVerifyRequestStatusEnum>;
  lte?: InputMaybe<UserVerifyRequestStatusEnum>;
  neq?: InputMaybe<UserVerifyRequestStatusEnum>;
  notILike?: InputMaybe<UserVerifyRequestStatusEnum>;
  notIn?: InputMaybe<Array<UserVerifyRequestStatusEnum>>;
  notLike?: InputMaybe<UserVerifyRequestStatusEnum>;
};

export type UserVerifyResponse = {
  __typename?: 'UserVerifyResponse';
  userVerifyRequest?: Maybe<UserVerifyRequest>;
  userVerifyRequestErrors: UserVerifyError;
};

/** Entity representing a verification status for users */
export type VerificationStatus = {
  __typename?: 'VerificationStatus';
  /** Unique code representing the verification status. Maximum length is 20 characters. */
  code: Scalars['String']['output'];
  /** Optional description providing additional details about the verification status. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the verification status. Automatically generated by the database. */
  id: Scalars['ID']['output'];
  /** List of users associated with this verification status. */
  users?: Maybe<Array<User>>;
};

export type VerificationType = {
  __typename?: 'VerificationType';
  code: Scalars['String']['output'];
  /** Unique identifier for the verification types. Automatically generated by the database. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Тип верификации */
export enum VerificationTypes {
  ChangeEmail = 'CHANGE_EMAIL',
  ChangePassword = 'CHANGE_PASSWORD',
  ChangePhone = 'CHANGE_PHONE',
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type VerifyRequest = {
  code: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  type: VerificationTypes;
};

export type VerifyResponse = {
  __typename?: 'VerifyResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EmergencyContactFieldsFragment = { __typename?: 'EmergencyContact', id: string, name: string, phoneNumber: string, category: EmergencyContactCategoryEnum, projectId: string, createdAt: string, updatedAt: string };

export type FriendRelationshipFieldsFragment = { __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } };

export type ObjectPassportApplicationFieldsFragment = { __typename?: 'ObjectPassportApplication', id: string, fullName: string, phone?: string | undefined, position?: string | undefined, additionalInfo?: string | undefined, applicationText?: string | undefined, participationFormat?: ObjectPassportParticipationFormatEnum | undefined, status: ObjectPassportApplicationStatusEnum, passportId: string, projectId: string, moduleSlug: string, createdAt: string, updatedAt: string, moderatedAt?: string | undefined, moderatorComment?: string | undefined, applicantUserId?: string | undefined };

export type ObjectPassportAttachmentFieldsFragment = { __typename?: 'ObjectPassportAttachment', id: string, fileKey: string, fileName: string, fileSize?: number | undefined, kind: ObjectPassportFileKindEnum, mimeType?: string | undefined, url?: string | undefined, passportId: string, createdAt: string };

export type ObjectPassportFieldsFragment = { __typename?: 'ObjectPassport', id: string, name: string, description?: string | undefined, eventType?: string | undefined, contactPersonName?: string | undefined, contactPersonUserId?: string | undefined, contactPhone?: string | undefined, startAt?: string | undefined, endAt?: string | undefined, expectedHeadcount?: number | undefined, location?: string | undefined, moduleSlug: string, moduleProgramRelated?: string | undefined, moduleReglamentRelated?: string | undefined, projectId: string, timezone?: string | undefined, createdAt: string, updatedAt: string, attachments: Array<{ __typename?: 'ObjectPassportAttachment', id: string, fileKey: string, fileName: string, fileSize?: number | undefined, kind: ObjectPassportFileKindEnum, mimeType?: string | undefined, url?: string | undefined, passportId: string, createdAt: string }> };

export type PlannerCalendarEventItemFieldsFragment = { __typename?: 'CalendarEvent', id: string, completed: boolean, title: string, description?: string | undefined, priority: CalendarEventPriorityEnum, location?: string | undefined, startAt: string, endAt: string, isAllDay: boolean, timezone?: string | undefined, ownerUserId: string, projectId?: string | undefined, createdAt: string, updatedAt: string, recurrenceGroupId?: string | undefined, recurrenceFrequency?: CalendarEventRecurrenceFrequencyEnum | undefined, recurrenceInterval?: number | undefined, recurrenceUntil?: string | undefined, isRecurrenceMaster: boolean, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, userId: string, status: CalendarEventParticipantStatusEnum, createdAt: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, PROFILE?: string | undefined } | undefined } | undefined } | undefined } }>, attachments: Array<{ __typename?: 'CalendarEventAttachment', id: string, fileName: string, mimeType?: string | undefined, fileSize?: number | undefined, fileKey: string, url?: string | undefined }>, reminders: Array<{ __typename?: 'CalendarEventReminder', id: string, remindAt: string, method: CalendarEventReminderMethodEnum, status: CalendarEventReminderStatusEnum }>, comments?: { __typename?: 'CommentCountOutput', commentCount: number, unreadCount?: number | undefined } | undefined };

export type ProgramItemAttachmentFieldsFragment = { __typename?: 'ProgramItemAttachment', id: string, programItemId: string, kind: ProgramFileKindEnum, fileName: string, mimeType?: string | undefined, fileSize?: number | undefined, fileKey: string, url?: string | undefined, uploadedByUserId: string, createdAt: string };

export type ProgramItemFieldsFragment = { __typename?: 'ProgramItem', id: string, projectId: string, moduleSlug: string, name: string, contactPersonName?: string | undefined, contactPersonUserId?: string | undefined, startAt?: string | undefined, endAt?: string | undefined, timezone?: string | undefined, location?: string | undefined, sortOrder: number, createdByUserId: string, updatedByUserId?: string | undefined, createdAt: string, updatedAt: string, attachments: Array<{ __typename?: 'ProgramItemAttachment', id: string, programItemId: string, kind: ProgramFileKindEnum, fileName: string, mimeType?: string | undefined, fileSize?: number | undefined, fileKey: string, url?: string | undefined, uploadedByUserId: string, createdAt: string }> };

export type ProjectFieldsFragment = { __typename?: 'Project', id: string, slug?: string | undefined, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, templateType: ProjectTemplateEnum, visibility: ProjectVisibilityEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, ownerUserId?: string | undefined, projectRequestId?: string | undefined, createdAt: string, updatedAt: string, owner: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> } };

export type ProjectMemberFieldsFragment = { __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined };

export type ProjectRequestFieldsFragment = { __typename?: 'ProjectRequest', id: string, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, visibility: ProjectVisibilityEnum, userId: string, status: ProjectRequestStatusEnum, projectId?: string | undefined, templateType: ProjectTemplateEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, createdAt: string, updatedAt: string, rejections?: Array<{ __typename?: 'ProjectRequestRejection', projectRequestId: string, reason: string, rejectedByUserId: string }> | undefined, media?: { __typename?: 'ProjectMedia', logo?: string | undefined, image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, TABLET?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, MOBILE?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined } | undefined } | undefined };

export type ProjectSupporterFieldsFragment = { __typename?: 'ProjectSupporter', firstName?: string | undefined, lastName?: string | undefined, middleName?: string | undefined, gender?: SupporterGender | undefined, birthday?: string | undefined, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, postalCode?: string | undefined, addressComment?: string | undefined, isManual?: boolean | undefined, comment?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, projectId: string, companyName?: string | undefined, companyPosition?: string | undefined, companyPhone?: string | undefined, companyEmail?: string | undefined, companyRegion?: string | undefined, companyCity?: string | undefined, companyCityDistrict?: string | undefined, companySettlement?: string | undefined, companyStreet?: string | undefined, companyFlat?: string | undefined, companyEntrance?: string | undefined, companyFloor?: string | undefined, companyDoorphone?: string | undefined, companyAddressComment?: string | undefined, companyPostalCode?: string | undefined, companyIsManual?: boolean | undefined, holidayName?: string | undefined, holidayDate?: string | undefined, createdAt: string, updatedAt: string };

export type ReglamentItemFieldsFragment = { __typename?: 'ReglamentItem', id: string, projectId: string, moduleSlug: string, speakerName: string, reportTopic?: string | undefined, startAt?: string | undefined, endAt?: string | undefined, questionsStartAt?: string | undefined, questionsEndAt?: string | undefined, timezone?: string | undefined, sortOrder: number, createdByUserId: string, updatedByUserId?: string | undefined, createdAt: string, updatedAt: string };

export type PlatformSummaryReportEntityFragment = { __typename?: 'PlatformSummaryReportEntity', id: string, totalRegisteredUsers: number, totalProjects: number, totalProjectOwners: number, totalProjectParticipants: number, averageSessionDuration?: number | undefined, activeUsersCount: number, totalFriendships: number, periodStart: string, periodEnd: string, reportDate: string, createdAt: string, updatedAt: string };

export type ProjectDetailedReportEntityFragment = { __typename?: 'ProjectDetailedReportEntity', id: string, projectId: string, projectName: string, projectOwnerName: string, totalParticipantsCount: number, activeParticipantsCount: number, averageSessionDuration?: number | undefined, reportDate: string, createdAt: string, updatedAt: string };

export type RegionalReportEntityFragment = { __typename?: 'RegionalReportEntity', id: string, region: string, registeredUsersCount: number, projectParticipantsCount: number, averageSessionDuration?: number | undefined, reportDate: string, createdAt: string, updatedAt: string };

export type UserDetailedReportEntityFragment = { __typename?: 'UserDetailedReportEntity', id: string, userId: string, fullName: string, ownedProjectsCount: number, friendsCount: number, averageSessionDuration?: number | undefined, reportDate: string, createdAt: string, updatedAt: string };

export type TokenFieldsFragment = { __typename?: 'AuthResponse', access_token?: string | undefined, refresh_token?: string | undefined, token_type?: string | undefined, expires_in?: number | undefined, refresh_expires_in?: number | undefined };

export type UserAddressFieldsFragment = { __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string };

export type UserFieldsFragment = { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined };

export type ConfirmVerificationCodeMutationVariables = Exact<{
  input: VerifyRequest;
}>;


export type ConfirmVerificationCodeMutation = { __typename?: 'Mutation', confirmVerificationCode: { __typename?: 'VerifyResponse', success: boolean, message: string } };

export type LoginMutationVariables = Exact<{
  username?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthResponse', access_token?: string | undefined, refresh_token?: string | undefined, token_type?: string | undefined, expires_in?: number | undefined, refresh_expires_in?: number | undefined } };

export type LoginByCodeMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type LoginByCodeMutation = { __typename?: 'Mutation', loginByCode: { __typename?: 'AuthResponse', access_token?: string | undefined, refresh_token?: string | undefined, token_type?: string | undefined, expires_in?: number | undefined, refresh_expires_in?: number | undefined } };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'AuthResponse', access_token?: string | undefined, refresh_token?: string | undefined, token_type?: string | undefined, expires_in?: number | undefined, refresh_expires_in?: number | undefined } };

export type RegisterUserMutationVariables = Exact<{
  input: RegisterUserRequest;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', registerUser: { __typename?: 'AuthResponse', access_token?: string | undefined, refresh_token?: string | undefined, token_type?: string | undefined, expires_in?: number | undefined, refresh_expires_in?: number | undefined } };

export type RemoveLoginCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveLoginCodeMutation = { __typename?: 'Mutation', removeLoginCode: boolean };

export type RequestPasswordResetMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  method: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: string };

export type RevokeTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RevokeTokenMutation = { __typename?: 'Mutation', revokeToken: string };

export type SendVerificationCodeMutationVariables = Exact<{
  input: SendVerificationCodeRequest;
}>;


export type SendVerificationCodeMutation = { __typename?: 'Mutation', sendVerificationCode: { __typename?: 'VerifyResponse', success: boolean, message: string } };

export type SetLoginCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type SetLoginCodeMutation = { __typename?: 'Mutation', setLoginCode: boolean };

export type SetNewPasswordAfterResetMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type SetNewPasswordAfterResetMutation = { __typename?: 'Mutation', setNewPasswordAfterReset: string };

export type SubmitContactRequestMutationVariables = Exact<{
  input: SubmitContactRequestInput;
}>;


export type SubmitContactRequestMutation = { __typename?: 'Mutation', submitContactRequest: { __typename?: 'ContactRequestResponse', id: string, subject: string, description: string, senderEmail?: string | undefined, status: ContactRequestStatus, createdAt: string, mediaUrls?: Array<string> | undefined } };

export type VerifyPasswordResetOtpMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
}>;


export type VerifyPasswordResetOtpMutation = { __typename?: 'Mutation', verifyPasswordResetOtp: string };

export type AddCalendarEventParticipantsMutationVariables = Exact<{
  input: AddCalendarEventParticipantsInput;
}>;


export type AddCalendarEventParticipantsMutation = { __typename?: 'Mutation', addCalendarEventParticipants: { __typename?: 'CalendarEvent', id: string, participants: Array<{ __typename?: 'CalendarEventParticipant', userId: string, status: CalendarEventParticipantStatusEnum }> } };

export type CreateCalendarEventMutationVariables = Exact<{
  input: CreateCalendarEventInput;
}>;


export type CreateCalendarEventMutation = { __typename?: 'Mutation', createCalendarEvent: { __typename?: 'CalendarEvent', id: string, completed: boolean, title: string, description?: string | undefined, priority: CalendarEventPriorityEnum, location?: string | undefined, startAt: string, endAt: string, isAllDay: boolean, timezone?: string | undefined, ownerUserId: string, projectId?: string | undefined, createdAt: string, updatedAt: string, recurrenceGroupId?: string | undefined, recurrenceFrequency?: CalendarEventRecurrenceFrequencyEnum | undefined, recurrenceInterval?: number | undefined, recurrenceUntil?: string | undefined, isRecurrenceMaster: boolean, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, userId: string, status: CalendarEventParticipantStatusEnum, createdAt: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, PROFILE?: string | undefined } | undefined } | undefined } | undefined } }>, attachments: Array<{ __typename?: 'CalendarEventAttachment', id: string, fileName: string, mimeType?: string | undefined, fileSize?: number | undefined, fileKey: string, url?: string | undefined }>, reminders: Array<{ __typename?: 'CalendarEventReminder', id: string, remindAt: string, method: CalendarEventReminderMethodEnum, status: CalendarEventReminderStatusEnum }>, comments?: { __typename?: 'CommentCountOutput', commentCount: number, unreadCount?: number | undefined } | undefined } };

export type DeleteCalendarEventMutationVariables = Exact<{
  input: DeleteCalendarEventInput;
}>;


export type DeleteCalendarEventMutation = { __typename?: 'Mutation', deleteCalendarEvent: { __typename?: 'CalendarEventDeleteResponse', id: string, success: boolean, message?: string | undefined } };

export type LeaveCalendarEventMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type LeaveCalendarEventMutation = { __typename?: 'Mutation', leaveCalendarEvent: { __typename?: 'CalendarEvent', id: string } };

export type RemoveCalendarEventParticipantMutationVariables = Exact<{
  input: RemoveCalendarEventParticipantInput;
}>;


export type RemoveCalendarEventParticipantMutation = { __typename?: 'Mutation', removeCalendarEventParticipant: { __typename?: 'CalendarEvent', id: string } };

export type UpdateCalendarEventMutationVariables = Exact<{
  input: UpdateCalendarEventInput;
}>;


export type UpdateCalendarEventMutation = { __typename?: 'Mutation', updateCalendarEvent: { __typename?: 'CalendarEvent', id: string, completed: boolean, title: string, description?: string | undefined, priority: CalendarEventPriorityEnum, location?: string | undefined, startAt: string, endAt: string, isAllDay: boolean, timezone?: string | undefined, ownerUserId: string, projectId?: string | undefined, createdAt: string, updatedAt: string, recurrenceGroupId?: string | undefined, recurrenceFrequency?: CalendarEventRecurrenceFrequencyEnum | undefined, recurrenceInterval?: number | undefined, recurrenceUntil?: string | undefined, isRecurrenceMaster: boolean, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, userId: string, status: CalendarEventParticipantStatusEnum, createdAt: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, PROFILE?: string | undefined } | undefined } | undefined } | undefined } }>, attachments: Array<{ __typename?: 'CalendarEventAttachment', id: string, fileName: string, mimeType?: string | undefined, fileSize?: number | undefined, fileKey: string, url?: string | undefined }>, reminders: Array<{ __typename?: 'CalendarEventReminder', id: string, remindAt: string, method: CalendarEventReminderMethodEnum, status: CalendarEventReminderStatusEnum }>, comments?: { __typename?: 'CommentCountOutput', commentCount: number, unreadCount?: number | undefined } | undefined } };

export type UpdateCalendarEventParticipantStatusMutationVariables = Exact<{
  input: UpdateCalendarEventParticipantStatusInput;
}>;


export type UpdateCalendarEventParticipantStatusMutation = { __typename?: 'Mutation', updateCalendarEventParticipantStatus: { __typename?: 'CalendarEvent', id: string, participants: Array<{ __typename?: 'CalendarEventParticipant', userId: string, status: CalendarEventParticipantStatusEnum }> } };

export type CreateOneCommentMutationVariables = Exact<{
  input: CreateOneCommentInput;
}>;


export type CreateOneCommentMutation = { __typename?: 'Mutation', createOneComment: { __typename?: 'Comment', id: string, content: string, commentableType: CommentableTypeEnum, commentableId: string, createdAt: string, updatedAt: string } };

export type DeleteOneCommentMutationVariables = Exact<{
  input: DeleteOneCommentInput;
}>;


export type DeleteOneCommentMutation = { __typename?: 'Mutation', deleteOneComment: { __typename?: 'CommentDeleteResponse', id?: string | undefined } };

export type MarkCommentsReadMutationVariables = Exact<{
  commentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkCommentsReadMutation = { __typename?: 'Mutation', markCommentsRead: boolean };

export type UpdateOneCommentMutationVariables = Exact<{
  input: UpdateOneCommentInput;
}>;


export type UpdateOneCommentMutation = { __typename?: 'Mutation', updateOneComment: { __typename?: 'Comment', id: string, content: string, commentableId: string, createdAt: string, updatedAt: string } };

export type CreateCounterReadingMutationVariables = Exact<{
  input: CreateCounterReadingInput;
}>;


export type CreateCounterReadingMutation = { __typename?: 'Mutation', createCounterReading: { __typename?: 'CounterReading', id: string, year: number, month: number, reading: number, consumption?: number | undefined, cost?: number | undefined, recordedAt: string } };

export type DeleteCounterReadingMutationVariables = Exact<{
  input: DeleteCounterReadingInput;
}>;


export type DeleteCounterReadingMutation = { __typename?: 'Mutation', deleteCounterReading: { __typename?: 'CounterReadingDeleteResponse', id: string, success: boolean, message?: string | undefined } };

export type InitializeProjectCountersMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type InitializeProjectCountersMutation = { __typename?: 'Mutation', initializeProjectCounters: Array<{ __typename?: 'Counter', id: string, type: CounterType, category: CounterCategory, name?: string | undefined, unit: string }> };

export type UpdateCounterMutationVariables = Exact<{
  input: UpdateCounterInput;
}>;


export type UpdateCounterMutation = { __typename?: 'Mutation', updateCounter: { __typename?: 'Counter', id: string, name?: string | undefined, serialNumber?: string | undefined, nextVerificationDate?: string | undefined } };

export type UpdateCounterReadingMutationVariables = Exact<{
  input: UpdateCounterReadingInput;
}>;


export type UpdateCounterReadingMutation = { __typename?: 'Mutation', updateCounterReading: { __typename?: 'CounterReading', id: string, reading: number, consumption?: number | undefined, cost?: number | undefined, recordedAt: string, note?: string | undefined } };

export type CreateEmergencyContactMutationVariables = Exact<{
  input: CreateEmergencyContactInput;
}>;


export type CreateEmergencyContactMutation = { __typename?: 'Mutation', createEmergencyContact: { __typename?: 'EmergencyContact', id: string, name: string, phoneNumber: string, category: EmergencyContactCategoryEnum, projectId: string, createdAt: string, updatedAt: string } };

export type DeleteEmergencyContactMutationVariables = Exact<{
  input: DeleteEmergencyContactInput;
}>;


export type DeleteEmergencyContactMutation = { __typename?: 'Mutation', deleteEmergencyContact: { __typename?: 'EmergencyContactDeleteResponse', id: string } };

export type UpdateEmergencyContactMutationVariables = Exact<{
  input: UpdateEmergencyContactInput;
}>;


export type UpdateEmergencyContactMutation = { __typename?: 'Mutation', updateEmergencyContact: { __typename?: 'EmergencyContact', id: string, name: string, phoneNumber: string, category: EmergencyContactCategoryEnum, projectId: string, createdAt: string, updatedAt: string } };

export type AcceptFriendRequestMutationVariables = Exact<{
  friendId: Scalars['String']['input'];
}>;


export type AcceptFriendRequestMutation = { __typename?: 'Mutation', acceptFriendRequest: { __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } } };

export type CancelOutgoingFriendRequestMutationVariables = Exact<{
  friendId: Scalars['String']['input'];
}>;


export type CancelOutgoingFriendRequestMutation = { __typename?: 'Mutation', cancelOutgoingFriendRequest: boolean };

export type ConvertSubscriberToFriendMutationVariables = Exact<{
  subscriberId: Scalars['String']['input'];
}>;


export type ConvertSubscriberToFriendMutation = { __typename?: 'Mutation', convertSubscriberToFriend: { __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } } };

export type RejectIncomingFriendRequestMutationVariables = Exact<{
  requesterId: Scalars['String']['input'];
}>;


export type RejectIncomingFriendRequestMutation = { __typename?: 'Mutation', rejectIncomingFriendRequest: boolean };

export type RemoveFriendMutationVariables = Exact<{
  friendId: Scalars['String']['input'];
}>;


export type RemoveFriendMutation = { __typename?: 'Mutation', removeFriend: { __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } } };

export type RemoveSubscriberMutationVariables = Exact<{
  friendId: Scalars['String']['input'];
}>;


export type RemoveSubscriberMutation = { __typename?: 'Mutation', removeSubscriber: boolean };

export type SendFriendRequestMutationVariables = Exact<{
  friendId: Scalars['String']['input'];
}>;


export type SendFriendRequestMutation = { __typename?: 'Mutation', sendFriendRequest: { __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } } };

export type WithdrawFriendRequestMutationVariables = Exact<{
  friendId: Scalars['String']['input'];
}>;


export type WithdrawFriendRequestMutation = { __typename?: 'Mutation', withdrawFriendRequest: boolean };

export type UpsertGlobalModuleAccessSettingsMutationVariables = Exact<{
  input: UpsertGlobalModuleAccessSettingsInput;
}>;


export type UpsertGlobalModuleAccessSettingsMutation = { __typename?: 'Mutation', upsertGlobalModuleAccessSettings: { __typename?: 'GlobalModuleAccessSettings', id: string, moduleSlug: string, dataEntryScope: ModuleAccessScopeEnum, dataEntryUserIds: Array<string>, editParticipantScope?: ModuleAccessEditScopeEnum | undefined, editUserIds: Array<string>, fullAccessUserIds: Array<string> } };

export type CreateMailThreadMutationVariables = Exact<{
  input: CreateMailThreadInput;
}>;


export type CreateMailThreadMutation = { __typename?: 'Mutation', createMailThread: { __typename?: 'MailThread', id: string, registrationNumber: string, status: MailThreadStatusEnum, creatorUserId: string, recipientUserId: string, messageCount: number, lastMessageAt: string, isRead: boolean, createdAt: string } };

export type MarkMailThreadAsReadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type MarkMailThreadAsReadMutation = { __typename?: 'Mutation', markMailThreadAsRead: boolean };

export type SendMailMessageMutationVariables = Exact<{
  input: SendMailMessageInput;
}>;


export type SendMailMessageMutation = { __typename?: 'Mutation', sendMailMessage: { __typename?: 'MailMessage', id: string, threadId: string, sequenceNumber: number, messageNumber: string, senderUserId: string, content: any, contentPreview?: string | undefined, createdAt: string } };

export type UpdateMailMessageMutationVariables = Exact<{
  input: UpdateMailMessageInput;
}>;


export type UpdateMailMessageMutation = { __typename?: 'Mutation', updateMailMessage: { __typename?: 'MailMessage', id: string, content: any, contentPreview?: string | undefined, createdAt: string } };

export type DeleteMediaMutationVariables = Exact<{
  objectType: FileObjectType;
}>;


export type DeleteMediaMutation = { __typename?: 'Mutation', deleteMedia: boolean };

export type AddNewsFavouriteMutationVariables = Exact<{
  newsId: Scalars['String']['input'];
}>;


export type AddNewsFavouriteMutation = { __typename?: 'Mutation', addNewsFavourite: boolean };

export type ApproveSpeechNewsMutationVariables = Exact<{
  newsId: Scalars['String']['input'];
}>;


export type ApproveSpeechNewsMutation = { __typename?: 'Mutation', approveSpeechNews: { __typename?: 'News', id: string, status: NewsStatusEnum, moduleSlug: string, rejectionReason?: string | undefined, updatedAt: string } };

export type CreateOneNewsMutationVariables = Exact<{
  input: CreateOneNewsInput;
}>;


export type CreateOneNewsMutation = { __typename?: 'Mutation', createOneNews: { __typename?: 'News', id: string, title: string, content?: any | undefined, ownerId: string, ownerType: NewsOwnerTypeEnum, status: NewsStatusEnum, authorFullname?: string | undefined, handwrittenFullname?: string | undefined, additionalInfo?: string | undefined, sourceLink?: string | undefined, createdAt: string, updatedAt: string, tags: { __typename?: 'NewsTagsConnection', nodes: Array<{ __typename?: 'TagDto', id: string, name: string }> } } };

export type DeleteOneNewsMutationVariables = Exact<{
  input: DeleteOneNewsInput;
}>;


export type DeleteOneNewsMutation = { __typename?: 'Mutation', deleteOneNews: { __typename?: 'NewsDeleteResponse', id?: string | undefined } };

export type MarkNewsAsViewedMutationVariables = Exact<{
  newsId: Scalars['String']['input'];
}>;


export type MarkNewsAsViewedMutation = { __typename?: 'Mutation', markNewsAsViewed: { __typename?: 'CounterEventNatsResponseDTO', message: string } };

export type MarkNewsSeenMutationVariables = Exact<{
  newsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkNewsSeenMutation = { __typename?: 'Mutation', markNewsSeen: boolean };

export type RejectSpeechNewsMutationVariables = Exact<{
  newsId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectSpeechNewsMutation = { __typename?: 'Mutation', rejectSpeechNews: { __typename?: 'News', id: string, status: NewsStatusEnum, moduleSlug: string, rejectionReason?: string | undefined, updatedAt: string } };

export type RemoveNewsFavouriteMutationVariables = Exact<{
  newsId: Scalars['String']['input'];
}>;


export type RemoveNewsFavouriteMutation = { __typename?: 'Mutation', removeNewsFavourite: boolean };

export type ReorderSpeechNewsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  moduleSlug: Scalars['String']['input'];
  orderedNewsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderSpeechNewsMutation = { __typename?: 'Mutation', reorderSpeechNews: Array<{ __typename?: 'News', id: string, title: string, moduleSlug: string, updatedAt: string }> };

export type UpdateOneNewsMutationVariables = Exact<{
  input: UpdateOneNewsInput;
}>;


export type UpdateOneNewsMutation = { __typename?: 'Mutation', updateOneNews: { __typename?: 'News', id: string, title: string, content?: any | undefined, mainImage?: string | undefined, customPhotos?: Array<string> | undefined, customVideos?: Array<string> | undefined, ownerId: string, ownerType: NewsOwnerTypeEnum, status: NewsStatusEnum, authorFullname?: string | undefined, handwrittenFullname?: string | undefined, additionalInfo?: string | undefined, sourceLink?: string | undefined, moduleSlug: string, createdAt: string, updatedAt: string, tags: { __typename?: 'NewsTagsConnection', nodes: Array<{ __typename?: 'TagDto', id: string, name: string }> } } };

export type MarkNotificationActionAppliedMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkNotificationActionAppliedMutation = { __typename?: 'Mutation', markNotificationActionApplied: boolean };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: boolean };

export type RegisterUserTokenMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  token: Scalars['String']['input'];
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterUserTokenMutation = { __typename?: 'Mutation', registerUserToken: boolean };

export type ApproveObjectPassportApplicationMutationVariables = Exact<{
  input: ApproveObjectPassportApplicationInput;
}>;


export type ApproveObjectPassportApplicationMutation = { __typename?: 'Mutation', approveObjectPassportApplication: { __typename?: 'ObjectPassportApplication', id: string, fullName: string, phone?: string | undefined, position?: string | undefined, additionalInfo?: string | undefined, applicationText?: string | undefined, participationFormat?: ObjectPassportParticipationFormatEnum | undefined, status: ObjectPassportApplicationStatusEnum, passportId: string, projectId: string, moduleSlug: string, createdAt: string, updatedAt: string, moderatedAt?: string | undefined, moderatorComment?: string | undefined, applicantUserId?: string | undefined } };

export type CreateObjectPassportApplicationMutationVariables = Exact<{
  input: CreateObjectPassportApplicationInput;
}>;


export type CreateObjectPassportApplicationMutation = { __typename?: 'Mutation', createObjectPassportApplication: { __typename?: 'ObjectPassportApplication', id: string, fullName: string, phone?: string | undefined, position?: string | undefined, additionalInfo?: string | undefined, applicationText?: string | undefined, participationFormat?: ObjectPassportParticipationFormatEnum | undefined, status: ObjectPassportApplicationStatusEnum, passportId: string, projectId: string, moduleSlug: string, createdAt: string, updatedAt: string, moderatedAt?: string | undefined, moderatorComment?: string | undefined, applicantUserId?: string | undefined } };

export type RejectObjectPassportApplicationMutationVariables = Exact<{
  input: RejectObjectPassportApplicationInput;
}>;


export type RejectObjectPassportApplicationMutation = { __typename?: 'Mutation', rejectObjectPassportApplication: { __typename?: 'ObjectPassportApplication', id: string, fullName: string, phone?: string | undefined, position?: string | undefined, additionalInfo?: string | undefined, applicationText?: string | undefined, participationFormat?: ObjectPassportParticipationFormatEnum | undefined, status: ObjectPassportApplicationStatusEnum, passportId: string, projectId: string, moduleSlug: string, createdAt: string, updatedAt: string, moderatedAt?: string | undefined, moderatorComment?: string | undefined, applicantUserId?: string | undefined } };

export type UpsertObjectPassportMutationVariables = Exact<{
  input: UpsertObjectPassportInput;
}>;


export type UpsertObjectPassportMutation = { __typename?: 'Mutation', upsertObjectPassport: { __typename?: 'ObjectPassport', id: string, name: string, description?: string | undefined, eventType?: string | undefined, contactPersonName?: string | undefined, contactPersonUserId?: string | undefined, contactPhone?: string | undefined, startAt?: string | undefined, endAt?: string | undefined, expectedHeadcount?: number | undefined, location?: string | undefined, moduleSlug: string, moduleProgramRelated?: string | undefined, moduleReglamentRelated?: string | undefined, projectId: string, timezone?: string | undefined, createdAt: string, updatedAt: string, attachments: Array<{ __typename?: 'ObjectPassportAttachment', id: string, fileKey: string, fileName: string, fileSize?: number | undefined, kind: ObjectPassportFileKindEnum, mimeType?: string | undefined, url?: string | undefined, passportId: string, createdAt: string }> } };

export type DeleteProgramItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProgramItemMutation = { __typename?: 'Mutation', deleteProgramItem: boolean };

export type SaveProgramItemsMutationVariables = Exact<{
  input: SaveProgramItemsInput;
}>;


export type SaveProgramItemsMutation = { __typename?: 'Mutation', saveProgramItems: Array<{ __typename?: 'ProgramItem', id: string, projectId: string, moduleSlug: string, name: string, contactPersonName?: string | undefined, contactPersonUserId?: string | undefined, startAt?: string | undefined, endAt?: string | undefined, timezone?: string | undefined, location?: string | undefined, sortOrder: number, createdByUserId: string, updatedByUserId?: string | undefined, createdAt: string, updatedAt: string, attachments: Array<{ __typename?: 'ProgramItemAttachment', id: string, programItemId: string, kind: ProgramFileKindEnum, fileName: string, mimeType?: string | undefined, fileSize?: number | undefined, fileKey: string, url?: string | undefined, uploadedByUserId: string, createdAt: string }> }> };

export type CreateOneProjectModuleMemberMutationVariables = Exact<{
  input: CreateOneProjectModuleMemberInput;
}>;


export type CreateOneProjectModuleMemberMutation = { __typename?: 'Mutation', createOneProjectModuleMember: { __typename?: 'ProjectModuleMember', id: string } };

export type DeleteOneProjectModuleMemberMutationVariables = Exact<{
  input: DeleteOneProjectModuleMemberInput;
}>;


export type DeleteOneProjectModuleMemberMutation = { __typename?: 'Mutation', deleteOneProjectModuleMember?: { __typename?: 'ProjectModuleMemberDeleteResponse', id?: string | undefined } | undefined };

export type UpsertProjectModuleAccessSettingsMutationVariables = Exact<{
  input: UpsertProjectModuleAccessSettingsInput;
}>;


export type UpsertProjectModuleAccessSettingsMutation = { __typename?: 'Mutation', upsertProjectModuleAccessSettings: { __typename?: 'ProjectModuleAccessSettings', id: string, projectId: string, moduleSlug: string } };

export type AcceptInvitationMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'ProjectMember', id: string } };

export type ApproveJoinRequestMutationVariables = Exact<{
  input: ApproveJoinRequestInput;
}>;


export type ApproveJoinRequestMutation = { __typename?: 'Mutation', approveJoinRequest: { __typename?: 'ProjectJoinRequest', id: string } };

export type ApproveProjectRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApproveProjectRequestMutation = { __typename?: 'Mutation', approveProjectRequest: { __typename?: 'Project', id: string, slug?: string | undefined, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, templateType: ProjectTemplateEnum, visibility: ProjectVisibilityEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, ownerUserId?: string | undefined, projectRequestId?: string | undefined, createdAt: string, updatedAt: string, owner: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> } } };

export type CreateDirectInvitationMutationVariables = Exact<{
  input: CreateDirectInvitationInput;
}>;


export type CreateDirectInvitationMutation = { __typename?: 'Mutation', createDirectInvitation: { __typename?: 'ProjectInvitation', id: string } };

export type CreateJoinRequestMutationVariables = Exact<{
  input: CreateJoinRequestInput;
}>;


export type CreateJoinRequestMutation = { __typename?: 'Mutation', createJoinRequest: { __typename?: 'ProjectJoinRequest', id: string } };

export type CreateMyProjectRequestMutationVariables = Exact<{
  input: CreateProjectRequestDto;
}>;


export type CreateMyProjectRequestMutation = { __typename?: 'Mutation', createMyProjectRequest: { __typename?: 'ProjectRequest', id: string, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, visibility: ProjectVisibilityEnum, userId: string, status: ProjectRequestStatusEnum, projectId?: string | undefined, templateType: ProjectTemplateEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, createdAt: string, updatedAt: string, rejections?: Array<{ __typename?: 'ProjectRequestRejection', projectRequestId: string, reason: string, rejectedByUserId: string }> | undefined, media?: { __typename?: 'ProjectMedia', logo?: string | undefined, image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, TABLET?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, MOBILE?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined } | undefined } | undefined } };

export type CreateOneProjectMutationVariables = Exact<{
  input: CreateOneProjectInput;
}>;


export type CreateOneProjectMutation = { __typename?: 'Mutation', createOneProject: { __typename?: 'Project', id: string, slug?: string | undefined, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, templateType: ProjectTemplateEnum, visibility: ProjectVisibilityEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, ownerUserId?: string | undefined, projectRequestId?: string | undefined, createdAt: string, updatedAt: string, owner: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> } } };

export type CreateOneProjectMemberMutationVariables = Exact<{
  input: CreateOneProjectMemberInput;
}>;


export type CreateOneProjectMemberMutation = { __typename?: 'Mutation', createOneProjectMember: { __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined } };

export type CreateOneProjectSupporterMutationVariables = Exact<{
  input: CreateOneProjectSupporterInput;
}>;


export type CreateOneProjectSupporterMutation = { __typename?: 'Mutation', createOneProjectSupporter: { __typename?: 'ProjectSupporter', id: string, firstName?: string | undefined, lastName?: string | undefined, middleName?: string | undefined, gender?: SupporterGender | undefined, birthday?: string | undefined, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, postalCode?: string | undefined, addressComment?: string | undefined, isManual?: boolean | undefined, comment?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, projectId: string, companyName?: string | undefined, companyPosition?: string | undefined, companyPhone?: string | undefined, companyEmail?: string | undefined, companyRegion?: string | undefined, companyCity?: string | undefined, companyCityDistrict?: string | undefined, companySettlement?: string | undefined, companyStreet?: string | undefined, companyFlat?: string | undefined, companyEntrance?: string | undefined, companyFloor?: string | undefined, companyDoorphone?: string | undefined, companyAddressComment?: string | undefined, companyPostalCode?: string | undefined, companyIsManual?: boolean | undefined, holidayName?: string | undefined, holidayDate?: string | undefined, createdAt: string, updatedAt: string } };

export type CreateProjectCustomModuleMutationVariables = Exact<{
  input: CreateProjectCustomModuleInput;
}>;


export type CreateProjectCustomModuleMutation = { __typename?: 'Mutation', createProjectCustomModule: { __typename?: 'ProjectCustomModule', id: string, moduleSlug: string, name: string, baseModuleType: CustomModuleBaseTypeEnum, format: CustomModuleFormatEnum, iconColor?: string | undefined, backgroundColor?: string | undefined, icon?: string | undefined } };

export type DeclineInvitationMutationVariables = Exact<{
  input: DeclineInvitationInput;
}>;


export type DeclineInvitationMutation = { __typename?: 'Mutation', declineInvitation: boolean };

export type DeleteOneProjectMutationVariables = Exact<{
  input: DeleteOneProjectInput;
}>;


export type DeleteOneProjectMutation = { __typename?: 'Mutation', deleteOneProject: { __typename?: 'ProjectDeleteResponse', id?: string | undefined } };

export type DeleteOneProjectMemberMutationVariables = Exact<{
  input: DeleteOneProjectMemberInput;
}>;


export type DeleteOneProjectMemberMutation = { __typename?: 'Mutation', deleteOneProjectMember?: { __typename?: 'ProjectMemberDeleteResponse', id?: string | undefined, projectId?: string | undefined, userId?: string | undefined, role?: ProjectMemberRoleEnum | undefined, createdAt?: string | undefined, updatedAt?: string | undefined } | undefined };

export type DeleteOneProjectSupporterMutationVariables = Exact<{
  input: DeleteOneProjectSupporterInput;
}>;


export type DeleteOneProjectSupporterMutation = { __typename?: 'Mutation', deleteOneProjectSupporter?: { __typename?: 'SupporterDeleteResponse', id?: string | undefined } | undefined };

export type DeleteProjectCustomModuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectCustomModuleMutation = { __typename?: 'Mutation', deleteProjectCustomModule: { __typename?: 'ProjectCustomModule', id: string, moduleSlug: string, name: string } };

export type DeleteProjectRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProjectRequestMutation = { __typename?: 'Mutation', deleteProjectRequest: boolean };

export type JoinOpenProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type JoinOpenProjectMutation = { __typename?: 'Mutation', joinOpenProject: { __typename?: 'ProjectMember', id: string } };

export type RejectJoinRequestMutationVariables = Exact<{
  input: RejectJoinRequestInput;
}>;


export type RejectJoinRequestMutation = { __typename?: 'Mutation', rejectJoinRequest: { __typename?: 'ProjectJoinRequest', id: string } };

export type RejectProjectRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type RejectProjectRequestMutation = { __typename?: 'Mutation', rejectProjectRequest: { __typename?: 'ProjectRequest', id: string, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, visibility: ProjectVisibilityEnum, userId: string, status: ProjectRequestStatusEnum, projectId?: string | undefined, templateType: ProjectTemplateEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, createdAt: string, updatedAt: string, rejections?: Array<{ __typename?: 'ProjectRequestRejection', projectRequestId: string, reason: string, rejectedByUserId: string }> | undefined, media?: { __typename?: 'ProjectMedia', logo?: string | undefined, image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, TABLET?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, MOBILE?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined } | undefined } | undefined } };

export type ToggleLikeMutationVariables = Exact<{
  input: ToggleLikeInput;
}>;


export type ToggleLikeMutation = { __typename?: 'Mutation', toggleLike: { __typename?: 'LikeOutput', isLiked: boolean, likeCount: number } };

export type UpdateMyProjectRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateProjectRequestDto;
}>;


export type UpdateMyProjectRequestMutation = { __typename?: 'Mutation', updateMyProjectRequest: { __typename?: 'ProjectRequest', id: string, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, visibility: ProjectVisibilityEnum, userId: string, status: ProjectRequestStatusEnum, projectId?: string | undefined, templateType: ProjectTemplateEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, createdAt: string, updatedAt: string, rejections?: Array<{ __typename?: 'ProjectRequestRejection', projectRequestId: string, reason: string, rejectedByUserId: string }> | undefined, media?: { __typename?: 'ProjectMedia', logo?: string | undefined, image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, TABLET?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, MOBILE?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined } | undefined } | undefined } };

export type UpdateOneProjectMutationVariables = Exact<{
  input: UpdateOneProjectInput;
}>;


export type UpdateOneProjectMutation = { __typename?: 'Mutation', updateOneProject: { __typename?: 'Project', id: string, slug?: string | undefined, headerButtons?: any | undefined, hamburgerButtons?: any | undefined } };

export type UpdateOneProjectMemberMutationVariables = Exact<{
  input: UpdateOneProjectMemberInput;
}>;


export type UpdateOneProjectMemberMutation = { __typename?: 'Mutation', updateOneProjectMember: { __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined } };

export type UpdateOneProjectSupporterMutationVariables = Exact<{
  input: UpdateOneProjectSupporterInput;
}>;


export type UpdateOneProjectSupporterMutation = { __typename?: 'Mutation', updateOneProjectSupporter: { __typename?: 'ProjectSupporter', firstName?: string | undefined, lastName?: string | undefined, middleName?: string | undefined, gender?: SupporterGender | undefined, birthday?: string | undefined, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, postalCode?: string | undefined, addressComment?: string | undefined, isManual?: boolean | undefined, comment?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, projectId: string, companyName?: string | undefined, companyPosition?: string | undefined, companyPhone?: string | undefined, companyEmail?: string | undefined, companyRegion?: string | undefined, companyCity?: string | undefined, companyCityDistrict?: string | undefined, companySettlement?: string | undefined, companyStreet?: string | undefined, companyFlat?: string | undefined, companyEntrance?: string | undefined, companyFloor?: string | undefined, companyDoorphone?: string | undefined, companyAddressComment?: string | undefined, companyPostalCode?: string | undefined, companyIsManual?: boolean | undefined, holidayName?: string | undefined, holidayDate?: string | undefined, createdAt: string, updatedAt: string } };

export type UpdateProjectCustomModuleMutationVariables = Exact<{
  input: UpdateProjectCustomModuleInput;
}>;


export type UpdateProjectCustomModuleMutation = { __typename?: 'Mutation', updateProjectCustomModule: { __typename?: 'ProjectCustomModule', id: string, name: string, iconColor?: string | undefined, backgroundColor?: string | undefined, format: CustomModuleFormatEnum, icon?: string | undefined } };

export type DeleteReglamentItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReglamentItemMutation = { __typename?: 'Mutation', deleteReglamentItem: boolean };

export type SaveReglamentItemsMutationVariables = Exact<{
  input: SaveReglamentItemsInput;
}>;


export type SaveReglamentItemsMutation = { __typename?: 'Mutation', saveReglamentItems: Array<{ __typename?: 'ReglamentItem', id: string, projectId: string, moduleSlug: string, speakerName: string, reportTopic?: string | undefined, startAt?: string | undefined, endAt?: string | undefined, questionsStartAt?: string | undefined, questionsEndAt?: string | undefined, timezone?: string | undefined, sortOrder: number, createdByUserId: string, updatedByUserId?: string | undefined, createdAt: string, updatedAt: string }> };

export type CreateAdminTemplateMutationVariables = Exact<{
  input: CreateTemplateInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAdminTemplateMutation = { __typename?: 'Mutation', createAdminTemplate: { __typename?: 'Template', id: string, name: string, label: string, text: string, isGlobal: boolean, userId?: string | undefined, projectId?: string | undefined, createdBy?: string | undefined, updatedBy?: string | undefined, createdAt: string, updatedAt: string } };

export type CreateMockupMutationVariables = Exact<{
  input: CreateMockupInput;
}>;


export type CreateMockupMutation = { __typename?: 'Mutation', createMockup: { __typename?: 'CreateMockupResponse', id: string, uploadUrl: string } };

export type CreateUserTemplateMutationVariables = Exact<{
  input: CreateTemplateInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUserTemplateMutation = { __typename?: 'Mutation', createUserTemplate: { __typename?: 'Template', id: string, name: string, label: string, text: string, isGlobal: boolean, userId?: string | undefined, projectId?: string | undefined, createdBy?: string | undefined, updatedBy?: string | undefined, createdAt: string, updatedAt: string } };

export type DeleteMockupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMockupMutation = { __typename?: 'Mutation', deleteMockup: boolean };

export type DeleteSystemMockupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSystemMockupMutation = { __typename?: 'Mutation', deleteSystemMockup: boolean };

export type DeleteUserTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteUserTemplateMutation = { __typename?: 'Mutation', deleteUserTemplate: boolean };

export type ExportSupporterReportMutationVariables = Exact<{
  input: ExportSupporterReportInput;
}>;


export type ExportSupporterReportMutation = { __typename?: 'Mutation', exportSupporterReport: { __typename?: 'ExportSupporterReportResult', url: string, filename: string } };

export type GeneratePlatformSummaryReportMutationVariables = Exact<{
  filters?: InputMaybe<AnalyticsFiltersInput>;
}>;


export type GeneratePlatformSummaryReportMutation = { __typename?: 'Mutation', generatePlatformSummaryReport: { __typename?: 'PlatformSummaryReportEntity', id: string, totalRegisteredUsers: number, totalProjects: number, totalProjectOwners: number, totalProjectParticipants: number, averageSessionDuration?: number | undefined, activeUsersCount: number, totalFriendships: number, periodStart: string, periodEnd: string, reportDate: string, createdAt: string, updatedAt: string } };

export type SendProjectSupportersNotificationMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  type: NotificationDeliveryType;
  template?: InputMaybe<NotificationTemplate>;
  content?: InputMaybe<NotificationContentDto>;
  templateParams?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendProjectSupportersNotificationMutation = { __typename?: 'Mutation', sendProjectSupportersNotification: boolean };

export type SendSupporterNotificationMutationVariables = Exact<{
  supporterIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  type: NotificationDeliveryType;
  template?: InputMaybe<NotificationTemplate>;
  content?: InputMaybe<NotificationContentDto>;
  templateParams?: InputMaybe<Scalars['String']['input']>;
  apiKeyType?: InputMaybe<SmscApiKeyType>;
}>;


export type SendSupporterNotificationMutation = { __typename?: 'Mutation', sendSupporterNotification: boolean };

export type UpdateMockupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateMockupInput;
}>;


export type UpdateMockupMutation = { __typename?: 'Mutation', updateMockup: { __typename?: 'Mockup', id: string, presignedUrl?: string | undefined } };

export type UpdateUserTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
  input: UpdateTemplateInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserTemplateMutation = { __typename?: 'Mutation', updateUserTemplate?: { __typename?: 'Template', id: string } | undefined };

export type ApplyMergeChangesMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type ApplyMergeChangesMutation = { __typename?: 'Mutation', applyMergeChanges: boolean };

export type CreateMergeRequestMutationVariables = Exact<{
  input: CreateMergeRequestDto;
}>;


export type CreateMergeRequestMutation = { __typename?: 'Mutation', createMergeRequest: { __typename?: 'MergeSessionDTO', id: string } };

export type CreateOneProjectOrganizationMutationVariables = Exact<{
  input: CreateOneProjectOrganizationInput;
}>;


export type CreateOneProjectOrganizationMutation = { __typename?: 'Mutation', createOneProjectOrganization: { __typename?: 'ProjectOrganization', id: string } };

export type DeleteOneProjectOrganizationMutationVariables = Exact<{
  input: DeleteOneProjectOrganizationInput;
}>;


export type DeleteOneProjectOrganizationMutation = { __typename?: 'Mutation', deleteOneProjectOrganization: { __typename?: 'ProjectOrganizationDeleteResponse', id?: string | undefined } };

export type DeleteRegistryContactsMutationVariables = Exact<{
  input: DeleteRegistryContactsInput;
}>;


export type DeleteRegistryContactsMutation = { __typename?: 'Mutation', deleteRegistryContacts: { __typename?: 'DeleteRegistryContactsResult', deleted: Array<{ __typename?: 'DeletedContactResult', id: string, contactType: RegistryContactTypeEnum }>, failed: Array<{ __typename?: 'FailedContactDeletion', id: string, contactType: RegistryContactTypeEnum }> } };

export type ImportFromCsvMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  csvContent: Scalars['String']['input'];
}>;


export type ImportFromCsvMutation = { __typename?: 'Mutation', importFromCsv: { __typename?: 'ImportResultDto', totalRecords: number, successfulPersons: number, successfulOrganizations: number } };

export type RespondToMergeRequestMutationVariables = Exact<{
  input: RespondMergeRequestDto;
}>;


export type RespondToMergeRequestMutation = { __typename?: 'Mutation', respondToMergeRequest: { __typename?: 'MergeSessionDTO', id: string } };

export type UpdateOneProjectOrganizationMutationVariables = Exact<{
  input: UpdateOneProjectOrganizationInput;
}>;


export type UpdateOneProjectOrganizationMutation = { __typename?: 'Mutation', updateOneProjectOrganization: { __typename?: 'ProjectOrganization', id: string } };

export type WithdrawMergeRequestMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type WithdrawMergeRequestMutation = { __typename?: 'Mutation', withdrawMergeRequest: { __typename?: 'MergeSessionDTO', id: string } };

export type CloseSurveyMutationVariables = Exact<{
  surveyId: Scalars['String']['input'];
}>;


export type CloseSurveyMutation = { __typename?: 'Mutation', closeSurvey: { __typename?: 'SurveyDto', id: string } };

export type CreateAnswersSurveyMutationVariables = Exact<{
  input: AnswerSurveyDto;
}>;


export type CreateAnswersSurveyMutation = { __typename?: 'Mutation', answerSurvey: { __typename?: 'ResponseDto', id: string } };

export type CreateInviteMutationVariables = Exact<{
  input: CreateInviteDto;
}>;


export type CreateInviteMutation = { __typename?: 'Mutation', createInvite: { __typename?: 'InviteDto', id: string } };

export type CreateOneAnswerMutationVariables = Exact<{
  input: CreateOneAnswerInput;
}>;


export type CreateOneAnswerMutation = { __typename?: 'Mutation', createOneAnswer: { __typename?: 'Answer', id: string } };

export type CreateOneQuestionDtoMutationVariables = Exact<{
  input: CreateOneQuestionDtoInput;
}>;


export type CreateOneQuestionDtoMutation = { __typename?: 'Mutation', createOneQuestionDto: { __typename?: 'QuestionDto', id: string } };

export type CreateOneQuestionFieldDtoMutationVariables = Exact<{
  input: CreateOneQuestionFieldDtoInput;
}>;


export type CreateOneQuestionFieldDtoMutation = { __typename?: 'Mutation', createOneQuestionFieldDto: { __typename?: 'QuestionFieldDto', id: string } };

export type CreateOneSurveyDtoMutationVariables = Exact<{
  input: CreateOneSurveyDtoInput;
}>;


export type CreateOneSurveyDtoMutation = { __typename?: 'Mutation', createOneSurveyDto: { __typename?: 'SurveyDto', id: string } };

export type CreateSurveyFullMutationVariables = Exact<{
  input: CreateSurveyFullDto;
}>;


export type CreateSurveyFullMutation = { __typename?: 'Mutation', createSurveyFull: { __typename?: 'SurveyDto', id: string } };

export type DeleteOneQuestionDtoMutationVariables = Exact<{
  input: DeleteOneQuestionDtoInput;
}>;


export type DeleteOneQuestionDtoMutation = { __typename?: 'Mutation', deleteOneQuestionDto: { __typename?: 'QuestionDtoDeleteResponse', id?: string | undefined } };

export type DeleteOneSurveyDtoMutationVariables = Exact<{
  input: DeleteOneSurveyDtoInput;
}>;


export type DeleteOneSurveyDtoMutation = { __typename?: 'Mutation', deleteOneSurveyDto: { __typename?: 'SurveyDtoDeleteResponse', id?: string | undefined } };

export type ExportSurveyReportMutationVariables = Exact<{
  input: ExportSurveyReportInput;
}>;


export type ExportSurveyReportMutation = { __typename?: 'Mutation', exportSurveyReport: { __typename?: 'ExportSurveyReportResult', filename: string, mimeType: string, base64: string } };

export type InviteUserToSurveyMutationVariables = Exact<{
  surveyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type InviteUserToSurveyMutation = { __typename?: 'Mutation', inviteUserToSurvey: { __typename?: 'InviteDto', id: string } };

export type PublishSurveyMutationVariables = Exact<{
  input: PublishSurveyDto;
}>;


export type PublishSurveyMutation = { __typename?: 'Mutation', publishSurvey: { __typename?: 'SurveyDto', id: string } };

export type SetSurveyVisibilityMutationVariables = Exact<{
  surveyId: Scalars['String']['input'];
  visibleToProjectAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  visibleToProjectMembers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetSurveyVisibilityMutation = { __typename?: 'Mutation', setSurveyVisibility: { __typename?: 'SurveyDto', id: string } };

export type ToggleSurveyPublicLinkMutationVariables = Exact<{
  surveyId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleSurveyPublicLinkMutation = { __typename?: 'Mutation', toggleSurveyPublicLink: { __typename?: 'SurveyDto', id: string } };

export type UpdateOneQuestionDtoMutationVariables = Exact<{
  input: UpdateOneQuestionDtoInput;
}>;


export type UpdateOneQuestionDtoMutation = { __typename?: 'Mutation', updateOneQuestionDto: { __typename?: 'QuestionDto', id: string } };

export type UpdateOneSurveyDtoMutationVariables = Exact<{
  input: UpdateOneSurveyDtoInput;
}>;


export type UpdateOneSurveyDtoMutation = { __typename?: 'Mutation', updateOneSurveyDto: { __typename?: 'SurveyDto', id: string } };

export type UpdateQuestionFullMutationVariables = Exact<{
  input: UpdateQuestionFullDto;
}>;


export type UpdateQuestionFullMutation = { __typename?: 'Mutation', updateQuestionFull: { __typename?: 'QuestionDto', id: string } };

export type CreateOneLandingTemplateMutationVariables = Exact<{
  input: CreateOneLandingTemplateInput;
}>;


export type CreateOneLandingTemplateMutation = { __typename?: 'Mutation', createOneLandingTemplate: { __typename?: 'LandingTemplate', id: string, name: string, description?: string | undefined, content: any, isPublic: boolean, createdBy: string, updatedBy: string, createdAt: string, updatedAt: string, deletedAt?: string | undefined } };

export type GetLandingImageUploadUrlMutationVariables = Exact<{
  input: LandingImageUploadInput;
}>;


export type GetLandingImageUploadUrlMutation = { __typename?: 'Mutation', getLandingImageUploadUrl: { __typename?: 'LandingImageUploadResponse', uploadUrl: string, publicUrl: string, imagePath: string } };

export type UpdateOneLandingTemplateMutationVariables = Exact<{
  input: UpdateOneLandingTemplateInput;
}>;


export type UpdateOneLandingTemplateMutation = { __typename?: 'Mutation', updateOneLandingTemplate: { __typename?: 'LandingTemplate', id: string, name: string, description?: string | undefined, content: any, isPublic: boolean, createdBy: string, updatedBy: string, createdAt: string, updatedAt: string, deletedAt?: string | undefined } };

export type DeleteUserAddressMutationVariables = Exact<{
  addressId: Scalars['Float']['input'];
}>;


export type DeleteUserAddressMutation = { __typename?: 'Mutation', deleteUserAddress: boolean };

export type ResetPasswordMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: string };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } };

export type UpdateUserOnlineStatusMutationVariables = Exact<{
  input: UpdateUserOnlineStatusInput;
}>;


export type UpdateUserOnlineStatusMutation = { __typename?: 'Mutation', updateUserOnlineStatus: { __typename?: 'User', id: string } };

export type LoginCodeStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginCodeStatusQuery = { __typename?: 'Query', loginCodeStatus: boolean };

export type CalendarEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CalendarEventQuery = { __typename?: 'Query', calendarEvent: { __typename?: 'CalendarEvent', id: string, completed: boolean, title: string, description?: string | undefined, priority: CalendarEventPriorityEnum, location?: string | undefined, startAt: string, endAt: string, isAllDay: boolean, timezone?: string | undefined, ownerUserId: string, projectId?: string | undefined, createdAt: string, updatedAt: string, recurrenceGroupId?: string | undefined, recurrenceFrequency?: CalendarEventRecurrenceFrequencyEnum | undefined, recurrenceInterval?: number | undefined, recurrenceUntil?: string | undefined, isRecurrenceMaster: boolean, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, userId: string, status: CalendarEventParticipantStatusEnum, createdAt: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, PROFILE?: string | undefined } | undefined } | undefined } | undefined } }>, attachments: Array<{ __typename?: 'CalendarEventAttachment', id: string, fileName: string, mimeType?: string | undefined, fileSize?: number | undefined, fileKey: string, url?: string | undefined }>, reminders: Array<{ __typename?: 'CalendarEventReminder', id: string, remindAt: string, method: CalendarEventReminderMethodEnum, status: CalendarEventReminderStatusEnum }>, comments?: { __typename?: 'CommentCountOutput', commentCount: number, unreadCount?: number | undefined } | undefined } };

export type CalendarEventDayCountsQueryVariables = Exact<{
  filter: CalendarEventDayCountFilterInput;
}>;


export type CalendarEventDayCountsQuery = { __typename?: 'Query', calendarEventDayCounts: Array<{ __typename?: 'CalendarEventDayCount', date: string, count: number, hasImportant: boolean, hasVeryImportant: boolean }> };

export type CalendarEventUsersQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CalendarEventUsersQuery = { __typename?: 'Query', calendarEventUsers: { __typename?: 'CalendarEventUsersResult', availableUsers: Array<{ __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined, PROFILE?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }> } };

export type CalendarEventsQueryVariables = Exact<{
  filter: CalendarEventListFilterInput;
}>;


export type CalendarEventsQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventList', total: number, page: number, limit: number, hasMore: boolean, items: Array<{ __typename?: 'CalendarEvent', id: string, completed: boolean, title: string, description?: string | undefined, priority: CalendarEventPriorityEnum, location?: string | undefined, startAt: string, endAt: string, isAllDay: boolean, timezone?: string | undefined, ownerUserId: string, projectId?: string | undefined, createdAt: string, updatedAt: string, recurrenceGroupId?: string | undefined, recurrenceFrequency?: CalendarEventRecurrenceFrequencyEnum | undefined, recurrenceInterval?: number | undefined, recurrenceUntil?: string | undefined, isRecurrenceMaster: boolean, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, userId: string, status: CalendarEventParticipantStatusEnum, createdAt: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, PROFILE?: string | undefined } | undefined } | undefined } | undefined } }>, attachments: Array<{ __typename?: 'CalendarEventAttachment', id: string, fileName: string, mimeType?: string | undefined, fileSize?: number | undefined, fileKey: string, url?: string | undefined }>, reminders: Array<{ __typename?: 'CalendarEventReminder', id: string, remindAt: string, method: CalendarEventReminderMethodEnum, status: CalendarEventReminderStatusEnum }>, comments?: { __typename?: 'CommentCountOutput', commentCount: number, unreadCount?: number | undefined } | undefined }> } };

export type GetMsProjectCalendarEventPermissionsQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMsProjectCalendarEventPermissionsQuery = { __typename?: 'Query', getMsProjectCalendarEventPermissions: Array<string> };

export type CommentsQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: CommentFilter;
  sorting?: Array<CommentSort> | CommentSort;
}>;


export type CommentsQuery = { __typename?: 'Query', comments: { __typename?: 'CommentConnection', totalCount: number, nodes: Array<{ __typename?: 'Comment', id: string, content: string, createdByUserId: string, updatedByUserId?: string | undefined, commentableId: string, commentableType: CommentableTypeEnum, parentId?: string | undefined, createdAt: string, updatedAt: string, deletedAt?: string | undefined, creator?: { __typename?: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined } | undefined, likes?: { __typename?: 'LikeOutput', isLiked: boolean, likeCount: number } | undefined }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | undefined, hasPreviousPage?: boolean | undefined } } };

export type CounterHistoryQueryVariables = Exact<{
  counterId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type CounterHistoryQuery = { __typename?: 'Query', counterHistory: { __typename?: 'CounterHistory', counterId: string, type: CounterType, name: string, unit: string, year: number, monthlyData: Array<{ __typename?: 'CounterMonthlyData', year: number, month: number, monthName: string, recordedAt?: string | undefined, reading?: number | undefined, consumption?: number | undefined, cost?: number | undefined, hasDelta: boolean, canEnter: boolean }>, chartData: Array<{ __typename?: 'CounterChartDataPoint', period: number, values: Array<number> }>, chartLegend: Array<{ __typename?: 'CounterChartLegendItem', label: string, value: string, color: string }> } };

export type CounterReadingsQueryVariables = Exact<{
  filter?: InputMaybe<CounterReadingFilter>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type CounterReadingsQuery = { __typename?: 'Query', counterReadings: { __typename?: 'CounterReadingConnection', nodes: Array<{ __typename?: 'CounterReading', id: string, counterId: string, year: number, month: number, reading: number, cost?: number | undefined }> } };

export type CountersByCategoryQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  category: CounterCategory;
}>;


export type CountersByCategoryQuery = { __typename?: 'Query', countersByCategory: Array<{ __typename?: 'Counter', id: string, type: CounterType, name?: string | undefined, unit: string }> };

export type ProjectCountersSummaryQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectCountersSummaryQuery = { __typename?: 'Query', projectCountersSummary: { __typename?: 'ProjectCountersSummary', projectId: string, categories: Array<{ __typename?: 'CounterCategorySummary', category: CounterCategory, name: string, icon: string, iconColor: string, currentMonthCost: number, yearlyCost: number, counters: Array<{ __typename?: 'CounterSummary', id: string, type: CounterType, category: CounterCategory, name: string, unit: string, lastReading?: number | undefined, currentConsumption?: number | undefined, currentCost?: number | undefined, yearlyConsumption?: number | undefined, yearlyCost?: number | undefined }> }>, chartData: Array<{ __typename?: 'CounterChartDataPoint', period: number, values: Array<number> }>, chartLegend: Array<{ __typename?: 'CounterChartLegendItem', label: string, value: string, color: string }> } };

export type EmergencyContactsQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: EmergencyContactFilter;
  sorting?: Array<EmergencyContactSort> | EmergencyContactSort;
}>;


export type EmergencyContactsQuery = { __typename?: 'Query', emergencyContacts: { __typename?: 'EmergencyContactConnection', totalCount: number, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | undefined, hasPreviousPage?: boolean | undefined }, nodes: Array<{ __typename?: 'EmergencyContact', id: string, name: string, phoneNumber: string, category: EmergencyContactCategoryEnum, projectId: string, createdAt: string, updatedAt: string }> } };

export type CommonFriendsQueryVariables = Exact<{
  userId1: Scalars['String']['input'];
  userId2: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
}>;


export type CommonFriendsQuery = { __typename?: 'Query', commonFriends: Array<{ __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } }> };

export type FriendRelationshipQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  friendId: Scalars['String']['input'];
}>;


export type FriendRelationshipQuery = { __typename?: 'Query', friendRelationship?: { __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, senderId: string, receiverId: string, isOutgoing: boolean, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }, user: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } } | undefined };

export type FriendsByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
}>;


export type FriendsByUserIdQuery = { __typename?: 'Query', friendsByUserId: Array<{ __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }, user: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } }> };

export type IncomingFriendRequestsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
}>;


export type IncomingFriendRequestsQuery = { __typename?: 'Query', incomingFriendRequests: Array<{ __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } }> };

export type OutgoingFriendRequestsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
}>;


export type OutgoingFriendRequestsQuery = { __typename?: 'Query', outgoingFriendRequests: Array<{ __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } }> };

export type RecommendedUsersQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
  withFriends?: Scalars['Boolean']['input'];
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
}>;


export type RecommendedUsersQuery = { __typename?: 'Query', recommendedUsers: Array<{ __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined }> };

export type SearchUsersQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }> };

export type SubscribersByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
  sortBy?: Scalars['String']['input'];
  sortOrder?: Scalars['String']['input'];
}>;


export type SubscribersByUserIdQuery = { __typename?: 'Query', subscribersByUserId: Array<{ __typename?: 'FriendRelationship', id: string, userId: string, status: FriendStatus, user: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }, friend: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } }> };

export type UserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined, PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } };

export type CurrentUserGlobalModuleCapabilitiesQueryVariables = Exact<{
  moduleSlug: Scalars['String']['input'];
}>;


export type CurrentUserGlobalModuleCapabilitiesQuery = { __typename?: 'Query', currentUserGlobalModuleCapabilities: { __typename?: 'CurrentUserGlobalModuleCapabilities', moduleSlug: string, canInsert: boolean, canEdit: boolean, hasFullAccess: boolean, canEditAllRecords: boolean } };

export type GlobalModuleAccessSettingsQueryVariables = Exact<{
  moduleSlug: Scalars['String']['input'];
}>;


export type GlobalModuleAccessSettingsQuery = { __typename?: 'Query', globalModuleAccessSettings: { __typename?: 'GlobalModuleAccessSettings', id: string, moduleSlug: string, dataEntryScope: ModuleAccessScopeEnum, dataEntryUserIds: Array<string>, editParticipantScope?: ModuleAccessEditScopeEnum | undefined, editUserIds: Array<string>, fullAccessUserIds: Array<string> } };

export type MailMessagesQueryVariables = Exact<{
  threadId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MailMessagesQuery = { __typename?: 'Query', mailMessages: Array<{ __typename?: 'MailMessage', id: string, threadId: string, sequenceNumber: number, messageNumber: string, senderUserId: string, content: any, contentPreview?: string | undefined, createdAt: string }> };

export type MailRecipientsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type MailRecipientsQuery = { __typename?: 'Query', mailRecipients: Array<{ __typename?: 'MailRecipient', userId: string, role: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, nickname: string, dateOfBirth?: string | undefined, addresses?: Array<{ __typename?: 'UserAddress', city?: string | undefined }> | undefined, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, ORIGINAL?: string | undefined } | undefined } | undefined } | undefined } }> };

export type MailThreadQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MailThreadQuery = { __typename?: 'Query', mailThread?: { __typename?: 'MailThread', id: string, registrationNumber: string, status: MailThreadStatusEnum, creatorUserId: string, recipientUserId: string, messageCount: number, lastMessageUserId: string, lastMessagePreview: string, lastMessageAt: string, isRead: boolean, createdAt: string, updatedAt: string } | undefined };

export type MailThreadsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  filter?: InputMaybe<MailThreadFilterEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type MailThreadsQuery = { __typename?: 'Query', mailThreads: { __typename?: 'MailThreadList', totalCount: number, hasMore: boolean, items: Array<{ __typename?: 'MailThread', id: string, registrationNumber: string, status: MailThreadStatusEnum, creatorUserId: string, recipientUserId: string, messageCount: number, lastMessageUserId: string, lastMessagePreview: string, lastMessageAt: string, isRead: boolean, createdAt: string }> } };

export type MailUnreadCountQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type MailUnreadCountQuery = { __typename?: 'Query', mailUnreadCount: number };

export type GetMediaStatusQueryVariables = Exact<{
  input: MediaStatusInputDto;
}>;


export type GetMediaStatusQuery = { __typename?: 'Query', getMediaStatus: Array<{ __typename?: 'MediaStatusItemOutputDTO', mediaId: string, mediaStatus: string, error?: string | undefined }> };

export type GetMediaUploadUrlQueryVariables = Exact<{
  input: MediaUploadUrlInputDto;
}>;


export type GetMediaUploadUrlQuery = { __typename?: 'Query', getMediaUploadUrl: { __typename?: 'MediaUploadUrlOutputDTO', mediaId: string, mediaUploadUrl: string, mediaStorageKey: string, mediaExpiresAt: string } };

export type PresignedGetUrlQueryVariables = Exact<{
  objectType: FileObjectType;
  imageType?: InputMaybe<ImageVariationType>;
  deviceType?: InputMaybe<MediaDeviceType>;
  expires?: InputMaybe<Scalars['Float']['input']>;
}>;


export type PresignedGetUrlQuery = { __typename?: 'Query', presignedGetUrl: string };

export type PresignedPutUrlQueryVariables = Exact<{
  input: GetPresignedUrlInput;
}>;


export type PresignedPutUrlQuery = { __typename?: 'Query', presignedPutUrl: string };

export type ProjectRequestPresignedGetUrlQueryVariables = Exact<{
  input: ProjectRequestPresignedUrlInput;
}>;


export type ProjectRequestPresignedGetUrlQuery = { __typename?: 'Query', projectRequestPresignedGetUrl: { __typename?: 'PresignedUrlResponse', url: string } };

export type ProjectRequestPresignedPutUrlQueryVariables = Exact<{
  input: ProjectRequestPresignedUrlInput;
}>;


export type ProjectRequestPresignedPutUrlQuery = { __typename?: 'Query', projectRequestPresignedPutUrl: { __typename?: 'PresignedUrlResponse', url: string } };

export type NewsQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: NewsFilter;
  sorting?: Array<NewsSort> | NewsSort;
  questAdminsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  myProjectsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  moderationStatus?: InputMaybe<NewsModerationStatusEnum>;
}>;


export type NewsQuery = { __typename?: 'Query', news: { __typename?: 'NewsOffsetConnection', totalCount: number, nodes: Array<{ __typename?: 'News', id: string, title: string, content?: any | undefined, ownerId: string, ownerType: NewsOwnerTypeEnum, createdByUserId: string, updatedByUserId?: string | undefined, status: NewsStatusEnum, sortOrder?: number | undefined, moderationStatus?: NewsModerationStatusEnum | undefined, authorFullname?: string | undefined, handwrittenFullname?: string | undefined, additionalInfo?: string | undefined, createdAt: string, updatedAt: string, moduleSlug: string, isFavourite: boolean, sourceLink?: string | undefined, permissions?: any | undefined, rejectionReason?: string | undefined, customPhotos?: Array<string> | undefined, customVideos?: Array<string> | undefined, media?: Array<{ __typename?: 'MediaOutputDTO', variants: { __typename?: 'MediaVariantsDTO', desktop?: string | undefined, tablet?: string | undefined, mobile?: string | undefined, thumb?: string | undefined, hls?: { __typename?: 'MediaVariantsHLSDTO', master?: string | undefined, poster?: string | undefined } | undefined } }> | undefined, owner: { __typename: 'Project', id: string, name: string, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', LIST?: string | undefined } | undefined } | undefined } | undefined } | { __typename: 'User', id: string, firstName: string, lastName: string }, author?: { __typename?: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined } | undefined, likes?: { __typename?: 'LikeOutput', likeCount: number, isLiked: boolean } | undefined, comments?: { __typename?: 'CommentCountOutput', commentCount: number } | undefined, counters?: { __typename?: 'CounterOutput', counterViewed: number } | undefined, tags: { __typename?: 'NewsTagsConnection', nodes: Array<{ __typename?: 'TagDto', id: string, name: string }> } }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | undefined, hasPreviousPage?: boolean | undefined } } };

export type NewsDigestUnseenCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsDigestUnseenCountQuery = { __typename?: 'Query', newsDigestUnseenCount: { __typename?: 'NewsDigestUnseenCount', quest: number, project: number, total: number } };

export type GetNewsIdsQueryVariables = Exact<{
  total: Scalars['Int']['input'];
  filter?: NewsFilter;
  questAdminsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  myProjectsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  moderationStatus?: InputMaybe<NewsModerationStatusEnum>;
}>;


export type GetNewsIdsQuery = { __typename?: 'Query', ids: { __typename?: 'NewsOffsetConnection', nodes: Array<{ __typename?: 'News', id: string }> } };

export type NewsItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NewsItemQuery = { __typename?: 'Query', newsOne: { __typename?: 'News', id: string, title: string, ownerId: string, ownerType: NewsOwnerTypeEnum, content?: any | undefined, authorFullname?: string | undefined, handwrittenFullname?: string | undefined, additionalInfo?: string | undefined, mainImage?: string | undefined, customPhotos?: Array<string> | undefined, customVideos?: Array<string> | undefined, moduleSlug: string, isFavourite: boolean, sourceLink?: string | undefined, status: NewsStatusEnum, moderationStatus?: NewsModerationStatusEnum | undefined, rejectionReason?: string | undefined, createdAt: string, updatedAt: string, updatedByUserId?: string | undefined, createdByUserId: string, permissions?: any | undefined, media?: Array<{ __typename?: 'MediaOutputDTO', variants: { __typename?: 'MediaVariantsDTO', desktop?: string | undefined, tablet?: string | undefined, mobile?: string | undefined, thumb?: string | undefined, hls?: { __typename?: 'MediaVariantsHLSDTO', master?: string | undefined, poster?: string | undefined } | undefined } }> | undefined, likes?: { __typename?: 'LikeOutput', likeCount: number, isLiked: boolean } | undefined, comments?: { __typename?: 'CommentCountOutput', commentCount: number } | undefined, counters?: { __typename?: 'CounterOutput', counterViewed: number } | undefined, owner: { __typename: 'Project', id: string, name: string, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', LIST?: string | undefined } | undefined } | undefined } | undefined } | { __typename: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined }, author?: { __typename?: 'User', id: string, firstName: string, lastName: string, phone?: string | undefined, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined } | undefined, tags: { __typename?: 'NewsTagsConnection', nodes: Array<{ __typename?: 'TagDto', id: string, name: string }> } } };

export type NewsPresignedPutUrlQueryVariables = Exact<{
  input: NewsPresignedPutUrlInput;
}>;


export type NewsPresignedPutUrlQuery = { __typename?: 'Query', newsPresignedPutUrl: { __typename?: 'NewsPresignedPutUrlResponse', url: string, objectName: string } };

export type GetNewsTotalQueryVariables = Exact<{
  filter?: NewsFilter;
  questAdminsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  myProjectsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  moderationStatus?: InputMaybe<NewsModerationStatusEnum>;
}>;


export type GetNewsTotalQuery = { __typename?: 'Query', total: { __typename?: 'NewsOffsetConnection', value: number } };

export type GetUserNotificationsQueryVariables = Exact<{
  type: NotificationType;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetUserNotificationsQuery = { __typename?: 'Query', getUserNotifications: { __typename?: 'NotificationConnection', total: number, hasMore: boolean, unreadCount: number, items: Array<{ __typename?: 'Notification', id: string, title: string, body: string, type: NotificationType, event: string, message: string, isRead: boolean, actionApplied: boolean, calendarEventId?: string | undefined, createdAt: string, sender?: { __typename?: 'UserInfo', userId: string, firstName?: string | undefined, lastName?: string | undefined, avatar?: string | undefined } | undefined, project?: { __typename?: 'ProjectInfo', projectId: string, invitationId?: string | undefined, joinRequestId?: string | undefined, name?: string | undefined, shortDescription?: string | undefined, photo?: string | undefined, moduleSlug?: string | undefined, threadId?: string | undefined } | undefined }> } };

export type GetUserNotificationsUnreadCountQueryVariables = Exact<{
  type: NotificationType;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserNotificationsUnreadCountQuery = { __typename?: 'Query', getUserNotifications: { __typename?: 'NotificationConnection', unreadCount: number } };

export type ObjectPassportQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  moduleSlug: Scalars['String']['input'];
}>;


export type ObjectPassportQuery = { __typename?: 'Query', objectPassport?: { __typename?: 'ObjectPassport', id: string, name: string, description?: string | undefined, eventType?: string | undefined, contactPersonName?: string | undefined, contactPersonUserId?: string | undefined, contactPhone?: string | undefined, startAt?: string | undefined, endAt?: string | undefined, expectedHeadcount?: number | undefined, location?: string | undefined, moduleSlug: string, moduleProgramRelated?: string | undefined, moduleReglamentRelated?: string | undefined, projectId: string, timezone?: string | undefined, createdAt: string, updatedAt: string, attachments: Array<{ __typename?: 'ObjectPassportAttachment', id: string, fileKey: string, fileName: string, fileSize?: number | undefined, kind: ObjectPassportFileKindEnum, mimeType?: string | undefined, url?: string | undefined, passportId: string, createdAt: string }> } | undefined };

export type ObjectPassportApplicationsQueryVariables = Exact<{
  filter: ObjectPassportApplicationListFilterInput;
}>;


export type ObjectPassportApplicationsQuery = { __typename?: 'Query', objectPassportApplications: { __typename?: 'ObjectPassportApplicationList', total: number, page: number, limit: number, hasMore: boolean, items: Array<{ __typename?: 'ObjectPassportApplication', id: string, fullName: string, phone?: string | undefined, position?: string | undefined, additionalInfo?: string | undefined, applicationText?: string | undefined, participationFormat?: ObjectPassportParticipationFormatEnum | undefined, status: ObjectPassportApplicationStatusEnum, passportId: string, projectId: string, moduleSlug: string, createdAt: string, updatedAt: string, moderatedAt?: string | undefined, moderatorComment?: string | undefined, applicantUserId?: string | undefined }> } };

export type ObjectPassportContactCandidatesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ObjectPassportContactCandidatesQuery = { __typename?: 'Query', objectPassportContactCandidates: Array<{ __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }> };

export type GetMsAnalyticsPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMsAnalyticsPermissionsQuery = { __typename?: 'Query', getMsAnalyticsPermissions: Array<string> };

export type GetMsCommentPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMsCommentPermissionsQuery = { __typename?: 'Query', getMsCommentPermissions: Array<string> };

export type GetMsNewsPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  newsId?: InputMaybe<Scalars['String']['input']>;
  moduleSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMsNewsPermissionsQuery = { __typename?: 'Query', getMsNewsPermissions: Array<string> };

export type GetMsProjectCounterPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectCounterPermissionsQuery = { __typename?: 'Query', getMsProjectCounterPermissions: Array<string> };

export type GetMsProjectCustomModulePermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectCustomModulePermissionsQuery = { __typename?: 'Query', getMsProjectCustomModulePermissions: Array<string> };

export type GetMsProjectMailPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectMailPermissionsQuery = { __typename?: 'Query', getMsProjectMailPermissions: Array<string> };

export type GetMsProjectMemberPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectMemberPermissionsQuery = { __typename?: 'Query', getMsProjectMemberPermissions: Array<string> };

export type GetMsProjectMockupsPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectMockupsPermissionsQuery = { __typename?: 'Query', getMsProjectMockupsPermissions: Array<string> };

export type GetMsProjectModuleAccessPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectModuleAccessPermissionsQuery = { __typename?: 'Query', getMsProjectModuleAccessPermissions: Array<string> };

export type GetMsProjectModuleMemberPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectModuleMemberPermissionsQuery = { __typename?: 'Query', getMsProjectModuleMemberPermissions: Array<string> };

export type GetMsProjectPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectPermissionsQuery = { __typename?: 'Query', getMsProjectPermissions: Array<string> };

export type GetMsProjectProjectRequestPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMsProjectProjectRequestPermissionsQuery = { __typename?: 'Query', getMsProjectProjectRequestPermissions: Array<string> };

export type GetMsProjectSupportersPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectSupportersPermissionsQuery = { __typename?: 'Query', getMsProjectSupportersPermissions: Array<string> };

export type GetMsProjectTemplatesPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetMsProjectTemplatesPermissionsQuery = { __typename?: 'Query', getMsProjectTemplatesPermissions: Array<string> };

export type GetMsSurveyPermissionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
}>;


export type GetMsSurveyPermissionsQuery = { __typename?: 'Query', getMsSurveyPermissions: Array<string> };

export type ProjectNewsModuleAccessCapabilitiesQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  moduleSlug: Scalars['String']['input'];
}>;


export type ProjectNewsModuleAccessCapabilitiesQuery = { __typename?: 'Query', projectNewsModuleAccessCapabilities: { __typename?: 'ProjectNewsModuleAccessCapabilitiesDTO', canViewList: boolean, canCreateNews: boolean } };

export type GetPhraseOfTheDayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPhraseOfTheDayQuery = { __typename?: 'Query', getPhraseOfTheDay: { __typename?: 'Phrase', id: string, text: string, author?: string | undefined } };

export type ProgramContactCandidatesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProgramContactCandidatesQuery = { __typename?: 'Query', programContactCandidates: Array<{ __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }> };

export type ProgramItemsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  moduleSlug: Scalars['String']['input'];
}>;


export type ProgramItemsQuery = { __typename?: 'Query', programItems: Array<{ __typename?: 'ProgramItem', id: string, projectId: string, moduleSlug: string, name: string, contactPersonName?: string | undefined, contactPersonUserId?: string | undefined, startAt?: string | undefined, endAt?: string | undefined, timezone?: string | undefined, location?: string | undefined, sortOrder: number, createdByUserId: string, updatedByUserId?: string | undefined, createdAt: string, updatedAt: string, attachments: Array<{ __typename?: 'ProgramItemAttachment', id: string, programItemId: string, kind: ProgramFileKindEnum, fileName: string, mimeType?: string | undefined, fileSize?: number | undefined, fileKey: string, url?: string | undefined, uploadedByUserId: string, createdAt: string }> }> };

export type ProjectMemberQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProjectMemberQuery = { __typename?: 'Query', projectMember: { __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined } };

export type ProjectMembersQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: ProjectMemberFilter;
  sorting?: Array<ProjectMemberSort> | ProjectMemberSort;
}>;


export type ProjectMembersQuery = { __typename?: 'Query', projectMembers: { __typename?: 'ProjectMemberConnection', totalCount: number, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | undefined, hasPreviousPage?: boolean | undefined }, nodes: Array<{ __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> } };

export type ProjectModuleMemberQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectModuleMemberQuery = { __typename?: 'Query', projectModuleMember: { __typename?: 'ProjectModuleMember', moduleSlug: string, role?: ProjectModuleRoleEnum | undefined, projectMember: { __typename?: 'ProjectMember', user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined } } };

export type ProjectModuleMembersQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: ProjectModuleMemberFilter;
  sorting?: Array<ProjectModuleMemberSort> | ProjectModuleMemberSort;
}>;


export type ProjectModuleMembersQuery = { __typename?: 'Query', projectModuleMembers: { __typename?: 'ProjectModuleMemberConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectModuleMember', id: string, moduleSlug: string, role?: ProjectModuleRoleEnum | undefined, projectMemberId: string, projectMember: { __typename?: 'ProjectMember', id: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined } }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | undefined, hasPreviousPage?: boolean | undefined } } };

export type CurrentUserProjectModuleCapabilitiesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  moduleSlug: Scalars['String']['input'];
}>;


export type CurrentUserProjectModuleCapabilitiesQuery = { __typename?: 'Query', currentUserProjectModuleCapabilities: { __typename?: 'CurrentUserProjectModuleCapabilities', moduleSlug: string, canShow: boolean, canView: boolean, canInsert: boolean, canEdit: boolean, hasFullAccess: boolean, canEditAllRecords: boolean } };

export type CurrentUserProjectModuleCapabilitiesBatchQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  moduleSlugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CurrentUserProjectModuleCapabilitiesBatchQuery = { __typename?: 'Query', currentUserProjectModuleCapabilitiesBatch: Array<{ __typename?: 'CurrentUserProjectModuleCapabilities', moduleSlug: string, canShow: boolean, canView: boolean, canInsert: boolean, canEdit: boolean, hasFullAccess: boolean, canEditAllRecords: boolean }> };

export type ProjectModuleAccessSettingsBySegmentQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  moduleSegment: Scalars['String']['input'];
}>;


export type ProjectModuleAccessSettingsBySegmentQuery = { __typename?: 'Query', projectModuleAccessSettingsBySegment: { __typename?: 'ProjectModuleAccessSettings', id: string, projectId: string, moduleSlug: string, show: { __typename?: 'ModuleAccessScopeRule', scope: ModuleAccessScopeEnum, participants: Array<{ __typename?: 'ProjectMember', id: string, userId: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined, FRIENDS_MINI_AVATAR?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> }, view: { __typename?: 'ModuleAccessScopeRule', scope: ModuleAccessScopeEnum, participants: Array<{ __typename?: 'ProjectMember', id: string, userId: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined, FRIENDS_MINI_AVATAR?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> }, dataEntry: { __typename?: 'ModuleAccessScopeRule', scope: ModuleAccessScopeEnum, participants: Array<{ __typename?: 'ProjectMember', id: string, userId: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined, FRIENDS_MINI_AVATAR?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> }, edit: { __typename?: 'ModuleAccessEditRule', membersScope?: ModuleAccessEditScopeEnum | undefined, statusScope?: ModuleAccessEditScopeEnum | undefined, participantScope?: ModuleAccessEditScopeEnum | undefined, participants: Array<{ __typename?: 'ProjectMember', id: string, userId: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined, FRIENDS_MINI_AVATAR?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> }, fullAccessMembers: Array<{ __typename?: 'ProjectMember', id: string, userId: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined, FRIENDS_MINI_AVATAR?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> } };

export type ProjectRequestApproveQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProjectRequestApproveQuery = { __typename?: 'Query', request: { __typename?: 'ProjectRequest', id: string, userId: string, name: string, shortDescription: string, detailedDescription?: string | undefined, endDate?: string | undefined, visibility: ProjectVisibilityEnum, themes: Array<ProjectThemeEnum>, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', OPEN_PROJECT?: string | undefined } | undefined } | undefined } | undefined } };

export type MyProjectRequestQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MyProjectRequestQuery = { __typename?: 'Query', request: { __typename?: 'ProjectRequest', id: string, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, visibility: ProjectVisibilityEnum, userId: string, status: ProjectRequestStatusEnum, projectId?: string | undefined, templateType: ProjectTemplateEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, createdAt: string, updatedAt: string, rejections?: Array<{ __typename?: 'ProjectRequestRejection', projectRequestId: string, reason: string, rejectedByUserId: string }> | undefined, media?: { __typename?: 'ProjectMedia', logo?: string | undefined, image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, TABLET?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, MOBILE?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined } | undefined } | undefined } };

export type ExportMySupportersQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  format: ProjectSupporterExportFormat;
}>;


export type ExportMySupportersQuery = { __typename?: 'Query', exportMySupporters: string };

export type GetAllProjectRequestsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllProjectRequestsQuery = { __typename?: 'Query', requests: Array<{ __typename?: 'ProjectRequest', id: string, name: string, shortDescription: string, status: ProjectRequestStatusEnum, createdAt: string, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined } | undefined } | undefined } | undefined }> };

export type GetMyAllProjectRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAllProjectRequestsQuery = { __typename?: 'Query', requests: Array<{ __typename?: 'ProjectRequest', id: string, name: string, shortDescription: string, status: ProjectRequestStatusEnum, createdAt: string, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', OPEN_REQUEST?: string | undefined } | undefined } | undefined } | undefined }> };

export type GetMyJoinRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyJoinRequestsQuery = { __typename?: 'Query', getMyJoinRequests: Array<{ __typename?: 'ProjectJoinRequest', id: string, projectId: string, status: JoinRequestStatusEnum }> };

export type GetMyLikedProjectsQueryVariables = Exact<{
  offset?: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
}>;


export type GetMyLikedProjectsQuery = { __typename?: 'Query', getMyLikedProjects: { __typename?: 'LikedProjectsConnection', totalCount: number, nodes: Array<{ __typename?: 'Project', id: string, slug?: string | undefined, name: string, shortDescription: string, ownerUserId?: string | undefined, visibility: ProjectVisibilityEnum, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', userId: string }> }, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', LIST?: string | undefined } | undefined } | undefined } | undefined, likes?: { __typename?: 'LikeOutput', likeCount: number, isLiked: boolean } | undefined }> } };

export type GetPendingJoinRequestsCountQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetPendingJoinRequestsCountQuery = { __typename?: 'Query', getPendingJoinRequests: Array<{ __typename?: 'ProjectJoinRequest', id: string }> };

export type GetProjectJoinRequestsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetProjectJoinRequestsQuery = { __typename?: 'Query', getProjectJoinRequests: Array<{ __typename?: 'ProjectJoinRequest', id: string, userId: string, status: JoinRequestStatusEnum, source: JoinRequestSourceEnum, message?: string | undefined, invitationId?: string | undefined, processedByUserId?: string | undefined, processedAt?: string | undefined, rejectionReason?: string | undefined, createdAt: string, user: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined, FRIENDS_CARD?: string | undefined, PROFILE?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } }> };

export type ProjectQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, slug?: string | undefined, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, templateType: ProjectTemplateEnum, visibility: ProjectVisibilityEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, ownerUserId?: string | undefined, projectRequestId?: string | undefined, createdAt: string, updatedAt: string, media?: { __typename?: 'ProjectMedia', logo?: string | undefined, image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', WORKSPACE?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, TABLET?: { __typename?: 'ProjectImageDeviceVariation', WORKSPACE?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, MOBILE?: { __typename?: 'ProjectImageDeviceVariation', WORKSPACE?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined } | undefined } | undefined, owner: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> } } | undefined };

export type ProjectCustomModuleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectCustomModuleQuery = { __typename?: 'Query', projectCustomModule?: { __typename?: 'ProjectCustomModule', id: string, projectId?: string | undefined, moduleSlug: string, name: string, iconColor?: string | undefined, backgroundColor?: string | undefined, format: CustomModuleFormatEnum, icon?: string | undefined, baseModuleType: CustomModuleBaseTypeEnum } | undefined };

export type ProjectCustomModulesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectCustomModulesQuery = { __typename?: 'Query', projectCustomModules: Array<{ __typename?: 'ProjectCustomModule', id: string, moduleSlug: string, name: string, iconColor?: string | undefined, backgroundColor?: string | undefined, format: CustomModuleFormatEnum, icon?: string | undefined, baseModuleType: CustomModuleBaseTypeEnum, createdAt: string }> };

export type ProjectCustomModulesForProjectRequestQueryVariables = Exact<{
  projectRequestId: Scalars['ID']['input'];
}>;


export type ProjectCustomModulesForProjectRequestQuery = { __typename?: 'Query', projectCustomModulesForProjectRequest: Array<{ __typename?: 'ProjectCustomModule', id: string, name: string, moduleSlug: string, baseModuleType: CustomModuleBaseTypeEnum, format: CustomModuleFormatEnum }> };

export type ProjectLandingPlacementButtonsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectLandingPlacementButtonsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, headerButtons?: any | undefined, hamburgerButtons?: any | undefined } | undefined };

export type ProjectLogoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectLogoQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, media?: { __typename?: 'ProjectMedia', logo?: string | undefined } | undefined } | undefined };

export type ProjectPreviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectPreviewQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, visibility: ProjectVisibilityEnum, ownerUserId?: string | undefined, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', userId: string }> } } | undefined };

export type ProjectPublicQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectPublicQuery = { __typename?: 'Query', publicProject: { __typename?: 'PublicProject', id: string, slug?: string | undefined, name: string, shortDescription: string, detailedDescription?: string | undefined, media?: { __typename?: 'ProjectMedia', logo?: string | undefined, image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', WORKSPACE?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, TABLET?: { __typename?: 'ProjectImageDeviceVariation', WORKSPACE?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined, MOBILE?: { __typename?: 'ProjectImageDeviceVariation', WORKSPACE?: string | undefined, OPEN_PROJECT?: string | undefined } | undefined } | undefined } | undefined } };

export type ProjectSupporterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProjectSupporterQuery = { __typename?: 'Query', projectSupporter: { __typename?: 'ProjectSupporter', id: string, firstName?: string | undefined, lastName?: string | undefined, middleName?: string | undefined, gender?: SupporterGender | undefined, birthday?: string | undefined, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, postalCode?: string | undefined, addressComment?: string | undefined, isManual?: boolean | undefined, comment?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, projectId: string, companyName?: string | undefined, companyPosition?: string | undefined, companyPhone?: string | undefined, companyEmail?: string | undefined, companyRegion?: string | undefined, companyCity?: string | undefined, companyCityDistrict?: string | undefined, companySettlement?: string | undefined, companyStreet?: string | undefined, companyFlat?: string | undefined, companyEntrance?: string | undefined, companyFloor?: string | undefined, companyDoorphone?: string | undefined, companyAddressComment?: string | undefined, companyPostalCode?: string | undefined, companyIsManual?: boolean | undefined, holidayName?: string | undefined, holidayDate?: string | undefined, createdAt: string, updatedAt: string } };

export type ProjectWorkspaceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectWorkspaceQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, slug?: string | undefined, name: string, shortDescription: string, themes: Array<ProjectThemeEnum>, templateType: ProjectTemplateEnum, workspaceNativeModules: Array<ProjectModuleSlugEnum>, ownerUserId?: string | undefined, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', id: string, userId: string, role?: ProjectMemberRoleEnum | undefined }> }, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', WORKSPACE?: string | undefined } | undefined } | undefined } | undefined } | undefined };

export type ProjectWorkspaceVisibleModuleSlugsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectWorkspaceVisibleModuleSlugsQuery = { __typename?: 'Query', projectWorkspaceVisibleModuleSlugs: Array<string> };

export type ProjectsQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: ProjectFilter;
  sorting?: Array<ProjectSort> | ProjectSort;
}>;


export type ProjectsQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectConnection', totalCount: number, nodes: Array<{ __typename?: 'Project', id: string, slug?: string | undefined, name: string, photo?: string | undefined, shortDescription: string, detailedDescription?: string | undefined, themes: Array<ProjectThemeEnum>, startDate: string, endDate?: string | undefined, templateType: ProjectTemplateEnum, visibility: ProjectVisibilityEnum, workspacePreset?: ProjectWorkspacePresetEnum | undefined, ownerUserId?: string | undefined, projectRequestId?: string | undefined, createdAt: string, updatedAt: string, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', LIST?: string | undefined } | undefined, TABLET?: { __typename?: 'ProjectImageDeviceVariation', LIST?: string | undefined } | undefined, MOBILE?: { __typename?: 'ProjectImageDeviceVariation', LIST?: string | undefined } | undefined } | undefined } | undefined, likes?: { __typename?: 'LikeOutput', likeCount: number, isLiked: boolean } | undefined, owner: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined }, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', id: string, projectId: string, userId: string, role?: ProjectMemberRoleEnum | undefined, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined, background?: { __typename?: 'Background', DESKTOP?: { __typename?: 'DesktopVariation', ORIGINAL?: string | undefined } | undefined } | undefined } | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } | undefined }> } }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | undefined, hasPreviousPage?: boolean | undefined } } };

export type ProjectsModuleQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: ProjectFilter;
  sorting?: Array<ProjectSort> | ProjectSort;
}>;


export type ProjectsModuleQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, slug?: string | undefined, name: string, shortDescription: string, ownerUserId?: string | undefined, visibility: ProjectVisibilityEnum, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', userId: string }> }, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', LIST?: string | undefined } | undefined } | undefined } | undefined, likes?: { __typename?: 'LikeOutput', likeCount: number, isLiked: boolean } | undefined }> } };

export type ReglamentItemsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  moduleSlug: Scalars['String']['input'];
}>;


export type ReglamentItemsQuery = { __typename?: 'Query', reglamentItems: Array<{ __typename?: 'ReglamentItem', id: string, projectId: string, moduleSlug: string, speakerName: string, reportTopic?: string | undefined, startAt?: string | undefined, endAt?: string | undefined, questionsStartAt?: string | undefined, questionsEndAt?: string | undefined, timezone?: string | undefined, sortOrder: number, createdByUserId: string, updatedByUserId?: string | undefined, createdAt: string, updatedAt: string }> };

export type GetAllTemplatesQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllTemplatesQuery = { __typename?: 'Query', getAllTemplates: { __typename?: 'AllTemplatesResponse', global: Array<{ __typename?: 'TemplateGroup', name: string, label: string, items: Array<{ __typename?: 'TemplateItem', name: string, label: string, text: string }> }>, personal: Array<{ __typename?: 'TemplateItem', name: string, label: string, text: string }> } };

export type GetLandingTemplatesQueryVariables = Exact<{
  paging?: CursorPaging;
  filter?: LandingTemplateFilter;
  sorting?: Array<LandingTemplateSort> | LandingTemplateSort;
}>;


export type GetLandingTemplatesQuery = { __typename?: 'Query', landingTemplates: { __typename?: 'LandingTemplateConnection', totalCount: number, edges: Array<{ __typename?: 'LandingTemplateEdge', cursor: any, node: { __typename?: 'LandingTemplate', id: string, name: string, description?: string | undefined, content: any, isPublic: boolean, createdBy: string, updatedBy: string, createdAt: string, updatedAt: string, deletedAt?: string | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | undefined, hasPreviousPage?: boolean | undefined, startCursor?: any | undefined, endCursor?: any | undefined } } };

export type GetMockupsQueryVariables = Exact<{
  filter?: InputMaybe<MockupFilterInput>;
}>;


export type GetMockupsQuery = { __typename?: 'Query', getMockups: Array<{ __typename?: 'Mockup', id: string, presignedUrl?: string | undefined, type: MockupTypeEnum }> };

export type GetPlatformSummaryReportsQueryVariables = Exact<{
  filters?: InputMaybe<AnalyticsFiltersInput>;
}>;


export type GetPlatformSummaryReportsQuery = { __typename?: 'Query', getPlatformSummaryReports: Array<{ __typename?: 'PlatformSummaryReportEntity', id: string, totalRegisteredUsers: number, totalProjects: number, totalProjectOwners: number, totalProjectParticipants: number, averageSessionDuration?: number | undefined, activeUsersCount: number, totalFriendships: number, periodStart: string, periodEnd: string, reportDate: string, createdAt: string, updatedAt: string }> };

export type GetProjectDetailedReportsQueryVariables = Exact<{
  filters?: InputMaybe<ProjectDetailedFiltersInput>;
}>;


export type GetProjectDetailedReportsQuery = { __typename?: 'Query', getProjectDetailedReports: Array<{ __typename?: 'ProjectDetailedReportEntity', id: string, projectId: string, projectName: string, projectOwnerName: string, totalParticipantsCount: number, activeParticipantsCount: number, averageSessionDuration?: number | undefined, reportDate: string, createdAt: string, updatedAt: string }> };

export type GetProjectMockupsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectMockupsQuery = { __typename?: 'Query', getProjectMockups: Array<{ __typename?: 'Mockup', id: string, presignedUrl?: string | undefined, type: MockupTypeEnum }> };

export type GetRegionalReportsQueryVariables = Exact<{
  filters?: InputMaybe<AnalyticsFiltersInput>;
}>;


export type GetRegionalReportsQuery = { __typename?: 'Query', getRegionalReports: Array<{ __typename?: 'RegionalReportEntity', id: string, region: string, registeredUsersCount: number, projectParticipantsCount: number, averageSessionDuration?: number | undefined, reportDate: string, createdAt: string, updatedAt: string }> };

export type GetSystemMockupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemMockupsQuery = { __typename?: 'Query', getSystemMockups: Array<{ __typename?: 'Mockup', id: string, presignedUrl?: string | undefined, type: MockupTypeEnum }> };

export type GetUserDetailedReportsQueryVariables = Exact<{
  filters?: InputMaybe<UserDetailedFiltersInput>;
}>;


export type GetUserDetailedReportsQuery = { __typename?: 'Query', getUserDetailedReports: Array<{ __typename?: 'UserDetailedReportEntity', id: string, userId: string, fullName: string, ownedProjectsCount: number, friendsCount: number, averageSessionDuration?: number | undefined, reportDate: string, createdAt: string, updatedAt: string }> };

export type GetUserTemplatesQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserTemplatesQuery = { __typename?: 'Query', getUserTemplates: Array<{ __typename?: 'Template', id: string, name: string, label: string, text: string, content?: any | undefined, isGlobal: boolean, category?: string | undefined, categoryLabel?: string | undefined, userId?: string | undefined, projectId?: string | undefined, createdBy?: string | undefined, updatedBy?: string | undefined, createdAt: string, updatedAt: string }> };

export type MockupPresignedPutUrlQueryVariables = Exact<{
  input: MockupPresignedPutUrlInput;
}>;


export type MockupPresignedPutUrlQuery = { __typename?: 'Query', mockupPresignedPutUrl: { __typename?: 'MockupPresignedUrlResponse', url: string } };

export type CommonSupporterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type CommonSupporterQuery = { __typename?: 'Query', registryContact?: { __typename?: 'RegistryContact', id: string, contactType: RegistryContactTypeEnum, projectId: string, projectName?: string | undefined, displayName: string, lastName?: string | undefined, firstName?: string | undefined, middleName?: string | undefined, phoneNumber?: string | undefined, email?: string | undefined, birthday?: string | undefined, birthdayMonthDay?: string | undefined, birthdayDay?: number | undefined, birthdayMonth?: number | undefined, gender?: SupporterGender | undefined, comment?: string | undefined, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, postalCode?: string | undefined, fullAddress?: string | undefined, companyName?: string | undefined, companyInn?: string | undefined, companyKpp?: string | undefined, companyOgrn?: string | undefined, companyEmail?: string | undefined, companyPhone?: string | undefined, companyPosition?: string | undefined, userId?: string | undefined, memberRole?: ProjectMemberRoleEnum | undefined, holidayName?: string | undefined, holidayDate?: string | undefined, holidayMonthDay?: string | undefined, holidayDay?: number | undefined, holidayMonth?: number | undefined, createdAt: string, updatedAt: string, originalProjectId?: string | undefined, originalOwnerId?: string | undefined, hasPhone: boolean, hasEmail: boolean, hasAddress: boolean, hasBirthday: boolean, hasHoliday: boolean } | undefined };

export type CommonSupportersQueryVariables = Exact<{
  filter: RegistryFilterInput;
}>;


export type CommonSupportersQuery = { __typename?: 'Query', registryContacts: { __typename?: 'RegistryContactConnection', totalCount: number, nodes: Array<{ __typename?: 'RegistryContact', id: string, contactType: RegistryContactTypeEnum, projectId: string, projectName?: string | undefined, displayName: string, lastName?: string | undefined, firstName?: string | undefined, middleName?: string | undefined, phoneNumber?: string | undefined, email?: string | undefined, birthday?: string | undefined, birthdayMonthDay?: string | undefined, birthdayDay?: number | undefined, birthdayMonth?: number | undefined, gender?: SupporterGender | undefined, comment?: string | undefined, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, postalCode?: string | undefined, fullAddress?: string | undefined, companyName?: string | undefined, companyInn?: string | undefined, companyKpp?: string | undefined, companyOgrn?: string | undefined, companyEmail?: string | undefined, companyPhone?: string | undefined, companyPosition?: string | undefined, userId?: string | undefined, memberRole?: ProjectMemberRoleEnum | undefined, holidayName?: string | undefined, holidayDate?: string | undefined, holidayMonthDay?: string | undefined, holidayDay?: number | undefined, holidayMonth?: number | undefined, createdAt: string, updatedAt: string, originalProjectId?: string | undefined, originalOwnerId?: string | undefined, hasPhone: boolean, hasEmail: boolean, hasAddress: boolean, hasBirthday: boolean, hasHoliday: boolean }> } };

export type ExportAllOrganizationsQueryVariables = Exact<{
  format: ProjectSupporterExportFormat;
  filter?: InputMaybe<ProjectOrganizationFilter>;
  sorting?: InputMaybe<Array<ProjectOrganizationSort> | ProjectOrganizationSort>;
}>;


export type ExportAllOrganizationsQuery = { __typename?: 'Query', exportAllOrganizations: string };

export type ExportAllSupportersQueryVariables = Exact<{
  format: ProjectSupporterExportFormat;
  filter?: InputMaybe<ProjectSupporterFilter>;
  sorting?: InputMaybe<Array<ProjectSupporterSort> | ProjectSupporterSort>;
}>;


export type ExportAllSupportersQuery = { __typename?: 'Query', exportAllSupporters: string };

export type GetIncomingMergeRequestsQueryVariables = Exact<{
  input: GetMergeRequestsDto;
}>;


export type GetIncomingMergeRequestsQuery = { __typename?: 'Query', requests: Array<{ __typename?: 'MergeSessionDTO', id: string, selectedSupporterIds: Array<string>, state: MergeSessionState, fromProject?: { __typename?: 'Project', id: string, name: string, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', DESKTOP?: { __typename?: 'ProjectImageDeviceVariation', LIST?: string | undefined } | undefined } | undefined } | undefined } | undefined, requestedByUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, patronymic?: string | undefined } | undefined }> };

export type GetSupportersMetaQueryVariables = Exact<{
  input: GetProjectSupporterOwnersInput;
}>;


export type GetSupportersMetaQuery = { __typename?: 'Query', lists: { __typename?: 'ProjectSupporterOwnersResponseDTO', owners: Array<{ __typename?: 'SupporterOwnerDTO', owner: { __typename?: 'User', id: string, firstName: string, lastName: string, isOrigin: boolean } }>, originProjects: Array<{ __typename?: 'Project', id: string, name: string }>, project: { __typename?: 'Project', id: string, name: string } } };

export type ProjectOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectOrganizationQuery = { __typename?: 'Query', item: { __typename?: 'ProjectOrganization', id: string, companyName: string, companyShortName?: string | undefined, companyEmail?: string | undefined, companyPhone?: string | undefined, companyInn?: string | undefined, companyKpp?: string | undefined, companyOgrn?: string | undefined, lastName?: string | undefined, firstName?: string | undefined, middleName?: string | undefined, companyPosition?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, companyRegion?: string | undefined, companyCity?: string | undefined, companyCityDistrict?: string | undefined, companySettlement?: string | undefined, companyStreet?: string | undefined, companyFlat?: string | undefined, companyAddressComment?: string | undefined, holidayName?: string | undefined, holidayDate?: string | undefined } };

export type ProjectOrganizationsQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: ProjectOrganizationFilter;
  sorting?: Array<ProjectOrganizationSort> | ProjectOrganizationSort;
}>;


export type ProjectOrganizationsQuery = { __typename?: 'Query', list: { __typename?: 'ProjectOrganizationConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectOrganization', id: string, companyName: string, companyShortName?: string | undefined, companyEmail?: string | undefined, companyPhone?: string | undefined, companyInn?: string | undefined, companyKpp?: string | undefined, companyOgrn?: string | undefined, lastName?: string | undefined, firstName?: string | undefined, middleName?: string | undefined, companyPosition?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, companyPostalCode?: string | undefined, companyRegion?: string | undefined, companyCity?: string | undefined, companyCityDistrict?: string | undefined, companySettlement?: string | undefined, companyStreet?: string | undefined, companyFlat?: string | undefined, companyAddressComment?: string | undefined, holidayName?: string | undefined, holidayDate?: string | undefined, project: { __typename?: 'ProjectOrganizationProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, owner: { __typename?: 'User', id: string, firstName: string, lastName: string, patronymic?: string | undefined } }> } }> } };

export type ProjectOrganizationsIdsQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: ProjectOrganizationFilter;
  sorting?: Array<ProjectOrganizationSort> | ProjectOrganizationSort;
}>;


export type ProjectOrganizationsIdsQuery = { __typename?: 'Query', projectOrganizations: { __typename?: 'ProjectOrganizationConnection', nodes: Array<{ __typename?: 'ProjectOrganization', id: string }> } };

export type ProjectSupportersQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: ProjectSupporterFilter;
  sorting?: Array<ProjectSupporterSort> | ProjectSupporterSort;
}>;


export type ProjectSupportersQuery = { __typename?: 'Query', projectSupporters: { __typename?: 'ProjectSupporterConnection', totalCount: number, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | undefined, hasPreviousPage?: boolean | undefined }, nodes: Array<{ __typename?: 'ProjectSupporter', id: string, firstName?: string | undefined, lastName?: string | undefined, middleName?: string | undefined, gender?: SupporterGender | undefined, birthday?: string | undefined, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, postalCode?: string | undefined, addressComment?: string | undefined, isManual?: boolean | undefined, comment?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, projectId: string, companyName?: string | undefined, companyPosition?: string | undefined, companyPhone?: string | undefined, companyEmail?: string | undefined, companyRegion?: string | undefined, companyCity?: string | undefined, companyCityDistrict?: string | undefined, companySettlement?: string | undefined, companyStreet?: string | undefined, companyFlat?: string | undefined, companyEntrance?: string | undefined, companyFloor?: string | undefined, companyDoorphone?: string | undefined, companyAddressComment?: string | undefined, companyPostalCode?: string | undefined, companyIsManual?: boolean | undefined, holidayName?: string | undefined, holidayDate?: string | undefined, createdAt: string, updatedAt: string, project: { __typename?: 'ProjectSupporterProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, owner: { __typename?: 'User', id: string, firstName: string, lastName: string, patronymic?: string | undefined } }> }, originalOwner?: { __typename?: 'User', id: string, firstName: string, lastName: string, patronymic?: string | undefined } | undefined, originalProject?: { __typename?: 'Project', id: string, name: string } | undefined }> } };

export type ProjectSupportersIdsQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: ProjectSupporterFilter;
  sorting?: Array<ProjectSupporterSort> | ProjectSupporterSort;
}>;


export type ProjectSupportersIdsQuery = { __typename?: 'Query', projectSupporters: { __typename?: 'ProjectSupporterConnection', nodes: Array<{ __typename?: 'ProjectSupporter', id: string }> } };

export type RegistryContactsCountQueryVariables = Exact<{
  filter: RegistryFilterInput;
}>;


export type RegistryContactsCountQuery = { __typename?: 'Query', registryContacts: { __typename?: 'RegistryContactConnection', totalCount: number } };

export type RegistryContactsIdsQueryVariables = Exact<{
  filter: RegistryFilterInput;
}>;


export type RegistryContactsIdsQuery = { __typename?: 'Query', registryContacts: { __typename?: 'RegistryContactConnection', nodes: Array<{ __typename?: 'RegistryContact', id: string }> } };

export type RegistryContactsMembersQueryVariables = Exact<{
  filter: RegistryFilterInput;
}>;


export type RegistryContactsMembersQuery = { __typename?: 'Query', registryContacts: { __typename?: 'RegistryContactConnection', totalCount: number, nodes: Array<{ __typename?: 'RegistryContact', id: string, contactType: RegistryContactTypeEnum, displayName: string, lastName?: string | undefined, firstName?: string | undefined, middleName?: string | undefined }> } };

export type QuestionDtosQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: QuestionDtoFilter;
  sorting?: Array<QuestionDtoSort> | QuestionDtoSort;
}>;


export type QuestionDtosQuery = { __typename?: 'Query', questionDtos: { __typename?: 'QuestionDtoConnection', nodes: Array<{ __typename?: 'QuestionDto', id: string, title: string, description?: string | undefined, order: number, isRequired: boolean, answers?: Array<{ __typename?: 'QuestionAnswerDto', respondent?: { __typename?: 'User', firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined } | undefined } | undefined, value: Array<{ __typename?: 'AnswerValueFieldDto', fieldId: string, fieldType: QuestionFieldType, result: any }> }> | undefined, fields: Array<{ __typename?: 'QuestionFieldDto', id: string, type: QuestionFieldType, order: number, value?: any | undefined, options?: Array<string> | undefined, metadata?: any | undefined, answerValidationType?: string | undefined }> }> } };

export type SurveyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SurveyQuery = { __typename?: 'Query', detail: { __typename?: 'SurveyDtoConnection', nodes: Array<{ __typename?: 'SurveyDto', id: string, title: string, description?: string | undefined, status: SurveyStatus, publishedAt?: string | undefined, createdByUserId: string, updatedByUserId?: string | undefined, projectId: string, publicLinkEnabled: boolean, visibleToProjectAdmins: boolean, visibleToProjectMembers: boolean, responseDeadline?: string | undefined, allowMultipleResponses: boolean, createdAt: string, updatedAt: string, questions: { __typename?: 'SurveyDtoQuestionsConnection', nodes: Array<{ __typename?: 'QuestionDto', id: string, title: string, order: number, isRequired: boolean, fields: Array<{ __typename?: 'QuestionFieldDto', id: string, type: QuestionFieldType, order: number, value?: any | undefined, options?: Array<string> | undefined, metadata?: any | undefined, answerValidationType?: string | undefined }> }> }, createdBy: { __typename?: 'User', firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined } | undefined } }> } };

export type SurveyDtosQueryVariables = Exact<{
  paging?: OffsetPaging;
  filter?: SurveyDtoFilter;
  sorting?: Array<SurveyDtoSort> | SurveyDtoSort;
}>;


export type SurveyDtosQuery = { __typename?: 'Query', surveyDtos: { __typename?: 'SurveyDtoConnection', totalCount: number, nodes: Array<{ __typename?: 'SurveyDto', id: string, title: string, description?: string | undefined, status: SurveyStatus, publishedAt?: string | undefined, createdByUserId: string, updatedByUserId?: string | undefined, projectId: string, publicLinkEnabled: boolean, visibleToProjectAdmins: boolean, visibleToProjectMembers: boolean, responseDeadline?: string | undefined, allowMultipleResponses: boolean, createdAt: string, updatedAt: string, questions: { __typename?: 'SurveyDtoQuestionsConnection', nodes: Array<{ __typename?: 'QuestionDto', id: string, title: string, order: number, isRequired: boolean, fields: Array<{ __typename?: 'QuestionFieldDto', id: string, type: QuestionFieldType, order: number, value?: any | undefined, options?: Array<string> | undefined, metadata?: any | undefined, answerValidationType?: string | undefined }> }> }, createdBy: { __typename?: 'User', firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined } | undefined } }> } };

export type SurveyInvitesQueryVariables = Exact<{
  surveyId: Scalars['String']['input'];
}>;


export type SurveyInvitesQuery = { __typename?: 'Query', surveyInvites: Array<{ __typename?: 'InviteDto', id: string }> };

export type SurveyParticipantsQueryVariables = Exact<{
  filter: SurveyParticipantsFilterDto;
}>;


export type SurveyParticipantsQuery = { __typename?: 'Query', surveyParticipants: Array<{ __typename?: 'SurveyParticipantDto', userId: string, completedResponsesCount: number, firstResponseAt: string, lastResponseAt: string, responseIds: Array<string>, user: { __typename?: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined } | undefined } }> };

export type SurveyPublicQueryVariables = Exact<{
  surveyId: Scalars['String']['input'];
  inviteToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type SurveyPublicQuery = { __typename?: 'Query', surveyPublic?: { __typename?: 'SurveyPublicDto', id: string, title: string, description?: string | undefined, status: SurveyStatus, publishedAt?: string | undefined, allowAnonymous: boolean, questions: Array<{ __typename?: 'QuestionDto', id: string, title: string, order: number, isRequired: boolean, fields: Array<{ __typename?: 'QuestionFieldDto', id: string, type: QuestionFieldType, order: number, value?: any | undefined, options?: Array<string> | undefined, metadata?: any | undefined, answerValidationType?: string | undefined }> }> } | undefined };

export type SurveyPublicLinkQueryVariables = Exact<{
  surveyId: Scalars['String']['input'];
}>;


export type SurveyPublicLinkQuery = { __typename?: 'Query', surveyPublicLink: string };

export type SurveyStatsQueryVariables = Exact<{
  surveyId: Scalars['String']['input'];
}>;


export type SurveyStatsQuery = { __typename?: 'Query', surveyStats: { __typename?: 'SurveyStatsDto', surveyId: string, totalResponses: number, submittedResponses: number, draftResponses: number, questionStats: any, updatedAt: string } };

export type UserCompletedSurveysQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserCompletedSurveysQuery = { __typename?: 'Query', userCompletedSurveys: Array<{ __typename?: 'UserCompletedSurveyDto', surveyId: string, responseId: string, completedAt: string, responsesCount: number, survey: { __typename?: 'SurveyDto', id: string, title: string, description?: string | undefined, status: SurveyStatus, createdAt: string, updatedAt: string } }> };

export type UserSurveyResponseQueryVariables = Exact<{
  surveyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type UserSurveyResponseQuery = { __typename?: 'Query', userSurveyResponse?: { __typename?: 'ResponseDto', id: string, status: ResponseStatus, submittedAt?: string | undefined, createdAt: string, respondent?: { __typename?: 'User', id: string, firstName: string, lastName: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined } | undefined } | undefined, answers: Array<{ __typename?: 'AnswerValueDto', id: string, questionId: string, value?: any | undefined }>, survey?: { __typename?: 'SurveyDto', id: string, title: string, description?: string | undefined, questions: { __typename?: 'SurveyDtoQuestionsConnection', nodes: Array<{ __typename?: 'QuestionDto', id: string, title: string, description?: string | undefined, order: number, isRequired: boolean, fields: Array<{ __typename?: 'QuestionFieldDto', id: string, type: QuestionFieldType, order: number, value?: any | undefined, options?: Array<string> | undefined, metadata?: any | undefined, answerValidationType?: string | undefined }> }> } } | undefined } | undefined };

export type UserMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMeQuery = { __typename?: 'Query', me: { __typename?: 'User', createdAt: string, updatedAt: string, id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, profileChanges?: Array<{ __typename?: 'UserProfileChange', id: string, userId: number, fieldName: string, oldValue?: string | undefined, newValue: string, status: string, adminUserId?: number | undefined, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, nickname: string, firstName: string, lastName: string, patronymic?: string | undefined, gender?: Gender | undefined, dateOfBirth?: string | undefined, phone?: string | undefined, phoneVerified: boolean, email?: string | undefined, emailVerified: boolean, locale: string, isActive: boolean, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined } }> | undefined, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', PROFILE?: string | undefined } | undefined } | undefined } | undefined, addresses?: Array<{ __typename?: 'UserAddress', id: string, region?: string | undefined, city?: string | undefined, cityDistrict?: string | undefined, settlement?: string | undefined, street?: string | undefined, flat?: string | undefined, entrance?: string | undefined, floor?: string | undefined, doorphone?: string | undefined, comment?: string | undefined, isManual: boolean, createdAt: string, updatedAt: string }> | undefined, activityStatus?: { __typename?: 'UserActivityStatus', isOnline: boolean, deviceType?: DeviceType | undefined, lastSeenAt?: string | undefined } | undefined } };

export type UserAuthorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserAuthorQuery = { __typename?: 'Query', user: { __typename?: 'User', firstName: string, lastName: string, nickname: string, dateOfBirth?: string | undefined, addresses?: Array<{ __typename?: 'UserAddress', city?: string | undefined }> | undefined, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined } | undefined } | undefined } | undefined } };

export type WorkspaceMeQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceMeQuery = { __typename?: 'Query', me: { __typename?: 'User', firstName: string, lastName: string, nickname: string, email?: string | undefined } };

export type WorkspaceModulesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  sameUserId: Scalars['String']['input'];
}>;


export type WorkspaceModulesQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, ownerUserId?: string | undefined, media?: { __typename?: 'ProjectMedia', image?: { __typename?: 'ProjectImage', MOBILE?: { __typename?: 'ProjectImageDeviceVariation', LIST?: string | undefined } | undefined } | undefined } | undefined, projectMembers: { __typename?: 'ProjectProjectMembersConnection', nodes: Array<{ __typename?: 'ProjectMember', userId: string }> } }> }, friends: Array<{ __typename?: 'FriendRelationship', friend: { __typename?: 'User', id: string, media?: { __typename?: 'Media', avatar?: { __typename?: 'Avatar', DESKTOP?: { __typename?: 'DesktopVariation', FRIENDS_MINI_AVATAR?: string | undefined } | undefined } | undefined } | undefined } }>, phrase: { __typename?: 'Phrase', text: string } };

export const EmergencyContactFieldsFragmentDoc = gql`
    fragment EmergencyContactFields on EmergencyContact {
  id
  name
  phoneNumber
  category
  projectId
  createdAt
  updatedAt
}
    `;
export const UserAddressFieldsFragmentDoc = gql`
    fragment UserAddressFields on UserAddress {
  id
  region
  city
  cityDistrict
  settlement
  street
  flat
  entrance
  floor
  doorphone
  comment
  isManual
  createdAt
  updatedAt
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  nickname
  firstName
  lastName
  patronymic
  gender
  dateOfBirth
  phone
  phoneVerified
  email
  emailVerified
  locale
  isActive
  activityStatus {
    isOnline
    deviceType
    lastSeenAt
  }
  addresses {
    ...UserAddressFields
  }
}
    ${UserAddressFieldsFragmentDoc}`;
export const FriendRelationshipFieldsFragmentDoc = gql`
    fragment FriendRelationshipFields on FriendRelationship {
  id
  userId
  status
  friend {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const ObjectPassportApplicationFieldsFragmentDoc = gql`
    fragment ObjectPassportApplicationFields on ObjectPassportApplication {
  id
  fullName
  phone
  position
  additionalInfo
  applicationText
  participationFormat
  status
  passportId
  projectId
  moduleSlug
  createdAt
  updatedAt
  moderatedAt
  moderatorComment
  applicantUserId
}
    `;
export const ObjectPassportAttachmentFieldsFragmentDoc = gql`
    fragment ObjectPassportAttachmentFields on ObjectPassportAttachment {
  id
  fileKey
  fileName
  fileSize
  kind
  mimeType
  url
  passportId
  createdAt
}
    `;
export const ObjectPassportFieldsFragmentDoc = gql`
    fragment ObjectPassportFields on ObjectPassport {
  id
  name
  description
  eventType
  contactPersonName
  contactPersonUserId
  contactPhone
  startAt
  endAt
  expectedHeadcount
  location
  moduleSlug
  moduleProgramRelated
  moduleReglamentRelated
  projectId
  timezone
  createdAt
  updatedAt
  attachments {
    ...ObjectPassportAttachmentFields
  }
}
    ${ObjectPassportAttachmentFieldsFragmentDoc}`;
export const PlannerCalendarEventItemFieldsFragmentDoc = gql`
    fragment PlannerCalendarEventItemFields on CalendarEvent {
  id
  completed
  title
  description
  priority
  location
  startAt
  endAt
  isAllDay
  timezone
  ownerUserId
  projectId
  createdAt
  updatedAt
  participants {
    id
    userId
    status
    createdAt
    user {
      id
      firstName
      lastName
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            PROFILE
          }
        }
      }
    }
  }
  attachments {
    id
    fileName
    mimeType
    fileSize
    fileKey
    url
  }
  reminders {
    id
    remindAt
    method
    status
  }
  recurrenceGroupId
  recurrenceFrequency
  recurrenceInterval
  recurrenceUntil
  isRecurrenceMaster
  comments {
    commentCount
    unreadCount
  }
}
    `;
export const ProgramItemAttachmentFieldsFragmentDoc = gql`
    fragment ProgramItemAttachmentFields on ProgramItemAttachment {
  id
  programItemId
  kind
  fileName
  mimeType
  fileSize
  fileKey
  url
  uploadedByUserId
  createdAt
}
    `;
export const ProgramItemFieldsFragmentDoc = gql`
    fragment ProgramItemFields on ProgramItem {
  id
  projectId
  moduleSlug
  name
  contactPersonName
  contactPersonUserId
  startAt
  endAt
  timezone
  location
  sortOrder
  createdByUserId
  updatedByUserId
  createdAt
  updatedAt
  attachments {
    ...ProgramItemAttachmentFields
  }
}
    ${ProgramItemAttachmentFieldsFragmentDoc}`;
export const ProjectMemberFieldsFragmentDoc = gql`
    fragment ProjectMemberFields on ProjectMember {
  id
  projectId
  userId
  role
  createdAt
  updatedAt
  user {
    ...UserFields
    media {
      avatar {
        DESKTOP {
          PROFILE
        }
      }
      background {
        DESKTOP {
          ORIGINAL
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const ProjectFieldsFragmentDoc = gql`
    fragment ProjectFields on Project {
  id
  slug
  name
  photo
  shortDescription
  detailedDescription
  themes
  startDate
  endDate
  templateType
  visibility
  workspacePreset
  ownerUserId
  projectRequestId
  createdAt
  updatedAt
  owner {
    ...UserFields
  }
  projectMembers {
    nodes {
      ...ProjectMemberFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${ProjectMemberFieldsFragmentDoc}`;
export const ProjectRequestFieldsFragmentDoc = gql`
    fragment ProjectRequestFields on ProjectRequest {
  id
  name
  photo
  shortDescription
  detailedDescription
  themes
  startDate
  endDate
  visibility
  userId
  status
  projectId
  templateType
  workspacePreset
  rejections {
    projectRequestId
    reason
    rejectedByUserId
  }
  media {
    logo
    image {
      DESKTOP {
        OPEN_REQUEST
        OPEN_PROJECT
      }
      TABLET {
        OPEN_REQUEST
        OPEN_PROJECT
      }
      MOBILE {
        OPEN_REQUEST
        OPEN_PROJECT
      }
    }
  }
  createdAt
  updatedAt
}
    `;
export const ProjectSupporterFieldsFragmentDoc = gql`
    fragment ProjectSupporterFields on ProjectSupporter {
  firstName
  lastName
  middleName
  gender
  birthday
  region
  city
  cityDistrict
  settlement
  street
  flat
  entrance
  floor
  doorphone
  postalCode
  addressComment
  isManual
  comment
  email
  phoneNumber
  projectId
  companyName
  companyPosition
  companyPhone
  companyEmail
  companyRegion
  companyCity
  companyCityDistrict
  companySettlement
  companyStreet
  companyFlat
  companyEntrance
  companyFloor
  companyDoorphone
  companyAddressComment
  companyPostalCode
  companyIsManual
  holidayName
  holidayDate
  createdAt
  updatedAt
}
    `;
export const ReglamentItemFieldsFragmentDoc = gql`
    fragment ReglamentItemFields on ReglamentItem {
  id
  projectId
  moduleSlug
  speakerName
  reportTopic
  startAt
  endAt
  questionsStartAt
  questionsEndAt
  timezone
  sortOrder
  createdByUserId
  updatedByUserId
  createdAt
  updatedAt
}
    `;
export const PlatformSummaryReportEntityFragmentDoc = gql`
    fragment PlatformSummaryReportEntity on PlatformSummaryReportEntity {
  id
  totalRegisteredUsers
  totalProjects
  totalProjectOwners
  totalProjectParticipants
  averageSessionDuration
  activeUsersCount
  totalFriendships
  periodStart
  periodEnd
  reportDate
  createdAt
  updatedAt
}
    `;
export const ProjectDetailedReportEntityFragmentDoc = gql`
    fragment ProjectDetailedReportEntity on ProjectDetailedReportEntity {
  id
  projectId
  projectName
  projectOwnerName
  totalParticipantsCount
  activeParticipantsCount
  averageSessionDuration
  reportDate
  createdAt
  updatedAt
}
    `;
export const RegionalReportEntityFragmentDoc = gql`
    fragment RegionalReportEntity on RegionalReportEntity {
  id
  region
  registeredUsersCount
  projectParticipantsCount
  averageSessionDuration
  reportDate
  createdAt
  updatedAt
}
    `;
export const UserDetailedReportEntityFragmentDoc = gql`
    fragment UserDetailedReportEntity on UserDetailedReportEntity {
  id
  userId
  fullName
  ownedProjectsCount
  friendsCount
  averageSessionDuration
  reportDate
  createdAt
  updatedAt
}
    `;
export const TokenFieldsFragmentDoc = gql`
    fragment TokenFields on AuthResponse {
  access_token
  refresh_token
  token_type
  expires_in
  refresh_expires_in
}
    `;
export const ConfirmVerificationCodeDocument = gql`
    mutation confirmVerificationCode($input: VerifyRequest!) {
  confirmVerificationCode(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useConfirmVerificationCodeMutation__
 *
 * To run a mutation, you first call `useConfirmVerificationCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmVerificationCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmVerificationCodeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConfirmVerificationCodeMutation(options: VueApolloComposable.UseMutationOptions<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>(ConfirmVerificationCodeDocument, options);
}
export type ConfirmVerificationCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmVerificationCodeMutation, ConfirmVerificationCodeMutationVariables>;
export const LoginDocument = gql`
    mutation login($username: String, $email: String, $phone: String, $password: String!) {
  login(
    registerUserInput: {username: $username, email: $email, phone: $phone, password: $password}
  ) {
    ...TokenFields
  }
}
    ${TokenFieldsFragmentDoc}`;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLoginMutation({
 *   variables: {
 *     username: // value for 'username'
 *     email: // value for 'email'
 *     phone: // value for 'phone'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(options: VueApolloComposable.UseMutationOptions<LoginMutation, LoginMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LoginMutation, LoginMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LoginMutation, LoginMutationVariables>;
export const LoginByCodeDocument = gql`
    mutation loginByCode($refreshToken: String!, $code: String!) {
  loginByCode(refreshToken: $refreshToken, code: $code) {
    ...TokenFields
  }
}
    ${TokenFieldsFragmentDoc}`;

/**
 * __useLoginByCodeMutation__
 *
 * To run a mutation, you first call `useLoginByCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLoginByCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLoginByCodeMutation({
 *   variables: {
 *     refreshToken: // value for 'refreshToken'
 *     code: // value for 'code'
 *   },
 * });
 */
export function useLoginByCodeMutation(options: VueApolloComposable.UseMutationOptions<LoginByCodeMutation, LoginByCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LoginByCodeMutation, LoginByCodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<LoginByCodeMutation, LoginByCodeMutationVariables>(LoginByCodeDocument, options);
}
export type LoginByCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LoginByCodeMutation, LoginByCodeMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    ...TokenFields
  }
}
    ${TokenFieldsFragmentDoc}`;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefreshTokenMutation({
 *   variables: {
 *     refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(options: VueApolloComposable.UseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
}
export type RefreshTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const RegisterUserDocument = gql`
    mutation registerUser($input: RegisterUserRequest!) {
  registerUser(registerUserInput: $input) {
    ...TokenFields
  }
}
    ${TokenFieldsFragmentDoc}`;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(options: VueApolloComposable.UseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
}
export type RegisterUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegisterUserMutation, RegisterUserMutationVariables>;
export const RemoveLoginCodeDocument = gql`
    mutation removeLoginCode {
  removeLoginCode
}
    `;

/**
 * __useRemoveLoginCodeMutation__
 *
 * To run a mutation, you first call `useRemoveLoginCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLoginCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveLoginCodeMutation();
 */
export function useRemoveLoginCodeMutation(options: VueApolloComposable.UseMutationOptions<RemoveLoginCodeMutation, RemoveLoginCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveLoginCodeMutation, RemoveLoginCodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveLoginCodeMutation, RemoveLoginCodeMutationVariables>(RemoveLoginCodeDocument, options);
}
export type RemoveLoginCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveLoginCodeMutation, RemoveLoginCodeMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation requestPasswordReset($identifier: String!, $method: String!) {
  requestPasswordReset(identifier: $identifier, method: $method)
}
    `;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestPasswordResetMutation({
 *   variables: {
 *     identifier: // value for 'identifier'
 *     method: // value for 'method'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(options: VueApolloComposable.UseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
}
export type RequestPasswordResetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const RevokeTokenDocument = gql`
    mutation revokeToken($token: String!) {
  revokeToken(token: $token)
}
    `;

/**
 * __useRevokeTokenMutation__
 *
 * To run a mutation, you first call `useRevokeTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeTokenMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useRevokeTokenMutation(options: VueApolloComposable.UseMutationOptions<RevokeTokenMutation, RevokeTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RevokeTokenMutation, RevokeTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RevokeTokenMutation, RevokeTokenMutationVariables>(RevokeTokenDocument, options);
}
export type RevokeTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RevokeTokenMutation, RevokeTokenMutationVariables>;
export const SendVerificationCodeDocument = gql`
    mutation sendVerificationCode($input: SendVerificationCodeRequest!) {
  sendVerificationCode(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useSendVerificationCodeMutation__
 *
 * To run a mutation, you first call `useSendVerificationCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendVerificationCodeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSendVerificationCodeMutation(options: VueApolloComposable.UseMutationOptions<SendVerificationCodeMutation, SendVerificationCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>(SendVerificationCodeDocument, options);
}
export type SendVerificationCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>;
export const SetLoginCodeDocument = gql`
    mutation setLoginCode($code: String!) {
  setLoginCode(code: $code)
}
    `;

/**
 * __useSetLoginCodeMutation__
 *
 * To run a mutation, you first call `useSetLoginCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetLoginCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetLoginCodeMutation({
 *   variables: {
 *     code: // value for 'code'
 *   },
 * });
 */
export function useSetLoginCodeMutation(options: VueApolloComposable.UseMutationOptions<SetLoginCodeMutation, SetLoginCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetLoginCodeMutation, SetLoginCodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetLoginCodeMutation, SetLoginCodeMutationVariables>(SetLoginCodeDocument, options);
}
export type SetLoginCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetLoginCodeMutation, SetLoginCodeMutationVariables>;
export const SetNewPasswordAfterResetDocument = gql`
    mutation setNewPasswordAfterReset($identifier: String!, $newPassword: String!) {
  setNewPasswordAfterReset(identifier: $identifier, newPassword: $newPassword)
}
    `;

/**
 * __useSetNewPasswordAfterResetMutation__
 *
 * To run a mutation, you first call `useSetNewPasswordAfterResetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetNewPasswordAfterResetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetNewPasswordAfterResetMutation({
 *   variables: {
 *     identifier: // value for 'identifier'
 *     newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useSetNewPasswordAfterResetMutation(options: VueApolloComposable.UseMutationOptions<SetNewPasswordAfterResetMutation, SetNewPasswordAfterResetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetNewPasswordAfterResetMutation, SetNewPasswordAfterResetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetNewPasswordAfterResetMutation, SetNewPasswordAfterResetMutationVariables>(SetNewPasswordAfterResetDocument, options);
}
export type SetNewPasswordAfterResetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetNewPasswordAfterResetMutation, SetNewPasswordAfterResetMutationVariables>;
export const SubmitContactRequestDocument = gql`
    mutation submitContactRequest($input: SubmitContactRequestInput!) {
  submitContactRequest(input: $input) {
    id
    subject
    description
    senderEmail
    status
    createdAt
    mediaUrls
  }
}
    `;

/**
 * __useSubmitContactRequestMutation__
 *
 * To run a mutation, you first call `useSubmitContactRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitContactRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitContactRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSubmitContactRequestMutation(options: VueApolloComposable.UseMutationOptions<SubmitContactRequestMutation, SubmitContactRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SubmitContactRequestMutation, SubmitContactRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SubmitContactRequestMutation, SubmitContactRequestMutationVariables>(SubmitContactRequestDocument, options);
}
export type SubmitContactRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SubmitContactRequestMutation, SubmitContactRequestMutationVariables>;
export const VerifyPasswordResetOtpDocument = gql`
    mutation verifyPasswordResetOtp($identifier: String!, $otpCode: String!) {
  verifyPasswordResetOtp(identifier: $identifier, otpCode: $otpCode)
}
    `;

/**
 * __useVerifyPasswordResetOtpMutation__
 *
 * To run a mutation, you first call `useVerifyPasswordResetOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasswordResetOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVerifyPasswordResetOtpMutation({
 *   variables: {
 *     identifier: // value for 'identifier'
 *     otpCode: // value for 'otpCode'
 *   },
 * });
 */
export function useVerifyPasswordResetOtpMutation(options: VueApolloComposable.UseMutationOptions<VerifyPasswordResetOtpMutation, VerifyPasswordResetOtpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<VerifyPasswordResetOtpMutation, VerifyPasswordResetOtpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<VerifyPasswordResetOtpMutation, VerifyPasswordResetOtpMutationVariables>(VerifyPasswordResetOtpDocument, options);
}
export type VerifyPasswordResetOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<VerifyPasswordResetOtpMutation, VerifyPasswordResetOtpMutationVariables>;
export const AddCalendarEventParticipantsDocument = gql`
    mutation addCalendarEventParticipants($input: AddCalendarEventParticipantsInput!) {
  addCalendarEventParticipants(input: $input) {
    id
    participants {
      userId
      status
    }
  }
}
    `;

/**
 * __useAddCalendarEventParticipantsMutation__
 *
 * To run a mutation, you first call `useAddCalendarEventParticipantsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCalendarEventParticipantsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCalendarEventParticipantsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddCalendarEventParticipantsMutation(options: VueApolloComposable.UseMutationOptions<AddCalendarEventParticipantsMutation, AddCalendarEventParticipantsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddCalendarEventParticipantsMutation, AddCalendarEventParticipantsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddCalendarEventParticipantsMutation, AddCalendarEventParticipantsMutationVariables>(AddCalendarEventParticipantsDocument, options);
}
export type AddCalendarEventParticipantsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddCalendarEventParticipantsMutation, AddCalendarEventParticipantsMutationVariables>;
export const CreateCalendarEventDocument = gql`
    mutation createCalendarEvent($input: CreateCalendarEventInput!) {
  createCalendarEvent(input: $input) {
    ...PlannerCalendarEventItemFields
  }
}
    ${PlannerCalendarEventItemFieldsFragmentDoc}`;

/**
 * __useCreateCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateCalendarEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCalendarEventMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalendarEventMutation(options: VueApolloComposable.UseMutationOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>(CreateCalendarEventDocument, options);
}
export type CreateCalendarEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;
export const DeleteCalendarEventDocument = gql`
    mutation deleteCalendarEvent($input: DeleteCalendarEventInput!) {
  deleteCalendarEvent(input: $input) {
    id
    success
    message
  }
}
    `;

/**
 * __useDeleteCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCalendarEventMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCalendarEventMutation(options: VueApolloComposable.UseMutationOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>(DeleteCalendarEventDocument, options);
}
export type DeleteCalendarEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>;
export const LeaveCalendarEventDocument = gql`
    mutation leaveCalendarEvent($eventId: ID!) {
  leaveCalendarEvent(eventId: $eventId) {
    id
  }
}
    `;

/**
 * __useLeaveCalendarEventMutation__
 *
 * To run a mutation, you first call `useLeaveCalendarEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCalendarEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLeaveCalendarEventMutation({
 *   variables: {
 *     eventId: // value for 'eventId'
 *   },
 * });
 */
export function useLeaveCalendarEventMutation(options: VueApolloComposable.UseMutationOptions<LeaveCalendarEventMutation, LeaveCalendarEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LeaveCalendarEventMutation, LeaveCalendarEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<LeaveCalendarEventMutation, LeaveCalendarEventMutationVariables>(LeaveCalendarEventDocument, options);
}
export type LeaveCalendarEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LeaveCalendarEventMutation, LeaveCalendarEventMutationVariables>;
export const RemoveCalendarEventParticipantDocument = gql`
    mutation removeCalendarEventParticipant($input: RemoveCalendarEventParticipantInput!) {
  removeCalendarEventParticipant(input: $input) {
    id
  }
}
    `;

/**
 * __useRemoveCalendarEventParticipantMutation__
 *
 * To run a mutation, you first call `useRemoveCalendarEventParticipantMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCalendarEventParticipantMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveCalendarEventParticipantMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCalendarEventParticipantMutation(options: VueApolloComposable.UseMutationOptions<RemoveCalendarEventParticipantMutation, RemoveCalendarEventParticipantMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveCalendarEventParticipantMutation, RemoveCalendarEventParticipantMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveCalendarEventParticipantMutation, RemoveCalendarEventParticipantMutationVariables>(RemoveCalendarEventParticipantDocument, options);
}
export type RemoveCalendarEventParticipantMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveCalendarEventParticipantMutation, RemoveCalendarEventParticipantMutationVariables>;
export const UpdateCalendarEventDocument = gql`
    mutation updateCalendarEvent($input: UpdateCalendarEventInput!) {
  updateCalendarEvent(input: $input) {
    ...PlannerCalendarEventItemFields
  }
}
    ${PlannerCalendarEventItemFieldsFragmentDoc}`;

/**
 * __useUpdateCalendarEventMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCalendarEventMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalendarEventMutation(options: VueApolloComposable.UseMutationOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>(UpdateCalendarEventDocument, options);
}
export type UpdateCalendarEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>;
export const UpdateCalendarEventParticipantStatusDocument = gql`
    mutation updateCalendarEventParticipantStatus($input: UpdateCalendarEventParticipantStatusInput!) {
  updateCalendarEventParticipantStatus(input: $input) {
    id
    participants {
      userId
      status
    }
  }
}
    `;

/**
 * __useUpdateCalendarEventParticipantStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarEventParticipantStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarEventParticipantStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCalendarEventParticipantStatusMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalendarEventParticipantStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateCalendarEventParticipantStatusMutation, UpdateCalendarEventParticipantStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCalendarEventParticipantStatusMutation, UpdateCalendarEventParticipantStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCalendarEventParticipantStatusMutation, UpdateCalendarEventParticipantStatusMutationVariables>(UpdateCalendarEventParticipantStatusDocument, options);
}
export type UpdateCalendarEventParticipantStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCalendarEventParticipantStatusMutation, UpdateCalendarEventParticipantStatusMutationVariables>;
export const CreateOneCommentDocument = gql`
    mutation createOneComment($input: CreateOneCommentInput!) {
  createOneComment(input: $input) {
    id
    content
    commentableType
    commentableId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateOneCommentMutation__
 *
 * To run a mutation, you first call `useCreateOneCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneCommentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneCommentMutation(options: VueApolloComposable.UseMutationOptions<CreateOneCommentMutation, CreateOneCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneCommentMutation, CreateOneCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneCommentMutation, CreateOneCommentMutationVariables>(CreateOneCommentDocument, options);
}
export type CreateOneCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneCommentMutation, CreateOneCommentMutationVariables>;
export const DeleteOneCommentDocument = gql`
    mutation deleteOneComment($input: DeleteOneCommentInput!) {
  deleteOneComment(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteOneCommentMutation__
 *
 * To run a mutation, you first call `useDeleteOneCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOneCommentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOneCommentMutation(options: VueApolloComposable.UseMutationOptions<DeleteOneCommentMutation, DeleteOneCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOneCommentMutation, DeleteOneCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOneCommentMutation, DeleteOneCommentMutationVariables>(DeleteOneCommentDocument, options);
}
export type DeleteOneCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOneCommentMutation, DeleteOneCommentMutationVariables>;
export const MarkCommentsReadDocument = gql`
    mutation MarkCommentsRead($commentIds: [ID!]!) {
  markCommentsRead(commentIds: $commentIds)
}
    `;

/**
 * __useMarkCommentsReadMutation__
 *
 * To run a mutation, you first call `useMarkCommentsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommentsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkCommentsReadMutation({
 *   variables: {
 *     commentIds: // value for 'commentIds'
 *   },
 * });
 */
export function useMarkCommentsReadMutation(options: VueApolloComposable.UseMutationOptions<MarkCommentsReadMutation, MarkCommentsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkCommentsReadMutation, MarkCommentsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkCommentsReadMutation, MarkCommentsReadMutationVariables>(MarkCommentsReadDocument, options);
}
export type MarkCommentsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkCommentsReadMutation, MarkCommentsReadMutationVariables>;
export const UpdateOneCommentDocument = gql`
    mutation updateOneComment($input: UpdateOneCommentInput!) {
  updateOneComment(input: $input) {
    id
    content
    commentableId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useUpdateOneCommentMutation__
 *
 * To run a mutation, you first call `useUpdateOneCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOneCommentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneCommentMutation(options: VueApolloComposable.UseMutationOptions<UpdateOneCommentMutation, UpdateOneCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOneCommentMutation, UpdateOneCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOneCommentMutation, UpdateOneCommentMutationVariables>(UpdateOneCommentDocument, options);
}
export type UpdateOneCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOneCommentMutation, UpdateOneCommentMutationVariables>;
export const CreateCounterReadingDocument = gql`
    mutation createCounterReading($input: CreateCounterReadingInput!) {
  createCounterReading(input: $input) {
    id
    year
    month
    reading
    consumption
    cost
    recordedAt
  }
}
    `;

/**
 * __useCreateCounterReadingMutation__
 *
 * To run a mutation, you first call `useCreateCounterReadingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCounterReadingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCounterReadingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCounterReadingMutation(options: VueApolloComposable.UseMutationOptions<CreateCounterReadingMutation, CreateCounterReadingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCounterReadingMutation, CreateCounterReadingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCounterReadingMutation, CreateCounterReadingMutationVariables>(CreateCounterReadingDocument, options);
}
export type CreateCounterReadingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCounterReadingMutation, CreateCounterReadingMutationVariables>;
export const DeleteCounterReadingDocument = gql`
    mutation deleteCounterReading($input: DeleteCounterReadingInput!) {
  deleteCounterReading(input: $input) {
    id
    success
    message
  }
}
    `;

/**
 * __useDeleteCounterReadingMutation__
 *
 * To run a mutation, you first call `useDeleteCounterReadingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCounterReadingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCounterReadingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCounterReadingMutation(options: VueApolloComposable.UseMutationOptions<DeleteCounterReadingMutation, DeleteCounterReadingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCounterReadingMutation, DeleteCounterReadingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCounterReadingMutation, DeleteCounterReadingMutationVariables>(DeleteCounterReadingDocument, options);
}
export type DeleteCounterReadingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCounterReadingMutation, DeleteCounterReadingMutationVariables>;
export const InitializeProjectCountersDocument = gql`
    mutation initializeProjectCounters($projectId: ID!) {
  initializeProjectCounters(projectId: $projectId) {
    id
    type
    category
    name
    unit
  }
}
    `;

/**
 * __useInitializeProjectCountersMutation__
 *
 * To run a mutation, you first call `useInitializeProjectCountersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInitializeProjectCountersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInitializeProjectCountersMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useInitializeProjectCountersMutation(options: VueApolloComposable.UseMutationOptions<InitializeProjectCountersMutation, InitializeProjectCountersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InitializeProjectCountersMutation, InitializeProjectCountersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InitializeProjectCountersMutation, InitializeProjectCountersMutationVariables>(InitializeProjectCountersDocument, options);
}
export type InitializeProjectCountersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InitializeProjectCountersMutation, InitializeProjectCountersMutationVariables>;
export const UpdateCounterDocument = gql`
    mutation updateCounter($input: UpdateCounterInput!) {
  updateCounter(input: $input) {
    id
    name
    serialNumber
    nextVerificationDate
  }
}
    `;

/**
 * __useUpdateCounterMutation__
 *
 * To run a mutation, you first call `useUpdateCounterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCounterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCounterMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCounterMutation(options: VueApolloComposable.UseMutationOptions<UpdateCounterMutation, UpdateCounterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCounterMutation, UpdateCounterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCounterMutation, UpdateCounterMutationVariables>(UpdateCounterDocument, options);
}
export type UpdateCounterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCounterMutation, UpdateCounterMutationVariables>;
export const UpdateCounterReadingDocument = gql`
    mutation updateCounterReading($input: UpdateCounterReadingInput!) {
  updateCounterReading(input: $input) {
    id
    reading
    consumption
    cost
    recordedAt
    note
  }
}
    `;

/**
 * __useUpdateCounterReadingMutation__
 *
 * To run a mutation, you first call `useUpdateCounterReadingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCounterReadingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCounterReadingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCounterReadingMutation(options: VueApolloComposable.UseMutationOptions<UpdateCounterReadingMutation, UpdateCounterReadingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCounterReadingMutation, UpdateCounterReadingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCounterReadingMutation, UpdateCounterReadingMutationVariables>(UpdateCounterReadingDocument, options);
}
export type UpdateCounterReadingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCounterReadingMutation, UpdateCounterReadingMutationVariables>;
export const CreateEmergencyContactDocument = gql`
    mutation createEmergencyContact($input: CreateEmergencyContactInput!) {
  createEmergencyContact(input: $input) {
    id
    ...EmergencyContactFields
  }
}
    ${EmergencyContactFieldsFragmentDoc}`;

/**
 * __useCreateEmergencyContactMutation__
 *
 * To run a mutation, you first call `useCreateEmergencyContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmergencyContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateEmergencyContactMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmergencyContactMutation(options: VueApolloComposable.UseMutationOptions<CreateEmergencyContactMutation, CreateEmergencyContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateEmergencyContactMutation, CreateEmergencyContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateEmergencyContactMutation, CreateEmergencyContactMutationVariables>(CreateEmergencyContactDocument, options);
}
export type CreateEmergencyContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateEmergencyContactMutation, CreateEmergencyContactMutationVariables>;
export const DeleteEmergencyContactDocument = gql`
    mutation deleteEmergencyContact($input: DeleteEmergencyContactInput!) {
  deleteEmergencyContact(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteEmergencyContactMutation__
 *
 * To run a mutation, you first call `useDeleteEmergencyContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmergencyContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteEmergencyContactMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEmergencyContactMutation(options: VueApolloComposable.UseMutationOptions<DeleteEmergencyContactMutation, DeleteEmergencyContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteEmergencyContactMutation, DeleteEmergencyContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteEmergencyContactMutation, DeleteEmergencyContactMutationVariables>(DeleteEmergencyContactDocument, options);
}
export type DeleteEmergencyContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteEmergencyContactMutation, DeleteEmergencyContactMutationVariables>;
export const UpdateEmergencyContactDocument = gql`
    mutation updateEmergencyContact($input: UpdateEmergencyContactInput!) {
  updateEmergencyContact(input: $input) {
    ...EmergencyContactFields
  }
}
    ${EmergencyContactFieldsFragmentDoc}`;

/**
 * __useUpdateEmergencyContactMutation__
 *
 * To run a mutation, you first call `useUpdateEmergencyContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmergencyContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEmergencyContactMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmergencyContactMutation(options: VueApolloComposable.UseMutationOptions<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>(UpdateEmergencyContactDocument, options);
}
export type UpdateEmergencyContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>;
export const AcceptFriendRequestDocument = gql`
    mutation acceptFriendRequest($friendId: String!) {
  acceptFriendRequest(friendId: $friendId) {
    ...FriendRelationshipFields
  }
}
    ${FriendRelationshipFieldsFragmentDoc}`;

/**
 * __useAcceptFriendRequestMutation__
 *
 * To run a mutation, you first call `useAcceptFriendRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptFriendRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptFriendRequestMutation({
 *   variables: {
 *     friendId: // value for 'friendId'
 *   },
 * });
 */
export function useAcceptFriendRequestMutation(options: VueApolloComposable.UseMutationOptions<AcceptFriendRequestMutation, AcceptFriendRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptFriendRequestMutation, AcceptFriendRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AcceptFriendRequestMutation, AcceptFriendRequestMutationVariables>(AcceptFriendRequestDocument, options);
}
export type AcceptFriendRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptFriendRequestMutation, AcceptFriendRequestMutationVariables>;
export const CancelOutgoingFriendRequestDocument = gql`
    mutation cancelOutgoingFriendRequest($friendId: String!) {
  cancelOutgoingFriendRequest(friendId: $friendId)
}
    `;

/**
 * __useCancelOutgoingFriendRequestMutation__
 *
 * To run a mutation, you first call `useCancelOutgoingFriendRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelOutgoingFriendRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelOutgoingFriendRequestMutation({
 *   variables: {
 *     friendId: // value for 'friendId'
 *   },
 * });
 */
export function useCancelOutgoingFriendRequestMutation(options: VueApolloComposable.UseMutationOptions<CancelOutgoingFriendRequestMutation, CancelOutgoingFriendRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelOutgoingFriendRequestMutation, CancelOutgoingFriendRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelOutgoingFriendRequestMutation, CancelOutgoingFriendRequestMutationVariables>(CancelOutgoingFriendRequestDocument, options);
}
export type CancelOutgoingFriendRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelOutgoingFriendRequestMutation, CancelOutgoingFriendRequestMutationVariables>;
export const ConvertSubscriberToFriendDocument = gql`
    mutation convertSubscriberToFriend($subscriberId: String!) {
  convertSubscriberToFriend(subscriberId: $subscriberId) {
    ...FriendRelationshipFields
  }
}
    ${FriendRelationshipFieldsFragmentDoc}`;

/**
 * __useConvertSubscriberToFriendMutation__
 *
 * To run a mutation, you first call `useConvertSubscriberToFriendMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConvertSubscriberToFriendMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConvertSubscriberToFriendMutation({
 *   variables: {
 *     subscriberId: // value for 'subscriberId'
 *   },
 * });
 */
export function useConvertSubscriberToFriendMutation(options: VueApolloComposable.UseMutationOptions<ConvertSubscriberToFriendMutation, ConvertSubscriberToFriendMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConvertSubscriberToFriendMutation, ConvertSubscriberToFriendMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConvertSubscriberToFriendMutation, ConvertSubscriberToFriendMutationVariables>(ConvertSubscriberToFriendDocument, options);
}
export type ConvertSubscriberToFriendMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConvertSubscriberToFriendMutation, ConvertSubscriberToFriendMutationVariables>;
export const RejectIncomingFriendRequestDocument = gql`
    mutation rejectIncomingFriendRequest($requesterId: String!) {
  rejectIncomingFriendRequest(requesterId: $requesterId)
}
    `;

/**
 * __useRejectIncomingFriendRequestMutation__
 *
 * To run a mutation, you first call `useRejectIncomingFriendRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectIncomingFriendRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectIncomingFriendRequestMutation({
 *   variables: {
 *     requesterId: // value for 'requesterId'
 *   },
 * });
 */
export function useRejectIncomingFriendRequestMutation(options: VueApolloComposable.UseMutationOptions<RejectIncomingFriendRequestMutation, RejectIncomingFriendRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectIncomingFriendRequestMutation, RejectIncomingFriendRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RejectIncomingFriendRequestMutation, RejectIncomingFriendRequestMutationVariables>(RejectIncomingFriendRequestDocument, options);
}
export type RejectIncomingFriendRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectIncomingFriendRequestMutation, RejectIncomingFriendRequestMutationVariables>;
export const RemoveFriendDocument = gql`
    mutation removeFriend($friendId: String!) {
  removeFriend(friendId: $friendId) {
    ...FriendRelationshipFields
  }
}
    ${FriendRelationshipFieldsFragmentDoc}`;

/**
 * __useRemoveFriendMutation__
 *
 * To run a mutation, you first call `useRemoveFriendMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFriendMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveFriendMutation({
 *   variables: {
 *     friendId: // value for 'friendId'
 *   },
 * });
 */
export function useRemoveFriendMutation(options: VueApolloComposable.UseMutationOptions<RemoveFriendMutation, RemoveFriendMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveFriendMutation, RemoveFriendMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveFriendMutation, RemoveFriendMutationVariables>(RemoveFriendDocument, options);
}
export type RemoveFriendMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveFriendMutation, RemoveFriendMutationVariables>;
export const RemoveSubscriberDocument = gql`
    mutation removeSubscriber($friendId: String!) {
  removeSubscriber(friendId: $friendId)
}
    `;

/**
 * __useRemoveSubscriberMutation__
 *
 * To run a mutation, you first call `useRemoveSubscriberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSubscriberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveSubscriberMutation({
 *   variables: {
 *     friendId: // value for 'friendId'
 *   },
 * });
 */
export function useRemoveSubscriberMutation(options: VueApolloComposable.UseMutationOptions<RemoveSubscriberMutation, RemoveSubscriberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveSubscriberMutation, RemoveSubscriberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveSubscriberMutation, RemoveSubscriberMutationVariables>(RemoveSubscriberDocument, options);
}
export type RemoveSubscriberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveSubscriberMutation, RemoveSubscriberMutationVariables>;
export const SendFriendRequestDocument = gql`
    mutation sendFriendRequest($friendId: String!) {
  sendFriendRequest(friendId: $friendId) {
    ...FriendRelationshipFields
  }
}
    ${FriendRelationshipFieldsFragmentDoc}`;

/**
 * __useSendFriendRequestMutation__
 *
 * To run a mutation, you first call `useSendFriendRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendFriendRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendFriendRequestMutation({
 *   variables: {
 *     friendId: // value for 'friendId'
 *   },
 * });
 */
export function useSendFriendRequestMutation(options: VueApolloComposable.UseMutationOptions<SendFriendRequestMutation, SendFriendRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendFriendRequestMutation, SendFriendRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendFriendRequestMutation, SendFriendRequestMutationVariables>(SendFriendRequestDocument, options);
}
export type SendFriendRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendFriendRequestMutation, SendFriendRequestMutationVariables>;
export const WithdrawFriendRequestDocument = gql`
    mutation withdrawFriendRequest($friendId: String!) {
  withdrawFriendRequest(friendId: $friendId)
}
    `;

/**
 * __useWithdrawFriendRequestMutation__
 *
 * To run a mutation, you first call `useWithdrawFriendRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawFriendRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useWithdrawFriendRequestMutation({
 *   variables: {
 *     friendId: // value for 'friendId'
 *   },
 * });
 */
export function useWithdrawFriendRequestMutation(options: VueApolloComposable.UseMutationOptions<WithdrawFriendRequestMutation, WithdrawFriendRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<WithdrawFriendRequestMutation, WithdrawFriendRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<WithdrawFriendRequestMutation, WithdrawFriendRequestMutationVariables>(WithdrawFriendRequestDocument, options);
}
export type WithdrawFriendRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<WithdrawFriendRequestMutation, WithdrawFriendRequestMutationVariables>;
export const UpsertGlobalModuleAccessSettingsDocument = gql`
    mutation upsertGlobalModuleAccessSettings($input: UpsertGlobalModuleAccessSettingsInput!) {
  upsertGlobalModuleAccessSettings(input: $input) {
    id
    moduleSlug
    dataEntryScope
    dataEntryUserIds
    editParticipantScope
    editUserIds
    fullAccessUserIds
  }
}
    `;

/**
 * __useUpsertGlobalModuleAccessSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertGlobalModuleAccessSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGlobalModuleAccessSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertGlobalModuleAccessSettingsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertGlobalModuleAccessSettingsMutation(options: VueApolloComposable.UseMutationOptions<UpsertGlobalModuleAccessSettingsMutation, UpsertGlobalModuleAccessSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertGlobalModuleAccessSettingsMutation, UpsertGlobalModuleAccessSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertGlobalModuleAccessSettingsMutation, UpsertGlobalModuleAccessSettingsMutationVariables>(UpsertGlobalModuleAccessSettingsDocument, options);
}
export type UpsertGlobalModuleAccessSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertGlobalModuleAccessSettingsMutation, UpsertGlobalModuleAccessSettingsMutationVariables>;
export const CreateMailThreadDocument = gql`
    mutation createMailThread($input: CreateMailThreadInput!) {
  createMailThread(input: $input) {
    id
    registrationNumber
    status
    creatorUserId
    recipientUserId
    messageCount
    lastMessageAt
    isRead
    createdAt
  }
}
    `;

/**
 * __useCreateMailThreadMutation__
 *
 * To run a mutation, you first call `useCreateMailThreadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailThreadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMailThreadMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMailThreadMutation(options: VueApolloComposable.UseMutationOptions<CreateMailThreadMutation, CreateMailThreadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMailThreadMutation, CreateMailThreadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateMailThreadMutation, CreateMailThreadMutationVariables>(CreateMailThreadDocument, options);
}
export type CreateMailThreadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMailThreadMutation, CreateMailThreadMutationVariables>;
export const MarkMailThreadAsReadDocument = gql`
    mutation markMailThreadAsRead($threadId: ID!) {
  markMailThreadAsRead(threadId: $threadId)
}
    `;

/**
 * __useMarkMailThreadAsReadMutation__
 *
 * To run a mutation, you first call `useMarkMailThreadAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkMailThreadAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkMailThreadAsReadMutation({
 *   variables: {
 *     threadId: // value for 'threadId'
 *   },
 * });
 */
export function useMarkMailThreadAsReadMutation(options: VueApolloComposable.UseMutationOptions<MarkMailThreadAsReadMutation, MarkMailThreadAsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkMailThreadAsReadMutation, MarkMailThreadAsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkMailThreadAsReadMutation, MarkMailThreadAsReadMutationVariables>(MarkMailThreadAsReadDocument, options);
}
export type MarkMailThreadAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkMailThreadAsReadMutation, MarkMailThreadAsReadMutationVariables>;
export const SendMailMessageDocument = gql`
    mutation sendMailMessage($input: SendMailMessageInput!) {
  sendMailMessage(input: $input) {
    id
    threadId
    sequenceNumber
    messageNumber
    senderUserId
    content
    contentPreview
    createdAt
  }
}
    `;

/**
 * __useSendMailMessageMutation__
 *
 * To run a mutation, you first call `useSendMailMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendMailMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendMailMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSendMailMessageMutation(options: VueApolloComposable.UseMutationOptions<SendMailMessageMutation, SendMailMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendMailMessageMutation, SendMailMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendMailMessageMutation, SendMailMessageMutationVariables>(SendMailMessageDocument, options);
}
export type SendMailMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendMailMessageMutation, SendMailMessageMutationVariables>;
export const UpdateMailMessageDocument = gql`
    mutation updateMailMessage($input: UpdateMailMessageInput!) {
  updateMailMessage(input: $input) {
    id
    content
    contentPreview
    createdAt
  }
}
    `;

/**
 * __useUpdateMailMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMailMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMailMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMailMessageMutation(options: VueApolloComposable.UseMutationOptions<UpdateMailMessageMutation, UpdateMailMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMailMessageMutation, UpdateMailMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMailMessageMutation, UpdateMailMessageMutationVariables>(UpdateMailMessageDocument, options);
}
export type UpdateMailMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMailMessageMutation, UpdateMailMessageMutationVariables>;
export const DeleteMediaDocument = gql`
    mutation deleteMedia($objectType: FileObjectType!) {
  deleteMedia(objectType: $objectType)
}
    `;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMediaMutation({
 *   variables: {
 *     objectType: // value for 'objectType'
 *   },
 * });
 */
export function useDeleteMediaMutation(options: VueApolloComposable.UseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMediaMutation, DeleteMediaMutationVariables>(DeleteMediaDocument, options);
}
export type DeleteMediaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMediaMutation, DeleteMediaMutationVariables>;
export const AddNewsFavouriteDocument = gql`
    mutation addNewsFavourite($newsId: String!) {
  addNewsFavourite(newsId: $newsId)
}
    `;

/**
 * __useAddNewsFavouriteMutation__
 *
 * To run a mutation, you first call `useAddNewsFavouriteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNewsFavouriteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNewsFavouriteMutation({
 *   variables: {
 *     newsId: // value for 'newsId'
 *   },
 * });
 */
export function useAddNewsFavouriteMutation(options: VueApolloComposable.UseMutationOptions<AddNewsFavouriteMutation, AddNewsFavouriteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddNewsFavouriteMutation, AddNewsFavouriteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddNewsFavouriteMutation, AddNewsFavouriteMutationVariables>(AddNewsFavouriteDocument, options);
}
export type AddNewsFavouriteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddNewsFavouriteMutation, AddNewsFavouriteMutationVariables>;
export const ApproveSpeechNewsDocument = gql`
    mutation approveSpeechNews($newsId: String!) {
  approveSpeechNews(newsId: $newsId) {
    id
    status
    moduleSlug
    rejectionReason
    updatedAt
  }
}
    `;

/**
 * __useApproveSpeechNewsMutation__
 *
 * To run a mutation, you first call `useApproveSpeechNewsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveSpeechNewsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveSpeechNewsMutation({
 *   variables: {
 *     newsId: // value for 'newsId'
 *   },
 * });
 */
export function useApproveSpeechNewsMutation(options: VueApolloComposable.UseMutationOptions<ApproveSpeechNewsMutation, ApproveSpeechNewsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveSpeechNewsMutation, ApproveSpeechNewsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApproveSpeechNewsMutation, ApproveSpeechNewsMutationVariables>(ApproveSpeechNewsDocument, options);
}
export type ApproveSpeechNewsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveSpeechNewsMutation, ApproveSpeechNewsMutationVariables>;
export const CreateOneNewsDocument = gql`
    mutation createOneNews($input: CreateOneNewsInput!) {
  createOneNews(input: $input) {
    id
    title
    content
    ownerId
    ownerType
    status
    authorFullname
    handwrittenFullname
    additionalInfo
    sourceLink
    tags {
      nodes {
        id
        name
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateOneNewsMutation__
 *
 * To run a mutation, you first call `useCreateOneNewsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneNewsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneNewsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneNewsMutation(options: VueApolloComposable.UseMutationOptions<CreateOneNewsMutation, CreateOneNewsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneNewsMutation, CreateOneNewsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneNewsMutation, CreateOneNewsMutationVariables>(CreateOneNewsDocument, options);
}
export type CreateOneNewsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneNewsMutation, CreateOneNewsMutationVariables>;
export const DeleteOneNewsDocument = gql`
    mutation deleteOneNews($input: DeleteOneNewsInput!) {
  deleteOneNews(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteOneNewsMutation__
 *
 * To run a mutation, you first call `useDeleteOneNewsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneNewsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOneNewsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOneNewsMutation(options: VueApolloComposable.UseMutationOptions<DeleteOneNewsMutation, DeleteOneNewsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOneNewsMutation, DeleteOneNewsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOneNewsMutation, DeleteOneNewsMutationVariables>(DeleteOneNewsDocument, options);
}
export type DeleteOneNewsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOneNewsMutation, DeleteOneNewsMutationVariables>;
export const MarkNewsAsViewedDocument = gql`
    mutation markNewsAsViewed($newsId: String!) {
  markNewsAsViewed(newsId: $newsId) {
    message
  }
}
    `;

/**
 * __useMarkNewsAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkNewsAsViewedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkNewsAsViewedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkNewsAsViewedMutation({
 *   variables: {
 *     newsId: // value for 'newsId'
 *   },
 * });
 */
export function useMarkNewsAsViewedMutation(options: VueApolloComposable.UseMutationOptions<MarkNewsAsViewedMutation, MarkNewsAsViewedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkNewsAsViewedMutation, MarkNewsAsViewedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkNewsAsViewedMutation, MarkNewsAsViewedMutationVariables>(MarkNewsAsViewedDocument, options);
}
export type MarkNewsAsViewedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkNewsAsViewedMutation, MarkNewsAsViewedMutationVariables>;
export const MarkNewsSeenDocument = gql`
    mutation markNewsSeen($newsIds: [ID!]!) {
  markNewsSeen(newsIds: $newsIds)
}
    `;

/**
 * __useMarkNewsSeenMutation__
 *
 * To run a mutation, you first call `useMarkNewsSeenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkNewsSeenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkNewsSeenMutation({
 *   variables: {
 *     newsIds: // value for 'newsIds'
 *   },
 * });
 */
export function useMarkNewsSeenMutation(options: VueApolloComposable.UseMutationOptions<MarkNewsSeenMutation, MarkNewsSeenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkNewsSeenMutation, MarkNewsSeenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkNewsSeenMutation, MarkNewsSeenMutationVariables>(MarkNewsSeenDocument, options);
}
export type MarkNewsSeenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkNewsSeenMutation, MarkNewsSeenMutationVariables>;
export const RejectSpeechNewsDocument = gql`
    mutation rejectSpeechNews($newsId: String!, $reason: String) {
  rejectSpeechNews(newsId: $newsId, reason: $reason) {
    id
    status
    moduleSlug
    rejectionReason
    updatedAt
  }
}
    `;

/**
 * __useRejectSpeechNewsMutation__
 *
 * To run a mutation, you first call `useRejectSpeechNewsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectSpeechNewsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectSpeechNewsMutation({
 *   variables: {
 *     newsId: // value for 'newsId'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectSpeechNewsMutation(options: VueApolloComposable.UseMutationOptions<RejectSpeechNewsMutation, RejectSpeechNewsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectSpeechNewsMutation, RejectSpeechNewsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RejectSpeechNewsMutation, RejectSpeechNewsMutationVariables>(RejectSpeechNewsDocument, options);
}
export type RejectSpeechNewsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectSpeechNewsMutation, RejectSpeechNewsMutationVariables>;
export const RemoveNewsFavouriteDocument = gql`
    mutation removeNewsFavourite($newsId: String!) {
  removeNewsFavourite(newsId: $newsId)
}
    `;

/**
 * __useRemoveNewsFavouriteMutation__
 *
 * To run a mutation, you first call `useRemoveNewsFavouriteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNewsFavouriteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveNewsFavouriteMutation({
 *   variables: {
 *     newsId: // value for 'newsId'
 *   },
 * });
 */
export function useRemoveNewsFavouriteMutation(options: VueApolloComposable.UseMutationOptions<RemoveNewsFavouriteMutation, RemoveNewsFavouriteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveNewsFavouriteMutation, RemoveNewsFavouriteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveNewsFavouriteMutation, RemoveNewsFavouriteMutationVariables>(RemoveNewsFavouriteDocument, options);
}
export type RemoveNewsFavouriteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveNewsFavouriteMutation, RemoveNewsFavouriteMutationVariables>;
export const ReorderSpeechNewsDocument = gql`
    mutation reorderSpeechNews($projectId: ID!, $moduleSlug: String!, $orderedNewsIds: [ID!]!) {
  reorderSpeechNews(
    projectId: $projectId
    moduleSlug: $moduleSlug
    orderedNewsIds: $orderedNewsIds
  ) {
    id
    title
    moduleSlug
    updatedAt
  }
}
    `;

/**
 * __useReorderSpeechNewsMutation__
 *
 * To run a mutation, you first call `useReorderSpeechNewsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReorderSpeechNewsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReorderSpeechNewsMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     moduleSlug: // value for 'moduleSlug'
 *     orderedNewsIds: // value for 'orderedNewsIds'
 *   },
 * });
 */
export function useReorderSpeechNewsMutation(options: VueApolloComposable.UseMutationOptions<ReorderSpeechNewsMutation, ReorderSpeechNewsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReorderSpeechNewsMutation, ReorderSpeechNewsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReorderSpeechNewsMutation, ReorderSpeechNewsMutationVariables>(ReorderSpeechNewsDocument, options);
}
export type ReorderSpeechNewsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReorderSpeechNewsMutation, ReorderSpeechNewsMutationVariables>;
export const UpdateOneNewsDocument = gql`
    mutation updateOneNews($input: UpdateOneNewsInput!) {
  updateOneNews(input: $input) {
    id
    title
    content
    mainImage
    customPhotos
    customVideos
    ownerId
    ownerType
    status
    authorFullname
    handwrittenFullname
    additionalInfo
    sourceLink
    moduleSlug
    tags {
      nodes {
        id
        name
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useUpdateOneNewsMutation__
 *
 * To run a mutation, you first call `useUpdateOneNewsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneNewsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOneNewsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneNewsMutation(options: VueApolloComposable.UseMutationOptions<UpdateOneNewsMutation, UpdateOneNewsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOneNewsMutation, UpdateOneNewsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOneNewsMutation, UpdateOneNewsMutationVariables>(UpdateOneNewsDocument, options);
}
export type UpdateOneNewsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOneNewsMutation, UpdateOneNewsMutationVariables>;
export const MarkNotificationActionAppliedDocument = gql`
    mutation markNotificationActionApplied($id: String!) {
  markNotificationActionApplied(id: $id)
}
    `;

/**
 * __useMarkNotificationActionAppliedMutation__
 *
 * To run a mutation, you first call `useMarkNotificationActionAppliedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationActionAppliedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkNotificationActionAppliedMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationActionAppliedMutation(options: VueApolloComposable.UseMutationOptions<MarkNotificationActionAppliedMutation, MarkNotificationActionAppliedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkNotificationActionAppliedMutation, MarkNotificationActionAppliedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkNotificationActionAppliedMutation, MarkNotificationActionAppliedMutationVariables>(MarkNotificationActionAppliedDocument, options);
}
export type MarkNotificationActionAppliedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkNotificationActionAppliedMutation, MarkNotificationActionAppliedMutationVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation markNotificationAsRead($id: String!) {
  markNotificationAsRead(id: $id)
}
    `;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkNotificationAsReadMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(options: VueApolloComposable.UseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
}
export type MarkNotificationAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const RegisterUserTokenDocument = gql`
    mutation RegisterUserToken($userId: String!, $token: String!, $deviceInfo: String) {
  registerUserToken(userId: $userId, token: $token, deviceInfo: $deviceInfo)
}
    `;

/**
 * __useRegisterUserTokenMutation__
 *
 * To run a mutation, you first call `useRegisterUserTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterUserTokenMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     token: // value for 'token'
 *     deviceInfo: // value for 'deviceInfo'
 *   },
 * });
 */
export function useRegisterUserTokenMutation(options: VueApolloComposable.UseMutationOptions<RegisterUserTokenMutation, RegisterUserTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegisterUserTokenMutation, RegisterUserTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RegisterUserTokenMutation, RegisterUserTokenMutationVariables>(RegisterUserTokenDocument, options);
}
export type RegisterUserTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegisterUserTokenMutation, RegisterUserTokenMutationVariables>;
export const ApproveObjectPassportApplicationDocument = gql`
    mutation approveObjectPassportApplication($input: ApproveObjectPassportApplicationInput!) {
  approveObjectPassportApplication(input: $input) {
    ...ObjectPassportApplicationFields
  }
}
    ${ObjectPassportApplicationFieldsFragmentDoc}`;

/**
 * __useApproveObjectPassportApplicationMutation__
 *
 * To run a mutation, you first call `useApproveObjectPassportApplicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveObjectPassportApplicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveObjectPassportApplicationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useApproveObjectPassportApplicationMutation(options: VueApolloComposable.UseMutationOptions<ApproveObjectPassportApplicationMutation, ApproveObjectPassportApplicationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveObjectPassportApplicationMutation, ApproveObjectPassportApplicationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApproveObjectPassportApplicationMutation, ApproveObjectPassportApplicationMutationVariables>(ApproveObjectPassportApplicationDocument, options);
}
export type ApproveObjectPassportApplicationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveObjectPassportApplicationMutation, ApproveObjectPassportApplicationMutationVariables>;
export const CreateObjectPassportApplicationDocument = gql`
    mutation createObjectPassportApplication($input: CreateObjectPassportApplicationInput!) {
  createObjectPassportApplication(input: $input) {
    ...ObjectPassportApplicationFields
  }
}
    ${ObjectPassportApplicationFieldsFragmentDoc}`;

/**
 * __useCreateObjectPassportApplicationMutation__
 *
 * To run a mutation, you first call `useCreateObjectPassportApplicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateObjectPassportApplicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateObjectPassportApplicationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateObjectPassportApplicationMutation(options: VueApolloComposable.UseMutationOptions<CreateObjectPassportApplicationMutation, CreateObjectPassportApplicationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateObjectPassportApplicationMutation, CreateObjectPassportApplicationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateObjectPassportApplicationMutation, CreateObjectPassportApplicationMutationVariables>(CreateObjectPassportApplicationDocument, options);
}
export type CreateObjectPassportApplicationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateObjectPassportApplicationMutation, CreateObjectPassportApplicationMutationVariables>;
export const RejectObjectPassportApplicationDocument = gql`
    mutation rejectObjectPassportApplication($input: RejectObjectPassportApplicationInput!) {
  rejectObjectPassportApplication(input: $input) {
    ...ObjectPassportApplicationFields
  }
}
    ${ObjectPassportApplicationFieldsFragmentDoc}`;

/**
 * __useRejectObjectPassportApplicationMutation__
 *
 * To run a mutation, you first call `useRejectObjectPassportApplicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectObjectPassportApplicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectObjectPassportApplicationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRejectObjectPassportApplicationMutation(options: VueApolloComposable.UseMutationOptions<RejectObjectPassportApplicationMutation, RejectObjectPassportApplicationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectObjectPassportApplicationMutation, RejectObjectPassportApplicationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RejectObjectPassportApplicationMutation, RejectObjectPassportApplicationMutationVariables>(RejectObjectPassportApplicationDocument, options);
}
export type RejectObjectPassportApplicationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectObjectPassportApplicationMutation, RejectObjectPassportApplicationMutationVariables>;
export const UpsertObjectPassportDocument = gql`
    mutation upsertObjectPassport($input: UpsertObjectPassportInput!) {
  upsertObjectPassport(input: $input) {
    ...ObjectPassportFields
  }
}
    ${ObjectPassportFieldsFragmentDoc}`;

/**
 * __useUpsertObjectPassportMutation__
 *
 * To run a mutation, you first call `useUpsertObjectPassportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertObjectPassportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertObjectPassportMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertObjectPassportMutation(options: VueApolloComposable.UseMutationOptions<UpsertObjectPassportMutation, UpsertObjectPassportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertObjectPassportMutation, UpsertObjectPassportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertObjectPassportMutation, UpsertObjectPassportMutationVariables>(UpsertObjectPassportDocument, options);
}
export type UpsertObjectPassportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertObjectPassportMutation, UpsertObjectPassportMutationVariables>;
export const DeleteProgramItemDocument = gql`
    mutation deleteProgramItem($id: ID!) {
  deleteProgramItem(id: $id)
}
    `;

/**
 * __useDeleteProgramItemMutation__
 *
 * To run a mutation, you first call `useDeleteProgramItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgramItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProgramItemMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProgramItemMutation(options: VueApolloComposable.UseMutationOptions<DeleteProgramItemMutation, DeleteProgramItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProgramItemMutation, DeleteProgramItemMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProgramItemMutation, DeleteProgramItemMutationVariables>(DeleteProgramItemDocument, options);
}
export type DeleteProgramItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProgramItemMutation, DeleteProgramItemMutationVariables>;
export const SaveProgramItemsDocument = gql`
    mutation saveProgramItems($input: SaveProgramItemsInput!) {
  saveProgramItems(input: $input) {
    ...ProgramItemFields
  }
}
    ${ProgramItemFieldsFragmentDoc}`;

/**
 * __useSaveProgramItemsMutation__
 *
 * To run a mutation, you first call `useSaveProgramItemsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveProgramItemsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveProgramItemsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveProgramItemsMutation(options: VueApolloComposable.UseMutationOptions<SaveProgramItemsMutation, SaveProgramItemsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveProgramItemsMutation, SaveProgramItemsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveProgramItemsMutation, SaveProgramItemsMutationVariables>(SaveProgramItemsDocument, options);
}
export type SaveProgramItemsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveProgramItemsMutation, SaveProgramItemsMutationVariables>;
export const CreateOneProjectModuleMemberDocument = gql`
    mutation createOneProjectModuleMember($input: CreateOneProjectModuleMemberInput!) {
  createOneProjectModuleMember(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateOneProjectModuleMemberMutation__
 *
 * To run a mutation, you first call `useCreateOneProjectModuleMemberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneProjectModuleMemberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneProjectModuleMemberMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneProjectModuleMemberMutation(options: VueApolloComposable.UseMutationOptions<CreateOneProjectModuleMemberMutation, CreateOneProjectModuleMemberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneProjectModuleMemberMutation, CreateOneProjectModuleMemberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneProjectModuleMemberMutation, CreateOneProjectModuleMemberMutationVariables>(CreateOneProjectModuleMemberDocument, options);
}
export type CreateOneProjectModuleMemberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneProjectModuleMemberMutation, CreateOneProjectModuleMemberMutationVariables>;
export const DeleteOneProjectModuleMemberDocument = gql`
    mutation deleteOneProjectModuleMember($input: DeleteOneProjectModuleMemberInput!) {
  deleteOneProjectModuleMember(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteOneProjectModuleMemberMutation__
 *
 * To run a mutation, you first call `useDeleteOneProjectModuleMemberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneProjectModuleMemberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOneProjectModuleMemberMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOneProjectModuleMemberMutation(options: VueApolloComposable.UseMutationOptions<DeleteOneProjectModuleMemberMutation, DeleteOneProjectModuleMemberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOneProjectModuleMemberMutation, DeleteOneProjectModuleMemberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOneProjectModuleMemberMutation, DeleteOneProjectModuleMemberMutationVariables>(DeleteOneProjectModuleMemberDocument, options);
}
export type DeleteOneProjectModuleMemberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOneProjectModuleMemberMutation, DeleteOneProjectModuleMemberMutationVariables>;
export const UpsertProjectModuleAccessSettingsDocument = gql`
    mutation upsertProjectModuleAccessSettings($input: UpsertProjectModuleAccessSettingsInput!) {
  upsertProjectModuleAccessSettings(input: $input) {
    id
    projectId
    moduleSlug
  }
}
    `;

/**
 * __useUpsertProjectModuleAccessSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertProjectModuleAccessSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectModuleAccessSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertProjectModuleAccessSettingsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertProjectModuleAccessSettingsMutation(options: VueApolloComposable.UseMutationOptions<UpsertProjectModuleAccessSettingsMutation, UpsertProjectModuleAccessSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProjectModuleAccessSettingsMutation, UpsertProjectModuleAccessSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProjectModuleAccessSettingsMutation, UpsertProjectModuleAccessSettingsMutationVariables>(UpsertProjectModuleAccessSettingsDocument, options);
}
export type UpsertProjectModuleAccessSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProjectModuleAccessSettingsMutation, UpsertProjectModuleAccessSettingsMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation acceptInvitation($input: AcceptInvitationInput!) {
  acceptInvitation(input: $input) {
    id
  }
}
    `;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptInvitationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAcceptInvitationMutation(options: VueApolloComposable.UseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
}
export type AcceptInvitationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const ApproveJoinRequestDocument = gql`
    mutation approveJoinRequest($input: ApproveJoinRequestInput!) {
  approveJoinRequest(input: $input) {
    id
  }
}
    `;

/**
 * __useApproveJoinRequestMutation__
 *
 * To run a mutation, you first call `useApproveJoinRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveJoinRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveJoinRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useApproveJoinRequestMutation(options: VueApolloComposable.UseMutationOptions<ApproveJoinRequestMutation, ApproveJoinRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveJoinRequestMutation, ApproveJoinRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApproveJoinRequestMutation, ApproveJoinRequestMutationVariables>(ApproveJoinRequestDocument, options);
}
export type ApproveJoinRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveJoinRequestMutation, ApproveJoinRequestMutationVariables>;
export const ApproveProjectRequestDocument = gql`
    mutation approveProjectRequest($id: String!) {
  approveProjectRequest(id: $id) {
    ...ProjectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useApproveProjectRequestMutation__
 *
 * To run a mutation, you first call `useApproveProjectRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveProjectRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveProjectRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useApproveProjectRequestMutation(options: VueApolloComposable.UseMutationOptions<ApproveProjectRequestMutation, ApproveProjectRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveProjectRequestMutation, ApproveProjectRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApproveProjectRequestMutation, ApproveProjectRequestMutationVariables>(ApproveProjectRequestDocument, options);
}
export type ApproveProjectRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveProjectRequestMutation, ApproveProjectRequestMutationVariables>;
export const CreateDirectInvitationDocument = gql`
    mutation createDirectInvitation($input: CreateDirectInvitationInput!) {
  createDirectInvitation(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateDirectInvitationMutation__
 *
 * To run a mutation, you first call `useCreateDirectInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDirectInvitationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateDirectInvitationMutation(options: VueApolloComposable.UseMutationOptions<CreateDirectInvitationMutation, CreateDirectInvitationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDirectInvitationMutation, CreateDirectInvitationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateDirectInvitationMutation, CreateDirectInvitationMutationVariables>(CreateDirectInvitationDocument, options);
}
export type CreateDirectInvitationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateDirectInvitationMutation, CreateDirectInvitationMutationVariables>;
export const CreateJoinRequestDocument = gql`
    mutation createJoinRequest($input: CreateJoinRequestInput!) {
  createJoinRequest(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateJoinRequestMutation__
 *
 * To run a mutation, you first call `useCreateJoinRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateJoinRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateJoinRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateJoinRequestMutation(options: VueApolloComposable.UseMutationOptions<CreateJoinRequestMutation, CreateJoinRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateJoinRequestMutation, CreateJoinRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateJoinRequestMutation, CreateJoinRequestMutationVariables>(CreateJoinRequestDocument, options);
}
export type CreateJoinRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateJoinRequestMutation, CreateJoinRequestMutationVariables>;
export const CreateMyProjectRequestDocument = gql`
    mutation createMyProjectRequest($input: CreateProjectRequestDto!) {
  createMyProjectRequest(input: $input) {
    ...ProjectRequestFields
  }
}
    ${ProjectRequestFieldsFragmentDoc}`;

/**
 * __useCreateMyProjectRequestMutation__
 *
 * To run a mutation, you first call `useCreateMyProjectRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyProjectRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMyProjectRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyProjectRequestMutation(options: VueApolloComposable.UseMutationOptions<CreateMyProjectRequestMutation, CreateMyProjectRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMyProjectRequestMutation, CreateMyProjectRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateMyProjectRequestMutation, CreateMyProjectRequestMutationVariables>(CreateMyProjectRequestDocument, options);
}
export type CreateMyProjectRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMyProjectRequestMutation, CreateMyProjectRequestMutationVariables>;
export const CreateOneProjectDocument = gql`
    mutation createOneProject($input: CreateOneProjectInput!) {
  createOneProject(input: $input) {
    ...ProjectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useCreateOneProjectMutation__
 *
 * To run a mutation, you first call `useCreateOneProjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneProjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneProjectMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneProjectMutation(options: VueApolloComposable.UseMutationOptions<CreateOneProjectMutation, CreateOneProjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneProjectMutation, CreateOneProjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneProjectMutation, CreateOneProjectMutationVariables>(CreateOneProjectDocument, options);
}
export type CreateOneProjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneProjectMutation, CreateOneProjectMutationVariables>;
export const CreateOneProjectMemberDocument = gql`
    mutation createOneProjectMember($input: CreateOneProjectMemberInput!) {
  createOneProjectMember(input: $input) {
    ...ProjectMemberFields
  }
}
    ${ProjectMemberFieldsFragmentDoc}`;

/**
 * __useCreateOneProjectMemberMutation__
 *
 * To run a mutation, you first call `useCreateOneProjectMemberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneProjectMemberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneProjectMemberMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneProjectMemberMutation(options: VueApolloComposable.UseMutationOptions<CreateOneProjectMemberMutation, CreateOneProjectMemberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneProjectMemberMutation, CreateOneProjectMemberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneProjectMemberMutation, CreateOneProjectMemberMutationVariables>(CreateOneProjectMemberDocument, options);
}
export type CreateOneProjectMemberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneProjectMemberMutation, CreateOneProjectMemberMutationVariables>;
export const CreateOneProjectSupporterDocument = gql`
    mutation createOneProjectSupporter($input: CreateOneProjectSupporterInput!) {
  createOneProjectSupporter(input: $input) {
    id
    ...ProjectSupporterFields
  }
}
    ${ProjectSupporterFieldsFragmentDoc}`;

/**
 * __useCreateOneProjectSupporterMutation__
 *
 * To run a mutation, you first call `useCreateOneProjectSupporterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneProjectSupporterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneProjectSupporterMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneProjectSupporterMutation(options: VueApolloComposable.UseMutationOptions<CreateOneProjectSupporterMutation, CreateOneProjectSupporterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneProjectSupporterMutation, CreateOneProjectSupporterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneProjectSupporterMutation, CreateOneProjectSupporterMutationVariables>(CreateOneProjectSupporterDocument, options);
}
export type CreateOneProjectSupporterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneProjectSupporterMutation, CreateOneProjectSupporterMutationVariables>;
export const CreateProjectCustomModuleDocument = gql`
    mutation createProjectCustomModule($input: CreateProjectCustomModuleInput!) {
  createProjectCustomModule(input: $input) {
    id
    moduleSlug
    name
    baseModuleType
    format
    iconColor
    backgroundColor
    icon
  }
}
    `;

/**
 * __useCreateProjectCustomModuleMutation__
 *
 * To run a mutation, you first call `useCreateProjectCustomModuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectCustomModuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProjectCustomModuleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectCustomModuleMutation(options: VueApolloComposable.UseMutationOptions<CreateProjectCustomModuleMutation, CreateProjectCustomModuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateProjectCustomModuleMutation, CreateProjectCustomModuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateProjectCustomModuleMutation, CreateProjectCustomModuleMutationVariables>(CreateProjectCustomModuleDocument, options);
}
export type CreateProjectCustomModuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateProjectCustomModuleMutation, CreateProjectCustomModuleMutationVariables>;
export const DeclineInvitationDocument = gql`
    mutation declineInvitation($input: DeclineInvitationInput!) {
  declineInvitation(input: $input)
}
    `;

/**
 * __useDeclineInvitationMutation__
 *
 * To run a mutation, you first call `useDeclineInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeclineInvitationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeclineInvitationMutation(options: VueApolloComposable.UseMutationOptions<DeclineInvitationMutation, DeclineInvitationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeclineInvitationMutation, DeclineInvitationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeclineInvitationMutation, DeclineInvitationMutationVariables>(DeclineInvitationDocument, options);
}
export type DeclineInvitationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeclineInvitationMutation, DeclineInvitationMutationVariables>;
export const DeleteOneProjectDocument = gql`
    mutation deleteOneProject($input: DeleteOneProjectInput!) {
  deleteOneProject(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteOneProjectMutation__
 *
 * To run a mutation, you first call `useDeleteOneProjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneProjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOneProjectMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOneProjectMutation(options: VueApolloComposable.UseMutationOptions<DeleteOneProjectMutation, DeleteOneProjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOneProjectMutation, DeleteOneProjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOneProjectMutation, DeleteOneProjectMutationVariables>(DeleteOneProjectDocument, options);
}
export type DeleteOneProjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOneProjectMutation, DeleteOneProjectMutationVariables>;
export const DeleteOneProjectMemberDocument = gql`
    mutation deleteOneProjectMember($input: DeleteOneProjectMemberInput!) {
  deleteOneProjectMember(input: $input) {
    id
    projectId
    userId
    role
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useDeleteOneProjectMemberMutation__
 *
 * To run a mutation, you first call `useDeleteOneProjectMemberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneProjectMemberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOneProjectMemberMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOneProjectMemberMutation(options: VueApolloComposable.UseMutationOptions<DeleteOneProjectMemberMutation, DeleteOneProjectMemberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOneProjectMemberMutation, DeleteOneProjectMemberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOneProjectMemberMutation, DeleteOneProjectMemberMutationVariables>(DeleteOneProjectMemberDocument, options);
}
export type DeleteOneProjectMemberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOneProjectMemberMutation, DeleteOneProjectMemberMutationVariables>;
export const DeleteOneProjectSupporterDocument = gql`
    mutation deleteOneProjectSupporter($input: DeleteOneProjectSupporterInput!) {
  deleteOneProjectSupporter(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteOneProjectSupporterMutation__
 *
 * To run a mutation, you first call `useDeleteOneProjectSupporterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneProjectSupporterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOneProjectSupporterMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOneProjectSupporterMutation(options: VueApolloComposable.UseMutationOptions<DeleteOneProjectSupporterMutation, DeleteOneProjectSupporterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOneProjectSupporterMutation, DeleteOneProjectSupporterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOneProjectSupporterMutation, DeleteOneProjectSupporterMutationVariables>(DeleteOneProjectSupporterDocument, options);
}
export type DeleteOneProjectSupporterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOneProjectSupporterMutation, DeleteOneProjectSupporterMutationVariables>;
export const DeleteProjectCustomModuleDocument = gql`
    mutation deleteProjectCustomModule($id: ID!) {
  deleteProjectCustomModule(id: $id) {
    id
    moduleSlug
    name
  }
}
    `;

/**
 * __useDeleteProjectCustomModuleMutation__
 *
 * To run a mutation, you first call `useDeleteProjectCustomModuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectCustomModuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectCustomModuleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectCustomModuleMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectCustomModuleMutation, DeleteProjectCustomModuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectCustomModuleMutation, DeleteProjectCustomModuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectCustomModuleMutation, DeleteProjectCustomModuleMutationVariables>(DeleteProjectCustomModuleDocument, options);
}
export type DeleteProjectCustomModuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectCustomModuleMutation, DeleteProjectCustomModuleMutationVariables>;
export const DeleteProjectRequestDocument = gql`
    mutation deleteProjectRequest($id: String!) {
  deleteProjectRequest(id: $id)
}
    `;

/**
 * __useDeleteProjectRequestMutation__
 *
 * To run a mutation, you first call `useDeleteProjectRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectRequestMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectRequestMutation, DeleteProjectRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectRequestMutation, DeleteProjectRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectRequestMutation, DeleteProjectRequestMutationVariables>(DeleteProjectRequestDocument, options);
}
export type DeleteProjectRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectRequestMutation, DeleteProjectRequestMutationVariables>;
export const JoinOpenProjectDocument = gql`
    mutation joinOpenProject($projectId: String!) {
  joinOpenProject(projectId: $projectId) {
    id
  }
}
    `;

/**
 * __useJoinOpenProjectMutation__
 *
 * To run a mutation, you first call `useJoinOpenProjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useJoinOpenProjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useJoinOpenProjectMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useJoinOpenProjectMutation(options: VueApolloComposable.UseMutationOptions<JoinOpenProjectMutation, JoinOpenProjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<JoinOpenProjectMutation, JoinOpenProjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<JoinOpenProjectMutation, JoinOpenProjectMutationVariables>(JoinOpenProjectDocument, options);
}
export type JoinOpenProjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<JoinOpenProjectMutation, JoinOpenProjectMutationVariables>;
export const RejectJoinRequestDocument = gql`
    mutation rejectJoinRequest($input: RejectJoinRequestInput!) {
  rejectJoinRequest(input: $input) {
    id
  }
}
    `;

/**
 * __useRejectJoinRequestMutation__
 *
 * To run a mutation, you first call `useRejectJoinRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectJoinRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectJoinRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRejectJoinRequestMutation(options: VueApolloComposable.UseMutationOptions<RejectJoinRequestMutation, RejectJoinRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectJoinRequestMutation, RejectJoinRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RejectJoinRequestMutation, RejectJoinRequestMutationVariables>(RejectJoinRequestDocument, options);
}
export type RejectJoinRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectJoinRequestMutation, RejectJoinRequestMutationVariables>;
export const RejectProjectRequestDocument = gql`
    mutation rejectProjectRequest($id: String!, $reason: String!) {
  rejectProjectRequest(id: $id, reason: $reason) {
    ...ProjectRequestFields
  }
}
    ${ProjectRequestFieldsFragmentDoc}`;

/**
 * __useRejectProjectRequestMutation__
 *
 * To run a mutation, you first call `useRejectProjectRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectProjectRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectProjectRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectProjectRequestMutation(options: VueApolloComposable.UseMutationOptions<RejectProjectRequestMutation, RejectProjectRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectProjectRequestMutation, RejectProjectRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RejectProjectRequestMutation, RejectProjectRequestMutationVariables>(RejectProjectRequestDocument, options);
}
export type RejectProjectRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectProjectRequestMutation, RejectProjectRequestMutationVariables>;
export const ToggleLikeDocument = gql`
    mutation toggleLike($input: ToggleLikeInput!) {
  toggleLike(input: $input) {
    isLiked
    likeCount
  }
}
    `;

/**
 * __useToggleLikeMutation__
 *
 * To run a mutation, you first call `useToggleLikeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleLikeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleLikeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useToggleLikeMutation(options: VueApolloComposable.UseMutationOptions<ToggleLikeMutation, ToggleLikeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ToggleLikeMutation, ToggleLikeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ToggleLikeMutation, ToggleLikeMutationVariables>(ToggleLikeDocument, options);
}
export type ToggleLikeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ToggleLikeMutation, ToggleLikeMutationVariables>;
export const UpdateMyProjectRequestDocument = gql`
    mutation updateMyProjectRequest($id: String!, $input: UpdateProjectRequestDto!) {
  updateMyProjectRequest(id: $id, input: $input) {
    ...ProjectRequestFields
  }
}
    ${ProjectRequestFieldsFragmentDoc}`;

/**
 * __useUpdateMyProjectRequestMutation__
 *
 * To run a mutation, you first call `useUpdateMyProjectRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProjectRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMyProjectRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyProjectRequestMutation(options: VueApolloComposable.UseMutationOptions<UpdateMyProjectRequestMutation, UpdateMyProjectRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMyProjectRequestMutation, UpdateMyProjectRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMyProjectRequestMutation, UpdateMyProjectRequestMutationVariables>(UpdateMyProjectRequestDocument, options);
}
export type UpdateMyProjectRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMyProjectRequestMutation, UpdateMyProjectRequestMutationVariables>;
export const UpdateOneProjectDocument = gql`
    mutation updateOneProject($input: UpdateOneProjectInput!) {
  updateOneProject(input: $input) {
    id
    slug
    headerButtons
    hamburgerButtons
  }
}
    `;

/**
 * __useUpdateOneProjectMutation__
 *
 * To run a mutation, you first call `useUpdateOneProjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneProjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOneProjectMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneProjectMutation(options: VueApolloComposable.UseMutationOptions<UpdateOneProjectMutation, UpdateOneProjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOneProjectMutation, UpdateOneProjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOneProjectMutation, UpdateOneProjectMutationVariables>(UpdateOneProjectDocument, options);
}
export type UpdateOneProjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOneProjectMutation, UpdateOneProjectMutationVariables>;
export const UpdateOneProjectMemberDocument = gql`
    mutation updateOneProjectMember($input: UpdateOneProjectMemberInput!) {
  updateOneProjectMember(input: $input) {
    ...ProjectMemberFields
  }
}
    ${ProjectMemberFieldsFragmentDoc}`;

/**
 * __useUpdateOneProjectMemberMutation__
 *
 * To run a mutation, you first call `useUpdateOneProjectMemberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneProjectMemberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOneProjectMemberMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneProjectMemberMutation(options: VueApolloComposable.UseMutationOptions<UpdateOneProjectMemberMutation, UpdateOneProjectMemberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOneProjectMemberMutation, UpdateOneProjectMemberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOneProjectMemberMutation, UpdateOneProjectMemberMutationVariables>(UpdateOneProjectMemberDocument, options);
}
export type UpdateOneProjectMemberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOneProjectMemberMutation, UpdateOneProjectMemberMutationVariables>;
export const UpdateOneProjectSupporterDocument = gql`
    mutation updateOneProjectSupporter($input: UpdateOneProjectSupporterInput!) {
  updateOneProjectSupporter(input: $input) {
    ...ProjectSupporterFields
  }
}
    ${ProjectSupporterFieldsFragmentDoc}`;

/**
 * __useUpdateOneProjectSupporterMutation__
 *
 * To run a mutation, you first call `useUpdateOneProjectSupporterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneProjectSupporterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOneProjectSupporterMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneProjectSupporterMutation(options: VueApolloComposable.UseMutationOptions<UpdateOneProjectSupporterMutation, UpdateOneProjectSupporterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOneProjectSupporterMutation, UpdateOneProjectSupporterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOneProjectSupporterMutation, UpdateOneProjectSupporterMutationVariables>(UpdateOneProjectSupporterDocument, options);
}
export type UpdateOneProjectSupporterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOneProjectSupporterMutation, UpdateOneProjectSupporterMutationVariables>;
export const UpdateProjectCustomModuleDocument = gql`
    mutation updateProjectCustomModule($input: UpdateProjectCustomModuleInput!) {
  updateProjectCustomModule(input: $input) {
    id
    name
    iconColor
    backgroundColor
    format
    icon
  }
}
    `;

/**
 * __useUpdateProjectCustomModuleMutation__
 *
 * To run a mutation, you first call `useUpdateProjectCustomModuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectCustomModuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProjectCustomModuleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectCustomModuleMutation(options: VueApolloComposable.UseMutationOptions<UpdateProjectCustomModuleMutation, UpdateProjectCustomModuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProjectCustomModuleMutation, UpdateProjectCustomModuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateProjectCustomModuleMutation, UpdateProjectCustomModuleMutationVariables>(UpdateProjectCustomModuleDocument, options);
}
export type UpdateProjectCustomModuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProjectCustomModuleMutation, UpdateProjectCustomModuleMutationVariables>;
export const DeleteReglamentItemDocument = gql`
    mutation deleteReglamentItem($id: ID!) {
  deleteReglamentItem(id: $id)
}
    `;

/**
 * __useDeleteReglamentItemMutation__
 *
 * To run a mutation, you first call `useDeleteReglamentItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReglamentItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteReglamentItemMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReglamentItemMutation(options: VueApolloComposable.UseMutationOptions<DeleteReglamentItemMutation, DeleteReglamentItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteReglamentItemMutation, DeleteReglamentItemMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteReglamentItemMutation, DeleteReglamentItemMutationVariables>(DeleteReglamentItemDocument, options);
}
export type DeleteReglamentItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteReglamentItemMutation, DeleteReglamentItemMutationVariables>;
export const SaveReglamentItemsDocument = gql`
    mutation saveReglamentItems($input: SaveReglamentItemsInput!) {
  saveReglamentItems(input: $input) {
    ...ReglamentItemFields
  }
}
    ${ReglamentItemFieldsFragmentDoc}`;

/**
 * __useSaveReglamentItemsMutation__
 *
 * To run a mutation, you first call `useSaveReglamentItemsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveReglamentItemsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveReglamentItemsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveReglamentItemsMutation(options: VueApolloComposable.UseMutationOptions<SaveReglamentItemsMutation, SaveReglamentItemsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveReglamentItemsMutation, SaveReglamentItemsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveReglamentItemsMutation, SaveReglamentItemsMutationVariables>(SaveReglamentItemsDocument, options);
}
export type SaveReglamentItemsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveReglamentItemsMutation, SaveReglamentItemsMutationVariables>;
export const CreateAdminTemplateDocument = gql`
    mutation createAdminTemplate($input: CreateTemplateInput!, $projectId: String) {
  createAdminTemplate(input: $input, projectId: $projectId) {
    id
    name
    label
    text
    isGlobal
    userId
    projectId
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateAdminTemplateMutation__
 *
 * To run a mutation, you first call `useCreateAdminTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAdminTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateAdminTemplateMutation(options: VueApolloComposable.UseMutationOptions<CreateAdminTemplateMutation, CreateAdminTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAdminTemplateMutation, CreateAdminTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAdminTemplateMutation, CreateAdminTemplateMutationVariables>(CreateAdminTemplateDocument, options);
}
export type CreateAdminTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAdminTemplateMutation, CreateAdminTemplateMutationVariables>;
export const CreateMockupDocument = gql`
    mutation createMockup($input: CreateMockupInput!) {
  createMockup(input: $input) {
    id
    uploadUrl
  }
}
    `;

/**
 * __useCreateMockupMutation__
 *
 * To run a mutation, you first call `useCreateMockupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMockupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMockupMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMockupMutation(options: VueApolloComposable.UseMutationOptions<CreateMockupMutation, CreateMockupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMockupMutation, CreateMockupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateMockupMutation, CreateMockupMutationVariables>(CreateMockupDocument, options);
}
export type CreateMockupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMockupMutation, CreateMockupMutationVariables>;
export const CreateUserTemplateDocument = gql`
    mutation createUserTemplate($input: CreateTemplateInput!, $projectId: String) {
  createUserTemplate(input: $input, projectId: $projectId) {
    id
    name
    label
    text
    isGlobal
    userId
    projectId
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateUserTemplateMutation__
 *
 * To run a mutation, you first call `useCreateUserTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateUserTemplateMutation(options: VueApolloComposable.UseMutationOptions<CreateUserTemplateMutation, CreateUserTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUserTemplateMutation, CreateUserTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateUserTemplateMutation, CreateUserTemplateMutationVariables>(CreateUserTemplateDocument, options);
}
export type CreateUserTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateUserTemplateMutation, CreateUserTemplateMutationVariables>;
export const DeleteMockupDocument = gql`
    mutation deleteMockup($id: ID!) {
  deleteMockup(id: $id)
}
    `;

/**
 * __useDeleteMockupMutation__
 *
 * To run a mutation, you first call `useDeleteMockupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMockupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMockupMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMockupMutation(options: VueApolloComposable.UseMutationOptions<DeleteMockupMutation, DeleteMockupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMockupMutation, DeleteMockupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMockupMutation, DeleteMockupMutationVariables>(DeleteMockupDocument, options);
}
export type DeleteMockupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMockupMutation, DeleteMockupMutationVariables>;
export const DeleteSystemMockupDocument = gql`
    mutation deleteSystemMockup($id: ID!) {
  deleteSystemMockup(id: $id)
}
    `;

/**
 * __useDeleteSystemMockupMutation__
 *
 * To run a mutation, you first call `useDeleteSystemMockupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSystemMockupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSystemMockupMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSystemMockupMutation(options: VueApolloComposable.UseMutationOptions<DeleteSystemMockupMutation, DeleteSystemMockupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSystemMockupMutation, DeleteSystemMockupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteSystemMockupMutation, DeleteSystemMockupMutationVariables>(DeleteSystemMockupDocument, options);
}
export type DeleteSystemMockupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSystemMockupMutation, DeleteSystemMockupMutationVariables>;
export const DeleteUserTemplateDocument = gql`
    mutation deleteUserTemplate($templateId: String!, $projectId: String) {
  deleteUserTemplate(templateId: $templateId, projectId: $projectId)
}
    `;

/**
 * __useDeleteUserTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteUserTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserTemplateMutation({
 *   variables: {
 *     templateId: // value for 'templateId'
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteUserTemplateMutation(options: VueApolloComposable.UseMutationOptions<DeleteUserTemplateMutation, DeleteUserTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteUserTemplateMutation, DeleteUserTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteUserTemplateMutation, DeleteUserTemplateMutationVariables>(DeleteUserTemplateDocument, options);
}
export type DeleteUserTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteUserTemplateMutation, DeleteUserTemplateMutationVariables>;
export const ExportSupporterReportDocument = gql`
    mutation exportSupporterReport($input: ExportSupporterReportInput!) {
  exportSupporterReport(input: $input) {
    url
    filename
  }
}
    `;

/**
 * __useExportSupporterReportMutation__
 *
 * To run a mutation, you first call `useExportSupporterReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportSupporterReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportSupporterReportMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useExportSupporterReportMutation(options: VueApolloComposable.UseMutationOptions<ExportSupporterReportMutation, ExportSupporterReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExportSupporterReportMutation, ExportSupporterReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExportSupporterReportMutation, ExportSupporterReportMutationVariables>(ExportSupporterReportDocument, options);
}
export type ExportSupporterReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExportSupporterReportMutation, ExportSupporterReportMutationVariables>;
export const GeneratePlatformSummaryReportDocument = gql`
    mutation generatePlatformSummaryReport($filters: AnalyticsFiltersInput) {
  generatePlatformSummaryReport(filters: $filters) {
    id
    totalRegisteredUsers
    totalProjects
    totalProjectOwners
    totalProjectParticipants
    averageSessionDuration
    activeUsersCount
    totalFriendships
    periodStart
    periodEnd
    reportDate
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGeneratePlatformSummaryReportMutation__
 *
 * To run a mutation, you first call `useGeneratePlatformSummaryReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePlatformSummaryReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGeneratePlatformSummaryReportMutation({
 *   variables: {
 *     filters: // value for 'filters'
 *   },
 * });
 */
export function useGeneratePlatformSummaryReportMutation(options: VueApolloComposable.UseMutationOptions<GeneratePlatformSummaryReportMutation, GeneratePlatformSummaryReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GeneratePlatformSummaryReportMutation, GeneratePlatformSummaryReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GeneratePlatformSummaryReportMutation, GeneratePlatformSummaryReportMutationVariables>(GeneratePlatformSummaryReportDocument, options);
}
export type GeneratePlatformSummaryReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GeneratePlatformSummaryReportMutation, GeneratePlatformSummaryReportMutationVariables>;
export const SendProjectSupportersNotificationDocument = gql`
    mutation sendProjectSupportersNotification($projectId: String!, $type: NotificationDeliveryType!, $template: NotificationTemplate, $content: NotificationContentDto, $templateParams: String) {
  sendProjectSupportersNotification(
    projectId: $projectId
    type: $type
    template: $template
    content: $content
    templateParams: $templateParams
  )
}
    `;

/**
 * __useSendProjectSupportersNotificationMutation__
 *
 * To run a mutation, you first call `useSendProjectSupportersNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendProjectSupportersNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendProjectSupportersNotificationMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     type: // value for 'type'
 *     template: // value for 'template'
 *     content: // value for 'content'
 *     templateParams: // value for 'templateParams'
 *   },
 * });
 */
export function useSendProjectSupportersNotificationMutation(options: VueApolloComposable.UseMutationOptions<SendProjectSupportersNotificationMutation, SendProjectSupportersNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendProjectSupportersNotificationMutation, SendProjectSupportersNotificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendProjectSupportersNotificationMutation, SendProjectSupportersNotificationMutationVariables>(SendProjectSupportersNotificationDocument, options);
}
export type SendProjectSupportersNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendProjectSupportersNotificationMutation, SendProjectSupportersNotificationMutationVariables>;
export const SendSupporterNotificationDocument = gql`
    mutation sendSupporterNotification($supporterIds: [String!]!, $type: NotificationDeliveryType!, $template: NotificationTemplate, $content: NotificationContentDto, $templateParams: String, $apiKeyType: SmscApiKeyType) {
  sendSupporterNotification(
    supporterIds: $supporterIds
    type: $type
    template: $template
    content: $content
    templateParams: $templateParams
    apiKeyType: $apiKeyType
  )
}
    `;

/**
 * __useSendSupporterNotificationMutation__
 *
 * To run a mutation, you first call `useSendSupporterNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendSupporterNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendSupporterNotificationMutation({
 *   variables: {
 *     supporterIds: // value for 'supporterIds'
 *     type: // value for 'type'
 *     template: // value for 'template'
 *     content: // value for 'content'
 *     templateParams: // value for 'templateParams'
 *     apiKeyType: // value for 'apiKeyType'
 *   },
 * });
 */
export function useSendSupporterNotificationMutation(options: VueApolloComposable.UseMutationOptions<SendSupporterNotificationMutation, SendSupporterNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendSupporterNotificationMutation, SendSupporterNotificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendSupporterNotificationMutation, SendSupporterNotificationMutationVariables>(SendSupporterNotificationDocument, options);
}
export type SendSupporterNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendSupporterNotificationMutation, SendSupporterNotificationMutationVariables>;
export const UpdateMockupDocument = gql`
    mutation updateMockup($id: ID!, $input: UpdateMockupInput!) {
  updateMockup(id: $id, input: $input) {
    id
    presignedUrl
  }
}
    `;

/**
 * __useUpdateMockupMutation__
 *
 * To run a mutation, you first call `useUpdateMockupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMockupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMockupMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMockupMutation(options: VueApolloComposable.UseMutationOptions<UpdateMockupMutation, UpdateMockupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMockupMutation, UpdateMockupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMockupMutation, UpdateMockupMutationVariables>(UpdateMockupDocument, options);
}
export type UpdateMockupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMockupMutation, UpdateMockupMutationVariables>;
export const UpdateUserTemplateDocument = gql`
    mutation updateUserTemplate($templateId: String!, $input: UpdateTemplateInput!, $projectId: String) {
  updateUserTemplate(
    templateId: $templateId
    input: $input
    projectId: $projectId
  ) {
    id
  }
}
    `;

/**
 * __useUpdateUserTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateUserTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserTemplateMutation({
 *   variables: {
 *     templateId: // value for 'templateId'
 *     input: // value for 'input'
 *     projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateUserTemplateMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserTemplateMutation, UpdateUserTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserTemplateMutation, UpdateUserTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserTemplateMutation, UpdateUserTemplateMutationVariables>(UpdateUserTemplateDocument, options);
}
export type UpdateUserTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserTemplateMutation, UpdateUserTemplateMutationVariables>;
export const ApplyMergeChangesDocument = gql`
    mutation applyMergeChanges($sessionId: String!) {
  applyMergeChanges(sessionId: $sessionId)
}
    `;

/**
 * __useApplyMergeChangesMutation__
 *
 * To run a mutation, you first call `useApplyMergeChangesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApplyMergeChangesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApplyMergeChangesMutation({
 *   variables: {
 *     sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useApplyMergeChangesMutation(options: VueApolloComposable.UseMutationOptions<ApplyMergeChangesMutation, ApplyMergeChangesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApplyMergeChangesMutation, ApplyMergeChangesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApplyMergeChangesMutation, ApplyMergeChangesMutationVariables>(ApplyMergeChangesDocument, options);
}
export type ApplyMergeChangesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApplyMergeChangesMutation, ApplyMergeChangesMutationVariables>;
export const CreateMergeRequestDocument = gql`
    mutation createMergeRequest($input: CreateMergeRequestDTO!) {
  createMergeRequest(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateMergeRequestMutation__
 *
 * To run a mutation, you first call `useCreateMergeRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMergeRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMergeRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMergeRequestMutation(options: VueApolloComposable.UseMutationOptions<CreateMergeRequestMutation, CreateMergeRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMergeRequestMutation, CreateMergeRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateMergeRequestMutation, CreateMergeRequestMutationVariables>(CreateMergeRequestDocument, options);
}
export type CreateMergeRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMergeRequestMutation, CreateMergeRequestMutationVariables>;
export const CreateOneProjectOrganizationDocument = gql`
    mutation createOneProjectOrganization($input: CreateOneProjectOrganizationInput!) {
  createOneProjectOrganization(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateOneProjectOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOneProjectOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneProjectOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneProjectOrganizationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneProjectOrganizationMutation(options: VueApolloComposable.UseMutationOptions<CreateOneProjectOrganizationMutation, CreateOneProjectOrganizationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneProjectOrganizationMutation, CreateOneProjectOrganizationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneProjectOrganizationMutation, CreateOneProjectOrganizationMutationVariables>(CreateOneProjectOrganizationDocument, options);
}
export type CreateOneProjectOrganizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneProjectOrganizationMutation, CreateOneProjectOrganizationMutationVariables>;
export const DeleteOneProjectOrganizationDocument = gql`
    mutation deleteOneProjectOrganization($input: DeleteOneProjectOrganizationInput!) {
  deleteOneProjectOrganization(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteOneProjectOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOneProjectOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneProjectOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOneProjectOrganizationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOneProjectOrganizationMutation(options: VueApolloComposable.UseMutationOptions<DeleteOneProjectOrganizationMutation, DeleteOneProjectOrganizationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOneProjectOrganizationMutation, DeleteOneProjectOrganizationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOneProjectOrganizationMutation, DeleteOneProjectOrganizationMutationVariables>(DeleteOneProjectOrganizationDocument, options);
}
export type DeleteOneProjectOrganizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOneProjectOrganizationMutation, DeleteOneProjectOrganizationMutationVariables>;
export const DeleteRegistryContactsDocument = gql`
    mutation deleteRegistryContacts($input: DeleteRegistryContactsInput!) {
  deleteRegistryContacts(input: $input) {
    deleted {
      id
      contactType
    }
    failed {
      id
      contactType
    }
  }
}
    `;

/**
 * __useDeleteRegistryContactsMutation__
 *
 * To run a mutation, you first call `useDeleteRegistryContactsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistryContactsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRegistryContactsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRegistryContactsMutation(options: VueApolloComposable.UseMutationOptions<DeleteRegistryContactsMutation, DeleteRegistryContactsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteRegistryContactsMutation, DeleteRegistryContactsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteRegistryContactsMutation, DeleteRegistryContactsMutationVariables>(DeleteRegistryContactsDocument, options);
}
export type DeleteRegistryContactsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteRegistryContactsMutation, DeleteRegistryContactsMutationVariables>;
export const ImportFromCsvDocument = gql`
    mutation importFromCsv($projectId: String!, $csvContent: String!) {
  importFromCsv(projectId: $projectId, csvContent: $csvContent) {
    totalRecords
    successfulPersons
    successfulOrganizations
  }
}
    `;

/**
 * __useImportFromCsvMutation__
 *
 * To run a mutation, you first call `useImportFromCsvMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportFromCsvMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportFromCsvMutation({
 *   variables: {
 *     projectId: // value for 'projectId'
 *     csvContent: // value for 'csvContent'
 *   },
 * });
 */
export function useImportFromCsvMutation(options: VueApolloComposable.UseMutationOptions<ImportFromCsvMutation, ImportFromCsvMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ImportFromCsvMutation, ImportFromCsvMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ImportFromCsvMutation, ImportFromCsvMutationVariables>(ImportFromCsvDocument, options);
}
export type ImportFromCsvMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ImportFromCsvMutation, ImportFromCsvMutationVariables>;
export const RespondToMergeRequestDocument = gql`
    mutation respondToMergeRequest($input: RespondMergeRequestDTO!) {
  respondToMergeRequest(input: $input) {
    id
  }
}
    `;

/**
 * __useRespondToMergeRequestMutation__
 *
 * To run a mutation, you first call `useRespondToMergeRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRespondToMergeRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRespondToMergeRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRespondToMergeRequestMutation(options: VueApolloComposable.UseMutationOptions<RespondToMergeRequestMutation, RespondToMergeRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RespondToMergeRequestMutation, RespondToMergeRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RespondToMergeRequestMutation, RespondToMergeRequestMutationVariables>(RespondToMergeRequestDocument, options);
}
export type RespondToMergeRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RespondToMergeRequestMutation, RespondToMergeRequestMutationVariables>;
export const UpdateOneProjectOrganizationDocument = gql`
    mutation updateOneProjectOrganization($input: UpdateOneProjectOrganizationInput!) {
  updateOneProjectOrganization(input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateOneProjectOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOneProjectOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneProjectOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOneProjectOrganizationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneProjectOrganizationMutation(options: VueApolloComposable.UseMutationOptions<UpdateOneProjectOrganizationMutation, UpdateOneProjectOrganizationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOneProjectOrganizationMutation, UpdateOneProjectOrganizationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOneProjectOrganizationMutation, UpdateOneProjectOrganizationMutationVariables>(UpdateOneProjectOrganizationDocument, options);
}
export type UpdateOneProjectOrganizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOneProjectOrganizationMutation, UpdateOneProjectOrganizationMutationVariables>;
export const WithdrawMergeRequestDocument = gql`
    mutation withdrawMergeRequest($sessionId: String!) {
  withdrawMergeRequest(sessionId: $sessionId) {
    id
  }
}
    `;

/**
 * __useWithdrawMergeRequestMutation__
 *
 * To run a mutation, you first call `useWithdrawMergeRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawMergeRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useWithdrawMergeRequestMutation({
 *   variables: {
 *     sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useWithdrawMergeRequestMutation(options: VueApolloComposable.UseMutationOptions<WithdrawMergeRequestMutation, WithdrawMergeRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<WithdrawMergeRequestMutation, WithdrawMergeRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<WithdrawMergeRequestMutation, WithdrawMergeRequestMutationVariables>(WithdrawMergeRequestDocument, options);
}
export type WithdrawMergeRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<WithdrawMergeRequestMutation, WithdrawMergeRequestMutationVariables>;
export const CloseSurveyDocument = gql`
    mutation closeSurvey($surveyId: String!) {
  closeSurvey(surveyId: $surveyId) {
    id
  }
}
    `;

/**
 * __useCloseSurveyMutation__
 *
 * To run a mutation, you first call `useCloseSurveyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloseSurveyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloseSurveyMutation({
 *   variables: {
 *     surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useCloseSurveyMutation(options: VueApolloComposable.UseMutationOptions<CloseSurveyMutation, CloseSurveyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloseSurveyMutation, CloseSurveyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CloseSurveyMutation, CloseSurveyMutationVariables>(CloseSurveyDocument, options);
}
export type CloseSurveyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloseSurveyMutation, CloseSurveyMutationVariables>;
export const CreateAnswersSurveyDocument = gql`
    mutation createAnswersSurvey($input: AnswerSurveyDto!) {
  answerSurvey(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateAnswersSurveyMutation__
 *
 * To run a mutation, you first call `useCreateAnswersSurveyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswersSurveyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAnswersSurveyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnswersSurveyMutation(options: VueApolloComposable.UseMutationOptions<CreateAnswersSurveyMutation, CreateAnswersSurveyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAnswersSurveyMutation, CreateAnswersSurveyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAnswersSurveyMutation, CreateAnswersSurveyMutationVariables>(CreateAnswersSurveyDocument, options);
}
export type CreateAnswersSurveyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAnswersSurveyMutation, CreateAnswersSurveyMutationVariables>;
export const CreateInviteDocument = gql`
    mutation createInvite($input: CreateInviteDto!) {
  createInvite(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateInviteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateInviteMutation(options: VueApolloComposable.UseMutationOptions<CreateInviteMutation, CreateInviteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateInviteMutation, CreateInviteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateInviteMutation, CreateInviteMutationVariables>(CreateInviteDocument, options);
}
export type CreateInviteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateInviteMutation, CreateInviteMutationVariables>;
export const CreateOneAnswerDocument = gql`
    mutation createOneAnswer($input: CreateOneAnswerInput!) {
  createOneAnswer(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateOneAnswerMutation__
 *
 * To run a mutation, you first call `useCreateOneAnswerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneAnswerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneAnswerMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneAnswerMutation(options: VueApolloComposable.UseMutationOptions<CreateOneAnswerMutation, CreateOneAnswerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneAnswerMutation, CreateOneAnswerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneAnswerMutation, CreateOneAnswerMutationVariables>(CreateOneAnswerDocument, options);
}
export type CreateOneAnswerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneAnswerMutation, CreateOneAnswerMutationVariables>;
export const CreateOneQuestionDtoDocument = gql`
    mutation createOneQuestionDto($input: CreateOneQuestionDtoInput!) {
  createOneQuestionDto(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateOneQuestionDtoMutation__
 *
 * To run a mutation, you first call `useCreateOneQuestionDtoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneQuestionDtoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneQuestionDtoMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneQuestionDtoMutation(options: VueApolloComposable.UseMutationOptions<CreateOneQuestionDtoMutation, CreateOneQuestionDtoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneQuestionDtoMutation, CreateOneQuestionDtoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneQuestionDtoMutation, CreateOneQuestionDtoMutationVariables>(CreateOneQuestionDtoDocument, options);
}
export type CreateOneQuestionDtoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneQuestionDtoMutation, CreateOneQuestionDtoMutationVariables>;
export const CreateOneQuestionFieldDtoDocument = gql`
    mutation createOneQuestionFieldDto($input: CreateOneQuestionFieldDtoInput!) {
  createOneQuestionFieldDto(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateOneQuestionFieldDtoMutation__
 *
 * To run a mutation, you first call `useCreateOneQuestionFieldDtoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneQuestionFieldDtoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneQuestionFieldDtoMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneQuestionFieldDtoMutation(options: VueApolloComposable.UseMutationOptions<CreateOneQuestionFieldDtoMutation, CreateOneQuestionFieldDtoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneQuestionFieldDtoMutation, CreateOneQuestionFieldDtoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneQuestionFieldDtoMutation, CreateOneQuestionFieldDtoMutationVariables>(CreateOneQuestionFieldDtoDocument, options);
}
export type CreateOneQuestionFieldDtoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneQuestionFieldDtoMutation, CreateOneQuestionFieldDtoMutationVariables>;
export const CreateOneSurveyDtoDocument = gql`
    mutation createOneSurveyDto($input: CreateOneSurveyDtoInput!) {
  createOneSurveyDto(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateOneSurveyDtoMutation__
 *
 * To run a mutation, you first call `useCreateOneSurveyDtoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneSurveyDtoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneSurveyDtoMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneSurveyDtoMutation(options: VueApolloComposable.UseMutationOptions<CreateOneSurveyDtoMutation, CreateOneSurveyDtoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneSurveyDtoMutation, CreateOneSurveyDtoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneSurveyDtoMutation, CreateOneSurveyDtoMutationVariables>(CreateOneSurveyDtoDocument, options);
}
export type CreateOneSurveyDtoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneSurveyDtoMutation, CreateOneSurveyDtoMutationVariables>;
export const CreateSurveyFullDocument = gql`
    mutation createSurveyFull($input: CreateSurveyFullDto!) {
  createSurveyFull(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateSurveyFullMutation__
 *
 * To run a mutation, you first call `useCreateSurveyFullMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyFullMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSurveyFullMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyFullMutation(options: VueApolloComposable.UseMutationOptions<CreateSurveyFullMutation, CreateSurveyFullMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSurveyFullMutation, CreateSurveyFullMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateSurveyFullMutation, CreateSurveyFullMutationVariables>(CreateSurveyFullDocument, options);
}
export type CreateSurveyFullMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSurveyFullMutation, CreateSurveyFullMutationVariables>;
export const DeleteOneQuestionDtoDocument = gql`
    mutation deleteOneQuestionDto($input: DeleteOneQuestionDtoInput!) {
  deleteOneQuestionDto(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteOneQuestionDtoMutation__
 *
 * To run a mutation, you first call `useDeleteOneQuestionDtoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneQuestionDtoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOneQuestionDtoMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOneQuestionDtoMutation(options: VueApolloComposable.UseMutationOptions<DeleteOneQuestionDtoMutation, DeleteOneQuestionDtoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOneQuestionDtoMutation, DeleteOneQuestionDtoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOneQuestionDtoMutation, DeleteOneQuestionDtoMutationVariables>(DeleteOneQuestionDtoDocument, options);
}
export type DeleteOneQuestionDtoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOneQuestionDtoMutation, DeleteOneQuestionDtoMutationVariables>;
export const DeleteOneSurveyDtoDocument = gql`
    mutation deleteOneSurveyDto($input: DeleteOneSurveyDtoInput!) {
  deleteOneSurveyDto(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteOneSurveyDtoMutation__
 *
 * To run a mutation, you first call `useDeleteOneSurveyDtoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneSurveyDtoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOneSurveyDtoMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOneSurveyDtoMutation(options: VueApolloComposable.UseMutationOptions<DeleteOneSurveyDtoMutation, DeleteOneSurveyDtoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOneSurveyDtoMutation, DeleteOneSurveyDtoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOneSurveyDtoMutation, DeleteOneSurveyDtoMutationVariables>(DeleteOneSurveyDtoDocument, options);
}
export type DeleteOneSurveyDtoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOneSurveyDtoMutation, DeleteOneSurveyDtoMutationVariables>;
export const ExportSurveyReportDocument = gql`
    mutation exportSurveyReport($input: ExportSurveyReportInput!) {
  exportSurveyReport(input: $input) {
    filename
    mimeType
    base64
  }
}
    `;

/**
 * __useExportSurveyReportMutation__
 *
 * To run a mutation, you first call `useExportSurveyReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportSurveyReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportSurveyReportMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useExportSurveyReportMutation(options: VueApolloComposable.UseMutationOptions<ExportSurveyReportMutation, ExportSurveyReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExportSurveyReportMutation, ExportSurveyReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExportSurveyReportMutation, ExportSurveyReportMutationVariables>(ExportSurveyReportDocument, options);
}
export type ExportSurveyReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExportSurveyReportMutation, ExportSurveyReportMutationVariables>;
export const InviteUserToSurveyDocument = gql`
    mutation inviteUserToSurvey($surveyId: String!, $userId: String!, $expiresAt: DateTime) {
  inviteUserToSurvey(surveyId: $surveyId, userId: $userId, expiresAt: $expiresAt) {
    id
  }
}
    `;

/**
 * __useInviteUserToSurveyMutation__
 *
 * To run a mutation, you first call `useInviteUserToSurveyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserToSurveyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInviteUserToSurveyMutation({
 *   variables: {
 *     surveyId: // value for 'surveyId'
 *     userId: // value for 'userId'
 *     expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useInviteUserToSurveyMutation(options: VueApolloComposable.UseMutationOptions<InviteUserToSurveyMutation, InviteUserToSurveyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InviteUserToSurveyMutation, InviteUserToSurveyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InviteUserToSurveyMutation, InviteUserToSurveyMutationVariables>(InviteUserToSurveyDocument, options);
}
export type InviteUserToSurveyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InviteUserToSurveyMutation, InviteUserToSurveyMutationVariables>;
export const PublishSurveyDocument = gql`
    mutation publishSurvey($input: PublishSurveyDto!) {
  publishSurvey(input: $input) {
    id
  }
}
    `;

/**
 * __usePublishSurveyMutation__
 *
 * To run a mutation, you first call `usePublishSurveyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishSurveyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishSurveyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePublishSurveyMutation(options: VueApolloComposable.UseMutationOptions<PublishSurveyMutation, PublishSurveyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PublishSurveyMutation, PublishSurveyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PublishSurveyMutation, PublishSurveyMutationVariables>(PublishSurveyDocument, options);
}
export type PublishSurveyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PublishSurveyMutation, PublishSurveyMutationVariables>;
export const SetSurveyVisibilityDocument = gql`
    mutation setSurveyVisibility($surveyId: String!, $visibleToProjectAdmins: Boolean, $visibleToProjectMembers: Boolean) {
  setSurveyVisibility(
    surveyId: $surveyId
    visibleToProjectAdmins: $visibleToProjectAdmins
    visibleToProjectMembers: $visibleToProjectMembers
  ) {
    id
  }
}
    `;

/**
 * __useSetSurveyVisibilityMutation__
 *
 * To run a mutation, you first call `useSetSurveyVisibilityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetSurveyVisibilityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetSurveyVisibilityMutation({
 *   variables: {
 *     surveyId: // value for 'surveyId'
 *     visibleToProjectAdmins: // value for 'visibleToProjectAdmins'
 *     visibleToProjectMembers: // value for 'visibleToProjectMembers'
 *   },
 * });
 */
export function useSetSurveyVisibilityMutation(options: VueApolloComposable.UseMutationOptions<SetSurveyVisibilityMutation, SetSurveyVisibilityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetSurveyVisibilityMutation, SetSurveyVisibilityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetSurveyVisibilityMutation, SetSurveyVisibilityMutationVariables>(SetSurveyVisibilityDocument, options);
}
export type SetSurveyVisibilityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetSurveyVisibilityMutation, SetSurveyVisibilityMutationVariables>;
export const ToggleSurveyPublicLinkDocument = gql`
    mutation toggleSurveyPublicLink($surveyId: String!, $enabled: Boolean!) {
  toggleSurveyPublicLink(surveyId: $surveyId, enabled: $enabled) {
    id
  }
}
    `;

/**
 * __useToggleSurveyPublicLinkMutation__
 *
 * To run a mutation, you first call `useToggleSurveyPublicLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleSurveyPublicLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleSurveyPublicLinkMutation({
 *   variables: {
 *     surveyId: // value for 'surveyId'
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleSurveyPublicLinkMutation(options: VueApolloComposable.UseMutationOptions<ToggleSurveyPublicLinkMutation, ToggleSurveyPublicLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ToggleSurveyPublicLinkMutation, ToggleSurveyPublicLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ToggleSurveyPublicLinkMutation, ToggleSurveyPublicLinkMutationVariables>(ToggleSurveyPublicLinkDocument, options);
}
export type ToggleSurveyPublicLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ToggleSurveyPublicLinkMutation, ToggleSurveyPublicLinkMutationVariables>;
export const UpdateOneQuestionDtoDocument = gql`
    mutation updateOneQuestionDto($input: UpdateOneQuestionDtoInput!) {
  updateOneQuestionDto(input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateOneQuestionDtoMutation__
 *
 * To run a mutation, you first call `useUpdateOneQuestionDtoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneQuestionDtoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOneQuestionDtoMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneQuestionDtoMutation(options: VueApolloComposable.UseMutationOptions<UpdateOneQuestionDtoMutation, UpdateOneQuestionDtoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOneQuestionDtoMutation, UpdateOneQuestionDtoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOneQuestionDtoMutation, UpdateOneQuestionDtoMutationVariables>(UpdateOneQuestionDtoDocument, options);
}
export type UpdateOneQuestionDtoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOneQuestionDtoMutation, UpdateOneQuestionDtoMutationVariables>;
export const UpdateOneSurveyDtoDocument = gql`
    mutation updateOneSurveyDto($input: UpdateOneSurveyDtoInput!) {
  updateOneSurveyDto(input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateOneSurveyDtoMutation__
 *
 * To run a mutation, you first call `useUpdateOneSurveyDtoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneSurveyDtoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOneSurveyDtoMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneSurveyDtoMutation(options: VueApolloComposable.UseMutationOptions<UpdateOneSurveyDtoMutation, UpdateOneSurveyDtoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOneSurveyDtoMutation, UpdateOneSurveyDtoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOneSurveyDtoMutation, UpdateOneSurveyDtoMutationVariables>(UpdateOneSurveyDtoDocument, options);
}
export type UpdateOneSurveyDtoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOneSurveyDtoMutation, UpdateOneSurveyDtoMutationVariables>;
export const UpdateQuestionFullDocument = gql`
    mutation updateQuestionFull($input: UpdateQuestionFullDto!) {
  updateQuestionFull(input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateQuestionFullMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionFullMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionFullMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionFullMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionFullMutation(options: VueApolloComposable.UseMutationOptions<UpdateQuestionFullMutation, UpdateQuestionFullMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateQuestionFullMutation, UpdateQuestionFullMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateQuestionFullMutation, UpdateQuestionFullMutationVariables>(UpdateQuestionFullDocument, options);
}
export type UpdateQuestionFullMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateQuestionFullMutation, UpdateQuestionFullMutationVariables>;
export const CreateOneLandingTemplateDocument = gql`
    mutation createOneLandingTemplate($input: CreateOneLandingTemplateInput!) {
  createOneLandingTemplate(input: $input) {
    id
    name
    description
    content
    isPublic
    createdBy
    updatedBy
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useCreateOneLandingTemplateMutation__
 *
 * To run a mutation, you first call `useCreateOneLandingTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneLandingTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOneLandingTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneLandingTemplateMutation(options: VueApolloComposable.UseMutationOptions<CreateOneLandingTemplateMutation, CreateOneLandingTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOneLandingTemplateMutation, CreateOneLandingTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOneLandingTemplateMutation, CreateOneLandingTemplateMutationVariables>(CreateOneLandingTemplateDocument, options);
}
export type CreateOneLandingTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOneLandingTemplateMutation, CreateOneLandingTemplateMutationVariables>;
export const GetLandingImageUploadUrlDocument = gql`
    mutation getLandingImageUploadUrl($input: LandingImageUploadInput!) {
  getLandingImageUploadUrl(input: $input) {
    uploadUrl
    publicUrl
    imagePath
  }
}
    `;

/**
 * __useGetLandingImageUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetLandingImageUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGetLandingImageUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGetLandingImageUploadUrlMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useGetLandingImageUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<GetLandingImageUploadUrlMutation, GetLandingImageUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GetLandingImageUploadUrlMutation, GetLandingImageUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GetLandingImageUploadUrlMutation, GetLandingImageUploadUrlMutationVariables>(GetLandingImageUploadUrlDocument, options);
}
export type GetLandingImageUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GetLandingImageUploadUrlMutation, GetLandingImageUploadUrlMutationVariables>;
export const UpdateOneLandingTemplateDocument = gql`
    mutation updateOneLandingTemplate($input: UpdateOneLandingTemplateInput!) {
  updateOneLandingTemplate(input: $input) {
    id
    name
    description
    content
    isPublic
    createdBy
    updatedBy
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useUpdateOneLandingTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateOneLandingTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneLandingTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOneLandingTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneLandingTemplateMutation(options: VueApolloComposable.UseMutationOptions<UpdateOneLandingTemplateMutation, UpdateOneLandingTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOneLandingTemplateMutation, UpdateOneLandingTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOneLandingTemplateMutation, UpdateOneLandingTemplateMutationVariables>(UpdateOneLandingTemplateDocument, options);
}
export type UpdateOneLandingTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOneLandingTemplateMutation, UpdateOneLandingTemplateMutationVariables>;
export const DeleteUserAddressDocument = gql`
    mutation deleteUserAddress($addressId: Float!) {
  deleteUserAddress(addressId: $addressId)
}
    `;

/**
 * __useDeleteUserAddressMutation__
 *
 * To run a mutation, you first call `useDeleteUserAddressMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAddressMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserAddressMutation({
 *   variables: {
 *     addressId: // value for 'addressId'
 *   },
 * });
 */
export function useDeleteUserAddressMutation(options: VueApolloComposable.UseMutationOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>(DeleteUserAddressDocument, options);
}
export type DeleteUserAddressMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($identifier: String!, $newPassword: String!) {
  resetPassword(identifier: $identifier, newPassword: $newPassword)
}
    `;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetPasswordMutation({
 *   variables: {
 *     identifier: // value for 'identifier'
 *     newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(options: VueApolloComposable.UseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
}
export type ResetPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(updateUserInput: $input) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserOnlineStatusDocument = gql`
    mutation updateUserOnlineStatus($input: UpdateUserOnlineStatusInput!) {
  updateUserOnlineStatus(input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateUserOnlineStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnlineStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnlineStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserOnlineStatusMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserOnlineStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserOnlineStatusMutation, UpdateUserOnlineStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserOnlineStatusMutation, UpdateUserOnlineStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserOnlineStatusMutation, UpdateUserOnlineStatusMutationVariables>(UpdateUserOnlineStatusDocument, options);
}
export type UpdateUserOnlineStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserOnlineStatusMutation, UpdateUserOnlineStatusMutationVariables>;
export const LoginCodeStatusDocument = gql`
    query loginCodeStatus {
  loginCodeStatus
}
    `;

/**
 * __useLoginCodeStatusQuery__
 *
 * To run a query within a Vue component, call `useLoginCodeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginCodeStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLoginCodeStatusQuery();
 */
export function useLoginCodeStatusQuery(options: VueApolloComposable.UseQueryOptions<LoginCodeStatusQuery, LoginCodeStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoginCodeStatusQuery, LoginCodeStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoginCodeStatusQuery, LoginCodeStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LoginCodeStatusQuery, LoginCodeStatusQueryVariables>(LoginCodeStatusDocument, {}, options);
}
export function useLoginCodeStatusLazyQuery(options: VueApolloComposable.UseQueryOptions<LoginCodeStatusQuery, LoginCodeStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoginCodeStatusQuery, LoginCodeStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoginCodeStatusQuery, LoginCodeStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LoginCodeStatusQuery, LoginCodeStatusQueryVariables>(LoginCodeStatusDocument, {}, options);
}
export type LoginCodeStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LoginCodeStatusQuery, LoginCodeStatusQueryVariables>;
export const CalendarEventDocument = gql`
    query calendarEvent($id: ID!) {
  calendarEvent(id: $id) {
    ...PlannerCalendarEventItemFields
  }
}
    ${PlannerCalendarEventItemFieldsFragmentDoc}`;

/**
 * __useCalendarEventQuery__
 *
 * To run a query within a Vue component, call `useCalendarEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalendarEventQuery({
 *   id: // value for 'id'
 * });
 */
export function useCalendarEventQuery(variables: CalendarEventQueryVariables | VueCompositionApi.Ref<CalendarEventQueryVariables> | ReactiveFunction<CalendarEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<CalendarEventQuery, CalendarEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarEventQuery, CalendarEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarEventQuery, CalendarEventQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CalendarEventQuery, CalendarEventQueryVariables>(CalendarEventDocument, variables, options);
}
export function useCalendarEventLazyQuery(variables?: CalendarEventQueryVariables | VueCompositionApi.Ref<CalendarEventQueryVariables> | ReactiveFunction<CalendarEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<CalendarEventQuery, CalendarEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarEventQuery, CalendarEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarEventQuery, CalendarEventQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CalendarEventQuery, CalendarEventQueryVariables>(CalendarEventDocument, variables, options);
}
export type CalendarEventQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CalendarEventQuery, CalendarEventQueryVariables>;
export const CalendarEventDayCountsDocument = gql`
    query calendarEventDayCounts($filter: CalendarEventDayCountFilterInput!) {
  calendarEventDayCounts(filter: $filter) {
    date
    count
    hasImportant
    hasVeryImportant
  }
}
    `;

/**
 * __useCalendarEventDayCountsQuery__
 *
 * To run a query within a Vue component, call `useCalendarEventDayCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventDayCountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalendarEventDayCountsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useCalendarEventDayCountsQuery(variables: CalendarEventDayCountsQueryVariables | VueCompositionApi.Ref<CalendarEventDayCountsQueryVariables> | ReactiveFunction<CalendarEventDayCountsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CalendarEventDayCountsQuery, CalendarEventDayCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarEventDayCountsQuery, CalendarEventDayCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarEventDayCountsQuery, CalendarEventDayCountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CalendarEventDayCountsQuery, CalendarEventDayCountsQueryVariables>(CalendarEventDayCountsDocument, variables, options);
}
export function useCalendarEventDayCountsLazyQuery(variables?: CalendarEventDayCountsQueryVariables | VueCompositionApi.Ref<CalendarEventDayCountsQueryVariables> | ReactiveFunction<CalendarEventDayCountsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CalendarEventDayCountsQuery, CalendarEventDayCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarEventDayCountsQuery, CalendarEventDayCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarEventDayCountsQuery, CalendarEventDayCountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CalendarEventDayCountsQuery, CalendarEventDayCountsQueryVariables>(CalendarEventDayCountsDocument, variables, options);
}
export type CalendarEventDayCountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CalendarEventDayCountsQuery, CalendarEventDayCountsQueryVariables>;
export const CalendarEventUsersDocument = gql`
    query calendarEventUsers($eventId: ID, $projectId: ID) {
  calendarEventUsers(eventId: $eventId, projectId: $projectId) {
    availableUsers {
      ...UserFields
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            FRIENDS_CARD
            PROFILE
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useCalendarEventUsersQuery__
 *
 * To run a query within a Vue component, call `useCalendarEventUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalendarEventUsersQuery({
 *   eventId: // value for 'eventId'
 *   projectId: // value for 'projectId'
 * });
 */
export function useCalendarEventUsersQuery(variables: CalendarEventUsersQueryVariables | VueCompositionApi.Ref<CalendarEventUsersQueryVariables> | ReactiveFunction<CalendarEventUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CalendarEventUsersQuery, CalendarEventUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarEventUsersQuery, CalendarEventUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarEventUsersQuery, CalendarEventUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CalendarEventUsersQuery, CalendarEventUsersQueryVariables>(CalendarEventUsersDocument, variables, options);
}
export function useCalendarEventUsersLazyQuery(variables: CalendarEventUsersQueryVariables | VueCompositionApi.Ref<CalendarEventUsersQueryVariables> | ReactiveFunction<CalendarEventUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CalendarEventUsersQuery, CalendarEventUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarEventUsersQuery, CalendarEventUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarEventUsersQuery, CalendarEventUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CalendarEventUsersQuery, CalendarEventUsersQueryVariables>(CalendarEventUsersDocument, variables, options);
}
export type CalendarEventUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CalendarEventUsersQuery, CalendarEventUsersQueryVariables>;
export const CalendarEventsDocument = gql`
    query calendarEvents($filter: CalendarEventListFilterInput!) {
  calendarEvents(filter: $filter) {
    total
    page
    limit
    hasMore
    items {
      ...PlannerCalendarEventItemFields
    }
  }
}
    ${PlannerCalendarEventItemFieldsFragmentDoc}`;

/**
 * __useCalendarEventsQuery__
 *
 * To run a query within a Vue component, call `useCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalendarEventsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useCalendarEventsQuery(variables: CalendarEventsQueryVariables | VueCompositionApi.Ref<CalendarEventsQueryVariables> | ReactiveFunction<CalendarEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CalendarEventsQuery, CalendarEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarEventsQuery, CalendarEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarEventsQuery, CalendarEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, variables, options);
}
export function useCalendarEventsLazyQuery(variables?: CalendarEventsQueryVariables | VueCompositionApi.Ref<CalendarEventsQueryVariables> | ReactiveFunction<CalendarEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CalendarEventsQuery, CalendarEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarEventsQuery, CalendarEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarEventsQuery, CalendarEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, variables, options);
}
export type CalendarEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CalendarEventsQuery, CalendarEventsQueryVariables>;
export const GetMsProjectCalendarEventPermissionsDocument = gql`
    query getMsProjectCalendarEventPermissions($projectId: ID) {
  getMsProjectCalendarEventPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectCalendarEventPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectCalendarEventPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectCalendarEventPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectCalendarEventPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectCalendarEventPermissionsQuery(variables: GetMsProjectCalendarEventPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectCalendarEventPermissionsQueryVariables> | ReactiveFunction<GetMsProjectCalendarEventPermissionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetMsProjectCalendarEventPermissionsQuery, GetMsProjectCalendarEventPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectCalendarEventPermissionsQuery, GetMsProjectCalendarEventPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectCalendarEventPermissionsQuery, GetMsProjectCalendarEventPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectCalendarEventPermissionsQuery, GetMsProjectCalendarEventPermissionsQueryVariables>(GetMsProjectCalendarEventPermissionsDocument, variables, options);
}
export function useGetMsProjectCalendarEventPermissionsLazyQuery(variables: GetMsProjectCalendarEventPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectCalendarEventPermissionsQueryVariables> | ReactiveFunction<GetMsProjectCalendarEventPermissionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetMsProjectCalendarEventPermissionsQuery, GetMsProjectCalendarEventPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectCalendarEventPermissionsQuery, GetMsProjectCalendarEventPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectCalendarEventPermissionsQuery, GetMsProjectCalendarEventPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectCalendarEventPermissionsQuery, GetMsProjectCalendarEventPermissionsQueryVariables>(GetMsProjectCalendarEventPermissionsDocument, variables, options);
}
export type GetMsProjectCalendarEventPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectCalendarEventPermissionsQuery, GetMsProjectCalendarEventPermissionsQueryVariables>;
export const CommentsDocument = gql`
    query comments($paging: OffsetPaging! = {limit: 50}, $filter: CommentFilter! = {}, $sorting: [CommentSort!]! = [{field: createdAt, direction: ASC}]) {
  comments(paging: $paging, filter: $filter, sorting: $sorting) {
    nodes {
      id
      content
      createdByUserId
      updatedByUserId
      commentableId
      commentableType
      parentId
      creator {
        id
        firstName
        lastName
        media {
          avatar {
            DESKTOP {
              ORIGINAL
            }
          }
        }
      }
      createdAt
      updatedAt
      likes {
        isLiked
        likeCount
      }
      deletedAt
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useCommentsQuery__
 *
 * To run a query within a Vue component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCommentsQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useCommentsQuery(variables: CommentsQueryVariables | VueCompositionApi.Ref<CommentsQueryVariables> | ReactiveFunction<CommentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommentsQuery, CommentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommentsQuery, CommentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommentsQuery, CommentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, variables, options);
}
export function useCommentsLazyQuery(variables?: CommentsQueryVariables | VueCompositionApi.Ref<CommentsQueryVariables> | ReactiveFunction<CommentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommentsQuery, CommentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommentsQuery, CommentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommentsQuery, CommentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, variables, options);
}
export type CommentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CommentsQuery, CommentsQueryVariables>;
export const CounterHistoryDocument = gql`
    query counterHistory($counterId: ID!, $year: Int!) {
  counterHistory(counterId: $counterId, year: $year) {
    counterId
    type
    name
    unit
    year
    monthlyData {
      year
      month
      monthName
      recordedAt
      reading
      consumption
      cost
      hasDelta
      canEnter
    }
    chartData {
      period
      values
    }
    chartLegend {
      label
      value
      color
    }
  }
}
    `;

/**
 * __useCounterHistoryQuery__
 *
 * To run a query within a Vue component, call `useCounterHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCounterHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCounterHistoryQuery({
 *   counterId: // value for 'counterId'
 *   year: // value for 'year'
 * });
 */
export function useCounterHistoryQuery(variables: CounterHistoryQueryVariables | VueCompositionApi.Ref<CounterHistoryQueryVariables> | ReactiveFunction<CounterHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<CounterHistoryQuery, CounterHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CounterHistoryQuery, CounterHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CounterHistoryQuery, CounterHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CounterHistoryQuery, CounterHistoryQueryVariables>(CounterHistoryDocument, variables, options);
}
export function useCounterHistoryLazyQuery(variables?: CounterHistoryQueryVariables | VueCompositionApi.Ref<CounterHistoryQueryVariables> | ReactiveFunction<CounterHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<CounterHistoryQuery, CounterHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CounterHistoryQuery, CounterHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CounterHistoryQuery, CounterHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CounterHistoryQuery, CounterHistoryQueryVariables>(CounterHistoryDocument, variables, options);
}
export type CounterHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CounterHistoryQuery, CounterHistoryQueryVariables>;
export const CounterReadingsDocument = gql`
    query counterReadings($filter: CounterReadingFilter, $paging: OffsetPaging) {
  counterReadings(filter: $filter, paging: $paging) {
    nodes {
      id
      counterId
      year
      month
      reading
      cost
    }
  }
}
    `;

/**
 * __useCounterReadingsQuery__
 *
 * To run a query within a Vue component, call `useCounterReadingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCounterReadingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCounterReadingsQuery({
 *   filter: // value for 'filter'
 *   paging: // value for 'paging'
 * });
 */
export function useCounterReadingsQuery(variables: CounterReadingsQueryVariables | VueCompositionApi.Ref<CounterReadingsQueryVariables> | ReactiveFunction<CounterReadingsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CounterReadingsQuery, CounterReadingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CounterReadingsQuery, CounterReadingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CounterReadingsQuery, CounterReadingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CounterReadingsQuery, CounterReadingsQueryVariables>(CounterReadingsDocument, variables, options);
}
export function useCounterReadingsLazyQuery(variables: CounterReadingsQueryVariables | VueCompositionApi.Ref<CounterReadingsQueryVariables> | ReactiveFunction<CounterReadingsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CounterReadingsQuery, CounterReadingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CounterReadingsQuery, CounterReadingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CounterReadingsQuery, CounterReadingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CounterReadingsQuery, CounterReadingsQueryVariables>(CounterReadingsDocument, variables, options);
}
export type CounterReadingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CounterReadingsQuery, CounterReadingsQueryVariables>;
export const CountersByCategoryDocument = gql`
    query countersByCategory($projectId: ID!, $category: CounterCategory!) {
  countersByCategory(projectId: $projectId, category: $category) {
    id
    type
    name
    unit
  }
}
    `;

/**
 * __useCountersByCategoryQuery__
 *
 * To run a query within a Vue component, call `useCountersByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountersByCategoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCountersByCategoryQuery({
 *   projectId: // value for 'projectId'
 *   category: // value for 'category'
 * });
 */
export function useCountersByCategoryQuery(variables: CountersByCategoryQueryVariables | VueCompositionApi.Ref<CountersByCategoryQueryVariables> | ReactiveFunction<CountersByCategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<CountersByCategoryQuery, CountersByCategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CountersByCategoryQuery, CountersByCategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CountersByCategoryQuery, CountersByCategoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CountersByCategoryQuery, CountersByCategoryQueryVariables>(CountersByCategoryDocument, variables, options);
}
export function useCountersByCategoryLazyQuery(variables?: CountersByCategoryQueryVariables | VueCompositionApi.Ref<CountersByCategoryQueryVariables> | ReactiveFunction<CountersByCategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<CountersByCategoryQuery, CountersByCategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CountersByCategoryQuery, CountersByCategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CountersByCategoryQuery, CountersByCategoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CountersByCategoryQuery, CountersByCategoryQueryVariables>(CountersByCategoryDocument, variables, options);
}
export type CountersByCategoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CountersByCategoryQuery, CountersByCategoryQueryVariables>;
export const ProjectCountersSummaryDocument = gql`
    query projectCountersSummary($projectId: ID!) {
  projectCountersSummary(projectId: $projectId) {
    projectId
    categories {
      category
      name
      icon
      iconColor
      currentMonthCost
      yearlyCost
      counters {
        id
        type
        category
        name
        unit
        lastReading
        currentConsumption
        currentCost
        yearlyConsumption
        yearlyCost
      }
    }
    chartData {
      period
      values
    }
    chartLegend {
      label
      value
      color
    }
  }
}
    `;

/**
 * __useProjectCountersSummaryQuery__
 *
 * To run a query within a Vue component, call `useProjectCountersSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCountersSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectCountersSummaryQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useProjectCountersSummaryQuery(variables: ProjectCountersSummaryQueryVariables | VueCompositionApi.Ref<ProjectCountersSummaryQueryVariables> | ReactiveFunction<ProjectCountersSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectCountersSummaryQuery, ProjectCountersSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectCountersSummaryQuery, ProjectCountersSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectCountersSummaryQuery, ProjectCountersSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectCountersSummaryQuery, ProjectCountersSummaryQueryVariables>(ProjectCountersSummaryDocument, variables, options);
}
export function useProjectCountersSummaryLazyQuery(variables?: ProjectCountersSummaryQueryVariables | VueCompositionApi.Ref<ProjectCountersSummaryQueryVariables> | ReactiveFunction<ProjectCountersSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectCountersSummaryQuery, ProjectCountersSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectCountersSummaryQuery, ProjectCountersSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectCountersSummaryQuery, ProjectCountersSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectCountersSummaryQuery, ProjectCountersSummaryQueryVariables>(ProjectCountersSummaryDocument, variables, options);
}
export type ProjectCountersSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectCountersSummaryQuery, ProjectCountersSummaryQueryVariables>;
export const EmergencyContactsDocument = gql`
    query emergencyContacts($paging: OffsetPaging! = {limit: 20}, $filter: EmergencyContactFilter! = {}, $sorting: [EmergencyContactSort!]! = [{field: createdAt, direction: DESC}]) {
  emergencyContacts(paging: $paging, filter: $filter, sorting: $sorting) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      id
      ...EmergencyContactFields
    }
    totalCount
  }
}
    ${EmergencyContactFieldsFragmentDoc}`;

/**
 * __useEmergencyContactsQuery__
 *
 * To run a query within a Vue component, call `useEmergencyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmergencyContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEmergencyContactsQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useEmergencyContactsQuery(variables: EmergencyContactsQueryVariables | VueCompositionApi.Ref<EmergencyContactsQueryVariables> | ReactiveFunction<EmergencyContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<EmergencyContactsQuery, EmergencyContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EmergencyContactsQuery, EmergencyContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EmergencyContactsQuery, EmergencyContactsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EmergencyContactsQuery, EmergencyContactsQueryVariables>(EmergencyContactsDocument, variables, options);
}
export function useEmergencyContactsLazyQuery(variables?: EmergencyContactsQueryVariables | VueCompositionApi.Ref<EmergencyContactsQueryVariables> | ReactiveFunction<EmergencyContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<EmergencyContactsQuery, EmergencyContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EmergencyContactsQuery, EmergencyContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EmergencyContactsQuery, EmergencyContactsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EmergencyContactsQuery, EmergencyContactsQueryVariables>(EmergencyContactsDocument, variables, options);
}
export type EmergencyContactsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EmergencyContactsQuery, EmergencyContactsQueryVariables>;
export const CommonFriendsDocument = gql`
    query commonFriends($userId1: String!, $userId2: String!, $searchTerm: String, $page: Int! = 1, $limit: Int! = 10, $sortBy: String! = "updatedAt", $sortOrder: String! = "DESC") {
  commonFriends(
    userId1: $userId1
    userId2: $userId2
    searchTerm: $searchTerm
    page: $page
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    ...FriendRelationshipFields
    friend {
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
          }
        }
      }
    }
  }
}
    ${FriendRelationshipFieldsFragmentDoc}`;

/**
 * __useCommonFriendsQuery__
 *
 * To run a query within a Vue component, call `useCommonFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonFriendsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCommonFriendsQuery({
 *   userId1: // value for 'userId1'
 *   userId2: // value for 'userId2'
 *   searchTerm: // value for 'searchTerm'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   sortBy: // value for 'sortBy'
 *   sortOrder: // value for 'sortOrder'
 * });
 */
export function useCommonFriendsQuery(variables: CommonFriendsQueryVariables | VueCompositionApi.Ref<CommonFriendsQueryVariables> | ReactiveFunction<CommonFriendsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommonFriendsQuery, CommonFriendsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommonFriendsQuery, CommonFriendsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommonFriendsQuery, CommonFriendsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CommonFriendsQuery, CommonFriendsQueryVariables>(CommonFriendsDocument, variables, options);
}
export function useCommonFriendsLazyQuery(variables?: CommonFriendsQueryVariables | VueCompositionApi.Ref<CommonFriendsQueryVariables> | ReactiveFunction<CommonFriendsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommonFriendsQuery, CommonFriendsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommonFriendsQuery, CommonFriendsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommonFriendsQuery, CommonFriendsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CommonFriendsQuery, CommonFriendsQueryVariables>(CommonFriendsDocument, variables, options);
}
export type CommonFriendsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CommonFriendsQuery, CommonFriendsQueryVariables>;
export const FriendRelationshipDocument = gql`
    query friendRelationship($userId: String!, $friendId: String!) {
  friendRelationship(userId: $userId, friendId: $friendId) {
    id
    userId
    status
    senderId
    receiverId
    isOutgoing
    friend {
      ...UserFields
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useFriendRelationshipQuery__
 *
 * To run a query within a Vue component, call `useFriendRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendRelationshipQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFriendRelationshipQuery({
 *   userId: // value for 'userId'
 *   friendId: // value for 'friendId'
 * });
 */
export function useFriendRelationshipQuery(variables: FriendRelationshipQueryVariables | VueCompositionApi.Ref<FriendRelationshipQueryVariables> | ReactiveFunction<FriendRelationshipQueryVariables>, options: VueApolloComposable.UseQueryOptions<FriendRelationshipQuery, FriendRelationshipQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FriendRelationshipQuery, FriendRelationshipQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FriendRelationshipQuery, FriendRelationshipQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FriendRelationshipQuery, FriendRelationshipQueryVariables>(FriendRelationshipDocument, variables, options);
}
export function useFriendRelationshipLazyQuery(variables?: FriendRelationshipQueryVariables | VueCompositionApi.Ref<FriendRelationshipQueryVariables> | ReactiveFunction<FriendRelationshipQueryVariables>, options: VueApolloComposable.UseQueryOptions<FriendRelationshipQuery, FriendRelationshipQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FriendRelationshipQuery, FriendRelationshipQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FriendRelationshipQuery, FriendRelationshipQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FriendRelationshipQuery, FriendRelationshipQueryVariables>(FriendRelationshipDocument, variables, options);
}
export type FriendRelationshipQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FriendRelationshipQuery, FriendRelationshipQueryVariables>;
export const FriendsByUserIdDocument = gql`
    query friendsByUserId($userId: String!, $searchTerm: String, $page: Int!, $limit: Int!, $sortBy: String! = "updatedAt", $sortOrder: String! = "DESC") {
  friendsByUserId(
    userId: $userId
    searchTerm: $searchTerm
    page: $page
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    id
    userId
    status
    friend {
      ...UserFields
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            FRIENDS_CARD
          }
        }
      }
    }
    user {
      ...UserFields
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            FRIENDS_CARD
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useFriendsByUserIdQuery__
 *
 * To run a query within a Vue component, call `useFriendsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendsByUserIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFriendsByUserIdQuery({
 *   userId: // value for 'userId'
 *   searchTerm: // value for 'searchTerm'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   sortBy: // value for 'sortBy'
 *   sortOrder: // value for 'sortOrder'
 * });
 */
export function useFriendsByUserIdQuery(variables: FriendsByUserIdQueryVariables | VueCompositionApi.Ref<FriendsByUserIdQueryVariables> | ReactiveFunction<FriendsByUserIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<FriendsByUserIdQuery, FriendsByUserIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FriendsByUserIdQuery, FriendsByUserIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FriendsByUserIdQuery, FriendsByUserIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FriendsByUserIdQuery, FriendsByUserIdQueryVariables>(FriendsByUserIdDocument, variables, options);
}
export function useFriendsByUserIdLazyQuery(variables?: FriendsByUserIdQueryVariables | VueCompositionApi.Ref<FriendsByUserIdQueryVariables> | ReactiveFunction<FriendsByUserIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<FriendsByUserIdQuery, FriendsByUserIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FriendsByUserIdQuery, FriendsByUserIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FriendsByUserIdQuery, FriendsByUserIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FriendsByUserIdQuery, FriendsByUserIdQueryVariables>(FriendsByUserIdDocument, variables, options);
}
export type FriendsByUserIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FriendsByUserIdQuery, FriendsByUserIdQueryVariables>;
export const IncomingFriendRequestsDocument = gql`
    query incomingFriendRequests($userId: String!, $searchTerm: String, $page: Int! = 1, $limit: Int! = 10, $sortBy: String! = "updatedAt", $sortOrder: String! = "DESC") {
  incomingFriendRequests(
    userId: $userId
    searchTerm: $searchTerm
    page: $page
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    ...FriendRelationshipFields
    friend {
      ...UserFields
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            FRIENDS_CARD
          }
        }
      }
    }
  }
}
    ${FriendRelationshipFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useIncomingFriendRequestsQuery__
 *
 * To run a query within a Vue component, call `useIncomingFriendRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingFriendRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIncomingFriendRequestsQuery({
 *   userId: // value for 'userId'
 *   searchTerm: // value for 'searchTerm'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   sortBy: // value for 'sortBy'
 *   sortOrder: // value for 'sortOrder'
 * });
 */
export function useIncomingFriendRequestsQuery(variables: IncomingFriendRequestsQueryVariables | VueCompositionApi.Ref<IncomingFriendRequestsQueryVariables> | ReactiveFunction<IncomingFriendRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<IncomingFriendRequestsQuery, IncomingFriendRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IncomingFriendRequestsQuery, IncomingFriendRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IncomingFriendRequestsQuery, IncomingFriendRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IncomingFriendRequestsQuery, IncomingFriendRequestsQueryVariables>(IncomingFriendRequestsDocument, variables, options);
}
export function useIncomingFriendRequestsLazyQuery(variables?: IncomingFriendRequestsQueryVariables | VueCompositionApi.Ref<IncomingFriendRequestsQueryVariables> | ReactiveFunction<IncomingFriendRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<IncomingFriendRequestsQuery, IncomingFriendRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IncomingFriendRequestsQuery, IncomingFriendRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IncomingFriendRequestsQuery, IncomingFriendRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IncomingFriendRequestsQuery, IncomingFriendRequestsQueryVariables>(IncomingFriendRequestsDocument, variables, options);
}
export type IncomingFriendRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IncomingFriendRequestsQuery, IncomingFriendRequestsQueryVariables>;
export const OutgoingFriendRequestsDocument = gql`
    query outgoingFriendRequests($userId: String!, $searchTerm: String, $page: Int! = 1, $limit: Int! = 10, $sortBy: String! = "updatedAt", $sortOrder: String! = "DESC") {
  outgoingFriendRequests(
    userId: $userId
    searchTerm: $searchTerm
    page: $page
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    ...FriendRelationshipFields
    friend {
      ...UserFields
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            FRIENDS_CARD
          }
        }
      }
    }
  }
}
    ${FriendRelationshipFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useOutgoingFriendRequestsQuery__
 *
 * To run a query within a Vue component, call `useOutgoingFriendRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingFriendRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOutgoingFriendRequestsQuery({
 *   userId: // value for 'userId'
 *   searchTerm: // value for 'searchTerm'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   sortBy: // value for 'sortBy'
 *   sortOrder: // value for 'sortOrder'
 * });
 */
export function useOutgoingFriendRequestsQuery(variables: OutgoingFriendRequestsQueryVariables | VueCompositionApi.Ref<OutgoingFriendRequestsQueryVariables> | ReactiveFunction<OutgoingFriendRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OutgoingFriendRequestsQuery, OutgoingFriendRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OutgoingFriendRequestsQuery, OutgoingFriendRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OutgoingFriendRequestsQuery, OutgoingFriendRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OutgoingFriendRequestsQuery, OutgoingFriendRequestsQueryVariables>(OutgoingFriendRequestsDocument, variables, options);
}
export function useOutgoingFriendRequestsLazyQuery(variables?: OutgoingFriendRequestsQueryVariables | VueCompositionApi.Ref<OutgoingFriendRequestsQueryVariables> | ReactiveFunction<OutgoingFriendRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OutgoingFriendRequestsQuery, OutgoingFriendRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OutgoingFriendRequestsQuery, OutgoingFriendRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OutgoingFriendRequestsQuery, OutgoingFriendRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OutgoingFriendRequestsQuery, OutgoingFriendRequestsQueryVariables>(OutgoingFriendRequestsDocument, variables, options);
}
export type OutgoingFriendRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OutgoingFriendRequestsQuery, OutgoingFriendRequestsQueryVariables>;
export const RecommendedUsersDocument = gql`
    query recommendedUsers($userId: String!, $searchTerm: String, $page: Int! = 1, $limit: Int! = 10, $withFriends: Boolean! = false, $sortBy: String! = "firstName", $sortOrder: String! = "ASC") {
  recommendedUsers(
    userId: $userId
    searchTerm: $searchTerm
    page: $page
    limit: $limit
    withFriends: $withFriends
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    addresses {
      ...UserAddressFields
    }
    ...UserFields
    media {
      avatar {
        DESKTOP {
          FRIENDS_MINI_AVATAR
          FRIENDS_CARD
        }
      }
    }
  }
}
    ${UserAddressFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useRecommendedUsersQuery__
 *
 * To run a query within a Vue component, call `useRecommendedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRecommendedUsersQuery({
 *   userId: // value for 'userId'
 *   searchTerm: // value for 'searchTerm'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   withFriends: // value for 'withFriends'
 *   sortBy: // value for 'sortBy'
 *   sortOrder: // value for 'sortOrder'
 * });
 */
export function useRecommendedUsersQuery(variables: RecommendedUsersQueryVariables | VueCompositionApi.Ref<RecommendedUsersQueryVariables> | ReactiveFunction<RecommendedUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<RecommendedUsersQuery, RecommendedUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RecommendedUsersQuery, RecommendedUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RecommendedUsersQuery, RecommendedUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RecommendedUsersQuery, RecommendedUsersQueryVariables>(RecommendedUsersDocument, variables, options);
}
export function useRecommendedUsersLazyQuery(variables?: RecommendedUsersQueryVariables | VueCompositionApi.Ref<RecommendedUsersQueryVariables> | ReactiveFunction<RecommendedUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<RecommendedUsersQuery, RecommendedUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RecommendedUsersQuery, RecommendedUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RecommendedUsersQuery, RecommendedUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RecommendedUsersQuery, RecommendedUsersQueryVariables>(RecommendedUsersDocument, variables, options);
}
export type RecommendedUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RecommendedUsersQuery, RecommendedUsersQueryVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($searchTerm: String!, $page: Float, $limit: Float) {
  searchUsers(searchTerm: $searchTerm, page: $page, limit: $limit) {
    ...UserFields
    media {
      avatar {
        DESKTOP {
          FRIENDS_MINI_AVATAR
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a Vue component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchUsersQuery({
 *   searchTerm: // value for 'searchTerm'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useSearchUsersQuery(variables: SearchUsersQueryVariables | VueCompositionApi.Ref<SearchUsersQueryVariables> | ReactiveFunction<SearchUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, variables, options);
}
export function useSearchUsersLazyQuery(variables?: SearchUsersQueryVariables | VueCompositionApi.Ref<SearchUsersQueryVariables> | ReactiveFunction<SearchUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, variables, options);
}
export type SearchUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchUsersQuery, SearchUsersQueryVariables>;
export const SubscribersByUserIdDocument = gql`
    query subscribersByUserId($userId: String!, $searchTerm: String, $page: Int! = 1, $limit: Int! = 10, $sortBy: String! = "updatedAt", $sortOrder: String! = "DESC") {
  subscribersByUserId(
    userId: $userId
    searchTerm: $searchTerm
    page: $page
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    ...FriendRelationshipFields
    user {
      ...UserFields
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            FRIENDS_CARD
          }
        }
      }
    }
    friend {
      ...UserFields
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            FRIENDS_CARD
          }
        }
      }
    }
  }
}
    ${FriendRelationshipFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useSubscribersByUserIdQuery__
 *
 * To run a query within a Vue component, call `useSubscribersByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscribersByUserIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribersByUserIdQuery({
 *   userId: // value for 'userId'
 *   searchTerm: // value for 'searchTerm'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   sortBy: // value for 'sortBy'
 *   sortOrder: // value for 'sortOrder'
 * });
 */
export function useSubscribersByUserIdQuery(variables: SubscribersByUserIdQueryVariables | VueCompositionApi.Ref<SubscribersByUserIdQueryVariables> | ReactiveFunction<SubscribersByUserIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<SubscribersByUserIdQuery, SubscribersByUserIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SubscribersByUserIdQuery, SubscribersByUserIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SubscribersByUserIdQuery, SubscribersByUserIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SubscribersByUserIdQuery, SubscribersByUserIdQueryVariables>(SubscribersByUserIdDocument, variables, options);
}
export function useSubscribersByUserIdLazyQuery(variables?: SubscribersByUserIdQueryVariables | VueCompositionApi.Ref<SubscribersByUserIdQueryVariables> | ReactiveFunction<SubscribersByUserIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<SubscribersByUserIdQuery, SubscribersByUserIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SubscribersByUserIdQuery, SubscribersByUserIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SubscribersByUserIdQuery, SubscribersByUserIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SubscribersByUserIdQuery, SubscribersByUserIdQueryVariables>(SubscribersByUserIdDocument, variables, options);
}
export type SubscribersByUserIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SubscribersByUserIdQuery, SubscribersByUserIdQueryVariables>;
export const UserDocument = gql`
    query user($id: String!) {
  user(id: $id) {
    ...UserFields
    media {
      avatar {
        DESKTOP {
          FRIENDS_MINI_AVATAR
          FRIENDS_CARD
          PROFILE
        }
      }
      background {
        DESKTOP {
          ORIGINAL
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a Vue component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserQuery(variables: UserQueryVariables | VueCompositionApi.Ref<UserQueryVariables> | ReactiveFunction<UserQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserQuery, UserQueryVariables>(UserDocument, variables, options);
}
export function useUserLazyQuery(variables?: UserQueryVariables | VueCompositionApi.Ref<UserQueryVariables> | ReactiveFunction<UserQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, variables, options);
}
export type UserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserQuery, UserQueryVariables>;
export const CurrentUserGlobalModuleCapabilitiesDocument = gql`
    query currentUserGlobalModuleCapabilities($moduleSlug: String!) {
  currentUserGlobalModuleCapabilities(moduleSlug: $moduleSlug) {
    moduleSlug
    canInsert
    canEdit
    hasFullAccess
    canEditAllRecords
  }
}
    `;

/**
 * __useCurrentUserGlobalModuleCapabilitiesQuery__
 *
 * To run a query within a Vue component, call `useCurrentUserGlobalModuleCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserGlobalModuleCapabilitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentUserGlobalModuleCapabilitiesQuery({
 *   moduleSlug: // value for 'moduleSlug'
 * });
 */
export function useCurrentUserGlobalModuleCapabilitiesQuery(variables: CurrentUserGlobalModuleCapabilitiesQueryVariables | VueCompositionApi.Ref<CurrentUserGlobalModuleCapabilitiesQueryVariables> | ReactiveFunction<CurrentUserGlobalModuleCapabilitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CurrentUserGlobalModuleCapabilitiesQuery, CurrentUserGlobalModuleCapabilitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserGlobalModuleCapabilitiesQuery, CurrentUserGlobalModuleCapabilitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserGlobalModuleCapabilitiesQuery, CurrentUserGlobalModuleCapabilitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CurrentUserGlobalModuleCapabilitiesQuery, CurrentUserGlobalModuleCapabilitiesQueryVariables>(CurrentUserGlobalModuleCapabilitiesDocument, variables, options);
}
export function useCurrentUserGlobalModuleCapabilitiesLazyQuery(variables?: CurrentUserGlobalModuleCapabilitiesQueryVariables | VueCompositionApi.Ref<CurrentUserGlobalModuleCapabilitiesQueryVariables> | ReactiveFunction<CurrentUserGlobalModuleCapabilitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CurrentUserGlobalModuleCapabilitiesQuery, CurrentUserGlobalModuleCapabilitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserGlobalModuleCapabilitiesQuery, CurrentUserGlobalModuleCapabilitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserGlobalModuleCapabilitiesQuery, CurrentUserGlobalModuleCapabilitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CurrentUserGlobalModuleCapabilitiesQuery, CurrentUserGlobalModuleCapabilitiesQueryVariables>(CurrentUserGlobalModuleCapabilitiesDocument, variables, options);
}
export type CurrentUserGlobalModuleCapabilitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CurrentUserGlobalModuleCapabilitiesQuery, CurrentUserGlobalModuleCapabilitiesQueryVariables>;
export const GlobalModuleAccessSettingsDocument = gql`
    query globalModuleAccessSettings($moduleSlug: String!) {
  globalModuleAccessSettings(moduleSlug: $moduleSlug) {
    id
    moduleSlug
    dataEntryScope
    dataEntryUserIds
    editParticipantScope
    editUserIds
    fullAccessUserIds
  }
}
    `;

/**
 * __useGlobalModuleAccessSettingsQuery__
 *
 * To run a query within a Vue component, call `useGlobalModuleAccessSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalModuleAccessSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGlobalModuleAccessSettingsQuery({
 *   moduleSlug: // value for 'moduleSlug'
 * });
 */
export function useGlobalModuleAccessSettingsQuery(variables: GlobalModuleAccessSettingsQueryVariables | VueCompositionApi.Ref<GlobalModuleAccessSettingsQueryVariables> | ReactiveFunction<GlobalModuleAccessSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GlobalModuleAccessSettingsQuery, GlobalModuleAccessSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GlobalModuleAccessSettingsQuery, GlobalModuleAccessSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GlobalModuleAccessSettingsQuery, GlobalModuleAccessSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GlobalModuleAccessSettingsQuery, GlobalModuleAccessSettingsQueryVariables>(GlobalModuleAccessSettingsDocument, variables, options);
}
export function useGlobalModuleAccessSettingsLazyQuery(variables?: GlobalModuleAccessSettingsQueryVariables | VueCompositionApi.Ref<GlobalModuleAccessSettingsQueryVariables> | ReactiveFunction<GlobalModuleAccessSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GlobalModuleAccessSettingsQuery, GlobalModuleAccessSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GlobalModuleAccessSettingsQuery, GlobalModuleAccessSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GlobalModuleAccessSettingsQuery, GlobalModuleAccessSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GlobalModuleAccessSettingsQuery, GlobalModuleAccessSettingsQueryVariables>(GlobalModuleAccessSettingsDocument, variables, options);
}
export type GlobalModuleAccessSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GlobalModuleAccessSettingsQuery, GlobalModuleAccessSettingsQueryVariables>;
export const MailMessagesDocument = gql`
    query mailMessages($threadId: ID!, $offset: Int = 0, $limit: Int = 50) {
  mailMessages(threadId: $threadId, offset: $offset, limit: $limit) {
    id
    threadId
    sequenceNumber
    messageNumber
    senderUserId
    content
    contentPreview
    createdAt
  }
}
    `;

/**
 * __useMailMessagesQuery__
 *
 * To run a query within a Vue component, call `useMailMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailMessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMailMessagesQuery({
 *   threadId: // value for 'threadId'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useMailMessagesQuery(variables: MailMessagesQueryVariables | VueCompositionApi.Ref<MailMessagesQueryVariables> | ReactiveFunction<MailMessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailMessagesQuery, MailMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailMessagesQuery, MailMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailMessagesQuery, MailMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MailMessagesQuery, MailMessagesQueryVariables>(MailMessagesDocument, variables, options);
}
export function useMailMessagesLazyQuery(variables?: MailMessagesQueryVariables | VueCompositionApi.Ref<MailMessagesQueryVariables> | ReactiveFunction<MailMessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailMessagesQuery, MailMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailMessagesQuery, MailMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailMessagesQuery, MailMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MailMessagesQuery, MailMessagesQueryVariables>(MailMessagesDocument, variables, options);
}
export type MailMessagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MailMessagesQuery, MailMessagesQueryVariables>;
export const MailRecipientsDocument = gql`
    query mailRecipients($projectId: ID!) {
  mailRecipients(projectId: $projectId) {
    userId
    role
    user {
      id
      firstName
      lastName
      nickname
      dateOfBirth
      addresses {
        city
      }
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            ORIGINAL
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMailRecipientsQuery__
 *
 * To run a query within a Vue component, call `useMailRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailRecipientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMailRecipientsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useMailRecipientsQuery(variables: MailRecipientsQueryVariables | VueCompositionApi.Ref<MailRecipientsQueryVariables> | ReactiveFunction<MailRecipientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailRecipientsQuery, MailRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailRecipientsQuery, MailRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailRecipientsQuery, MailRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MailRecipientsQuery, MailRecipientsQueryVariables>(MailRecipientsDocument, variables, options);
}
export function useMailRecipientsLazyQuery(variables?: MailRecipientsQueryVariables | VueCompositionApi.Ref<MailRecipientsQueryVariables> | ReactiveFunction<MailRecipientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailRecipientsQuery, MailRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailRecipientsQuery, MailRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailRecipientsQuery, MailRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MailRecipientsQuery, MailRecipientsQueryVariables>(MailRecipientsDocument, variables, options);
}
export type MailRecipientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MailRecipientsQuery, MailRecipientsQueryVariables>;
export const MailThreadDocument = gql`
    query mailThread($id: ID!) {
  mailThread(id: $id) {
    id
    registrationNumber
    status
    creatorUserId
    recipientUserId
    messageCount
    lastMessageUserId
    lastMessagePreview
    lastMessageAt
    isRead
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMailThreadQuery__
 *
 * To run a query within a Vue component, call `useMailThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailThreadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMailThreadQuery({
 *   id: // value for 'id'
 * });
 */
export function useMailThreadQuery(variables: MailThreadQueryVariables | VueCompositionApi.Ref<MailThreadQueryVariables> | ReactiveFunction<MailThreadQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailThreadQuery, MailThreadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailThreadQuery, MailThreadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailThreadQuery, MailThreadQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MailThreadQuery, MailThreadQueryVariables>(MailThreadDocument, variables, options);
}
export function useMailThreadLazyQuery(variables?: MailThreadQueryVariables | VueCompositionApi.Ref<MailThreadQueryVariables> | ReactiveFunction<MailThreadQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailThreadQuery, MailThreadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailThreadQuery, MailThreadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailThreadQuery, MailThreadQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MailThreadQuery, MailThreadQueryVariables>(MailThreadDocument, variables, options);
}
export type MailThreadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MailThreadQuery, MailThreadQueryVariables>;
export const MailThreadsDocument = gql`
    query mailThreads($projectId: ID!, $filter: MailThreadFilterEnum = ALL, $offset: Int = 0, $limit: Int = 20, $moduleSlug: String, $search: String) {
  mailThreads(
    projectId: $projectId
    filter: $filter
    offset: $offset
    limit: $limit
    moduleSlug: $moduleSlug
    search: $search
  ) {
    items {
      id
      registrationNumber
      status
      creatorUserId
      recipientUserId
      messageCount
      lastMessageUserId
      lastMessagePreview
      lastMessageAt
      isRead
      createdAt
    }
    totalCount
    hasMore
  }
}
    `;

/**
 * __useMailThreadsQuery__
 *
 * To run a query within a Vue component, call `useMailThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailThreadsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMailThreadsQuery({
 *   projectId: // value for 'projectId'
 *   filter: // value for 'filter'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 *   moduleSlug: // value for 'moduleSlug'
 *   search: // value for 'search'
 * });
 */
export function useMailThreadsQuery(variables: MailThreadsQueryVariables | VueCompositionApi.Ref<MailThreadsQueryVariables> | ReactiveFunction<MailThreadsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailThreadsQuery, MailThreadsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailThreadsQuery, MailThreadsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailThreadsQuery, MailThreadsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MailThreadsQuery, MailThreadsQueryVariables>(MailThreadsDocument, variables, options);
}
export function useMailThreadsLazyQuery(variables?: MailThreadsQueryVariables | VueCompositionApi.Ref<MailThreadsQueryVariables> | ReactiveFunction<MailThreadsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailThreadsQuery, MailThreadsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailThreadsQuery, MailThreadsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailThreadsQuery, MailThreadsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MailThreadsQuery, MailThreadsQueryVariables>(MailThreadsDocument, variables, options);
}
export type MailThreadsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MailThreadsQuery, MailThreadsQueryVariables>;
export const MailUnreadCountDocument = gql`
    query mailUnreadCount($projectId: ID!) {
  mailUnreadCount(projectId: $projectId)
}
    `;

/**
 * __useMailUnreadCountQuery__
 *
 * To run a query within a Vue component, call `useMailUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailUnreadCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMailUnreadCountQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useMailUnreadCountQuery(variables: MailUnreadCountQueryVariables | VueCompositionApi.Ref<MailUnreadCountQueryVariables> | ReactiveFunction<MailUnreadCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailUnreadCountQuery, MailUnreadCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailUnreadCountQuery, MailUnreadCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailUnreadCountQuery, MailUnreadCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MailUnreadCountQuery, MailUnreadCountQueryVariables>(MailUnreadCountDocument, variables, options);
}
export function useMailUnreadCountLazyQuery(variables?: MailUnreadCountQueryVariables | VueCompositionApi.Ref<MailUnreadCountQueryVariables> | ReactiveFunction<MailUnreadCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<MailUnreadCountQuery, MailUnreadCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MailUnreadCountQuery, MailUnreadCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MailUnreadCountQuery, MailUnreadCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MailUnreadCountQuery, MailUnreadCountQueryVariables>(MailUnreadCountDocument, variables, options);
}
export type MailUnreadCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MailUnreadCountQuery, MailUnreadCountQueryVariables>;
export const GetMediaStatusDocument = gql`
    query getMediaStatus($input: MediaStatusInputDTO!) {
  getMediaStatus(input: $input) {
    mediaId
    mediaStatus
    error
  }
}
    `;

/**
 * __useGetMediaStatusQuery__
 *
 * To run a query within a Vue component, call `useGetMediaStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMediaStatusQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetMediaStatusQuery(variables: GetMediaStatusQueryVariables | VueCompositionApi.Ref<GetMediaStatusQueryVariables> | ReactiveFunction<GetMediaStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMediaStatusQuery, GetMediaStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMediaStatusQuery, GetMediaStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMediaStatusQuery, GetMediaStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMediaStatusQuery, GetMediaStatusQueryVariables>(GetMediaStatusDocument, variables, options);
}
export function useGetMediaStatusLazyQuery(variables?: GetMediaStatusQueryVariables | VueCompositionApi.Ref<GetMediaStatusQueryVariables> | ReactiveFunction<GetMediaStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMediaStatusQuery, GetMediaStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMediaStatusQuery, GetMediaStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMediaStatusQuery, GetMediaStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMediaStatusQuery, GetMediaStatusQueryVariables>(GetMediaStatusDocument, variables, options);
}
export type GetMediaStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMediaStatusQuery, GetMediaStatusQueryVariables>;
export const GetMediaUploadUrlDocument = gql`
    query getMediaUploadUrl($input: MediaUploadUrlInputDTO!) {
  getMediaUploadUrl(input: $input) {
    mediaId
    mediaUploadUrl
    mediaStorageKey
    mediaExpiresAt
  }
}
    `;

/**
 * __useGetMediaUploadUrlQuery__
 *
 * To run a query within a Vue component, call `useGetMediaUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaUploadUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMediaUploadUrlQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetMediaUploadUrlQuery(variables: GetMediaUploadUrlQueryVariables | VueCompositionApi.Ref<GetMediaUploadUrlQueryVariables> | ReactiveFunction<GetMediaUploadUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables>(GetMediaUploadUrlDocument, variables, options);
}
export function useGetMediaUploadUrlLazyQuery(variables?: GetMediaUploadUrlQueryVariables | VueCompositionApi.Ref<GetMediaUploadUrlQueryVariables> | ReactiveFunction<GetMediaUploadUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables>(GetMediaUploadUrlDocument, variables, options);
}
export type GetMediaUploadUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables>;
export const PresignedGetUrlDocument = gql`
    query presignedGetUrl($objectType: FileObjectType!, $imageType: ImageVariationType, $deviceType: MediaDeviceType, $expires: Float) {
  presignedGetUrl(
    objectType: $objectType
    imageType: $imageType
    deviceType: $deviceType
    expires: $expires
  )
}
    `;

/**
 * __usePresignedGetUrlQuery__
 *
 * To run a query within a Vue component, call `usePresignedGetUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresignedGetUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePresignedGetUrlQuery({
 *   objectType: // value for 'objectType'
 *   imageType: // value for 'imageType'
 *   deviceType: // value for 'deviceType'
 *   expires: // value for 'expires'
 * });
 */
export function usePresignedGetUrlQuery(variables: PresignedGetUrlQueryVariables | VueCompositionApi.Ref<PresignedGetUrlQueryVariables> | ReactiveFunction<PresignedGetUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<PresignedGetUrlQuery, PresignedGetUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PresignedGetUrlQuery, PresignedGetUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PresignedGetUrlQuery, PresignedGetUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PresignedGetUrlQuery, PresignedGetUrlQueryVariables>(PresignedGetUrlDocument, variables, options);
}
export function usePresignedGetUrlLazyQuery(variables?: PresignedGetUrlQueryVariables | VueCompositionApi.Ref<PresignedGetUrlQueryVariables> | ReactiveFunction<PresignedGetUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<PresignedGetUrlQuery, PresignedGetUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PresignedGetUrlQuery, PresignedGetUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PresignedGetUrlQuery, PresignedGetUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PresignedGetUrlQuery, PresignedGetUrlQueryVariables>(PresignedGetUrlDocument, variables, options);
}
export type PresignedGetUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PresignedGetUrlQuery, PresignedGetUrlQueryVariables>;
export const PresignedPutUrlDocument = gql`
    query presignedPutUrl($input: GetPresignedUrlInput!) {
  presignedPutUrl(input: $input)
}
    `;

/**
 * __usePresignedPutUrlQuery__
 *
 * To run a query within a Vue component, call `usePresignedPutUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresignedPutUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePresignedPutUrlQuery({
 *   input: // value for 'input'
 * });
 */
export function usePresignedPutUrlQuery(variables: PresignedPutUrlQueryVariables | VueCompositionApi.Ref<PresignedPutUrlQueryVariables> | ReactiveFunction<PresignedPutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<PresignedPutUrlQuery, PresignedPutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PresignedPutUrlQuery, PresignedPutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PresignedPutUrlQuery, PresignedPutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PresignedPutUrlQuery, PresignedPutUrlQueryVariables>(PresignedPutUrlDocument, variables, options);
}
export function usePresignedPutUrlLazyQuery(variables?: PresignedPutUrlQueryVariables | VueCompositionApi.Ref<PresignedPutUrlQueryVariables> | ReactiveFunction<PresignedPutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<PresignedPutUrlQuery, PresignedPutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PresignedPutUrlQuery, PresignedPutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PresignedPutUrlQuery, PresignedPutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PresignedPutUrlQuery, PresignedPutUrlQueryVariables>(PresignedPutUrlDocument, variables, options);
}
export type PresignedPutUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PresignedPutUrlQuery, PresignedPutUrlQueryVariables>;
export const ProjectRequestPresignedGetUrlDocument = gql`
    query projectRequestPresignedGetUrl($input: ProjectRequestPresignedUrlInput!) {
  projectRequestPresignedGetUrl(input: $input) {
    url
  }
}
    `;

/**
 * __useProjectRequestPresignedGetUrlQuery__
 *
 * To run a query within a Vue component, call `useProjectRequestPresignedGetUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestPresignedGetUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectRequestPresignedGetUrlQuery({
 *   input: // value for 'input'
 * });
 */
export function useProjectRequestPresignedGetUrlQuery(variables: ProjectRequestPresignedGetUrlQueryVariables | VueCompositionApi.Ref<ProjectRequestPresignedGetUrlQueryVariables> | ReactiveFunction<ProjectRequestPresignedGetUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRequestPresignedGetUrlQuery, ProjectRequestPresignedGetUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRequestPresignedGetUrlQuery, ProjectRequestPresignedGetUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRequestPresignedGetUrlQuery, ProjectRequestPresignedGetUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectRequestPresignedGetUrlQuery, ProjectRequestPresignedGetUrlQueryVariables>(ProjectRequestPresignedGetUrlDocument, variables, options);
}
export function useProjectRequestPresignedGetUrlLazyQuery(variables?: ProjectRequestPresignedGetUrlQueryVariables | VueCompositionApi.Ref<ProjectRequestPresignedGetUrlQueryVariables> | ReactiveFunction<ProjectRequestPresignedGetUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRequestPresignedGetUrlQuery, ProjectRequestPresignedGetUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRequestPresignedGetUrlQuery, ProjectRequestPresignedGetUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRequestPresignedGetUrlQuery, ProjectRequestPresignedGetUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectRequestPresignedGetUrlQuery, ProjectRequestPresignedGetUrlQueryVariables>(ProjectRequestPresignedGetUrlDocument, variables, options);
}
export type ProjectRequestPresignedGetUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectRequestPresignedGetUrlQuery, ProjectRequestPresignedGetUrlQueryVariables>;
export const ProjectRequestPresignedPutUrlDocument = gql`
    query projectRequestPresignedPutUrl($input: ProjectRequestPresignedUrlInput!) {
  projectRequestPresignedPutUrl(input: $input) {
    url
  }
}
    `;

/**
 * __useProjectRequestPresignedPutUrlQuery__
 *
 * To run a query within a Vue component, call `useProjectRequestPresignedPutUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestPresignedPutUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectRequestPresignedPutUrlQuery({
 *   input: // value for 'input'
 * });
 */
export function useProjectRequestPresignedPutUrlQuery(variables: ProjectRequestPresignedPutUrlQueryVariables | VueCompositionApi.Ref<ProjectRequestPresignedPutUrlQueryVariables> | ReactiveFunction<ProjectRequestPresignedPutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRequestPresignedPutUrlQuery, ProjectRequestPresignedPutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRequestPresignedPutUrlQuery, ProjectRequestPresignedPutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRequestPresignedPutUrlQuery, ProjectRequestPresignedPutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectRequestPresignedPutUrlQuery, ProjectRequestPresignedPutUrlQueryVariables>(ProjectRequestPresignedPutUrlDocument, variables, options);
}
export function useProjectRequestPresignedPutUrlLazyQuery(variables?: ProjectRequestPresignedPutUrlQueryVariables | VueCompositionApi.Ref<ProjectRequestPresignedPutUrlQueryVariables> | ReactiveFunction<ProjectRequestPresignedPutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRequestPresignedPutUrlQuery, ProjectRequestPresignedPutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRequestPresignedPutUrlQuery, ProjectRequestPresignedPutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRequestPresignedPutUrlQuery, ProjectRequestPresignedPutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectRequestPresignedPutUrlQuery, ProjectRequestPresignedPutUrlQueryVariables>(ProjectRequestPresignedPutUrlDocument, variables, options);
}
export type ProjectRequestPresignedPutUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectRequestPresignedPutUrlQuery, ProjectRequestPresignedPutUrlQueryVariables>;
export const NewsDocument = gql`
    query news($paging: OffsetPaging! = {limit: 10}, $filter: NewsFilter! = {}, $sorting: [NewsSort!]! = [{field: createdAt, direction: DESC}], $questAdminsOnly: Boolean, $myProjectsOnly: Boolean, $isFavourite: Boolean, $moderationStatus: NewsModerationStatusEnum) {
  news(
    paging: $paging
    filter: $filter
    sorting: $sorting
    questAdminsOnly: $questAdminsOnly
    myProjectsOnly: $myProjectsOnly
    isFavourite: $isFavourite
    moderationStatus: $moderationStatus
  ) {
    nodes {
      id
      title
      content
      media {
        variants {
          desktop
          tablet
          mobile
          thumb
          hls {
            master
            poster
          }
        }
      }
      ownerId
      ownerType
      owner {
        __typename
        ... on User {
          id
          firstName
          lastName
        }
        ... on Project {
          id
          name
          media {
            image {
              DESKTOP {
                LIST
              }
            }
          }
        }
      }
      createdByUserId
      updatedByUserId
      status
      sortOrder
      moderationStatus
      authorFullname
      handwrittenFullname
      additionalInfo
      author {
        id
        firstName
        lastName
        media {
          avatar {
            DESKTOP {
              ORIGINAL
            }
          }
        }
      }
      likes {
        likeCount
        isLiked
      }
      comments {
        commentCount
      }
      counters {
        counterViewed
      }
      createdAt
      updatedAt
      moduleSlug
      isFavourite
      sourceLink
      tags {
        nodes {
          id
          name
        }
      }
      permissions
      rejectionReason
      customPhotos
      customVideos
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useNewsQuery__
 *
 * To run a query within a Vue component, call `useNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNewsQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 *   questAdminsOnly: // value for 'questAdminsOnly'
 *   myProjectsOnly: // value for 'myProjectsOnly'
 *   isFavourite: // value for 'isFavourite'
 *   moderationStatus: // value for 'moderationStatus'
 * });
 */
export function useNewsQuery(variables: NewsQueryVariables | VueCompositionApi.Ref<NewsQueryVariables> | ReactiveFunction<NewsQueryVariables>, options: VueApolloComposable.UseQueryOptions<NewsQuery, NewsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NewsQuery, NewsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NewsQuery, NewsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NewsQuery, NewsQueryVariables>(NewsDocument, variables, options);
}
export function useNewsLazyQuery(variables?: NewsQueryVariables | VueCompositionApi.Ref<NewsQueryVariables> | ReactiveFunction<NewsQueryVariables>, options: VueApolloComposable.UseQueryOptions<NewsQuery, NewsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NewsQuery, NewsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NewsQuery, NewsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NewsQuery, NewsQueryVariables>(NewsDocument, variables, options);
}
export type NewsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NewsQuery, NewsQueryVariables>;
export const NewsDigestUnseenCountDocument = gql`
    query newsDigestUnseenCount {
  newsDigestUnseenCount {
    quest
    project
    total
  }
}
    `;

/**
 * __useNewsDigestUnseenCountQuery__
 *
 * To run a query within a Vue component, call `useNewsDigestUnseenCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsDigestUnseenCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNewsDigestUnseenCountQuery();
 */
export function useNewsDigestUnseenCountQuery(options: VueApolloComposable.UseQueryOptions<NewsDigestUnseenCountQuery, NewsDigestUnseenCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NewsDigestUnseenCountQuery, NewsDigestUnseenCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NewsDigestUnseenCountQuery, NewsDigestUnseenCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NewsDigestUnseenCountQuery, NewsDigestUnseenCountQueryVariables>(NewsDigestUnseenCountDocument, {}, options);
}
export function useNewsDigestUnseenCountLazyQuery(options: VueApolloComposable.UseQueryOptions<NewsDigestUnseenCountQuery, NewsDigestUnseenCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NewsDigestUnseenCountQuery, NewsDigestUnseenCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NewsDigestUnseenCountQuery, NewsDigestUnseenCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NewsDigestUnseenCountQuery, NewsDigestUnseenCountQueryVariables>(NewsDigestUnseenCountDocument, {}, options);
}
export type NewsDigestUnseenCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NewsDigestUnseenCountQuery, NewsDigestUnseenCountQueryVariables>;
export const GetNewsIdsDocument = gql`
    query getNewsIds($total: Int!, $filter: NewsFilter! = {}, $questAdminsOnly: Boolean, $myProjectsOnly: Boolean, $isFavourite: Boolean, $moderationStatus: NewsModerationStatusEnum) {
  ids: news(
    paging: {limit: $total, offset: 0}
    filter: $filter
    sorting: [{field: createdAt, direction: DESC}]
    questAdminsOnly: $questAdminsOnly
    myProjectsOnly: $myProjectsOnly
    isFavourite: $isFavourite
    moderationStatus: $moderationStatus
  ) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useGetNewsIdsQuery__
 *
 * To run a query within a Vue component, call `useGetNewsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsIdsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNewsIdsQuery({
 *   total: // value for 'total'
 *   filter: // value for 'filter'
 *   questAdminsOnly: // value for 'questAdminsOnly'
 *   myProjectsOnly: // value for 'myProjectsOnly'
 *   isFavourite: // value for 'isFavourite'
 *   moderationStatus: // value for 'moderationStatus'
 * });
 */
export function useGetNewsIdsQuery(variables: GetNewsIdsQueryVariables | VueCompositionApi.Ref<GetNewsIdsQueryVariables> | ReactiveFunction<GetNewsIdsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNewsIdsQuery, GetNewsIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNewsIdsQuery, GetNewsIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNewsIdsQuery, GetNewsIdsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetNewsIdsQuery, GetNewsIdsQueryVariables>(GetNewsIdsDocument, variables, options);
}
export function useGetNewsIdsLazyQuery(variables?: GetNewsIdsQueryVariables | VueCompositionApi.Ref<GetNewsIdsQueryVariables> | ReactiveFunction<GetNewsIdsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNewsIdsQuery, GetNewsIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNewsIdsQuery, GetNewsIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNewsIdsQuery, GetNewsIdsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetNewsIdsQuery, GetNewsIdsQueryVariables>(GetNewsIdsDocument, variables, options);
}
export type GetNewsIdsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetNewsIdsQuery, GetNewsIdsQueryVariables>;
export const NewsItemDocument = gql`
    query newsItem($id: ID!) {
  newsOne(id: $id) {
    id
    title
    media {
      variants {
        desktop
        tablet
        mobile
        thumb
        hls {
          master
          poster
        }
      }
    }
    likes {
      likeCount
      isLiked
    }
    comments {
      commentCount
    }
    counters {
      counterViewed
    }
    ownerId
    ownerType
    owner {
      __typename
      ... on User {
        id
        firstName
        lastName
        media {
          avatar {
            DESKTOP {
              ORIGINAL
            }
          }
        }
      }
      ... on Project {
        id
        name
        media {
          image {
            DESKTOP {
              LIST
            }
          }
        }
      }
    }
    author {
      id
      firstName
      lastName
      phone
      media {
        avatar {
          DESKTOP {
            ORIGINAL
          }
        }
      }
    }
    content
    title
    authorFullname
    handwrittenFullname
    additionalInfo
    mainImage
    customPhotos
    customVideos
    moduleSlug
    isFavourite
    sourceLink
    tags {
      nodes {
        id
        name
      }
    }
    status
    moderationStatus
    rejectionReason
    createdAt
    updatedAt
    updatedByUserId
    createdByUserId
    permissions
  }
}
    `;

/**
 * __useNewsItemQuery__
 *
 * To run a query within a Vue component, call `useNewsItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNewsItemQuery({
 *   id: // value for 'id'
 * });
 */
export function useNewsItemQuery(variables: NewsItemQueryVariables | VueCompositionApi.Ref<NewsItemQueryVariables> | ReactiveFunction<NewsItemQueryVariables>, options: VueApolloComposable.UseQueryOptions<NewsItemQuery, NewsItemQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NewsItemQuery, NewsItemQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NewsItemQuery, NewsItemQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, variables, options);
}
export function useNewsItemLazyQuery(variables?: NewsItemQueryVariables | VueCompositionApi.Ref<NewsItemQueryVariables> | ReactiveFunction<NewsItemQueryVariables>, options: VueApolloComposable.UseQueryOptions<NewsItemQuery, NewsItemQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NewsItemQuery, NewsItemQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NewsItemQuery, NewsItemQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, variables, options);
}
export type NewsItemQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NewsItemQuery, NewsItemQueryVariables>;
export const NewsPresignedPutUrlDocument = gql`
    query newsPresignedPutUrl($input: NewsPresignedPutUrlInput!) {
  newsPresignedPutUrl(input: $input) {
    url
    objectName
  }
}
    `;

/**
 * __useNewsPresignedPutUrlQuery__
 *
 * To run a query within a Vue component, call `useNewsPresignedPutUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsPresignedPutUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNewsPresignedPutUrlQuery({
 *   input: // value for 'input'
 * });
 */
export function useNewsPresignedPutUrlQuery(variables: NewsPresignedPutUrlQueryVariables | VueCompositionApi.Ref<NewsPresignedPutUrlQueryVariables> | ReactiveFunction<NewsPresignedPutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<NewsPresignedPutUrlQuery, NewsPresignedPutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NewsPresignedPutUrlQuery, NewsPresignedPutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NewsPresignedPutUrlQuery, NewsPresignedPutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NewsPresignedPutUrlQuery, NewsPresignedPutUrlQueryVariables>(NewsPresignedPutUrlDocument, variables, options);
}
export function useNewsPresignedPutUrlLazyQuery(variables?: NewsPresignedPutUrlQueryVariables | VueCompositionApi.Ref<NewsPresignedPutUrlQueryVariables> | ReactiveFunction<NewsPresignedPutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<NewsPresignedPutUrlQuery, NewsPresignedPutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NewsPresignedPutUrlQuery, NewsPresignedPutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NewsPresignedPutUrlQuery, NewsPresignedPutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NewsPresignedPutUrlQuery, NewsPresignedPutUrlQueryVariables>(NewsPresignedPutUrlDocument, variables, options);
}
export type NewsPresignedPutUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NewsPresignedPutUrlQuery, NewsPresignedPutUrlQueryVariables>;
export const GetNewsTotalDocument = gql`
    query getNewsTotal($filter: NewsFilter! = {}, $questAdminsOnly: Boolean, $myProjectsOnly: Boolean, $isFavourite: Boolean, $moderationStatus: NewsModerationStatusEnum) {
  total: news(
    filter: $filter
    sorting: [{field: createdAt, direction: DESC}]
    questAdminsOnly: $questAdminsOnly
    myProjectsOnly: $myProjectsOnly
    isFavourite: $isFavourite
    moderationStatus: $moderationStatus
  ) {
    value: totalCount
  }
}
    `;

/**
 * __useGetNewsTotalQuery__
 *
 * To run a query within a Vue component, call `useGetNewsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsTotalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNewsTotalQuery({
 *   filter: // value for 'filter'
 *   questAdminsOnly: // value for 'questAdminsOnly'
 *   myProjectsOnly: // value for 'myProjectsOnly'
 *   isFavourite: // value for 'isFavourite'
 *   moderationStatus: // value for 'moderationStatus'
 * });
 */
export function useGetNewsTotalQuery(variables: GetNewsTotalQueryVariables | VueCompositionApi.Ref<GetNewsTotalQueryVariables> | ReactiveFunction<GetNewsTotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNewsTotalQuery, GetNewsTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNewsTotalQuery, GetNewsTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNewsTotalQuery, GetNewsTotalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetNewsTotalQuery, GetNewsTotalQueryVariables>(GetNewsTotalDocument, variables, options);
}
export function useGetNewsTotalLazyQuery(variables?: GetNewsTotalQueryVariables | VueCompositionApi.Ref<GetNewsTotalQueryVariables> | ReactiveFunction<GetNewsTotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNewsTotalQuery, GetNewsTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNewsTotalQuery, GetNewsTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNewsTotalQuery, GetNewsTotalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetNewsTotalQuery, GetNewsTotalQueryVariables>(GetNewsTotalDocument, variables, options);
}
export type GetNewsTotalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetNewsTotalQuery, GetNewsTotalQueryVariables>;
export const GetUserNotificationsDocument = gql`
    query getUserNotifications($type: NotificationType!, $page: Int!, $limit: Int!) {
  getUserNotifications(type: $type, page: $page, limit: $limit) {
    items {
      id
      title
      body
      type
      event
      message
      isRead
      actionApplied
      calendarEventId
      createdAt
      sender {
        userId
        firstName
        lastName
        avatar
      }
      project {
        projectId
        invitationId
        joinRequestId
        name
        shortDescription
        photo
        moduleSlug
        threadId
      }
    }
    total
    hasMore
    unreadCount
  }
}
    `;

/**
 * __useGetUserNotificationsQuery__
 *
 * To run a query within a Vue component, call `useGetUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserNotificationsQuery({
 *   type: // value for 'type'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetUserNotificationsQuery(variables: GetUserNotificationsQueryVariables | VueCompositionApi.Ref<GetUserNotificationsQueryVariables> | ReactiveFunction<GetUserNotificationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, variables, options);
}
export function useGetUserNotificationsLazyQuery(variables?: GetUserNotificationsQueryVariables | VueCompositionApi.Ref<GetUserNotificationsQueryVariables> | ReactiveFunction<GetUserNotificationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, variables, options);
}
export type GetUserNotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const GetUserNotificationsUnreadCountDocument = gql`
    query getUserNotificationsUnreadCount($type: NotificationType!, $page: Int = 1, $limit: Int = 1) {
  getUserNotifications(type: $type, page: $page, limit: $limit) {
    unreadCount
  }
}
    `;

/**
 * __useGetUserNotificationsUnreadCountQuery__
 *
 * To run a query within a Vue component, call `useGetUserNotificationsUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsUnreadCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserNotificationsUnreadCountQuery({
 *   type: // value for 'type'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetUserNotificationsUnreadCountQuery(variables: GetUserNotificationsUnreadCountQueryVariables | VueCompositionApi.Ref<GetUserNotificationsUnreadCountQueryVariables> | ReactiveFunction<GetUserNotificationsUnreadCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserNotificationsUnreadCountQuery, GetUserNotificationsUnreadCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserNotificationsUnreadCountQuery, GetUserNotificationsUnreadCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserNotificationsUnreadCountQuery, GetUserNotificationsUnreadCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserNotificationsUnreadCountQuery, GetUserNotificationsUnreadCountQueryVariables>(GetUserNotificationsUnreadCountDocument, variables, options);
}
export function useGetUserNotificationsUnreadCountLazyQuery(variables?: GetUserNotificationsUnreadCountQueryVariables | VueCompositionApi.Ref<GetUserNotificationsUnreadCountQueryVariables> | ReactiveFunction<GetUserNotificationsUnreadCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserNotificationsUnreadCountQuery, GetUserNotificationsUnreadCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserNotificationsUnreadCountQuery, GetUserNotificationsUnreadCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserNotificationsUnreadCountQuery, GetUserNotificationsUnreadCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserNotificationsUnreadCountQuery, GetUserNotificationsUnreadCountQueryVariables>(GetUserNotificationsUnreadCountDocument, variables, options);
}
export type GetUserNotificationsUnreadCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserNotificationsUnreadCountQuery, GetUserNotificationsUnreadCountQueryVariables>;
export const ObjectPassportDocument = gql`
    query objectPassport($projectId: ID!, $moduleSlug: String!) {
  objectPassport(projectId: $projectId, moduleSlug: $moduleSlug) {
    ...ObjectPassportFields
  }
}
    ${ObjectPassportFieldsFragmentDoc}`;

/**
 * __useObjectPassportQuery__
 *
 * To run a query within a Vue component, call `useObjectPassportQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectPassportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useObjectPassportQuery({
 *   projectId: // value for 'projectId'
 *   moduleSlug: // value for 'moduleSlug'
 * });
 */
export function useObjectPassportQuery(variables: ObjectPassportQueryVariables | VueCompositionApi.Ref<ObjectPassportQueryVariables> | ReactiveFunction<ObjectPassportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ObjectPassportQuery, ObjectPassportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObjectPassportQuery, ObjectPassportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObjectPassportQuery, ObjectPassportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ObjectPassportQuery, ObjectPassportQueryVariables>(ObjectPassportDocument, variables, options);
}
export function useObjectPassportLazyQuery(variables?: ObjectPassportQueryVariables | VueCompositionApi.Ref<ObjectPassportQueryVariables> | ReactiveFunction<ObjectPassportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ObjectPassportQuery, ObjectPassportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObjectPassportQuery, ObjectPassportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObjectPassportQuery, ObjectPassportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ObjectPassportQuery, ObjectPassportQueryVariables>(ObjectPassportDocument, variables, options);
}
export type ObjectPassportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ObjectPassportQuery, ObjectPassportQueryVariables>;
export const ObjectPassportApplicationsDocument = gql`
    query objectPassportApplications($filter: ObjectPassportApplicationListFilterInput!) {
  objectPassportApplications(filter: $filter) {
    total
    page
    limit
    hasMore
    items {
      ...ObjectPassportApplicationFields
    }
  }
}
    ${ObjectPassportApplicationFieldsFragmentDoc}`;

/**
 * __useObjectPassportApplicationsQuery__
 *
 * To run a query within a Vue component, call `useObjectPassportApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectPassportApplicationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useObjectPassportApplicationsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useObjectPassportApplicationsQuery(variables: ObjectPassportApplicationsQueryVariables | VueCompositionApi.Ref<ObjectPassportApplicationsQueryVariables> | ReactiveFunction<ObjectPassportApplicationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ObjectPassportApplicationsQuery, ObjectPassportApplicationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObjectPassportApplicationsQuery, ObjectPassportApplicationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObjectPassportApplicationsQuery, ObjectPassportApplicationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ObjectPassportApplicationsQuery, ObjectPassportApplicationsQueryVariables>(ObjectPassportApplicationsDocument, variables, options);
}
export function useObjectPassportApplicationsLazyQuery(variables?: ObjectPassportApplicationsQueryVariables | VueCompositionApi.Ref<ObjectPassportApplicationsQueryVariables> | ReactiveFunction<ObjectPassportApplicationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ObjectPassportApplicationsQuery, ObjectPassportApplicationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObjectPassportApplicationsQuery, ObjectPassportApplicationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObjectPassportApplicationsQuery, ObjectPassportApplicationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ObjectPassportApplicationsQuery, ObjectPassportApplicationsQueryVariables>(ObjectPassportApplicationsDocument, variables, options);
}
export type ObjectPassportApplicationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ObjectPassportApplicationsQuery, ObjectPassportApplicationsQueryVariables>;
export const ObjectPassportContactCandidatesDocument = gql`
    query objectPassportContactCandidates($projectId: ID!) {
  objectPassportContactCandidates(projectId: $projectId) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useObjectPassportContactCandidatesQuery__
 *
 * To run a query within a Vue component, call `useObjectPassportContactCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectPassportContactCandidatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useObjectPassportContactCandidatesQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useObjectPassportContactCandidatesQuery(variables: ObjectPassportContactCandidatesQueryVariables | VueCompositionApi.Ref<ObjectPassportContactCandidatesQueryVariables> | ReactiveFunction<ObjectPassportContactCandidatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ObjectPassportContactCandidatesQuery, ObjectPassportContactCandidatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObjectPassportContactCandidatesQuery, ObjectPassportContactCandidatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObjectPassportContactCandidatesQuery, ObjectPassportContactCandidatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ObjectPassportContactCandidatesQuery, ObjectPassportContactCandidatesQueryVariables>(ObjectPassportContactCandidatesDocument, variables, options);
}
export function useObjectPassportContactCandidatesLazyQuery(variables?: ObjectPassportContactCandidatesQueryVariables | VueCompositionApi.Ref<ObjectPassportContactCandidatesQueryVariables> | ReactiveFunction<ObjectPassportContactCandidatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ObjectPassportContactCandidatesQuery, ObjectPassportContactCandidatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObjectPassportContactCandidatesQuery, ObjectPassportContactCandidatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObjectPassportContactCandidatesQuery, ObjectPassportContactCandidatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ObjectPassportContactCandidatesQuery, ObjectPassportContactCandidatesQueryVariables>(ObjectPassportContactCandidatesDocument, variables, options);
}
export type ObjectPassportContactCandidatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ObjectPassportContactCandidatesQuery, ObjectPassportContactCandidatesQueryVariables>;
export const GetMsAnalyticsPermissionsDocument = gql`
    query getMsAnalyticsPermissions {
  getMsAnalyticsPermissions
}
    `;

/**
 * __useGetMsAnalyticsPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsAnalyticsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsAnalyticsPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsAnalyticsPermissionsQuery();
 */
export function useGetMsAnalyticsPermissionsQuery(options: VueApolloComposable.UseQueryOptions<GetMsAnalyticsPermissionsQuery, GetMsAnalyticsPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsAnalyticsPermissionsQuery, GetMsAnalyticsPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsAnalyticsPermissionsQuery, GetMsAnalyticsPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsAnalyticsPermissionsQuery, GetMsAnalyticsPermissionsQueryVariables>(GetMsAnalyticsPermissionsDocument, {}, options);
}
export function useGetMsAnalyticsPermissionsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMsAnalyticsPermissionsQuery, GetMsAnalyticsPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsAnalyticsPermissionsQuery, GetMsAnalyticsPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsAnalyticsPermissionsQuery, GetMsAnalyticsPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsAnalyticsPermissionsQuery, GetMsAnalyticsPermissionsQueryVariables>(GetMsAnalyticsPermissionsDocument, {}, options);
}
export type GetMsAnalyticsPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsAnalyticsPermissionsQuery, GetMsAnalyticsPermissionsQueryVariables>;
export const GetMsCommentPermissionsDocument = gql`
    query getMsCommentPermissions {
  getMsCommentPermissions
}
    `;

/**
 * __useGetMsCommentPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsCommentPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsCommentPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsCommentPermissionsQuery();
 */
export function useGetMsCommentPermissionsQuery(options: VueApolloComposable.UseQueryOptions<GetMsCommentPermissionsQuery, GetMsCommentPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsCommentPermissionsQuery, GetMsCommentPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsCommentPermissionsQuery, GetMsCommentPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsCommentPermissionsQuery, GetMsCommentPermissionsQueryVariables>(GetMsCommentPermissionsDocument, {}, options);
}
export function useGetMsCommentPermissionsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMsCommentPermissionsQuery, GetMsCommentPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsCommentPermissionsQuery, GetMsCommentPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsCommentPermissionsQuery, GetMsCommentPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsCommentPermissionsQuery, GetMsCommentPermissionsQueryVariables>(GetMsCommentPermissionsDocument, {}, options);
}
export type GetMsCommentPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsCommentPermissionsQuery, GetMsCommentPermissionsQueryVariables>;
export const GetMsNewsPermissionsDocument = gql`
    query getMsNewsPermissions($projectId: String!, $newsId: String, $moduleSlug: String) {
  getMsNewsPermissions(
    projectId: $projectId
    newsId: $newsId
    moduleSlug: $moduleSlug
  )
}
    `;

/**
 * __useGetMsNewsPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsNewsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsNewsPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsNewsPermissionsQuery({
 *   projectId: // value for 'projectId'
 *   newsId: // value for 'newsId'
 *   moduleSlug: // value for 'moduleSlug'
 * });
 */
export function useGetMsNewsPermissionsQuery(variables: GetMsNewsPermissionsQueryVariables | VueCompositionApi.Ref<GetMsNewsPermissionsQueryVariables> | ReactiveFunction<GetMsNewsPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsNewsPermissionsQuery, GetMsNewsPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsNewsPermissionsQuery, GetMsNewsPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsNewsPermissionsQuery, GetMsNewsPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsNewsPermissionsQuery, GetMsNewsPermissionsQueryVariables>(GetMsNewsPermissionsDocument, variables, options);
}
export function useGetMsNewsPermissionsLazyQuery(variables?: GetMsNewsPermissionsQueryVariables | VueCompositionApi.Ref<GetMsNewsPermissionsQueryVariables> | ReactiveFunction<GetMsNewsPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsNewsPermissionsQuery, GetMsNewsPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsNewsPermissionsQuery, GetMsNewsPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsNewsPermissionsQuery, GetMsNewsPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsNewsPermissionsQuery, GetMsNewsPermissionsQueryVariables>(GetMsNewsPermissionsDocument, variables, options);
}
export type GetMsNewsPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsNewsPermissionsQuery, GetMsNewsPermissionsQueryVariables>;
export const GetMsProjectCounterPermissionsDocument = gql`
    query getMsProjectCounterPermissions($projectId: String!) {
  getMsProjectCounterPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectCounterPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectCounterPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectCounterPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectCounterPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectCounterPermissionsQuery(variables: GetMsProjectCounterPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectCounterPermissionsQueryVariables> | ReactiveFunction<GetMsProjectCounterPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectCounterPermissionsQuery, GetMsProjectCounterPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectCounterPermissionsQuery, GetMsProjectCounterPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectCounterPermissionsQuery, GetMsProjectCounterPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectCounterPermissionsQuery, GetMsProjectCounterPermissionsQueryVariables>(GetMsProjectCounterPermissionsDocument, variables, options);
}
export function useGetMsProjectCounterPermissionsLazyQuery(variables?: GetMsProjectCounterPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectCounterPermissionsQueryVariables> | ReactiveFunction<GetMsProjectCounterPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectCounterPermissionsQuery, GetMsProjectCounterPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectCounterPermissionsQuery, GetMsProjectCounterPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectCounterPermissionsQuery, GetMsProjectCounterPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectCounterPermissionsQuery, GetMsProjectCounterPermissionsQueryVariables>(GetMsProjectCounterPermissionsDocument, variables, options);
}
export type GetMsProjectCounterPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectCounterPermissionsQuery, GetMsProjectCounterPermissionsQueryVariables>;
export const GetMsProjectCustomModulePermissionsDocument = gql`
    query getMsProjectCustomModulePermissions($projectId: String!) {
  getMsProjectCustomModulePermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectCustomModulePermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectCustomModulePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectCustomModulePermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectCustomModulePermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectCustomModulePermissionsQuery(variables: GetMsProjectCustomModulePermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectCustomModulePermissionsQueryVariables> | ReactiveFunction<GetMsProjectCustomModulePermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectCustomModulePermissionsQuery, GetMsProjectCustomModulePermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectCustomModulePermissionsQuery, GetMsProjectCustomModulePermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectCustomModulePermissionsQuery, GetMsProjectCustomModulePermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectCustomModulePermissionsQuery, GetMsProjectCustomModulePermissionsQueryVariables>(GetMsProjectCustomModulePermissionsDocument, variables, options);
}
export function useGetMsProjectCustomModulePermissionsLazyQuery(variables?: GetMsProjectCustomModulePermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectCustomModulePermissionsQueryVariables> | ReactiveFunction<GetMsProjectCustomModulePermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectCustomModulePermissionsQuery, GetMsProjectCustomModulePermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectCustomModulePermissionsQuery, GetMsProjectCustomModulePermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectCustomModulePermissionsQuery, GetMsProjectCustomModulePermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectCustomModulePermissionsQuery, GetMsProjectCustomModulePermissionsQueryVariables>(GetMsProjectCustomModulePermissionsDocument, variables, options);
}
export type GetMsProjectCustomModulePermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectCustomModulePermissionsQuery, GetMsProjectCustomModulePermissionsQueryVariables>;
export const GetMsProjectMailPermissionsDocument = gql`
    query getMsProjectMailPermissions($projectId: String!) {
  getMsProjectMailPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectMailPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectMailPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectMailPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectMailPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectMailPermissionsQuery(variables: GetMsProjectMailPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectMailPermissionsQueryVariables> | ReactiveFunction<GetMsProjectMailPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectMailPermissionsQuery, GetMsProjectMailPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectMailPermissionsQuery, GetMsProjectMailPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectMailPermissionsQuery, GetMsProjectMailPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectMailPermissionsQuery, GetMsProjectMailPermissionsQueryVariables>(GetMsProjectMailPermissionsDocument, variables, options);
}
export function useGetMsProjectMailPermissionsLazyQuery(variables?: GetMsProjectMailPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectMailPermissionsQueryVariables> | ReactiveFunction<GetMsProjectMailPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectMailPermissionsQuery, GetMsProjectMailPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectMailPermissionsQuery, GetMsProjectMailPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectMailPermissionsQuery, GetMsProjectMailPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectMailPermissionsQuery, GetMsProjectMailPermissionsQueryVariables>(GetMsProjectMailPermissionsDocument, variables, options);
}
export type GetMsProjectMailPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectMailPermissionsQuery, GetMsProjectMailPermissionsQueryVariables>;
export const GetMsProjectMemberPermissionsDocument = gql`
    query getMsProjectMemberPermissions($projectId: String!) {
  getMsProjectMemberPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectMemberPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectMemberPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectMemberPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectMemberPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectMemberPermissionsQuery(variables: GetMsProjectMemberPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectMemberPermissionsQueryVariables> | ReactiveFunction<GetMsProjectMemberPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectMemberPermissionsQuery, GetMsProjectMemberPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectMemberPermissionsQuery, GetMsProjectMemberPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectMemberPermissionsQuery, GetMsProjectMemberPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectMemberPermissionsQuery, GetMsProjectMemberPermissionsQueryVariables>(GetMsProjectMemberPermissionsDocument, variables, options);
}
export function useGetMsProjectMemberPermissionsLazyQuery(variables?: GetMsProjectMemberPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectMemberPermissionsQueryVariables> | ReactiveFunction<GetMsProjectMemberPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectMemberPermissionsQuery, GetMsProjectMemberPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectMemberPermissionsQuery, GetMsProjectMemberPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectMemberPermissionsQuery, GetMsProjectMemberPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectMemberPermissionsQuery, GetMsProjectMemberPermissionsQueryVariables>(GetMsProjectMemberPermissionsDocument, variables, options);
}
export type GetMsProjectMemberPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectMemberPermissionsQuery, GetMsProjectMemberPermissionsQueryVariables>;
export const GetMsProjectMockupsPermissionsDocument = gql`
    query getMsProjectMockupsPermissions($projectId: String!) {
  getMsProjectMockupsPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectMockupsPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectMockupsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectMockupsPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectMockupsPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectMockupsPermissionsQuery(variables: GetMsProjectMockupsPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectMockupsPermissionsQueryVariables> | ReactiveFunction<GetMsProjectMockupsPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectMockupsPermissionsQuery, GetMsProjectMockupsPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectMockupsPermissionsQuery, GetMsProjectMockupsPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectMockupsPermissionsQuery, GetMsProjectMockupsPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectMockupsPermissionsQuery, GetMsProjectMockupsPermissionsQueryVariables>(GetMsProjectMockupsPermissionsDocument, variables, options);
}
export function useGetMsProjectMockupsPermissionsLazyQuery(variables?: GetMsProjectMockupsPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectMockupsPermissionsQueryVariables> | ReactiveFunction<GetMsProjectMockupsPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectMockupsPermissionsQuery, GetMsProjectMockupsPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectMockupsPermissionsQuery, GetMsProjectMockupsPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectMockupsPermissionsQuery, GetMsProjectMockupsPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectMockupsPermissionsQuery, GetMsProjectMockupsPermissionsQueryVariables>(GetMsProjectMockupsPermissionsDocument, variables, options);
}
export type GetMsProjectMockupsPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectMockupsPermissionsQuery, GetMsProjectMockupsPermissionsQueryVariables>;
export const GetMsProjectModuleAccessPermissionsDocument = gql`
    query getMsProjectModuleAccessPermissions($projectId: String!) {
  getMsProjectModuleAccessPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectModuleAccessPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectModuleAccessPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectModuleAccessPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectModuleAccessPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectModuleAccessPermissionsQuery(variables: GetMsProjectModuleAccessPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectModuleAccessPermissionsQueryVariables> | ReactiveFunction<GetMsProjectModuleAccessPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectModuleAccessPermissionsQuery, GetMsProjectModuleAccessPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectModuleAccessPermissionsQuery, GetMsProjectModuleAccessPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectModuleAccessPermissionsQuery, GetMsProjectModuleAccessPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectModuleAccessPermissionsQuery, GetMsProjectModuleAccessPermissionsQueryVariables>(GetMsProjectModuleAccessPermissionsDocument, variables, options);
}
export function useGetMsProjectModuleAccessPermissionsLazyQuery(variables?: GetMsProjectModuleAccessPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectModuleAccessPermissionsQueryVariables> | ReactiveFunction<GetMsProjectModuleAccessPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectModuleAccessPermissionsQuery, GetMsProjectModuleAccessPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectModuleAccessPermissionsQuery, GetMsProjectModuleAccessPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectModuleAccessPermissionsQuery, GetMsProjectModuleAccessPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectModuleAccessPermissionsQuery, GetMsProjectModuleAccessPermissionsQueryVariables>(GetMsProjectModuleAccessPermissionsDocument, variables, options);
}
export type GetMsProjectModuleAccessPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectModuleAccessPermissionsQuery, GetMsProjectModuleAccessPermissionsQueryVariables>;
export const GetMsProjectModuleMemberPermissionsDocument = gql`
    query getMsProjectModuleMemberPermissions($projectId: String!) {
  getMsProjectModuleMemberPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectModuleMemberPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectModuleMemberPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectModuleMemberPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectModuleMemberPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectModuleMemberPermissionsQuery(variables: GetMsProjectModuleMemberPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectModuleMemberPermissionsQueryVariables> | ReactiveFunction<GetMsProjectModuleMemberPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectModuleMemberPermissionsQuery, GetMsProjectModuleMemberPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectModuleMemberPermissionsQuery, GetMsProjectModuleMemberPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectModuleMemberPermissionsQuery, GetMsProjectModuleMemberPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectModuleMemberPermissionsQuery, GetMsProjectModuleMemberPermissionsQueryVariables>(GetMsProjectModuleMemberPermissionsDocument, variables, options);
}
export function useGetMsProjectModuleMemberPermissionsLazyQuery(variables?: GetMsProjectModuleMemberPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectModuleMemberPermissionsQueryVariables> | ReactiveFunction<GetMsProjectModuleMemberPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectModuleMemberPermissionsQuery, GetMsProjectModuleMemberPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectModuleMemberPermissionsQuery, GetMsProjectModuleMemberPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectModuleMemberPermissionsQuery, GetMsProjectModuleMemberPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectModuleMemberPermissionsQuery, GetMsProjectModuleMemberPermissionsQueryVariables>(GetMsProjectModuleMemberPermissionsDocument, variables, options);
}
export type GetMsProjectModuleMemberPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectModuleMemberPermissionsQuery, GetMsProjectModuleMemberPermissionsQueryVariables>;
export const GetMsProjectPermissionsDocument = gql`
    query getMsProjectPermissions($projectId: String!) {
  getMsProjectPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectPermissionsQuery(variables: GetMsProjectPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectPermissionsQueryVariables> | ReactiveFunction<GetMsProjectPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectPermissionsQuery, GetMsProjectPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectPermissionsQuery, GetMsProjectPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectPermissionsQuery, GetMsProjectPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectPermissionsQuery, GetMsProjectPermissionsQueryVariables>(GetMsProjectPermissionsDocument, variables, options);
}
export function useGetMsProjectPermissionsLazyQuery(variables?: GetMsProjectPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectPermissionsQueryVariables> | ReactiveFunction<GetMsProjectPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectPermissionsQuery, GetMsProjectPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectPermissionsQuery, GetMsProjectPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectPermissionsQuery, GetMsProjectPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectPermissionsQuery, GetMsProjectPermissionsQueryVariables>(GetMsProjectPermissionsDocument, variables, options);
}
export type GetMsProjectPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectPermissionsQuery, GetMsProjectPermissionsQueryVariables>;
export const GetMsProjectProjectRequestPermissionsDocument = gql`
    query getMsProjectProjectRequestPermissions {
  getMsProjectProjectRequestPermissions
}
    `;

/**
 * __useGetMsProjectProjectRequestPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectProjectRequestPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectProjectRequestPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectProjectRequestPermissionsQuery();
 */
export function useGetMsProjectProjectRequestPermissionsQuery(options: VueApolloComposable.UseQueryOptions<GetMsProjectProjectRequestPermissionsQuery, GetMsProjectProjectRequestPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectProjectRequestPermissionsQuery, GetMsProjectProjectRequestPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectProjectRequestPermissionsQuery, GetMsProjectProjectRequestPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectProjectRequestPermissionsQuery, GetMsProjectProjectRequestPermissionsQueryVariables>(GetMsProjectProjectRequestPermissionsDocument, {}, options);
}
export function useGetMsProjectProjectRequestPermissionsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMsProjectProjectRequestPermissionsQuery, GetMsProjectProjectRequestPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectProjectRequestPermissionsQuery, GetMsProjectProjectRequestPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectProjectRequestPermissionsQuery, GetMsProjectProjectRequestPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectProjectRequestPermissionsQuery, GetMsProjectProjectRequestPermissionsQueryVariables>(GetMsProjectProjectRequestPermissionsDocument, {}, options);
}
export type GetMsProjectProjectRequestPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectProjectRequestPermissionsQuery, GetMsProjectProjectRequestPermissionsQueryVariables>;
export const GetMsProjectSupportersPermissionsDocument = gql`
    query getMsProjectSupportersPermissions($projectId: String!) {
  getMsProjectSupportersPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectSupportersPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectSupportersPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectSupportersPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectSupportersPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectSupportersPermissionsQuery(variables: GetMsProjectSupportersPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectSupportersPermissionsQueryVariables> | ReactiveFunction<GetMsProjectSupportersPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectSupportersPermissionsQuery, GetMsProjectSupportersPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectSupportersPermissionsQuery, GetMsProjectSupportersPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectSupportersPermissionsQuery, GetMsProjectSupportersPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectSupportersPermissionsQuery, GetMsProjectSupportersPermissionsQueryVariables>(GetMsProjectSupportersPermissionsDocument, variables, options);
}
export function useGetMsProjectSupportersPermissionsLazyQuery(variables?: GetMsProjectSupportersPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectSupportersPermissionsQueryVariables> | ReactiveFunction<GetMsProjectSupportersPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectSupportersPermissionsQuery, GetMsProjectSupportersPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectSupportersPermissionsQuery, GetMsProjectSupportersPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectSupportersPermissionsQuery, GetMsProjectSupportersPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectSupportersPermissionsQuery, GetMsProjectSupportersPermissionsQueryVariables>(GetMsProjectSupportersPermissionsDocument, variables, options);
}
export type GetMsProjectSupportersPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectSupportersPermissionsQuery, GetMsProjectSupportersPermissionsQueryVariables>;
export const GetMsProjectTemplatesPermissionsDocument = gql`
    query getMsProjectTemplatesPermissions($projectId: String!) {
  getMsProjectTemplatesPermissions(projectId: $projectId)
}
    `;

/**
 * __useGetMsProjectTemplatesPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsProjectTemplatesPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsProjectTemplatesPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsProjectTemplatesPermissionsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetMsProjectTemplatesPermissionsQuery(variables: GetMsProjectTemplatesPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectTemplatesPermissionsQueryVariables> | ReactiveFunction<GetMsProjectTemplatesPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectTemplatesPermissionsQuery, GetMsProjectTemplatesPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectTemplatesPermissionsQuery, GetMsProjectTemplatesPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectTemplatesPermissionsQuery, GetMsProjectTemplatesPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsProjectTemplatesPermissionsQuery, GetMsProjectTemplatesPermissionsQueryVariables>(GetMsProjectTemplatesPermissionsDocument, variables, options);
}
export function useGetMsProjectTemplatesPermissionsLazyQuery(variables?: GetMsProjectTemplatesPermissionsQueryVariables | VueCompositionApi.Ref<GetMsProjectTemplatesPermissionsQueryVariables> | ReactiveFunction<GetMsProjectTemplatesPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsProjectTemplatesPermissionsQuery, GetMsProjectTemplatesPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsProjectTemplatesPermissionsQuery, GetMsProjectTemplatesPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsProjectTemplatesPermissionsQuery, GetMsProjectTemplatesPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsProjectTemplatesPermissionsQuery, GetMsProjectTemplatesPermissionsQueryVariables>(GetMsProjectTemplatesPermissionsDocument, variables, options);
}
export type GetMsProjectTemplatesPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsProjectTemplatesPermissionsQuery, GetMsProjectTemplatesPermissionsQueryVariables>;
export const GetMsSurveyPermissionsDocument = gql`
    query getMsSurveyPermissions($projectId: String!, $surveyId: String!) {
  getMsSurveyPermissions(projectId: $projectId, surveyId: $surveyId)
}
    `;

/**
 * __useGetMsSurveyPermissionsQuery__
 *
 * To run a query within a Vue component, call `useGetMsSurveyPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsSurveyPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMsSurveyPermissionsQuery({
 *   projectId: // value for 'projectId'
 *   surveyId: // value for 'surveyId'
 * });
 */
export function useGetMsSurveyPermissionsQuery(variables: GetMsSurveyPermissionsQueryVariables | VueCompositionApi.Ref<GetMsSurveyPermissionsQueryVariables> | ReactiveFunction<GetMsSurveyPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsSurveyPermissionsQuery, GetMsSurveyPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsSurveyPermissionsQuery, GetMsSurveyPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsSurveyPermissionsQuery, GetMsSurveyPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMsSurveyPermissionsQuery, GetMsSurveyPermissionsQueryVariables>(GetMsSurveyPermissionsDocument, variables, options);
}
export function useGetMsSurveyPermissionsLazyQuery(variables?: GetMsSurveyPermissionsQueryVariables | VueCompositionApi.Ref<GetMsSurveyPermissionsQueryVariables> | ReactiveFunction<GetMsSurveyPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMsSurveyPermissionsQuery, GetMsSurveyPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMsSurveyPermissionsQuery, GetMsSurveyPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMsSurveyPermissionsQuery, GetMsSurveyPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMsSurveyPermissionsQuery, GetMsSurveyPermissionsQueryVariables>(GetMsSurveyPermissionsDocument, variables, options);
}
export type GetMsSurveyPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMsSurveyPermissionsQuery, GetMsSurveyPermissionsQueryVariables>;
export const ProjectNewsModuleAccessCapabilitiesDocument = gql`
    query projectNewsModuleAccessCapabilities($projectId: String!, $moduleSlug: String!) {
  projectNewsModuleAccessCapabilities(
    projectId: $projectId
    moduleSlug: $moduleSlug
  ) {
    canViewList
    canCreateNews
  }
}
    `;

/**
 * __useProjectNewsModuleAccessCapabilitiesQuery__
 *
 * To run a query within a Vue component, call `useProjectNewsModuleAccessCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectNewsModuleAccessCapabilitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectNewsModuleAccessCapabilitiesQuery({
 *   projectId: // value for 'projectId'
 *   moduleSlug: // value for 'moduleSlug'
 * });
 */
export function useProjectNewsModuleAccessCapabilitiesQuery(variables: ProjectNewsModuleAccessCapabilitiesQueryVariables | VueCompositionApi.Ref<ProjectNewsModuleAccessCapabilitiesQueryVariables> | ReactiveFunction<ProjectNewsModuleAccessCapabilitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectNewsModuleAccessCapabilitiesQuery, ProjectNewsModuleAccessCapabilitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectNewsModuleAccessCapabilitiesQuery, ProjectNewsModuleAccessCapabilitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectNewsModuleAccessCapabilitiesQuery, ProjectNewsModuleAccessCapabilitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectNewsModuleAccessCapabilitiesQuery, ProjectNewsModuleAccessCapabilitiesQueryVariables>(ProjectNewsModuleAccessCapabilitiesDocument, variables, options);
}
export function useProjectNewsModuleAccessCapabilitiesLazyQuery(variables?: ProjectNewsModuleAccessCapabilitiesQueryVariables | VueCompositionApi.Ref<ProjectNewsModuleAccessCapabilitiesQueryVariables> | ReactiveFunction<ProjectNewsModuleAccessCapabilitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectNewsModuleAccessCapabilitiesQuery, ProjectNewsModuleAccessCapabilitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectNewsModuleAccessCapabilitiesQuery, ProjectNewsModuleAccessCapabilitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectNewsModuleAccessCapabilitiesQuery, ProjectNewsModuleAccessCapabilitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectNewsModuleAccessCapabilitiesQuery, ProjectNewsModuleAccessCapabilitiesQueryVariables>(ProjectNewsModuleAccessCapabilitiesDocument, variables, options);
}
export type ProjectNewsModuleAccessCapabilitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectNewsModuleAccessCapabilitiesQuery, ProjectNewsModuleAccessCapabilitiesQueryVariables>;
export const GetPhraseOfTheDayDocument = gql`
    query getPhraseOfTheDay {
  getPhraseOfTheDay {
    id
    text
    author
  }
}
    `;

/**
 * __useGetPhraseOfTheDayQuery__
 *
 * To run a query within a Vue component, call `useGetPhraseOfTheDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhraseOfTheDayQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPhraseOfTheDayQuery();
 */
export function useGetPhraseOfTheDayQuery(options: VueApolloComposable.UseQueryOptions<GetPhraseOfTheDayQuery, GetPhraseOfTheDayQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPhraseOfTheDayQuery, GetPhraseOfTheDayQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPhraseOfTheDayQuery, GetPhraseOfTheDayQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPhraseOfTheDayQuery, GetPhraseOfTheDayQueryVariables>(GetPhraseOfTheDayDocument, {}, options);
}
export function useGetPhraseOfTheDayLazyQuery(options: VueApolloComposable.UseQueryOptions<GetPhraseOfTheDayQuery, GetPhraseOfTheDayQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPhraseOfTheDayQuery, GetPhraseOfTheDayQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPhraseOfTheDayQuery, GetPhraseOfTheDayQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPhraseOfTheDayQuery, GetPhraseOfTheDayQueryVariables>(GetPhraseOfTheDayDocument, {}, options);
}
export type GetPhraseOfTheDayQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPhraseOfTheDayQuery, GetPhraseOfTheDayQueryVariables>;
export const ProgramContactCandidatesDocument = gql`
    query programContactCandidates($projectId: ID!) {
  programContactCandidates(projectId: $projectId) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useProgramContactCandidatesQuery__
 *
 * To run a query within a Vue component, call `useProgramContactCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramContactCandidatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProgramContactCandidatesQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useProgramContactCandidatesQuery(variables: ProgramContactCandidatesQueryVariables | VueCompositionApi.Ref<ProgramContactCandidatesQueryVariables> | ReactiveFunction<ProgramContactCandidatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProgramContactCandidatesQuery, ProgramContactCandidatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProgramContactCandidatesQuery, ProgramContactCandidatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProgramContactCandidatesQuery, ProgramContactCandidatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProgramContactCandidatesQuery, ProgramContactCandidatesQueryVariables>(ProgramContactCandidatesDocument, variables, options);
}
export function useProgramContactCandidatesLazyQuery(variables?: ProgramContactCandidatesQueryVariables | VueCompositionApi.Ref<ProgramContactCandidatesQueryVariables> | ReactiveFunction<ProgramContactCandidatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProgramContactCandidatesQuery, ProgramContactCandidatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProgramContactCandidatesQuery, ProgramContactCandidatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProgramContactCandidatesQuery, ProgramContactCandidatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProgramContactCandidatesQuery, ProgramContactCandidatesQueryVariables>(ProgramContactCandidatesDocument, variables, options);
}
export type ProgramContactCandidatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProgramContactCandidatesQuery, ProgramContactCandidatesQueryVariables>;
export const ProgramItemsDocument = gql`
    query programItems($projectId: ID!, $moduleSlug: String!) {
  programItems(projectId: $projectId, moduleSlug: $moduleSlug) {
    ...ProgramItemFields
  }
}
    ${ProgramItemFieldsFragmentDoc}`;

/**
 * __useProgramItemsQuery__
 *
 * To run a query within a Vue component, call `useProgramItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProgramItemsQuery({
 *   projectId: // value for 'projectId'
 *   moduleSlug: // value for 'moduleSlug'
 * });
 */
export function useProgramItemsQuery(variables: ProgramItemsQueryVariables | VueCompositionApi.Ref<ProgramItemsQueryVariables> | ReactiveFunction<ProgramItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProgramItemsQuery, ProgramItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProgramItemsQuery, ProgramItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProgramItemsQuery, ProgramItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProgramItemsQuery, ProgramItemsQueryVariables>(ProgramItemsDocument, variables, options);
}
export function useProgramItemsLazyQuery(variables?: ProgramItemsQueryVariables | VueCompositionApi.Ref<ProgramItemsQueryVariables> | ReactiveFunction<ProgramItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProgramItemsQuery, ProgramItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProgramItemsQuery, ProgramItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProgramItemsQuery, ProgramItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProgramItemsQuery, ProgramItemsQueryVariables>(ProgramItemsDocument, variables, options);
}
export type ProgramItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProgramItemsQuery, ProgramItemsQueryVariables>;
export const ProjectMemberDocument = gql`
    query projectMember($id: ID!, $projectId: ID) {
  projectMember(id: $id, projectId: $projectId) {
    ...ProjectMemberFields
  }
}
    ${ProjectMemberFieldsFragmentDoc}`;

/**
 * __useProjectMemberQuery__
 *
 * To run a query within a Vue component, call `useProjectMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMemberQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectMemberQuery({
 *   id: // value for 'id'
 *   projectId: // value for 'projectId'
 * });
 */
export function useProjectMemberQuery(variables: ProjectMemberQueryVariables | VueCompositionApi.Ref<ProjectMemberQueryVariables> | ReactiveFunction<ProjectMemberQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectMemberQuery, ProjectMemberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMemberQuery, ProjectMemberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMemberQuery, ProjectMemberQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectMemberQuery, ProjectMemberQueryVariables>(ProjectMemberDocument, variables, options);
}
export function useProjectMemberLazyQuery(variables?: ProjectMemberQueryVariables | VueCompositionApi.Ref<ProjectMemberQueryVariables> | ReactiveFunction<ProjectMemberQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectMemberQuery, ProjectMemberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMemberQuery, ProjectMemberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMemberQuery, ProjectMemberQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectMemberQuery, ProjectMemberQueryVariables>(ProjectMemberDocument, variables, options);
}
export type ProjectMemberQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectMemberQuery, ProjectMemberQueryVariables>;
export const ProjectMembersDocument = gql`
    query projectMembers($paging: OffsetPaging! = {limit: 9999}, $filter: ProjectMemberFilter! = {}, $sorting: [ProjectMemberSort!]! = []) {
  projectMembers(paging: $paging, filter: $filter, sorting: $sorting) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ...ProjectMemberFields
    }
    totalCount
  }
}
    ${ProjectMemberFieldsFragmentDoc}`;

/**
 * __useProjectMembersQuery__
 *
 * To run a query within a Vue component, call `useProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectMembersQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useProjectMembersQuery(variables: ProjectMembersQueryVariables | VueCompositionApi.Ref<ProjectMembersQueryVariables> | ReactiveFunction<ProjectMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectMembersQuery, ProjectMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMembersQuery, ProjectMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMembersQuery, ProjectMembersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, variables, options);
}
export function useProjectMembersLazyQuery(variables?: ProjectMembersQueryVariables | VueCompositionApi.Ref<ProjectMembersQueryVariables> | ReactiveFunction<ProjectMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectMembersQuery, ProjectMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectMembersQuery, ProjectMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectMembersQuery, ProjectMembersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, variables, options);
}
export type ProjectMembersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectMembersQuery, ProjectMembersQueryVariables>;
export const ProjectModuleMemberDocument = gql`
    query projectModuleMember($id: ID!) {
  projectModuleMember(id: $id) {
    moduleSlug
    role
    projectMember {
      user {
        ...UserFields
        media {
          avatar {
            DESKTOP {
              PROFILE
            }
          }
          background {
            DESKTOP {
              ORIGINAL
            }
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useProjectModuleMemberQuery__
 *
 * To run a query within a Vue component, call `useProjectModuleMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectModuleMemberQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectModuleMemberQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectModuleMemberQuery(variables: ProjectModuleMemberQueryVariables | VueCompositionApi.Ref<ProjectModuleMemberQueryVariables> | ReactiveFunction<ProjectModuleMemberQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectModuleMemberQuery, ProjectModuleMemberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectModuleMemberQuery, ProjectModuleMemberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectModuleMemberQuery, ProjectModuleMemberQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectModuleMemberQuery, ProjectModuleMemberQueryVariables>(ProjectModuleMemberDocument, variables, options);
}
export function useProjectModuleMemberLazyQuery(variables?: ProjectModuleMemberQueryVariables | VueCompositionApi.Ref<ProjectModuleMemberQueryVariables> | ReactiveFunction<ProjectModuleMemberQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectModuleMemberQuery, ProjectModuleMemberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectModuleMemberQuery, ProjectModuleMemberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectModuleMemberQuery, ProjectModuleMemberQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectModuleMemberQuery, ProjectModuleMemberQueryVariables>(ProjectModuleMemberDocument, variables, options);
}
export type ProjectModuleMemberQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectModuleMemberQuery, ProjectModuleMemberQueryVariables>;
export const ProjectModuleMembersDocument = gql`
    query projectModuleMembers($paging: OffsetPaging! = {limit: 9999}, $filter: ProjectModuleMemberFilter! = {}, $sorting: [ProjectModuleMemberSort!]! = []) {
  projectModuleMembers(paging: $paging, filter: $filter, sorting: $sorting) {
    nodes {
      id
      moduleSlug
      role
      projectMemberId
      projectMember {
        id
        user {
          ...UserFields
          media {
            avatar {
              DESKTOP {
                PROFILE
              }
            }
            background {
              DESKTOP {
                ORIGINAL
              }
            }
          }
        }
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useProjectModuleMembersQuery__
 *
 * To run a query within a Vue component, call `useProjectModuleMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectModuleMembersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectModuleMembersQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useProjectModuleMembersQuery(variables: ProjectModuleMembersQueryVariables | VueCompositionApi.Ref<ProjectModuleMembersQueryVariables> | ReactiveFunction<ProjectModuleMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectModuleMembersQuery, ProjectModuleMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectModuleMembersQuery, ProjectModuleMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectModuleMembersQuery, ProjectModuleMembersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectModuleMembersQuery, ProjectModuleMembersQueryVariables>(ProjectModuleMembersDocument, variables, options);
}
export function useProjectModuleMembersLazyQuery(variables?: ProjectModuleMembersQueryVariables | VueCompositionApi.Ref<ProjectModuleMembersQueryVariables> | ReactiveFunction<ProjectModuleMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectModuleMembersQuery, ProjectModuleMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectModuleMembersQuery, ProjectModuleMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectModuleMembersQuery, ProjectModuleMembersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectModuleMembersQuery, ProjectModuleMembersQueryVariables>(ProjectModuleMembersDocument, variables, options);
}
export type ProjectModuleMembersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectModuleMembersQuery, ProjectModuleMembersQueryVariables>;
export const CurrentUserProjectModuleCapabilitiesDocument = gql`
    query currentUserProjectModuleCapabilities($projectId: ID!, $moduleSlug: String!) {
  currentUserProjectModuleCapabilities(
    projectId: $projectId
    moduleSlug: $moduleSlug
  ) {
    moduleSlug
    canShow
    canView
    canInsert
    canEdit
    hasFullAccess
    canEditAllRecords
  }
}
    `;

/**
 * __useCurrentUserProjectModuleCapabilitiesQuery__
 *
 * To run a query within a Vue component, call `useCurrentUserProjectModuleCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserProjectModuleCapabilitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentUserProjectModuleCapabilitiesQuery({
 *   projectId: // value for 'projectId'
 *   moduleSlug: // value for 'moduleSlug'
 * });
 */
export function useCurrentUserProjectModuleCapabilitiesQuery(variables: CurrentUserProjectModuleCapabilitiesQueryVariables | VueCompositionApi.Ref<CurrentUserProjectModuleCapabilitiesQueryVariables> | ReactiveFunction<CurrentUserProjectModuleCapabilitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesQuery, CurrentUserProjectModuleCapabilitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesQuery, CurrentUserProjectModuleCapabilitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesQuery, CurrentUserProjectModuleCapabilitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CurrentUserProjectModuleCapabilitiesQuery, CurrentUserProjectModuleCapabilitiesQueryVariables>(CurrentUserProjectModuleCapabilitiesDocument, variables, options);
}
export function useCurrentUserProjectModuleCapabilitiesLazyQuery(variables?: CurrentUserProjectModuleCapabilitiesQueryVariables | VueCompositionApi.Ref<CurrentUserProjectModuleCapabilitiesQueryVariables> | ReactiveFunction<CurrentUserProjectModuleCapabilitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesQuery, CurrentUserProjectModuleCapabilitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesQuery, CurrentUserProjectModuleCapabilitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesQuery, CurrentUserProjectModuleCapabilitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CurrentUserProjectModuleCapabilitiesQuery, CurrentUserProjectModuleCapabilitiesQueryVariables>(CurrentUserProjectModuleCapabilitiesDocument, variables, options);
}
export type CurrentUserProjectModuleCapabilitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CurrentUserProjectModuleCapabilitiesQuery, CurrentUserProjectModuleCapabilitiesQueryVariables>;
export const CurrentUserProjectModuleCapabilitiesBatchDocument = gql`
    query currentUserProjectModuleCapabilitiesBatch($projectId: ID!, $moduleSlugs: [String!]!) {
  currentUserProjectModuleCapabilitiesBatch(
    projectId: $projectId
    moduleSlugs: $moduleSlugs
  ) {
    moduleSlug
    canShow
    canView
    canInsert
    canEdit
    hasFullAccess
    canEditAllRecords
  }
}
    `;

/**
 * __useCurrentUserProjectModuleCapabilitiesBatchQuery__
 *
 * To run a query within a Vue component, call `useCurrentUserProjectModuleCapabilitiesBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserProjectModuleCapabilitiesBatchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentUserProjectModuleCapabilitiesBatchQuery({
 *   projectId: // value for 'projectId'
 *   moduleSlugs: // value for 'moduleSlugs'
 * });
 */
export function useCurrentUserProjectModuleCapabilitiesBatchQuery(variables: CurrentUserProjectModuleCapabilitiesBatchQueryVariables | VueCompositionApi.Ref<CurrentUserProjectModuleCapabilitiesBatchQueryVariables> | ReactiveFunction<CurrentUserProjectModuleCapabilitiesBatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesBatchQuery, CurrentUserProjectModuleCapabilitiesBatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesBatchQuery, CurrentUserProjectModuleCapabilitiesBatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesBatchQuery, CurrentUserProjectModuleCapabilitiesBatchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CurrentUserProjectModuleCapabilitiesBatchQuery, CurrentUserProjectModuleCapabilitiesBatchQueryVariables>(CurrentUserProjectModuleCapabilitiesBatchDocument, variables, options);
}
export function useCurrentUserProjectModuleCapabilitiesBatchLazyQuery(variables?: CurrentUserProjectModuleCapabilitiesBatchQueryVariables | VueCompositionApi.Ref<CurrentUserProjectModuleCapabilitiesBatchQueryVariables> | ReactiveFunction<CurrentUserProjectModuleCapabilitiesBatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesBatchQuery, CurrentUserProjectModuleCapabilitiesBatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesBatchQuery, CurrentUserProjectModuleCapabilitiesBatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserProjectModuleCapabilitiesBatchQuery, CurrentUserProjectModuleCapabilitiesBatchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CurrentUserProjectModuleCapabilitiesBatchQuery, CurrentUserProjectModuleCapabilitiesBatchQueryVariables>(CurrentUserProjectModuleCapabilitiesBatchDocument, variables, options);
}
export type CurrentUserProjectModuleCapabilitiesBatchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CurrentUserProjectModuleCapabilitiesBatchQuery, CurrentUserProjectModuleCapabilitiesBatchQueryVariables>;
export const ProjectModuleAccessSettingsBySegmentDocument = gql`
    query projectModuleAccessSettingsBySegment($projectId: ID!, $moduleSegment: String!) {
  projectModuleAccessSettingsBySegment(
    projectId: $projectId
    moduleSegment: $moduleSegment
  ) {
    id
    projectId
    moduleSlug
    show {
      scope
      participants {
        id
        userId
        user {
          ...UserFields
          media {
            avatar {
              DESKTOP {
                PROFILE
                FRIENDS_MINI_AVATAR
              }
            }
          }
        }
      }
    }
    view {
      scope
      participants {
        id
        userId
        user {
          ...UserFields
          media {
            avatar {
              DESKTOP {
                PROFILE
                FRIENDS_MINI_AVATAR
              }
            }
          }
        }
      }
    }
    dataEntry {
      scope
      participants {
        id
        userId
        user {
          ...UserFields
          media {
            avatar {
              DESKTOP {
                PROFILE
                FRIENDS_MINI_AVATAR
              }
            }
          }
        }
      }
    }
    edit {
      membersScope
      statusScope
      participantScope
      participants {
        id
        userId
        user {
          ...UserFields
          media {
            avatar {
              DESKTOP {
                PROFILE
                FRIENDS_MINI_AVATAR
              }
            }
          }
        }
      }
    }
    fullAccessMembers {
      id
      userId
      user {
        ...UserFields
        media {
          avatar {
            DESKTOP {
              PROFILE
              FRIENDS_MINI_AVATAR
            }
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useProjectModuleAccessSettingsBySegmentQuery__
 *
 * To run a query within a Vue component, call `useProjectModuleAccessSettingsBySegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectModuleAccessSettingsBySegmentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectModuleAccessSettingsBySegmentQuery({
 *   projectId: // value for 'projectId'
 *   moduleSegment: // value for 'moduleSegment'
 * });
 */
export function useProjectModuleAccessSettingsBySegmentQuery(variables: ProjectModuleAccessSettingsBySegmentQueryVariables | VueCompositionApi.Ref<ProjectModuleAccessSettingsBySegmentQueryVariables> | ReactiveFunction<ProjectModuleAccessSettingsBySegmentQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectModuleAccessSettingsBySegmentQuery, ProjectModuleAccessSettingsBySegmentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectModuleAccessSettingsBySegmentQuery, ProjectModuleAccessSettingsBySegmentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectModuleAccessSettingsBySegmentQuery, ProjectModuleAccessSettingsBySegmentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectModuleAccessSettingsBySegmentQuery, ProjectModuleAccessSettingsBySegmentQueryVariables>(ProjectModuleAccessSettingsBySegmentDocument, variables, options);
}
export function useProjectModuleAccessSettingsBySegmentLazyQuery(variables?: ProjectModuleAccessSettingsBySegmentQueryVariables | VueCompositionApi.Ref<ProjectModuleAccessSettingsBySegmentQueryVariables> | ReactiveFunction<ProjectModuleAccessSettingsBySegmentQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectModuleAccessSettingsBySegmentQuery, ProjectModuleAccessSettingsBySegmentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectModuleAccessSettingsBySegmentQuery, ProjectModuleAccessSettingsBySegmentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectModuleAccessSettingsBySegmentQuery, ProjectModuleAccessSettingsBySegmentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectModuleAccessSettingsBySegmentQuery, ProjectModuleAccessSettingsBySegmentQueryVariables>(ProjectModuleAccessSettingsBySegmentDocument, variables, options);
}
export type ProjectModuleAccessSettingsBySegmentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectModuleAccessSettingsBySegmentQuery, ProjectModuleAccessSettingsBySegmentQueryVariables>;
export const ProjectRequestApproveDocument = gql`
    query projectRequestApprove($id: String!) {
  request: getProjectRequest(id: $id) {
    id
    userId
    name
    shortDescription
    detailedDescription
    endDate
    visibility
    themes
    media {
      image {
        DESKTOP {
          OPEN_PROJECT
        }
      }
    }
  }
}
    `;

/**
 * __useProjectRequestApproveQuery__
 *
 * To run a query within a Vue component, call `useProjectRequestApproveQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestApproveQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectRequestApproveQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectRequestApproveQuery(variables: ProjectRequestApproveQueryVariables | VueCompositionApi.Ref<ProjectRequestApproveQueryVariables> | ReactiveFunction<ProjectRequestApproveQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRequestApproveQuery, ProjectRequestApproveQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRequestApproveQuery, ProjectRequestApproveQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRequestApproveQuery, ProjectRequestApproveQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectRequestApproveQuery, ProjectRequestApproveQueryVariables>(ProjectRequestApproveDocument, variables, options);
}
export function useProjectRequestApproveLazyQuery(variables?: ProjectRequestApproveQueryVariables | VueCompositionApi.Ref<ProjectRequestApproveQueryVariables> | ReactiveFunction<ProjectRequestApproveQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectRequestApproveQuery, ProjectRequestApproveQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectRequestApproveQuery, ProjectRequestApproveQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectRequestApproveQuery, ProjectRequestApproveQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectRequestApproveQuery, ProjectRequestApproveQueryVariables>(ProjectRequestApproveDocument, variables, options);
}
export type ProjectRequestApproveQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectRequestApproveQuery, ProjectRequestApproveQueryVariables>;
export const MyProjectRequestDocument = gql`
    query myProjectRequest($id: String!) {
  request: getMyProjectRequest(id: $id) {
    ...ProjectRequestFields
  }
}
    ${ProjectRequestFieldsFragmentDoc}`;

/**
 * __useMyProjectRequestQuery__
 *
 * To run a query within a Vue component, call `useMyProjectRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProjectRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyProjectRequestQuery({
 *   id: // value for 'id'
 * });
 */
export function useMyProjectRequestQuery(variables: MyProjectRequestQueryVariables | VueCompositionApi.Ref<MyProjectRequestQueryVariables> | ReactiveFunction<MyProjectRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<MyProjectRequestQuery, MyProjectRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyProjectRequestQuery, MyProjectRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyProjectRequestQuery, MyProjectRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyProjectRequestQuery, MyProjectRequestQueryVariables>(MyProjectRequestDocument, variables, options);
}
export function useMyProjectRequestLazyQuery(variables?: MyProjectRequestQueryVariables | VueCompositionApi.Ref<MyProjectRequestQueryVariables> | ReactiveFunction<MyProjectRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<MyProjectRequestQuery, MyProjectRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyProjectRequestQuery, MyProjectRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyProjectRequestQuery, MyProjectRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MyProjectRequestQuery, MyProjectRequestQueryVariables>(MyProjectRequestDocument, variables, options);
}
export type MyProjectRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyProjectRequestQuery, MyProjectRequestQueryVariables>;
export const ExportMySupportersDocument = gql`
    query exportMySupporters($projectId: String!, $format: ProjectSupporterExportFormat!) {
  exportMySupporters(projectId: $projectId, format: $format)
}
    `;

/**
 * __useExportMySupportersQuery__
 *
 * To run a query within a Vue component, call `useExportMySupportersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportMySupportersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportMySupportersQuery({
 *   projectId: // value for 'projectId'
 *   format: // value for 'format'
 * });
 */
export function useExportMySupportersQuery(variables: ExportMySupportersQueryVariables | VueCompositionApi.Ref<ExportMySupportersQueryVariables> | ReactiveFunction<ExportMySupportersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportMySupportersQuery, ExportMySupportersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportMySupportersQuery, ExportMySupportersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportMySupportersQuery, ExportMySupportersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportMySupportersQuery, ExportMySupportersQueryVariables>(ExportMySupportersDocument, variables, options);
}
export function useExportMySupportersLazyQuery(variables?: ExportMySupportersQueryVariables | VueCompositionApi.Ref<ExportMySupportersQueryVariables> | ReactiveFunction<ExportMySupportersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportMySupportersQuery, ExportMySupportersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportMySupportersQuery, ExportMySupportersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportMySupportersQuery, ExportMySupportersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportMySupportersQuery, ExportMySupportersQueryVariables>(ExportMySupportersDocument, variables, options);
}
export type ExportMySupportersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportMySupportersQuery, ExportMySupportersQueryVariables>;
export const GetAllProjectRequestsDocument = gql`
    query getAllProjectRequests($search: String) {
  requests: getAllProjectRequests(search: $search) {
    id
    name
    shortDescription
    status
    createdAt
    media {
      image {
        DESKTOP {
          OPEN_REQUEST
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllProjectRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetAllProjectRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllProjectRequestsQuery({
 *   search: // value for 'search'
 * });
 */
export function useGetAllProjectRequestsQuery(variables: GetAllProjectRequestsQueryVariables | VueCompositionApi.Ref<GetAllProjectRequestsQueryVariables> | ReactiveFunction<GetAllProjectRequestsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAllProjectRequestsQuery, GetAllProjectRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllProjectRequestsQuery, GetAllProjectRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllProjectRequestsQuery, GetAllProjectRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllProjectRequestsQuery, GetAllProjectRequestsQueryVariables>(GetAllProjectRequestsDocument, variables, options);
}
export function useGetAllProjectRequestsLazyQuery(variables: GetAllProjectRequestsQueryVariables | VueCompositionApi.Ref<GetAllProjectRequestsQueryVariables> | ReactiveFunction<GetAllProjectRequestsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAllProjectRequestsQuery, GetAllProjectRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllProjectRequestsQuery, GetAllProjectRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllProjectRequestsQuery, GetAllProjectRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllProjectRequestsQuery, GetAllProjectRequestsQueryVariables>(GetAllProjectRequestsDocument, variables, options);
}
export type GetAllProjectRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllProjectRequestsQuery, GetAllProjectRequestsQueryVariables>;
export const GetMyAllProjectRequestsDocument = gql`
    query getMyAllProjectRequests {
  requests: getMyAllProjectRequests {
    id
    name
    shortDescription
    status
    createdAt
    media {
      image {
        DESKTOP {
          OPEN_REQUEST
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyAllProjectRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetMyAllProjectRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAllProjectRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyAllProjectRequestsQuery();
 */
export function useGetMyAllProjectRequestsQuery(options: VueApolloComposable.UseQueryOptions<GetMyAllProjectRequestsQuery, GetMyAllProjectRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyAllProjectRequestsQuery, GetMyAllProjectRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyAllProjectRequestsQuery, GetMyAllProjectRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyAllProjectRequestsQuery, GetMyAllProjectRequestsQueryVariables>(GetMyAllProjectRequestsDocument, {}, options);
}
export function useGetMyAllProjectRequestsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMyAllProjectRequestsQuery, GetMyAllProjectRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyAllProjectRequestsQuery, GetMyAllProjectRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyAllProjectRequestsQuery, GetMyAllProjectRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMyAllProjectRequestsQuery, GetMyAllProjectRequestsQueryVariables>(GetMyAllProjectRequestsDocument, {}, options);
}
export type GetMyAllProjectRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyAllProjectRequestsQuery, GetMyAllProjectRequestsQueryVariables>;
export const GetMyJoinRequestsDocument = gql`
    query getMyJoinRequests {
  getMyJoinRequests {
    id
    projectId
    status
  }
}
    `;

/**
 * __useGetMyJoinRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetMyJoinRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyJoinRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyJoinRequestsQuery();
 */
export function useGetMyJoinRequestsQuery(options: VueApolloComposable.UseQueryOptions<GetMyJoinRequestsQuery, GetMyJoinRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyJoinRequestsQuery, GetMyJoinRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyJoinRequestsQuery, GetMyJoinRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyJoinRequestsQuery, GetMyJoinRequestsQueryVariables>(GetMyJoinRequestsDocument, {}, options);
}
export function useGetMyJoinRequestsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMyJoinRequestsQuery, GetMyJoinRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyJoinRequestsQuery, GetMyJoinRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyJoinRequestsQuery, GetMyJoinRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMyJoinRequestsQuery, GetMyJoinRequestsQueryVariables>(GetMyJoinRequestsDocument, {}, options);
}
export type GetMyJoinRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyJoinRequestsQuery, GetMyJoinRequestsQueryVariables>;
export const GetMyLikedProjectsDocument = gql`
    query getMyLikedProjects($offset: Int! = 0, $limit: Int! = 10) {
  getMyLikedProjects(offset: $offset, limit: $limit) {
    totalCount
    nodes {
      id
      slug
      name
      shortDescription
      ownerUserId
      projectMembers {
        nodes {
          userId
        }
      }
      visibility
      media {
        image {
          DESKTOP {
            LIST
          }
        }
      }
      likes {
        likeCount
        isLiked
      }
    }
  }
}
    `;

/**
 * __useGetMyLikedProjectsQuery__
 *
 * To run a query within a Vue component, call `useGetMyLikedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLikedProjectsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyLikedProjectsQuery({
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useGetMyLikedProjectsQuery(variables: GetMyLikedProjectsQueryVariables | VueCompositionApi.Ref<GetMyLikedProjectsQueryVariables> | ReactiveFunction<GetMyLikedProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMyLikedProjectsQuery, GetMyLikedProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyLikedProjectsQuery, GetMyLikedProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyLikedProjectsQuery, GetMyLikedProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyLikedProjectsQuery, GetMyLikedProjectsQueryVariables>(GetMyLikedProjectsDocument, variables, options);
}
export function useGetMyLikedProjectsLazyQuery(variables?: GetMyLikedProjectsQueryVariables | VueCompositionApi.Ref<GetMyLikedProjectsQueryVariables> | ReactiveFunction<GetMyLikedProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMyLikedProjectsQuery, GetMyLikedProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyLikedProjectsQuery, GetMyLikedProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyLikedProjectsQuery, GetMyLikedProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMyLikedProjectsQuery, GetMyLikedProjectsQueryVariables>(GetMyLikedProjectsDocument, variables, options);
}
export type GetMyLikedProjectsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyLikedProjectsQuery, GetMyLikedProjectsQueryVariables>;
export const GetPendingJoinRequestsCountDocument = gql`
    query getPendingJoinRequestsCount($projectId: String!) {
  getPendingJoinRequests(projectId: $projectId) {
    id
  }
}
    `;

/**
 * __useGetPendingJoinRequestsCountQuery__
 *
 * To run a query within a Vue component, call `useGetPendingJoinRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingJoinRequestsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPendingJoinRequestsCountQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetPendingJoinRequestsCountQuery(variables: GetPendingJoinRequestsCountQueryVariables | VueCompositionApi.Ref<GetPendingJoinRequestsCountQueryVariables> | ReactiveFunction<GetPendingJoinRequestsCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPendingJoinRequestsCountQuery, GetPendingJoinRequestsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPendingJoinRequestsCountQuery, GetPendingJoinRequestsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPendingJoinRequestsCountQuery, GetPendingJoinRequestsCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPendingJoinRequestsCountQuery, GetPendingJoinRequestsCountQueryVariables>(GetPendingJoinRequestsCountDocument, variables, options);
}
export function useGetPendingJoinRequestsCountLazyQuery(variables?: GetPendingJoinRequestsCountQueryVariables | VueCompositionApi.Ref<GetPendingJoinRequestsCountQueryVariables> | ReactiveFunction<GetPendingJoinRequestsCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPendingJoinRequestsCountQuery, GetPendingJoinRequestsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPendingJoinRequestsCountQuery, GetPendingJoinRequestsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPendingJoinRequestsCountQuery, GetPendingJoinRequestsCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPendingJoinRequestsCountQuery, GetPendingJoinRequestsCountQueryVariables>(GetPendingJoinRequestsCountDocument, variables, options);
}
export type GetPendingJoinRequestsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPendingJoinRequestsCountQuery, GetPendingJoinRequestsCountQueryVariables>;
export const GetProjectJoinRequestsDocument = gql`
    query getProjectJoinRequests($projectId: String!) {
  getProjectJoinRequests(projectId: $projectId) {
    id
    userId
    user {
      ...UserFields
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
            FRIENDS_CARD
            PROFILE
          }
        }
      }
    }
    status
    source
    message
    invitationId
    processedByUserId
    processedAt
    rejectionReason
    createdAt
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetProjectJoinRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetProjectJoinRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectJoinRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectJoinRequestsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectJoinRequestsQuery(variables: GetProjectJoinRequestsQueryVariables | VueCompositionApi.Ref<GetProjectJoinRequestsQueryVariables> | ReactiveFunction<GetProjectJoinRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectJoinRequestsQuery, GetProjectJoinRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectJoinRequestsQuery, GetProjectJoinRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectJoinRequestsQuery, GetProjectJoinRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectJoinRequestsQuery, GetProjectJoinRequestsQueryVariables>(GetProjectJoinRequestsDocument, variables, options);
}
export function useGetProjectJoinRequestsLazyQuery(variables?: GetProjectJoinRequestsQueryVariables | VueCompositionApi.Ref<GetProjectJoinRequestsQueryVariables> | ReactiveFunction<GetProjectJoinRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectJoinRequestsQuery, GetProjectJoinRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectJoinRequestsQuery, GetProjectJoinRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectJoinRequestsQuery, GetProjectJoinRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectJoinRequestsQuery, GetProjectJoinRequestsQueryVariables>(GetProjectJoinRequestsDocument, variables, options);
}
export type GetProjectJoinRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectJoinRequestsQuery, GetProjectJoinRequestsQueryVariables>;
export const ProjectDocument = gql`
    query project($id: ID, $slug: String) {
  project(id: $id, slug: $slug) {
    ...ProjectFields
    media {
      logo
      image {
        DESKTOP {
          WORKSPACE
          OPEN_PROJECT
        }
        TABLET {
          WORKSPACE
          OPEN_PROJECT
        }
        MOBILE {
          WORKSPACE
          OPEN_PROJECT
        }
      }
    }
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useProjectQuery__
 *
 * To run a query within a Vue component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectQuery({
 *   id: // value for 'id'
 *   slug: // value for 'slug'
 * });
 */
export function useProjectQuery(variables: ProjectQueryVariables | VueCompositionApi.Ref<ProjectQueryVariables> | ReactiveFunction<ProjectQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, variables, options);
}
export function useProjectLazyQuery(variables: ProjectQueryVariables | VueCompositionApi.Ref<ProjectQueryVariables> | ReactiveFunction<ProjectQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, variables, options);
}
export type ProjectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectQuery, ProjectQueryVariables>;
export const ProjectCustomModuleDocument = gql`
    query projectCustomModule($id: ID!) {
  projectCustomModule(id: $id) {
    id
    projectId
    moduleSlug
    name
    iconColor
    backgroundColor
    format
    icon
    baseModuleType
  }
}
    `;

/**
 * __useProjectCustomModuleQuery__
 *
 * To run a query within a Vue component, call `useProjectCustomModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCustomModuleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectCustomModuleQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectCustomModuleQuery(variables: ProjectCustomModuleQueryVariables | VueCompositionApi.Ref<ProjectCustomModuleQueryVariables> | ReactiveFunction<ProjectCustomModuleQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectCustomModuleQuery, ProjectCustomModuleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectCustomModuleQuery, ProjectCustomModuleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectCustomModuleQuery, ProjectCustomModuleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectCustomModuleQuery, ProjectCustomModuleQueryVariables>(ProjectCustomModuleDocument, variables, options);
}
export function useProjectCustomModuleLazyQuery(variables?: ProjectCustomModuleQueryVariables | VueCompositionApi.Ref<ProjectCustomModuleQueryVariables> | ReactiveFunction<ProjectCustomModuleQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectCustomModuleQuery, ProjectCustomModuleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectCustomModuleQuery, ProjectCustomModuleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectCustomModuleQuery, ProjectCustomModuleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectCustomModuleQuery, ProjectCustomModuleQueryVariables>(ProjectCustomModuleDocument, variables, options);
}
export type ProjectCustomModuleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectCustomModuleQuery, ProjectCustomModuleQueryVariables>;
export const ProjectCustomModulesDocument = gql`
    query projectCustomModules($projectId: ID!) {
  projectCustomModules(projectId: $projectId) {
    id
    moduleSlug
    name
    iconColor
    backgroundColor
    format
    icon
    baseModuleType
    createdAt
  }
}
    `;

/**
 * __useProjectCustomModulesQuery__
 *
 * To run a query within a Vue component, call `useProjectCustomModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCustomModulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectCustomModulesQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useProjectCustomModulesQuery(variables: ProjectCustomModulesQueryVariables | VueCompositionApi.Ref<ProjectCustomModulesQueryVariables> | ReactiveFunction<ProjectCustomModulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectCustomModulesQuery, ProjectCustomModulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectCustomModulesQuery, ProjectCustomModulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectCustomModulesQuery, ProjectCustomModulesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectCustomModulesQuery, ProjectCustomModulesQueryVariables>(ProjectCustomModulesDocument, variables, options);
}
export function useProjectCustomModulesLazyQuery(variables?: ProjectCustomModulesQueryVariables | VueCompositionApi.Ref<ProjectCustomModulesQueryVariables> | ReactiveFunction<ProjectCustomModulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectCustomModulesQuery, ProjectCustomModulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectCustomModulesQuery, ProjectCustomModulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectCustomModulesQuery, ProjectCustomModulesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectCustomModulesQuery, ProjectCustomModulesQueryVariables>(ProjectCustomModulesDocument, variables, options);
}
export type ProjectCustomModulesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectCustomModulesQuery, ProjectCustomModulesQueryVariables>;
export const ProjectCustomModulesForProjectRequestDocument = gql`
    query projectCustomModulesForProjectRequest($projectRequestId: ID!) {
  projectCustomModulesForProjectRequest(projectRequestId: $projectRequestId) {
    id
    name
    moduleSlug
    baseModuleType
    format
  }
}
    `;

/**
 * __useProjectCustomModulesForProjectRequestQuery__
 *
 * To run a query within a Vue component, call `useProjectCustomModulesForProjectRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCustomModulesForProjectRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectCustomModulesForProjectRequestQuery({
 *   projectRequestId: // value for 'projectRequestId'
 * });
 */
export function useProjectCustomModulesForProjectRequestQuery(variables: ProjectCustomModulesForProjectRequestQueryVariables | VueCompositionApi.Ref<ProjectCustomModulesForProjectRequestQueryVariables> | ReactiveFunction<ProjectCustomModulesForProjectRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectCustomModulesForProjectRequestQuery, ProjectCustomModulesForProjectRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectCustomModulesForProjectRequestQuery, ProjectCustomModulesForProjectRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectCustomModulesForProjectRequestQuery, ProjectCustomModulesForProjectRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectCustomModulesForProjectRequestQuery, ProjectCustomModulesForProjectRequestQueryVariables>(ProjectCustomModulesForProjectRequestDocument, variables, options);
}
export function useProjectCustomModulesForProjectRequestLazyQuery(variables?: ProjectCustomModulesForProjectRequestQueryVariables | VueCompositionApi.Ref<ProjectCustomModulesForProjectRequestQueryVariables> | ReactiveFunction<ProjectCustomModulesForProjectRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectCustomModulesForProjectRequestQuery, ProjectCustomModulesForProjectRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectCustomModulesForProjectRequestQuery, ProjectCustomModulesForProjectRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectCustomModulesForProjectRequestQuery, ProjectCustomModulesForProjectRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectCustomModulesForProjectRequestQuery, ProjectCustomModulesForProjectRequestQueryVariables>(ProjectCustomModulesForProjectRequestDocument, variables, options);
}
export type ProjectCustomModulesForProjectRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectCustomModulesForProjectRequestQuery, ProjectCustomModulesForProjectRequestQueryVariables>;
export const ProjectLandingPlacementButtonsDocument = gql`
    query projectLandingPlacementButtons($id: ID!) {
  project(id: $id) {
    id
    headerButtons
    hamburgerButtons
  }
}
    `;

/**
 * __useProjectLandingPlacementButtonsQuery__
 *
 * To run a query within a Vue component, call `useProjectLandingPlacementButtonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectLandingPlacementButtonsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectLandingPlacementButtonsQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectLandingPlacementButtonsQuery(variables: ProjectLandingPlacementButtonsQueryVariables | VueCompositionApi.Ref<ProjectLandingPlacementButtonsQueryVariables> | ReactiveFunction<ProjectLandingPlacementButtonsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectLandingPlacementButtonsQuery, ProjectLandingPlacementButtonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectLandingPlacementButtonsQuery, ProjectLandingPlacementButtonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectLandingPlacementButtonsQuery, ProjectLandingPlacementButtonsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectLandingPlacementButtonsQuery, ProjectLandingPlacementButtonsQueryVariables>(ProjectLandingPlacementButtonsDocument, variables, options);
}
export function useProjectLandingPlacementButtonsLazyQuery(variables?: ProjectLandingPlacementButtonsQueryVariables | VueCompositionApi.Ref<ProjectLandingPlacementButtonsQueryVariables> | ReactiveFunction<ProjectLandingPlacementButtonsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectLandingPlacementButtonsQuery, ProjectLandingPlacementButtonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectLandingPlacementButtonsQuery, ProjectLandingPlacementButtonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectLandingPlacementButtonsQuery, ProjectLandingPlacementButtonsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectLandingPlacementButtonsQuery, ProjectLandingPlacementButtonsQueryVariables>(ProjectLandingPlacementButtonsDocument, variables, options);
}
export type ProjectLandingPlacementButtonsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectLandingPlacementButtonsQuery, ProjectLandingPlacementButtonsQueryVariables>;
export const ProjectLogoDocument = gql`
    query projectLogo($id: ID!) {
  project(id: $id) {
    id
    media {
      logo
    }
  }
}
    `;

/**
 * __useProjectLogoQuery__
 *
 * To run a query within a Vue component, call `useProjectLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectLogoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectLogoQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectLogoQuery(variables: ProjectLogoQueryVariables | VueCompositionApi.Ref<ProjectLogoQueryVariables> | ReactiveFunction<ProjectLogoQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectLogoQuery, ProjectLogoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectLogoQuery, ProjectLogoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectLogoQuery, ProjectLogoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectLogoQuery, ProjectLogoQueryVariables>(ProjectLogoDocument, variables, options);
}
export function useProjectLogoLazyQuery(variables?: ProjectLogoQueryVariables | VueCompositionApi.Ref<ProjectLogoQueryVariables> | ReactiveFunction<ProjectLogoQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectLogoQuery, ProjectLogoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectLogoQuery, ProjectLogoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectLogoQuery, ProjectLogoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectLogoQuery, ProjectLogoQueryVariables>(ProjectLogoDocument, variables, options);
}
export type ProjectLogoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectLogoQuery, ProjectLogoQueryVariables>;
export const ProjectPreviewDocument = gql`
    query projectPreview($id: ID!) {
  project(id: $id) {
    id
    name
    visibility
    ownerUserId
    projectMembers {
      nodes {
        userId
      }
    }
  }
}
    `;

/**
 * __useProjectPreviewQuery__
 *
 * To run a query within a Vue component, call `useProjectPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPreviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectPreviewQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectPreviewQuery(variables: ProjectPreviewQueryVariables | VueCompositionApi.Ref<ProjectPreviewQueryVariables> | ReactiveFunction<ProjectPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectPreviewQuery, ProjectPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectPreviewQuery, ProjectPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectPreviewQuery, ProjectPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectPreviewQuery, ProjectPreviewQueryVariables>(ProjectPreviewDocument, variables, options);
}
export function useProjectPreviewLazyQuery(variables?: ProjectPreviewQueryVariables | VueCompositionApi.Ref<ProjectPreviewQueryVariables> | ReactiveFunction<ProjectPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectPreviewQuery, ProjectPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectPreviewQuery, ProjectPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectPreviewQuery, ProjectPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectPreviewQuery, ProjectPreviewQueryVariables>(ProjectPreviewDocument, variables, options);
}
export type ProjectPreviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectPreviewQuery, ProjectPreviewQueryVariables>;
export const ProjectPublicDocument = gql`
    query projectPublic($id: ID, $slug: String) {
  publicProject(id: $id, slug: $slug) {
    id
    slug
    name
    shortDescription
    detailedDescription
    media {
      logo
      image {
        DESKTOP {
          WORKSPACE
          OPEN_PROJECT
        }
        TABLET {
          WORKSPACE
          OPEN_PROJECT
        }
        MOBILE {
          WORKSPACE
          OPEN_PROJECT
        }
      }
    }
  }
}
    `;

/**
 * __useProjectPublicQuery__
 *
 * To run a query within a Vue component, call `useProjectPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPublicQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectPublicQuery({
 *   id: // value for 'id'
 *   slug: // value for 'slug'
 * });
 */
export function useProjectPublicQuery(variables: ProjectPublicQueryVariables | VueCompositionApi.Ref<ProjectPublicQueryVariables> | ReactiveFunction<ProjectPublicQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectPublicQuery, ProjectPublicQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectPublicQuery, ProjectPublicQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectPublicQuery, ProjectPublicQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectPublicQuery, ProjectPublicQueryVariables>(ProjectPublicDocument, variables, options);
}
export function useProjectPublicLazyQuery(variables: ProjectPublicQueryVariables | VueCompositionApi.Ref<ProjectPublicQueryVariables> | ReactiveFunction<ProjectPublicQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectPublicQuery, ProjectPublicQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectPublicQuery, ProjectPublicQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectPublicQuery, ProjectPublicQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectPublicQuery, ProjectPublicQueryVariables>(ProjectPublicDocument, variables, options);
}
export type ProjectPublicQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectPublicQuery, ProjectPublicQueryVariables>;
export const ProjectSupporterDocument = gql`
    query projectSupporter($id: ID!, $projectId: ID) {
  projectSupporter(id: $id, projectId: $projectId) {
    id
    ...ProjectSupporterFields
  }
}
    ${ProjectSupporterFieldsFragmentDoc}`;

/**
 * __useProjectSupporterQuery__
 *
 * To run a query within a Vue component, call `useProjectSupporterQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSupporterQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectSupporterQuery({
 *   id: // value for 'id'
 *   projectId: // value for 'projectId'
 * });
 */
export function useProjectSupporterQuery(variables: ProjectSupporterQueryVariables | VueCompositionApi.Ref<ProjectSupporterQueryVariables> | ReactiveFunction<ProjectSupporterQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectSupporterQuery, ProjectSupporterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectSupporterQuery, ProjectSupporterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectSupporterQuery, ProjectSupporterQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectSupporterQuery, ProjectSupporterQueryVariables>(ProjectSupporterDocument, variables, options);
}
export function useProjectSupporterLazyQuery(variables?: ProjectSupporterQueryVariables | VueCompositionApi.Ref<ProjectSupporterQueryVariables> | ReactiveFunction<ProjectSupporterQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectSupporterQuery, ProjectSupporterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectSupporterQuery, ProjectSupporterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectSupporterQuery, ProjectSupporterQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectSupporterQuery, ProjectSupporterQueryVariables>(ProjectSupporterDocument, variables, options);
}
export type ProjectSupporterQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectSupporterQuery, ProjectSupporterQueryVariables>;
export const ProjectWorkspaceDocument = gql`
    query projectWorkspace($id: ID!) {
  project(id: $id) {
    id
    slug
    name
    shortDescription
    themes
    templateType
    workspaceNativeModules
    ownerUserId
    projectMembers {
      nodes {
        id
        userId
        role
      }
    }
    media {
      image {
        DESKTOP {
          WORKSPACE
        }
      }
    }
  }
}
    `;

/**
 * __useProjectWorkspaceQuery__
 *
 * To run a query within a Vue component, call `useProjectWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectWorkspaceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectWorkspaceQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectWorkspaceQuery(variables: ProjectWorkspaceQueryVariables | VueCompositionApi.Ref<ProjectWorkspaceQueryVariables> | ReactiveFunction<ProjectWorkspaceQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectWorkspaceQuery, ProjectWorkspaceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectWorkspaceQuery, ProjectWorkspaceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectWorkspaceQuery, ProjectWorkspaceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectWorkspaceQuery, ProjectWorkspaceQueryVariables>(ProjectWorkspaceDocument, variables, options);
}
export function useProjectWorkspaceLazyQuery(variables?: ProjectWorkspaceQueryVariables | VueCompositionApi.Ref<ProjectWorkspaceQueryVariables> | ReactiveFunction<ProjectWorkspaceQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectWorkspaceQuery, ProjectWorkspaceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectWorkspaceQuery, ProjectWorkspaceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectWorkspaceQuery, ProjectWorkspaceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectWorkspaceQuery, ProjectWorkspaceQueryVariables>(ProjectWorkspaceDocument, variables, options);
}
export type ProjectWorkspaceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectWorkspaceQuery, ProjectWorkspaceQueryVariables>;
export const ProjectWorkspaceVisibleModuleSlugsDocument = gql`
    query projectWorkspaceVisibleModuleSlugs($projectId: ID!) {
  projectWorkspaceVisibleModuleSlugs(projectId: $projectId)
}
    `;

/**
 * __useProjectWorkspaceVisibleModuleSlugsQuery__
 *
 * To run a query within a Vue component, call `useProjectWorkspaceVisibleModuleSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectWorkspaceVisibleModuleSlugsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectWorkspaceVisibleModuleSlugsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useProjectWorkspaceVisibleModuleSlugsQuery(variables: ProjectWorkspaceVisibleModuleSlugsQueryVariables | VueCompositionApi.Ref<ProjectWorkspaceVisibleModuleSlugsQueryVariables> | ReactiveFunction<ProjectWorkspaceVisibleModuleSlugsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectWorkspaceVisibleModuleSlugsQuery, ProjectWorkspaceVisibleModuleSlugsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectWorkspaceVisibleModuleSlugsQuery, ProjectWorkspaceVisibleModuleSlugsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectWorkspaceVisibleModuleSlugsQuery, ProjectWorkspaceVisibleModuleSlugsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectWorkspaceVisibleModuleSlugsQuery, ProjectWorkspaceVisibleModuleSlugsQueryVariables>(ProjectWorkspaceVisibleModuleSlugsDocument, variables, options);
}
export function useProjectWorkspaceVisibleModuleSlugsLazyQuery(variables?: ProjectWorkspaceVisibleModuleSlugsQueryVariables | VueCompositionApi.Ref<ProjectWorkspaceVisibleModuleSlugsQueryVariables> | ReactiveFunction<ProjectWorkspaceVisibleModuleSlugsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectWorkspaceVisibleModuleSlugsQuery, ProjectWorkspaceVisibleModuleSlugsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectWorkspaceVisibleModuleSlugsQuery, ProjectWorkspaceVisibleModuleSlugsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectWorkspaceVisibleModuleSlugsQuery, ProjectWorkspaceVisibleModuleSlugsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectWorkspaceVisibleModuleSlugsQuery, ProjectWorkspaceVisibleModuleSlugsQueryVariables>(ProjectWorkspaceVisibleModuleSlugsDocument, variables, options);
}
export type ProjectWorkspaceVisibleModuleSlugsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectWorkspaceVisibleModuleSlugsQuery, ProjectWorkspaceVisibleModuleSlugsQueryVariables>;
export const ProjectsDocument = gql`
    query projects($paging: OffsetPaging! = {limit: 10}, $filter: ProjectFilter! = {}, $sorting: [ProjectSort!]! = [{field: startDate, direction: DESC}]) {
  projects(paging: $paging, filter: $filter, sorting: $sorting) {
    nodes {
      ...ProjectFields
      media {
        image {
          DESKTOP {
            LIST
          }
          TABLET {
            LIST
          }
          MOBILE {
            LIST
          }
        }
      }
      likes {
        likeCount
        isLiked
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a Vue component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectsQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useProjectsQuery(variables: ProjectsQueryVariables | VueCompositionApi.Ref<ProjectsQueryVariables> | ReactiveFunction<ProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, variables, options);
}
export function useProjectsLazyQuery(variables?: ProjectsQueryVariables | VueCompositionApi.Ref<ProjectsQueryVariables> | ReactiveFunction<ProjectsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, variables, options);
}
export type ProjectsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectsQuery, ProjectsQueryVariables>;
export const ProjectsModuleDocument = gql`
    query projectsModule($paging: OffsetPaging! = {limit: 10}, $filter: ProjectFilter! = {}, $sorting: [ProjectSort!]! = [{field: startDate, direction: DESC}]) {
  projects(paging: $paging, filter: $filter, sorting: $sorting) {
    nodes {
      id
      slug
      name
      shortDescription
      ownerUserId
      projectMembers {
        nodes {
          userId
        }
      }
      visibility
      media {
        image {
          DESKTOP {
            LIST
          }
        }
      }
      likes {
        likeCount
        isLiked
      }
    }
  }
}
    `;

/**
 * __useProjectsModuleQuery__
 *
 * To run a query within a Vue component, call `useProjectsModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsModuleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectsModuleQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useProjectsModuleQuery(variables: ProjectsModuleQueryVariables | VueCompositionApi.Ref<ProjectsModuleQueryVariables> | ReactiveFunction<ProjectsModuleQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectsModuleQuery, ProjectsModuleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsModuleQuery, ProjectsModuleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsModuleQuery, ProjectsModuleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectsModuleQuery, ProjectsModuleQueryVariables>(ProjectsModuleDocument, variables, options);
}
export function useProjectsModuleLazyQuery(variables?: ProjectsModuleQueryVariables | VueCompositionApi.Ref<ProjectsModuleQueryVariables> | ReactiveFunction<ProjectsModuleQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectsModuleQuery, ProjectsModuleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsModuleQuery, ProjectsModuleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsModuleQuery, ProjectsModuleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectsModuleQuery, ProjectsModuleQueryVariables>(ProjectsModuleDocument, variables, options);
}
export type ProjectsModuleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectsModuleQuery, ProjectsModuleQueryVariables>;
export const ReglamentItemsDocument = gql`
    query reglamentItems($projectId: ID!, $moduleSlug: String!) {
  reglamentItems(projectId: $projectId, moduleSlug: $moduleSlug) {
    ...ReglamentItemFields
  }
}
    ${ReglamentItemFieldsFragmentDoc}`;

/**
 * __useReglamentItemsQuery__
 *
 * To run a query within a Vue component, call `useReglamentItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReglamentItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReglamentItemsQuery({
 *   projectId: // value for 'projectId'
 *   moduleSlug: // value for 'moduleSlug'
 * });
 */
export function useReglamentItemsQuery(variables: ReglamentItemsQueryVariables | VueCompositionApi.Ref<ReglamentItemsQueryVariables> | ReactiveFunction<ReglamentItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReglamentItemsQuery, ReglamentItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReglamentItemsQuery, ReglamentItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReglamentItemsQuery, ReglamentItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReglamentItemsQuery, ReglamentItemsQueryVariables>(ReglamentItemsDocument, variables, options);
}
export function useReglamentItemsLazyQuery(variables?: ReglamentItemsQueryVariables | VueCompositionApi.Ref<ReglamentItemsQueryVariables> | ReactiveFunction<ReglamentItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReglamentItemsQuery, ReglamentItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReglamentItemsQuery, ReglamentItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReglamentItemsQuery, ReglamentItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReglamentItemsQuery, ReglamentItemsQueryVariables>(ReglamentItemsDocument, variables, options);
}
export type ReglamentItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReglamentItemsQuery, ReglamentItemsQueryVariables>;
export const GetAllTemplatesDocument = gql`
    query getAllTemplates($projectId: String) {
  getAllTemplates(projectId: $projectId) {
    global {
      name
      label
      items {
        name
        label
        text
      }
    }
    personal {
      name
      label
      text
    }
  }
}
    `;

/**
 * __useGetAllTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAllTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllTemplatesQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetAllTemplatesQuery(variables: GetAllTemplatesQueryVariables | VueCompositionApi.Ref<GetAllTemplatesQueryVariables> | ReactiveFunction<GetAllTemplatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAllTemplatesQuery, GetAllTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>(GetAllTemplatesDocument, variables, options);
}
export function useGetAllTemplatesLazyQuery(variables: GetAllTemplatesQueryVariables | VueCompositionApi.Ref<GetAllTemplatesQueryVariables> | ReactiveFunction<GetAllTemplatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAllTemplatesQuery, GetAllTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>(GetAllTemplatesDocument, variables, options);
}
export type GetAllTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>;
export const GetLandingTemplatesDocument = gql`
    query getLandingTemplates($paging: CursorPaging! = {first: 10}, $filter: LandingTemplateFilter! = {}, $sorting: [LandingTemplateSort!]! = []) {
  landingTemplates(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        id
        name
        description
        content
        isPublic
        createdBy
        updatedBy
        createdAt
        updatedAt
        deletedAt
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetLandingTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetLandingTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLandingTemplatesQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useGetLandingTemplatesQuery(variables: GetLandingTemplatesQueryVariables | VueCompositionApi.Ref<GetLandingTemplatesQueryVariables> | ReactiveFunction<GetLandingTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLandingTemplatesQuery, GetLandingTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLandingTemplatesQuery, GetLandingTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLandingTemplatesQuery, GetLandingTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLandingTemplatesQuery, GetLandingTemplatesQueryVariables>(GetLandingTemplatesDocument, variables, options);
}
export function useGetLandingTemplatesLazyQuery(variables?: GetLandingTemplatesQueryVariables | VueCompositionApi.Ref<GetLandingTemplatesQueryVariables> | ReactiveFunction<GetLandingTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLandingTemplatesQuery, GetLandingTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLandingTemplatesQuery, GetLandingTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLandingTemplatesQuery, GetLandingTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetLandingTemplatesQuery, GetLandingTemplatesQueryVariables>(GetLandingTemplatesDocument, variables, options);
}
export type GetLandingTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLandingTemplatesQuery, GetLandingTemplatesQueryVariables>;
export const GetMockupsDocument = gql`
    query getMockups($filter: MockupFilterInput) {
  getMockups(filter: $filter) {
    id
    presignedUrl
    type
  }
}
    `;

/**
 * __useGetMockupsQuery__
 *
 * To run a query within a Vue component, call `useGetMockupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMockupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMockupsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useGetMockupsQuery(variables: GetMockupsQueryVariables | VueCompositionApi.Ref<GetMockupsQueryVariables> | ReactiveFunction<GetMockupsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetMockupsQuery, GetMockupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMockupsQuery, GetMockupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMockupsQuery, GetMockupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMockupsQuery, GetMockupsQueryVariables>(GetMockupsDocument, variables, options);
}
export function useGetMockupsLazyQuery(variables: GetMockupsQueryVariables | VueCompositionApi.Ref<GetMockupsQueryVariables> | ReactiveFunction<GetMockupsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetMockupsQuery, GetMockupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMockupsQuery, GetMockupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMockupsQuery, GetMockupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMockupsQuery, GetMockupsQueryVariables>(GetMockupsDocument, variables, options);
}
export type GetMockupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMockupsQuery, GetMockupsQueryVariables>;
export const GetPlatformSummaryReportsDocument = gql`
    query getPlatformSummaryReports($filters: AnalyticsFiltersInput) {
  getPlatformSummaryReports(filters: $filters) {
    ...PlatformSummaryReportEntity
  }
}
    ${PlatformSummaryReportEntityFragmentDoc}`;

/**
 * __useGetPlatformSummaryReportsQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformSummaryReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformSummaryReportsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformSummaryReportsQuery({
 *   filters: // value for 'filters'
 * });
 */
export function useGetPlatformSummaryReportsQuery(variables: GetPlatformSummaryReportsQueryVariables | VueCompositionApi.Ref<GetPlatformSummaryReportsQueryVariables> | ReactiveFunction<GetPlatformSummaryReportsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetPlatformSummaryReportsQuery, GetPlatformSummaryReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformSummaryReportsQuery, GetPlatformSummaryReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformSummaryReportsQuery, GetPlatformSummaryReportsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformSummaryReportsQuery, GetPlatformSummaryReportsQueryVariables>(GetPlatformSummaryReportsDocument, variables, options);
}
export function useGetPlatformSummaryReportsLazyQuery(variables: GetPlatformSummaryReportsQueryVariables | VueCompositionApi.Ref<GetPlatformSummaryReportsQueryVariables> | ReactiveFunction<GetPlatformSummaryReportsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetPlatformSummaryReportsQuery, GetPlatformSummaryReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformSummaryReportsQuery, GetPlatformSummaryReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformSummaryReportsQuery, GetPlatformSummaryReportsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformSummaryReportsQuery, GetPlatformSummaryReportsQueryVariables>(GetPlatformSummaryReportsDocument, variables, options);
}
export type GetPlatformSummaryReportsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformSummaryReportsQuery, GetPlatformSummaryReportsQueryVariables>;
export const GetProjectDetailedReportsDocument = gql`
    query getProjectDetailedReports($filters: ProjectDetailedFiltersInput) {
  getProjectDetailedReports(filters: $filters) {
    ...ProjectDetailedReportEntity
  }
}
    ${ProjectDetailedReportEntityFragmentDoc}`;

/**
 * __useGetProjectDetailedReportsQuery__
 *
 * To run a query within a Vue component, call `useGetProjectDetailedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDetailedReportsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectDetailedReportsQuery({
 *   filters: // value for 'filters'
 * });
 */
export function useGetProjectDetailedReportsQuery(variables: GetProjectDetailedReportsQueryVariables | VueCompositionApi.Ref<GetProjectDetailedReportsQueryVariables> | ReactiveFunction<GetProjectDetailedReportsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetProjectDetailedReportsQuery, GetProjectDetailedReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectDetailedReportsQuery, GetProjectDetailedReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectDetailedReportsQuery, GetProjectDetailedReportsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectDetailedReportsQuery, GetProjectDetailedReportsQueryVariables>(GetProjectDetailedReportsDocument, variables, options);
}
export function useGetProjectDetailedReportsLazyQuery(variables: GetProjectDetailedReportsQueryVariables | VueCompositionApi.Ref<GetProjectDetailedReportsQueryVariables> | ReactiveFunction<GetProjectDetailedReportsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetProjectDetailedReportsQuery, GetProjectDetailedReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectDetailedReportsQuery, GetProjectDetailedReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectDetailedReportsQuery, GetProjectDetailedReportsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectDetailedReportsQuery, GetProjectDetailedReportsQueryVariables>(GetProjectDetailedReportsDocument, variables, options);
}
export type GetProjectDetailedReportsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectDetailedReportsQuery, GetProjectDetailedReportsQueryVariables>;
export const GetProjectMockupsDocument = gql`
    query getProjectMockups($projectId: ID!) {
  getProjectMockups(projectId: $projectId) {
    id
    presignedUrl
    type
  }
}
    `;

/**
 * __useGetProjectMockupsQuery__
 *
 * To run a query within a Vue component, call `useGetProjectMockupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMockupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProjectMockupsQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetProjectMockupsQuery(variables: GetProjectMockupsQueryVariables | VueCompositionApi.Ref<GetProjectMockupsQueryVariables> | ReactiveFunction<GetProjectMockupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectMockupsQuery, GetProjectMockupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectMockupsQuery, GetProjectMockupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectMockupsQuery, GetProjectMockupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProjectMockupsQuery, GetProjectMockupsQueryVariables>(GetProjectMockupsDocument, variables, options);
}
export function useGetProjectMockupsLazyQuery(variables?: GetProjectMockupsQueryVariables | VueCompositionApi.Ref<GetProjectMockupsQueryVariables> | ReactiveFunction<GetProjectMockupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProjectMockupsQuery, GetProjectMockupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProjectMockupsQuery, GetProjectMockupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProjectMockupsQuery, GetProjectMockupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProjectMockupsQuery, GetProjectMockupsQueryVariables>(GetProjectMockupsDocument, variables, options);
}
export type GetProjectMockupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProjectMockupsQuery, GetProjectMockupsQueryVariables>;
export const GetRegionalReportsDocument = gql`
    query getRegionalReports($filters: AnalyticsFiltersInput) {
  getRegionalReports(filters: $filters) {
    ...RegionalReportEntity
  }
}
    ${RegionalReportEntityFragmentDoc}`;

/**
 * __useGetRegionalReportsQuery__
 *
 * To run a query within a Vue component, call `useGetRegionalReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionalReportsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRegionalReportsQuery({
 *   filters: // value for 'filters'
 * });
 */
export function useGetRegionalReportsQuery(variables: GetRegionalReportsQueryVariables | VueCompositionApi.Ref<GetRegionalReportsQueryVariables> | ReactiveFunction<GetRegionalReportsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetRegionalReportsQuery, GetRegionalReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRegionalReportsQuery, GetRegionalReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRegionalReportsQuery, GetRegionalReportsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRegionalReportsQuery, GetRegionalReportsQueryVariables>(GetRegionalReportsDocument, variables, options);
}
export function useGetRegionalReportsLazyQuery(variables: GetRegionalReportsQueryVariables | VueCompositionApi.Ref<GetRegionalReportsQueryVariables> | ReactiveFunction<GetRegionalReportsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetRegionalReportsQuery, GetRegionalReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRegionalReportsQuery, GetRegionalReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRegionalReportsQuery, GetRegionalReportsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRegionalReportsQuery, GetRegionalReportsQueryVariables>(GetRegionalReportsDocument, variables, options);
}
export type GetRegionalReportsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRegionalReportsQuery, GetRegionalReportsQueryVariables>;
export const GetSystemMockupsDocument = gql`
    query getSystemMockups {
  getSystemMockups {
    id
    presignedUrl
    type
  }
}
    `;

/**
 * __useGetSystemMockupsQuery__
 *
 * To run a query within a Vue component, call `useGetSystemMockupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemMockupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSystemMockupsQuery();
 */
export function useGetSystemMockupsQuery(options: VueApolloComposable.UseQueryOptions<GetSystemMockupsQuery, GetSystemMockupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSystemMockupsQuery, GetSystemMockupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSystemMockupsQuery, GetSystemMockupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSystemMockupsQuery, GetSystemMockupsQueryVariables>(GetSystemMockupsDocument, {}, options);
}
export function useGetSystemMockupsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetSystemMockupsQuery, GetSystemMockupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSystemMockupsQuery, GetSystemMockupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSystemMockupsQuery, GetSystemMockupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSystemMockupsQuery, GetSystemMockupsQueryVariables>(GetSystemMockupsDocument, {}, options);
}
export type GetSystemMockupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSystemMockupsQuery, GetSystemMockupsQueryVariables>;
export const GetUserDetailedReportsDocument = gql`
    query getUserDetailedReports($filters: UserDetailedFiltersInput) {
  getUserDetailedReports(filters: $filters) {
    ...UserDetailedReportEntity
  }
}
    ${UserDetailedReportEntityFragmentDoc}`;

/**
 * __useGetUserDetailedReportsQuery__
 *
 * To run a query within a Vue component, call `useGetUserDetailedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailedReportsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserDetailedReportsQuery({
 *   filters: // value for 'filters'
 * });
 */
export function useGetUserDetailedReportsQuery(variables: GetUserDetailedReportsQueryVariables | VueCompositionApi.Ref<GetUserDetailedReportsQueryVariables> | ReactiveFunction<GetUserDetailedReportsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetUserDetailedReportsQuery, GetUserDetailedReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserDetailedReportsQuery, GetUserDetailedReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserDetailedReportsQuery, GetUserDetailedReportsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserDetailedReportsQuery, GetUserDetailedReportsQueryVariables>(GetUserDetailedReportsDocument, variables, options);
}
export function useGetUserDetailedReportsLazyQuery(variables: GetUserDetailedReportsQueryVariables | VueCompositionApi.Ref<GetUserDetailedReportsQueryVariables> | ReactiveFunction<GetUserDetailedReportsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetUserDetailedReportsQuery, GetUserDetailedReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserDetailedReportsQuery, GetUserDetailedReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserDetailedReportsQuery, GetUserDetailedReportsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserDetailedReportsQuery, GetUserDetailedReportsQueryVariables>(GetUserDetailedReportsDocument, variables, options);
}
export type GetUserDetailedReportsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserDetailedReportsQuery, GetUserDetailedReportsQueryVariables>;
export const GetUserTemplatesDocument = gql`
    query getUserTemplates($projectId: String) {
  getUserTemplates(projectId: $projectId) {
    id
    name
    label
    text
    content
    isGlobal
    category
    categoryLabel
    userId
    projectId
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetUserTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetUserTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserTemplatesQuery({
 *   projectId: // value for 'projectId'
 * });
 */
export function useGetUserTemplatesQuery(variables: GetUserTemplatesQueryVariables | VueCompositionApi.Ref<GetUserTemplatesQueryVariables> | ReactiveFunction<GetUserTemplatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetUserTemplatesQuery, GetUserTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserTemplatesQuery, GetUserTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserTemplatesQuery, GetUserTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserTemplatesQuery, GetUserTemplatesQueryVariables>(GetUserTemplatesDocument, variables, options);
}
export function useGetUserTemplatesLazyQuery(variables: GetUserTemplatesQueryVariables | VueCompositionApi.Ref<GetUserTemplatesQueryVariables> | ReactiveFunction<GetUserTemplatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetUserTemplatesQuery, GetUserTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserTemplatesQuery, GetUserTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserTemplatesQuery, GetUserTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserTemplatesQuery, GetUserTemplatesQueryVariables>(GetUserTemplatesDocument, variables, options);
}
export type GetUserTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserTemplatesQuery, GetUserTemplatesQueryVariables>;
export const MockupPresignedPutUrlDocument = gql`
    query mockupPresignedPutUrl($input: MockupPresignedPutUrlInput!) {
  mockupPresignedPutUrl(input: $input) {
    url
  }
}
    `;

/**
 * __useMockupPresignedPutUrlQuery__
 *
 * To run a query within a Vue component, call `useMockupPresignedPutUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMockupPresignedPutUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMockupPresignedPutUrlQuery({
 *   input: // value for 'input'
 * });
 */
export function useMockupPresignedPutUrlQuery(variables: MockupPresignedPutUrlQueryVariables | VueCompositionApi.Ref<MockupPresignedPutUrlQueryVariables> | ReactiveFunction<MockupPresignedPutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<MockupPresignedPutUrlQuery, MockupPresignedPutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MockupPresignedPutUrlQuery, MockupPresignedPutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MockupPresignedPutUrlQuery, MockupPresignedPutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MockupPresignedPutUrlQuery, MockupPresignedPutUrlQueryVariables>(MockupPresignedPutUrlDocument, variables, options);
}
export function useMockupPresignedPutUrlLazyQuery(variables?: MockupPresignedPutUrlQueryVariables | VueCompositionApi.Ref<MockupPresignedPutUrlQueryVariables> | ReactiveFunction<MockupPresignedPutUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<MockupPresignedPutUrlQuery, MockupPresignedPutUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MockupPresignedPutUrlQuery, MockupPresignedPutUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MockupPresignedPutUrlQuery, MockupPresignedPutUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MockupPresignedPutUrlQuery, MockupPresignedPutUrlQueryVariables>(MockupPresignedPutUrlDocument, variables, options);
}
export type MockupPresignedPutUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MockupPresignedPutUrlQuery, MockupPresignedPutUrlQueryVariables>;
export const CommonSupporterDocument = gql`
    query commonSupporter($id: ID!, $projectId: ID!) {
  registryContact(id: $id, projectId: $projectId) {
    id
    contactType
    projectId
    projectName
    displayName
    lastName
    firstName
    middleName
    phoneNumber
    email
    birthday
    birthdayMonthDay
    birthdayDay
    birthdayMonth
    gender
    comment
    region
    city
    cityDistrict
    settlement
    street
    flat
    postalCode
    fullAddress
    companyName
    companyInn
    companyKpp
    companyOgrn
    companyEmail
    companyPhone
    companyPosition
    userId
    memberRole
    holidayName
    holidayDate
    holidayMonthDay
    holidayDay
    holidayMonth
    createdAt
    updatedAt
    originalProjectId
    originalOwnerId
    hasPhone
    hasEmail
    hasAddress
    hasBirthday
    hasHoliday
  }
}
    `;

/**
 * __useCommonSupporterQuery__
 *
 * To run a query within a Vue component, call `useCommonSupporterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonSupporterQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCommonSupporterQuery({
 *   id: // value for 'id'
 *   projectId: // value for 'projectId'
 * });
 */
export function useCommonSupporterQuery(variables: CommonSupporterQueryVariables | VueCompositionApi.Ref<CommonSupporterQueryVariables> | ReactiveFunction<CommonSupporterQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommonSupporterQuery, CommonSupporterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommonSupporterQuery, CommonSupporterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommonSupporterQuery, CommonSupporterQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CommonSupporterQuery, CommonSupporterQueryVariables>(CommonSupporterDocument, variables, options);
}
export function useCommonSupporterLazyQuery(variables?: CommonSupporterQueryVariables | VueCompositionApi.Ref<CommonSupporterQueryVariables> | ReactiveFunction<CommonSupporterQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommonSupporterQuery, CommonSupporterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommonSupporterQuery, CommonSupporterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommonSupporterQuery, CommonSupporterQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CommonSupporterQuery, CommonSupporterQueryVariables>(CommonSupporterDocument, variables, options);
}
export type CommonSupporterQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CommonSupporterQuery, CommonSupporterQueryVariables>;
export const CommonSupportersDocument = gql`
    query commonSupporters($filter: RegistryFilterInput!) {
  registryContacts(filter: $filter) {
    totalCount
    nodes {
      id
      contactType
      projectId
      projectName
      displayName
      lastName
      firstName
      middleName
      phoneNumber
      email
      birthday
      birthdayMonthDay
      birthdayDay
      birthdayMonth
      gender
      comment
      region
      city
      cityDistrict
      settlement
      street
      flat
      postalCode
      fullAddress
      companyName
      companyInn
      companyKpp
      companyOgrn
      companyEmail
      companyPhone
      companyPosition
      userId
      memberRole
      holidayName
      holidayDate
      holidayMonthDay
      holidayDay
      holidayMonth
      createdAt
      updatedAt
      originalProjectId
      originalOwnerId
      hasPhone
      hasEmail
      hasAddress
      hasBirthday
      hasHoliday
    }
  }
}
    `;

/**
 * __useCommonSupportersQuery__
 *
 * To run a query within a Vue component, call `useCommonSupportersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonSupportersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCommonSupportersQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useCommonSupportersQuery(variables: CommonSupportersQueryVariables | VueCompositionApi.Ref<CommonSupportersQueryVariables> | ReactiveFunction<CommonSupportersQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommonSupportersQuery, CommonSupportersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommonSupportersQuery, CommonSupportersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommonSupportersQuery, CommonSupportersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CommonSupportersQuery, CommonSupportersQueryVariables>(CommonSupportersDocument, variables, options);
}
export function useCommonSupportersLazyQuery(variables?: CommonSupportersQueryVariables | VueCompositionApi.Ref<CommonSupportersQueryVariables> | ReactiveFunction<CommonSupportersQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommonSupportersQuery, CommonSupportersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommonSupportersQuery, CommonSupportersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommonSupportersQuery, CommonSupportersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CommonSupportersQuery, CommonSupportersQueryVariables>(CommonSupportersDocument, variables, options);
}
export type CommonSupportersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CommonSupportersQuery, CommonSupportersQueryVariables>;
export const ExportAllOrganizationsDocument = gql`
    query exportAllOrganizations($format: ProjectSupporterExportFormat!, $filter: ProjectOrganizationFilter, $sorting: [ProjectOrganizationSort!]) {
  exportAllOrganizations(format: $format, filter: $filter, sorting: $sorting)
}
    `;

/**
 * __useExportAllOrganizationsQuery__
 *
 * To run a query within a Vue component, call `useExportAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportAllOrganizationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportAllOrganizationsQuery({
 *   format: // value for 'format'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useExportAllOrganizationsQuery(variables: ExportAllOrganizationsQueryVariables | VueCompositionApi.Ref<ExportAllOrganizationsQueryVariables> | ReactiveFunction<ExportAllOrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportAllOrganizationsQuery, ExportAllOrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportAllOrganizationsQuery, ExportAllOrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportAllOrganizationsQuery, ExportAllOrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportAllOrganizationsQuery, ExportAllOrganizationsQueryVariables>(ExportAllOrganizationsDocument, variables, options);
}
export function useExportAllOrganizationsLazyQuery(variables?: ExportAllOrganizationsQueryVariables | VueCompositionApi.Ref<ExportAllOrganizationsQueryVariables> | ReactiveFunction<ExportAllOrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportAllOrganizationsQuery, ExportAllOrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportAllOrganizationsQuery, ExportAllOrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportAllOrganizationsQuery, ExportAllOrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportAllOrganizationsQuery, ExportAllOrganizationsQueryVariables>(ExportAllOrganizationsDocument, variables, options);
}
export type ExportAllOrganizationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportAllOrganizationsQuery, ExportAllOrganizationsQueryVariables>;
export const ExportAllSupportersDocument = gql`
    query exportAllSupporters($format: ProjectSupporterExportFormat!, $filter: ProjectSupporterFilter, $sorting: [ProjectSupporterSort!]) {
  exportAllSupporters(format: $format, filter: $filter, sorting: $sorting)
}
    `;

/**
 * __useExportAllSupportersQuery__
 *
 * To run a query within a Vue component, call `useExportAllSupportersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportAllSupportersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportAllSupportersQuery({
 *   format: // value for 'format'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useExportAllSupportersQuery(variables: ExportAllSupportersQueryVariables | VueCompositionApi.Ref<ExportAllSupportersQueryVariables> | ReactiveFunction<ExportAllSupportersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportAllSupportersQuery, ExportAllSupportersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportAllSupportersQuery, ExportAllSupportersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportAllSupportersQuery, ExportAllSupportersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportAllSupportersQuery, ExportAllSupportersQueryVariables>(ExportAllSupportersDocument, variables, options);
}
export function useExportAllSupportersLazyQuery(variables?: ExportAllSupportersQueryVariables | VueCompositionApi.Ref<ExportAllSupportersQueryVariables> | ReactiveFunction<ExportAllSupportersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportAllSupportersQuery, ExportAllSupportersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportAllSupportersQuery, ExportAllSupportersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportAllSupportersQuery, ExportAllSupportersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportAllSupportersQuery, ExportAllSupportersQueryVariables>(ExportAllSupportersDocument, variables, options);
}
export type ExportAllSupportersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportAllSupportersQuery, ExportAllSupportersQueryVariables>;
export const GetIncomingMergeRequestsDocument = gql`
    query getIncomingMergeRequests($input: GetMergeRequestsDTO!) {
  requests: getIncomingMergeRequests(input: $input) {
    id
    fromProject {
      id
      name
      media {
        image {
          DESKTOP {
            LIST
          }
        }
      }
    }
    requestedByUser {
      id
      firstName
      lastName
      patronymic
    }
    selectedSupporterIds
    state
  }
}
    `;

/**
 * __useGetIncomingMergeRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetIncomingMergeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomingMergeRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIncomingMergeRequestsQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetIncomingMergeRequestsQuery(variables: GetIncomingMergeRequestsQueryVariables | VueCompositionApi.Ref<GetIncomingMergeRequestsQueryVariables> | ReactiveFunction<GetIncomingMergeRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIncomingMergeRequestsQuery, GetIncomingMergeRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIncomingMergeRequestsQuery, GetIncomingMergeRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIncomingMergeRequestsQuery, GetIncomingMergeRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetIncomingMergeRequestsQuery, GetIncomingMergeRequestsQueryVariables>(GetIncomingMergeRequestsDocument, variables, options);
}
export function useGetIncomingMergeRequestsLazyQuery(variables?: GetIncomingMergeRequestsQueryVariables | VueCompositionApi.Ref<GetIncomingMergeRequestsQueryVariables> | ReactiveFunction<GetIncomingMergeRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIncomingMergeRequestsQuery, GetIncomingMergeRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIncomingMergeRequestsQuery, GetIncomingMergeRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIncomingMergeRequestsQuery, GetIncomingMergeRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetIncomingMergeRequestsQuery, GetIncomingMergeRequestsQueryVariables>(GetIncomingMergeRequestsDocument, variables, options);
}
export type GetIncomingMergeRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetIncomingMergeRequestsQuery, GetIncomingMergeRequestsQueryVariables>;
export const GetSupportersMetaDocument = gql`
    query getSupportersMeta($input: GetProjectSupporterOwnersInput!) {
  lists: getSupportersMeta(input: $input) {
    owners {
      owner {
        id
        firstName
        lastName
        isOrigin
      }
    }
    originProjects {
      id
      name
    }
    project {
      id
      name
    }
  }
}
    `;

/**
 * __useGetSupportersMetaQuery__
 *
 * To run a query within a Vue component, call `useGetSupportersMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportersMetaQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSupportersMetaQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetSupportersMetaQuery(variables: GetSupportersMetaQueryVariables | VueCompositionApi.Ref<GetSupportersMetaQueryVariables> | ReactiveFunction<GetSupportersMetaQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSupportersMetaQuery, GetSupportersMetaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSupportersMetaQuery, GetSupportersMetaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSupportersMetaQuery, GetSupportersMetaQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSupportersMetaQuery, GetSupportersMetaQueryVariables>(GetSupportersMetaDocument, variables, options);
}
export function useGetSupportersMetaLazyQuery(variables?: GetSupportersMetaQueryVariables | VueCompositionApi.Ref<GetSupportersMetaQueryVariables> | ReactiveFunction<GetSupportersMetaQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSupportersMetaQuery, GetSupportersMetaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSupportersMetaQuery, GetSupportersMetaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSupportersMetaQuery, GetSupportersMetaQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSupportersMetaQuery, GetSupportersMetaQueryVariables>(GetSupportersMetaDocument, variables, options);
}
export type GetSupportersMetaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSupportersMetaQuery, GetSupportersMetaQueryVariables>;
export const ProjectOrganizationDocument = gql`
    query projectOrganization($id: ID!) {
  item: projectOrganization(id: $id) {
    id
    companyName
    companyShortName
    companyEmail
    companyPhone
    companyInn
    companyKpp
    companyOgrn
    lastName
    firstName
    middleName
    companyPosition
    email
    phoneNumber
    companyRegion
    companyCity
    companyCityDistrict
    companySettlement
    companyStreet
    companyFlat
    companyAddressComment
    holidayName
    holidayDate
  }
}
    `;

/**
 * __useProjectOrganizationQuery__
 *
 * To run a query within a Vue component, call `useProjectOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOrganizationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectOrganizationQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectOrganizationQuery(variables: ProjectOrganizationQueryVariables | VueCompositionApi.Ref<ProjectOrganizationQueryVariables> | ReactiveFunction<ProjectOrganizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectOrganizationQuery, ProjectOrganizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectOrganizationQuery, ProjectOrganizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectOrganizationQuery, ProjectOrganizationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectOrganizationQuery, ProjectOrganizationQueryVariables>(ProjectOrganizationDocument, variables, options);
}
export function useProjectOrganizationLazyQuery(variables?: ProjectOrganizationQueryVariables | VueCompositionApi.Ref<ProjectOrganizationQueryVariables> | ReactiveFunction<ProjectOrganizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectOrganizationQuery, ProjectOrganizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectOrganizationQuery, ProjectOrganizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectOrganizationQuery, ProjectOrganizationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectOrganizationQuery, ProjectOrganizationQueryVariables>(ProjectOrganizationDocument, variables, options);
}
export type ProjectOrganizationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectOrganizationQuery, ProjectOrganizationQueryVariables>;
export const ProjectOrganizationsDocument = gql`
    query projectOrganizations($paging: OffsetPaging! = {limit: 9999}, $filter: ProjectOrganizationFilter! = {}, $sorting: [ProjectOrganizationSort!]! = [{field: companyName, direction: ASC}]) {
  list: projectOrganizations(paging: $paging, filter: $filter, sorting: $sorting) {
    totalCount
    nodes {
      id
      companyName
      companyShortName
      companyEmail
      companyPhone
      companyInn
      companyKpp
      companyOgrn
      lastName
      firstName
      middleName
      companyPosition
      email
      phoneNumber
      companyPostalCode
      companyRegion
      companyCity
      companyCityDistrict
      companySettlement
      companyStreet
      companyFlat
      companyAddressComment
      holidayName
      holidayDate
      project {
        nodes {
          id
          name
          owner {
            id
            firstName
            lastName
            patronymic
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProjectOrganizationsQuery__
 *
 * To run a query within a Vue component, call `useProjectOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOrganizationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectOrganizationsQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useProjectOrganizationsQuery(variables: ProjectOrganizationsQueryVariables | VueCompositionApi.Ref<ProjectOrganizationsQueryVariables> | ReactiveFunction<ProjectOrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectOrganizationsQuery, ProjectOrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectOrganizationsQuery, ProjectOrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectOrganizationsQuery, ProjectOrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectOrganizationsQuery, ProjectOrganizationsQueryVariables>(ProjectOrganizationsDocument, variables, options);
}
export function useProjectOrganizationsLazyQuery(variables?: ProjectOrganizationsQueryVariables | VueCompositionApi.Ref<ProjectOrganizationsQueryVariables> | ReactiveFunction<ProjectOrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectOrganizationsQuery, ProjectOrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectOrganizationsQuery, ProjectOrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectOrganizationsQuery, ProjectOrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectOrganizationsQuery, ProjectOrganizationsQueryVariables>(ProjectOrganizationsDocument, variables, options);
}
export type ProjectOrganizationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectOrganizationsQuery, ProjectOrganizationsQueryVariables>;
export const ProjectOrganizationsIdsDocument = gql`
    query projectOrganizationsIds($paging: OffsetPaging! = {limit: 9999}, $filter: ProjectOrganizationFilter! = {}, $sorting: [ProjectOrganizationSort!]! = []) {
  projectOrganizations(paging: $paging, filter: $filter, sorting: $sorting) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useProjectOrganizationsIdsQuery__
 *
 * To run a query within a Vue component, call `useProjectOrganizationsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOrganizationsIdsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectOrganizationsIdsQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useProjectOrganizationsIdsQuery(variables: ProjectOrganizationsIdsQueryVariables | VueCompositionApi.Ref<ProjectOrganizationsIdsQueryVariables> | ReactiveFunction<ProjectOrganizationsIdsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectOrganizationsIdsQuery, ProjectOrganizationsIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectOrganizationsIdsQuery, ProjectOrganizationsIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectOrganizationsIdsQuery, ProjectOrganizationsIdsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectOrganizationsIdsQuery, ProjectOrganizationsIdsQueryVariables>(ProjectOrganizationsIdsDocument, variables, options);
}
export function useProjectOrganizationsIdsLazyQuery(variables?: ProjectOrganizationsIdsQueryVariables | VueCompositionApi.Ref<ProjectOrganizationsIdsQueryVariables> | ReactiveFunction<ProjectOrganizationsIdsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectOrganizationsIdsQuery, ProjectOrganizationsIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectOrganizationsIdsQuery, ProjectOrganizationsIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectOrganizationsIdsQuery, ProjectOrganizationsIdsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectOrganizationsIdsQuery, ProjectOrganizationsIdsQueryVariables>(ProjectOrganizationsIdsDocument, variables, options);
}
export type ProjectOrganizationsIdsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectOrganizationsIdsQuery, ProjectOrganizationsIdsQueryVariables>;
export const ProjectSupportersDocument = gql`
    query projectSupporters($paging: OffsetPaging! = {limit: 10}, $filter: ProjectSupporterFilter! = {}, $sorting: [ProjectSupporterSort!]! = []) {
  projectSupporters(paging: $paging, filter: $filter, sorting: $sorting) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      id
      ...ProjectSupporterFields
      project {
        nodes {
          id
          name
          owner {
            id
            firstName
            lastName
            patronymic
          }
        }
      }
      originalOwner {
        id
        firstName
        lastName
        patronymic
      }
      originalProject {
        id
        name
      }
    }
    totalCount
  }
}
    ${ProjectSupporterFieldsFragmentDoc}`;

/**
 * __useProjectSupportersQuery__
 *
 * To run a query within a Vue component, call `useProjectSupportersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSupportersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectSupportersQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useProjectSupportersQuery(variables: ProjectSupportersQueryVariables | VueCompositionApi.Ref<ProjectSupportersQueryVariables> | ReactiveFunction<ProjectSupportersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectSupportersQuery, ProjectSupportersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectSupportersQuery, ProjectSupportersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectSupportersQuery, ProjectSupportersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectSupportersQuery, ProjectSupportersQueryVariables>(ProjectSupportersDocument, variables, options);
}
export function useProjectSupportersLazyQuery(variables?: ProjectSupportersQueryVariables | VueCompositionApi.Ref<ProjectSupportersQueryVariables> | ReactiveFunction<ProjectSupportersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectSupportersQuery, ProjectSupportersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectSupportersQuery, ProjectSupportersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectSupportersQuery, ProjectSupportersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectSupportersQuery, ProjectSupportersQueryVariables>(ProjectSupportersDocument, variables, options);
}
export type ProjectSupportersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectSupportersQuery, ProjectSupportersQueryVariables>;
export const ProjectSupportersIdsDocument = gql`
    query projectSupportersIds($paging: OffsetPaging! = {limit: 9999}, $filter: ProjectSupporterFilter! = {}, $sorting: [ProjectSupporterSort!]! = []) {
  projectSupporters(paging: $paging, filter: $filter, sorting: $sorting) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useProjectSupportersIdsQuery__
 *
 * To run a query within a Vue component, call `useProjectSupportersIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSupportersIdsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectSupportersIdsQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useProjectSupportersIdsQuery(variables: ProjectSupportersIdsQueryVariables | VueCompositionApi.Ref<ProjectSupportersIdsQueryVariables> | ReactiveFunction<ProjectSupportersIdsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectSupportersIdsQuery, ProjectSupportersIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectSupportersIdsQuery, ProjectSupportersIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectSupportersIdsQuery, ProjectSupportersIdsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectSupportersIdsQuery, ProjectSupportersIdsQueryVariables>(ProjectSupportersIdsDocument, variables, options);
}
export function useProjectSupportersIdsLazyQuery(variables?: ProjectSupportersIdsQueryVariables | VueCompositionApi.Ref<ProjectSupportersIdsQueryVariables> | ReactiveFunction<ProjectSupportersIdsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectSupportersIdsQuery, ProjectSupportersIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectSupportersIdsQuery, ProjectSupportersIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectSupportersIdsQuery, ProjectSupportersIdsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectSupportersIdsQuery, ProjectSupportersIdsQueryVariables>(ProjectSupportersIdsDocument, variables, options);
}
export type ProjectSupportersIdsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectSupportersIdsQuery, ProjectSupportersIdsQueryVariables>;
export const RegistryContactsCountDocument = gql`
    query registryContactsCount($filter: RegistryFilterInput!) {
  registryContacts(filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useRegistryContactsCountQuery__
 *
 * To run a query within a Vue component, call `useRegistryContactsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryContactsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRegistryContactsCountQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useRegistryContactsCountQuery(variables: RegistryContactsCountQueryVariables | VueCompositionApi.Ref<RegistryContactsCountQueryVariables> | ReactiveFunction<RegistryContactsCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegistryContactsCountQuery, RegistryContactsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegistryContactsCountQuery, RegistryContactsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegistryContactsCountQuery, RegistryContactsCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RegistryContactsCountQuery, RegistryContactsCountQueryVariables>(RegistryContactsCountDocument, variables, options);
}
export function useRegistryContactsCountLazyQuery(variables?: RegistryContactsCountQueryVariables | VueCompositionApi.Ref<RegistryContactsCountQueryVariables> | ReactiveFunction<RegistryContactsCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegistryContactsCountQuery, RegistryContactsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegistryContactsCountQuery, RegistryContactsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegistryContactsCountQuery, RegistryContactsCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RegistryContactsCountQuery, RegistryContactsCountQueryVariables>(RegistryContactsCountDocument, variables, options);
}
export type RegistryContactsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RegistryContactsCountQuery, RegistryContactsCountQueryVariables>;
export const RegistryContactsIdsDocument = gql`
    query registryContactsIds($filter: RegistryFilterInput!) {
  registryContacts(filter: $filter) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useRegistryContactsIdsQuery__
 *
 * To run a query within a Vue component, call `useRegistryContactsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryContactsIdsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRegistryContactsIdsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useRegistryContactsIdsQuery(variables: RegistryContactsIdsQueryVariables | VueCompositionApi.Ref<RegistryContactsIdsQueryVariables> | ReactiveFunction<RegistryContactsIdsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegistryContactsIdsQuery, RegistryContactsIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegistryContactsIdsQuery, RegistryContactsIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegistryContactsIdsQuery, RegistryContactsIdsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RegistryContactsIdsQuery, RegistryContactsIdsQueryVariables>(RegistryContactsIdsDocument, variables, options);
}
export function useRegistryContactsIdsLazyQuery(variables?: RegistryContactsIdsQueryVariables | VueCompositionApi.Ref<RegistryContactsIdsQueryVariables> | ReactiveFunction<RegistryContactsIdsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegistryContactsIdsQuery, RegistryContactsIdsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegistryContactsIdsQuery, RegistryContactsIdsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegistryContactsIdsQuery, RegistryContactsIdsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RegistryContactsIdsQuery, RegistryContactsIdsQueryVariables>(RegistryContactsIdsDocument, variables, options);
}
export type RegistryContactsIdsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RegistryContactsIdsQuery, RegistryContactsIdsQueryVariables>;
export const RegistryContactsMembersDocument = gql`
    query registryContactsMembers($filter: RegistryFilterInput!) {
  registryContacts(filter: $filter) {
    totalCount
    nodes {
      id
      contactType
      displayName
      lastName
      firstName
      middleName
    }
  }
}
    `;

/**
 * __useRegistryContactsMembersQuery__
 *
 * To run a query within a Vue component, call `useRegistryContactsMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryContactsMembersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRegistryContactsMembersQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useRegistryContactsMembersQuery(variables: RegistryContactsMembersQueryVariables | VueCompositionApi.Ref<RegistryContactsMembersQueryVariables> | ReactiveFunction<RegistryContactsMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegistryContactsMembersQuery, RegistryContactsMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegistryContactsMembersQuery, RegistryContactsMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegistryContactsMembersQuery, RegistryContactsMembersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RegistryContactsMembersQuery, RegistryContactsMembersQueryVariables>(RegistryContactsMembersDocument, variables, options);
}
export function useRegistryContactsMembersLazyQuery(variables?: RegistryContactsMembersQueryVariables | VueCompositionApi.Ref<RegistryContactsMembersQueryVariables> | ReactiveFunction<RegistryContactsMembersQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegistryContactsMembersQuery, RegistryContactsMembersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegistryContactsMembersQuery, RegistryContactsMembersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegistryContactsMembersQuery, RegistryContactsMembersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RegistryContactsMembersQuery, RegistryContactsMembersQueryVariables>(RegistryContactsMembersDocument, variables, options);
}
export type RegistryContactsMembersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RegistryContactsMembersQuery, RegistryContactsMembersQueryVariables>;
export const QuestionDtosDocument = gql`
    query questionDtos($paging: OffsetPaging! = {limit: 9999}, $filter: QuestionDtoFilter! = {}, $sorting: [QuestionDtoSort!]! = [{field: order, direction: ASC}]) {
  questionDtos(paging: $paging, filter: $filter, sorting: $sorting) {
    nodes {
      id
      title
      description
      order
      isRequired
      answers {
        respondent {
          firstName
          lastName
          media {
            avatar {
              DESKTOP {
                PROFILE
              }
            }
          }
        }
        value {
          fieldId
          fieldType
          result
        }
      }
      fields {
        id
        type
        order
        value
        options
        metadata
        answerValidationType
      }
    }
  }
}
    `;

/**
 * __useQuestionDtosQuery__
 *
 * To run a query within a Vue component, call `useQuestionDtosQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionDtosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuestionDtosQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useQuestionDtosQuery(variables: QuestionDtosQueryVariables | VueCompositionApi.Ref<QuestionDtosQueryVariables> | ReactiveFunction<QuestionDtosQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuestionDtosQuery, QuestionDtosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuestionDtosQuery, QuestionDtosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuestionDtosQuery, QuestionDtosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QuestionDtosQuery, QuestionDtosQueryVariables>(QuestionDtosDocument, variables, options);
}
export function useQuestionDtosLazyQuery(variables?: QuestionDtosQueryVariables | VueCompositionApi.Ref<QuestionDtosQueryVariables> | ReactiveFunction<QuestionDtosQueryVariables>, options: VueApolloComposable.UseQueryOptions<QuestionDtosQuery, QuestionDtosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QuestionDtosQuery, QuestionDtosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QuestionDtosQuery, QuestionDtosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QuestionDtosQuery, QuestionDtosQueryVariables>(QuestionDtosDocument, variables, options);
}
export type QuestionDtosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QuestionDtosQuery, QuestionDtosQueryVariables>;
export const SurveyDocument = gql`
    query survey($id: ID!) {
  detail: surveyDtos(paging: {limit: 1}, filter: {id: {eq: $id}}) {
    nodes {
      id
      title
      description
      status
      publishedAt
      createdByUserId
      updatedByUserId
      projectId
      publicLinkEnabled
      visibleToProjectAdmins
      visibleToProjectMembers
      responseDeadline
      allowMultipleResponses
      questions {
        nodes {
          id
          title
          order
          isRequired
          fields {
            id
            type
            order
            value
            options
            metadata
            answerValidationType
          }
        }
      }
      createdBy {
        firstName
        lastName
        media {
          avatar {
            DESKTOP {
              PROFILE
            }
          }
        }
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useSurveyQuery__
 *
 * To run a query within a Vue component, call `useSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSurveyQuery({
 *   id: // value for 'id'
 * });
 */
export function useSurveyQuery(variables: SurveyQueryVariables | VueCompositionApi.Ref<SurveyQueryVariables> | ReactiveFunction<SurveyQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyQuery, SurveyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyQuery, SurveyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyQuery, SurveyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, variables, options);
}
export function useSurveyLazyQuery(variables?: SurveyQueryVariables | VueCompositionApi.Ref<SurveyQueryVariables> | ReactiveFunction<SurveyQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyQuery, SurveyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyQuery, SurveyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyQuery, SurveyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, variables, options);
}
export type SurveyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SurveyQuery, SurveyQueryVariables>;
export const SurveyDtosDocument = gql`
    query surveyDtos($paging: OffsetPaging! = {limit: 10}, $filter: SurveyDtoFilter! = {}, $sorting: [SurveyDtoSort!]! = [{field: createdAt, direction: DESC}]) {
  surveyDtos(paging: $paging, filter: $filter, sorting: $sorting) {
    nodes {
      id
      title
      description
      status
      publishedAt
      createdByUserId
      updatedByUserId
      projectId
      publicLinkEnabled
      visibleToProjectAdmins
      visibleToProjectMembers
      responseDeadline
      allowMultipleResponses
      questions {
        nodes {
          id
          title
          order
          isRequired
          fields {
            id
            type
            order
            value
            options
            metadata
            answerValidationType
          }
        }
      }
      createdBy {
        firstName
        lastName
        media {
          avatar {
            DESKTOP {
              PROFILE
            }
          }
        }
      }
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

/**
 * __useSurveyDtosQuery__
 *
 * To run a query within a Vue component, call `useSurveyDtosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyDtosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSurveyDtosQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 *   sorting: // value for 'sorting'
 * });
 */
export function useSurveyDtosQuery(variables: SurveyDtosQueryVariables | VueCompositionApi.Ref<SurveyDtosQueryVariables> | ReactiveFunction<SurveyDtosQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyDtosQuery, SurveyDtosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyDtosQuery, SurveyDtosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyDtosQuery, SurveyDtosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SurveyDtosQuery, SurveyDtosQueryVariables>(SurveyDtosDocument, variables, options);
}
export function useSurveyDtosLazyQuery(variables?: SurveyDtosQueryVariables | VueCompositionApi.Ref<SurveyDtosQueryVariables> | ReactiveFunction<SurveyDtosQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyDtosQuery, SurveyDtosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyDtosQuery, SurveyDtosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyDtosQuery, SurveyDtosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SurveyDtosQuery, SurveyDtosQueryVariables>(SurveyDtosDocument, variables, options);
}
export type SurveyDtosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SurveyDtosQuery, SurveyDtosQueryVariables>;
export const SurveyInvitesDocument = gql`
    query surveyInvites($surveyId: String!) {
  surveyInvites(surveyId: $surveyId) {
    id
  }
}
    `;

/**
 * __useSurveyInvitesQuery__
 *
 * To run a query within a Vue component, call `useSurveyInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyInvitesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSurveyInvitesQuery({
 *   surveyId: // value for 'surveyId'
 * });
 */
export function useSurveyInvitesQuery(variables: SurveyInvitesQueryVariables | VueCompositionApi.Ref<SurveyInvitesQueryVariables> | ReactiveFunction<SurveyInvitesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyInvitesQuery, SurveyInvitesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyInvitesQuery, SurveyInvitesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyInvitesQuery, SurveyInvitesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SurveyInvitesQuery, SurveyInvitesQueryVariables>(SurveyInvitesDocument, variables, options);
}
export function useSurveyInvitesLazyQuery(variables?: SurveyInvitesQueryVariables | VueCompositionApi.Ref<SurveyInvitesQueryVariables> | ReactiveFunction<SurveyInvitesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyInvitesQuery, SurveyInvitesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyInvitesQuery, SurveyInvitesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyInvitesQuery, SurveyInvitesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SurveyInvitesQuery, SurveyInvitesQueryVariables>(SurveyInvitesDocument, variables, options);
}
export type SurveyInvitesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SurveyInvitesQuery, SurveyInvitesQueryVariables>;
export const SurveyParticipantsDocument = gql`
    query surveyParticipants($filter: SurveyParticipantsFilterDto!) {
  surveyParticipants(filter: $filter) {
    userId
    user {
      id
      firstName
      lastName
      media {
        avatar {
          DESKTOP {
            PROFILE
          }
        }
      }
    }
    completedResponsesCount
    firstResponseAt
    lastResponseAt
    responseIds
  }
}
    `;

/**
 * __useSurveyParticipantsQuery__
 *
 * To run a query within a Vue component, call `useSurveyParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyParticipantsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSurveyParticipantsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useSurveyParticipantsQuery(variables: SurveyParticipantsQueryVariables | VueCompositionApi.Ref<SurveyParticipantsQueryVariables> | ReactiveFunction<SurveyParticipantsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyParticipantsQuery, SurveyParticipantsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>(SurveyParticipantsDocument, variables, options);
}
export function useSurveyParticipantsLazyQuery(variables?: SurveyParticipantsQueryVariables | VueCompositionApi.Ref<SurveyParticipantsQueryVariables> | ReactiveFunction<SurveyParticipantsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyParticipantsQuery, SurveyParticipantsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>(SurveyParticipantsDocument, variables, options);
}
export type SurveyParticipantsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>;
export const SurveyPublicDocument = gql`
    query surveyPublic($surveyId: String!, $inviteToken: String) {
  surveyPublic(surveyId: $surveyId, inviteToken: $inviteToken) {
    id
    title
    description
    status
    publishedAt
    allowAnonymous
    questions {
      id
      title
      order
      isRequired
      fields {
        id
        type
        order
        value
        options
        metadata
        answerValidationType
      }
    }
  }
}
    `;

/**
 * __useSurveyPublicQuery__
 *
 * To run a query within a Vue component, call `useSurveyPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyPublicQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSurveyPublicQuery({
 *   surveyId: // value for 'surveyId'
 *   inviteToken: // value for 'inviteToken'
 * });
 */
export function useSurveyPublicQuery(variables: SurveyPublicQueryVariables | VueCompositionApi.Ref<SurveyPublicQueryVariables> | ReactiveFunction<SurveyPublicQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyPublicQuery, SurveyPublicQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyPublicQuery, SurveyPublicQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyPublicQuery, SurveyPublicQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SurveyPublicQuery, SurveyPublicQueryVariables>(SurveyPublicDocument, variables, options);
}
export function useSurveyPublicLazyQuery(variables?: SurveyPublicQueryVariables | VueCompositionApi.Ref<SurveyPublicQueryVariables> | ReactiveFunction<SurveyPublicQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyPublicQuery, SurveyPublicQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyPublicQuery, SurveyPublicQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyPublicQuery, SurveyPublicQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SurveyPublicQuery, SurveyPublicQueryVariables>(SurveyPublicDocument, variables, options);
}
export type SurveyPublicQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SurveyPublicQuery, SurveyPublicQueryVariables>;
export const SurveyPublicLinkDocument = gql`
    query surveyPublicLink($surveyId: String!) {
  surveyPublicLink(surveyId: $surveyId)
}
    `;

/**
 * __useSurveyPublicLinkQuery__
 *
 * To run a query within a Vue component, call `useSurveyPublicLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyPublicLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSurveyPublicLinkQuery({
 *   surveyId: // value for 'surveyId'
 * });
 */
export function useSurveyPublicLinkQuery(variables: SurveyPublicLinkQueryVariables | VueCompositionApi.Ref<SurveyPublicLinkQueryVariables> | ReactiveFunction<SurveyPublicLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyPublicLinkQuery, SurveyPublicLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyPublicLinkQuery, SurveyPublicLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyPublicLinkQuery, SurveyPublicLinkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SurveyPublicLinkQuery, SurveyPublicLinkQueryVariables>(SurveyPublicLinkDocument, variables, options);
}
export function useSurveyPublicLinkLazyQuery(variables?: SurveyPublicLinkQueryVariables | VueCompositionApi.Ref<SurveyPublicLinkQueryVariables> | ReactiveFunction<SurveyPublicLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyPublicLinkQuery, SurveyPublicLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyPublicLinkQuery, SurveyPublicLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyPublicLinkQuery, SurveyPublicLinkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SurveyPublicLinkQuery, SurveyPublicLinkQueryVariables>(SurveyPublicLinkDocument, variables, options);
}
export type SurveyPublicLinkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SurveyPublicLinkQuery, SurveyPublicLinkQueryVariables>;
export const SurveyStatsDocument = gql`
    query surveyStats($surveyId: String!) {
  surveyStats(surveyId: $surveyId) {
    surveyId
    totalResponses
    submittedResponses
    draftResponses
    questionStats
    updatedAt
  }
}
    `;

/**
 * __useSurveyStatsQuery__
 *
 * To run a query within a Vue component, call `useSurveyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSurveyStatsQuery({
 *   surveyId: // value for 'surveyId'
 * });
 */
export function useSurveyStatsQuery(variables: SurveyStatsQueryVariables | VueCompositionApi.Ref<SurveyStatsQueryVariables> | ReactiveFunction<SurveyStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyStatsQuery, SurveyStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyStatsQuery, SurveyStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyStatsQuery, SurveyStatsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SurveyStatsQuery, SurveyStatsQueryVariables>(SurveyStatsDocument, variables, options);
}
export function useSurveyStatsLazyQuery(variables?: SurveyStatsQueryVariables | VueCompositionApi.Ref<SurveyStatsQueryVariables> | ReactiveFunction<SurveyStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SurveyStatsQuery, SurveyStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SurveyStatsQuery, SurveyStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SurveyStatsQuery, SurveyStatsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SurveyStatsQuery, SurveyStatsQueryVariables>(SurveyStatsDocument, variables, options);
}
export type SurveyStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SurveyStatsQuery, SurveyStatsQueryVariables>;
export const UserCompletedSurveysDocument = gql`
    query userCompletedSurveys($userId: String) {
  userCompletedSurveys(userId: $userId) {
    surveyId
    survey {
      id
      title
      description
      status
      createdAt
      updatedAt
    }
    responseId
    completedAt
    responsesCount
  }
}
    `;

/**
 * __useUserCompletedSurveysQuery__
 *
 * To run a query within a Vue component, call `useUserCompletedSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompletedSurveysQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserCompletedSurveysQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useUserCompletedSurveysQuery(variables: UserCompletedSurveysQueryVariables | VueCompositionApi.Ref<UserCompletedSurveysQueryVariables> | ReactiveFunction<UserCompletedSurveysQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UserCompletedSurveysQuery, UserCompletedSurveysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserCompletedSurveysQuery, UserCompletedSurveysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserCompletedSurveysQuery, UserCompletedSurveysQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserCompletedSurveysQuery, UserCompletedSurveysQueryVariables>(UserCompletedSurveysDocument, variables, options);
}
export function useUserCompletedSurveysLazyQuery(variables: UserCompletedSurveysQueryVariables | VueCompositionApi.Ref<UserCompletedSurveysQueryVariables> | ReactiveFunction<UserCompletedSurveysQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UserCompletedSurveysQuery, UserCompletedSurveysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserCompletedSurveysQuery, UserCompletedSurveysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserCompletedSurveysQuery, UserCompletedSurveysQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserCompletedSurveysQuery, UserCompletedSurveysQueryVariables>(UserCompletedSurveysDocument, variables, options);
}
export type UserCompletedSurveysQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserCompletedSurveysQuery, UserCompletedSurveysQueryVariables>;
export const UserSurveyResponseDocument = gql`
    query userSurveyResponse($surveyId: String!, $userId: String!) {
  userSurveyResponse(surveyId: $surveyId, userId: $userId) {
    id
    status
    submittedAt
    createdAt
    respondent {
      id
      firstName
      lastName
      media {
        avatar {
          DESKTOP {
            PROFILE
          }
        }
      }
    }
    answers {
      id
      questionId
      value
    }
    survey {
      id
      title
      description
      questions {
        nodes {
          id
          title
          description
          order
          isRequired
          fields {
            id
            type
            order
            value
            options
            metadata
            answerValidationType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserSurveyResponseQuery__
 *
 * To run a query within a Vue component, call `useUserSurveyResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSurveyResponseQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserSurveyResponseQuery({
 *   surveyId: // value for 'surveyId'
 *   userId: // value for 'userId'
 * });
 */
export function useUserSurveyResponseQuery(variables: UserSurveyResponseQueryVariables | VueCompositionApi.Ref<UserSurveyResponseQueryVariables> | ReactiveFunction<UserSurveyResponseQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserSurveyResponseQuery, UserSurveyResponseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserSurveyResponseQuery, UserSurveyResponseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserSurveyResponseQuery, UserSurveyResponseQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserSurveyResponseQuery, UserSurveyResponseQueryVariables>(UserSurveyResponseDocument, variables, options);
}
export function useUserSurveyResponseLazyQuery(variables?: UserSurveyResponseQueryVariables | VueCompositionApi.Ref<UserSurveyResponseQueryVariables> | ReactiveFunction<UserSurveyResponseQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserSurveyResponseQuery, UserSurveyResponseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserSurveyResponseQuery, UserSurveyResponseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserSurveyResponseQuery, UserSurveyResponseQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserSurveyResponseQuery, UserSurveyResponseQueryVariables>(UserSurveyResponseDocument, variables, options);
}
export type UserSurveyResponseQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserSurveyResponseQuery, UserSurveyResponseQueryVariables>;
export const UserMeDocument = gql`
    query userMe {
  me {
    ...UserFields
    profileChanges {
      id
      userId
      user {
        ...UserFields
      }
      fieldName
      oldValue
      newValue
      status
      adminUserId
      createdAt
      updatedAt
    }
    media {
      avatar {
        DESKTOP {
          PROFILE
        }
      }
    }
    addresses {
      ...UserAddressFields
    }
    createdAt
    updatedAt
  }
}
    ${UserFieldsFragmentDoc}
${UserAddressFieldsFragmentDoc}`;

/**
 * __useUserMeQuery__
 *
 * To run a query within a Vue component, call `useUserMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserMeQuery();
 */
export function useUserMeQuery(options: VueApolloComposable.UseQueryOptions<UserMeQuery, UserMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserMeQuery, UserMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserMeQuery, UserMeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, {}, options);
}
export function useUserMeLazyQuery(options: VueApolloComposable.UseQueryOptions<UserMeQuery, UserMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserMeQuery, UserMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserMeQuery, UserMeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, {}, options);
}
export type UserMeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserMeQuery, UserMeQueryVariables>;
export const UserAuthorDocument = gql`
    query userAuthor($id: String!) {
  user(id: $id) {
    firstName
    lastName
    nickname
    dateOfBirth
    addresses {
      city
    }
    media {
      avatar {
        DESKTOP {
          FRIENDS_MINI_AVATAR
        }
      }
    }
  }
}
    `;

/**
 * __useUserAuthorQuery__
 *
 * To run a query within a Vue component, call `useUserAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAuthorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAuthorQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserAuthorQuery(variables: UserAuthorQueryVariables | VueCompositionApi.Ref<UserAuthorQueryVariables> | ReactiveFunction<UserAuthorQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAuthorQuery, UserAuthorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAuthorQuery, UserAuthorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAuthorQuery, UserAuthorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAuthorQuery, UserAuthorQueryVariables>(UserAuthorDocument, variables, options);
}
export function useUserAuthorLazyQuery(variables?: UserAuthorQueryVariables | VueCompositionApi.Ref<UserAuthorQueryVariables> | ReactiveFunction<UserAuthorQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAuthorQuery, UserAuthorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAuthorQuery, UserAuthorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAuthorQuery, UserAuthorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAuthorQuery, UserAuthorQueryVariables>(UserAuthorDocument, variables, options);
}
export type UserAuthorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAuthorQuery, UserAuthorQueryVariables>;
export const WorkspaceMeDocument = gql`
    query workspaceMe {
  me {
    firstName
    lastName
    nickname
    email
  }
}
    `;

/**
 * __useWorkspaceMeQuery__
 *
 * To run a query within a Vue component, call `useWorkspaceMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWorkspaceMeQuery();
 */
export function useWorkspaceMeQuery(options: VueApolloComposable.UseQueryOptions<WorkspaceMeQuery, WorkspaceMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkspaceMeQuery, WorkspaceMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkspaceMeQuery, WorkspaceMeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WorkspaceMeQuery, WorkspaceMeQueryVariables>(WorkspaceMeDocument, {}, options);
}
export function useWorkspaceMeLazyQuery(options: VueApolloComposable.UseQueryOptions<WorkspaceMeQuery, WorkspaceMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkspaceMeQuery, WorkspaceMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkspaceMeQuery, WorkspaceMeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WorkspaceMeQuery, WorkspaceMeQueryVariables>(WorkspaceMeDocument, {}, options);
}
export type WorkspaceMeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WorkspaceMeQuery, WorkspaceMeQueryVariables>;
export const WorkspaceModulesDocument = gql`
    query workspaceModules($userId: ID!, $sameUserId: String!) {
  projects(
    filter: {or: [{ownerUserId: {eq: $userId}}, {projectMembers: {userId: {eq: $userId}}}]}
    paging: {offset: 0, limit: 3}
  ) {
    nodes {
      id
      name
      ownerUserId
      media {
        image {
          MOBILE {
            LIST
          }
        }
      }
      projectMembers {
        nodes {
          userId
        }
      }
    }
  }
  friends: friendsByUserId(userId: $sameUserId, page: 1, limit: 12) {
    friend {
      id
      media {
        avatar {
          DESKTOP {
            FRIENDS_MINI_AVATAR
          }
        }
      }
    }
  }
  phrase: getPhraseOfTheDay {
    text
  }
}
    `;

/**
 * __useWorkspaceModulesQuery__
 *
 * To run a query within a Vue component, call `useWorkspaceModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceModulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWorkspaceModulesQuery({
 *   userId: // value for 'userId'
 *   sameUserId: // value for 'sameUserId'
 * });
 */
export function useWorkspaceModulesQuery(variables: WorkspaceModulesQueryVariables | VueCompositionApi.Ref<WorkspaceModulesQueryVariables> | ReactiveFunction<WorkspaceModulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkspaceModulesQuery, WorkspaceModulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkspaceModulesQuery, WorkspaceModulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkspaceModulesQuery, WorkspaceModulesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WorkspaceModulesQuery, WorkspaceModulesQueryVariables>(WorkspaceModulesDocument, variables, options);
}
export function useWorkspaceModulesLazyQuery(variables?: WorkspaceModulesQueryVariables | VueCompositionApi.Ref<WorkspaceModulesQueryVariables> | ReactiveFunction<WorkspaceModulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkspaceModulesQuery, WorkspaceModulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkspaceModulesQuery, WorkspaceModulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkspaceModulesQuery, WorkspaceModulesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WorkspaceModulesQuery, WorkspaceModulesQueryVariables>(WorkspaceModulesDocument, variables, options);
}
export type WorkspaceModulesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WorkspaceModulesQuery, WorkspaceModulesQueryVariables>;